"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * SWC Application API
 * Sustainable Water Cloud API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordApiFp = exports.PasswordApiAxiosParamCreator = exports.NodesApi = exports.NodesApiFactory = exports.NodesApiFp = exports.NodesApiAxiosParamCreator = exports.MasterApi = exports.MasterApiFactory = exports.MasterApiFp = exports.MasterApiAxiosParamCreator = exports.ManualApi = exports.ManualApiFactory = exports.ManualApiFp = exports.ManualApiAxiosParamCreator = exports.LogoutApi = exports.LogoutApiFactory = exports.LogoutApiFp = exports.LogoutApiAxiosParamCreator = exports.LoginApi = exports.LoginApiFactory = exports.LoginApiFp = exports.LoginApiAxiosParamCreator = exports.HealthAlwaysNgApi = exports.HealthAlwaysNgApiFactory = exports.HealthAlwaysNgApiFp = exports.HealthAlwaysNgApiAxiosParamCreator = exports.HealthApi = exports.HealthApiFactory = exports.HealthApiFp = exports.HealthApiAxiosParamCreator = exports.GraphicApi = exports.GraphicApiFactory = exports.GraphicApiFp = exports.GraphicApiAxiosParamCreator = exports.ApiApi = exports.ApiApiFactory = exports.ApiApiFp = exports.ApiApiAxiosParamCreator = exports.UsageEnum = exports.SplitByEnum = exports.NullEnum = exports.MlVariableTypeEnum = exports.JudgeTypeEnum = exports.ItemEnum = exports.GroupCodeEnum = exports.DirectionEnum = exports.CategoryEnum = exports.BlankEnum = exports.AsFreqEnum = exports.AggregationEnum = void 0;
exports.UserinfoApi = exports.UserinfoApiFactory = exports.UserinfoApiFp = exports.UserinfoApiAxiosParamCreator = exports.UserApi = exports.UserApiFactory = exports.UserApiFp = exports.UserApiAxiosParamCreator = exports.TokenApi = exports.TokenApiFactory = exports.TokenApiFp = exports.TokenApiAxiosParamCreator = exports.PasswordApi = exports.PasswordApiFactory = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
 * * `1` - 1 * `2` - 2 * `3` - 3 * `4` - 4 * `5` - 5
 * @export
 * @enum {string}
 */
var AggregationEnum;
(function (AggregationEnum) {
    AggregationEnum[AggregationEnum["NUMBER_1"] = 1] = "NUMBER_1";
    AggregationEnum[AggregationEnum["NUMBER_2"] = 2] = "NUMBER_2";
    AggregationEnum[AggregationEnum["NUMBER_3"] = 3] = "NUMBER_3";
    AggregationEnum[AggregationEnum["NUMBER_4"] = 4] = "NUMBER_4";
    AggregationEnum[AggregationEnum["NUMBER_5"] = 5] = "NUMBER_5";
})(AggregationEnum = exports.AggregationEnum || (exports.AggregationEnum = {}));
/**
 * * `m` - m * `10m` - 10m * `H` - H * `D` - D * `None` - None
 * @export
 * @enum {string}
 */
var AsFreqEnum;
(function (AsFreqEnum) {
    AsFreqEnum["M"] = "m";
    AsFreqEnum["_10m"] = "10m";
    AsFreqEnum["H"] = "H";
    AsFreqEnum["D"] = "D";
    AsFreqEnum["None"] = "None";
})(AsFreqEnum = exports.AsFreqEnum || (exports.AsFreqEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var BlankEnum;
(function (BlankEnum) {
    BlankEnum["Empty"] = "";
})(BlankEnum = exports.BlankEnum || (exports.BlankEnum = {}));
/**
 * * `train` - train * `test` - test * `valid` - valid
 * @export
 * @enum {string}
 */
var CategoryEnum;
(function (CategoryEnum) {
    CategoryEnum["Train"] = "train";
    CategoryEnum["Test"] = "test";
    CategoryEnum["Valid"] = "valid";
})(CategoryEnum = exports.CategoryEnum || (exports.CategoryEnum = {}));
/**
 * * `positive` - positive * `negative` - negative
 * @export
 * @enum {string}
 */
var DirectionEnum;
(function (DirectionEnum) {
    DirectionEnum["Positive"] = "positive";
    DirectionEnum["Negative"] = "negative";
})(DirectionEnum = exports.DirectionEnum || (exports.DirectionEnum = {}));
/**
 * * `cf_diff_pressure` - cf_diff_pressure * `pressure` - pressure * `pressure_loss` - pressure_loss * `water_flow` - water_flow * `conductivity` - conductivity * `ph` - ph * `water_temperature` - water_temperature * `corrected_permeated_water_flow` - corrected_permeated_water_flow
 * @export
 * @enum {string}
 */
var GroupCodeEnum;
(function (GroupCodeEnum) {
    GroupCodeEnum["CfDiffPressure"] = "cf_diff_pressure";
    GroupCodeEnum["Pressure"] = "pressure";
    GroupCodeEnum["PressureLoss"] = "pressure_loss";
    GroupCodeEnum["WaterFlow"] = "water_flow";
    GroupCodeEnum["Conductivity"] = "conductivity";
    GroupCodeEnum["Ph"] = "ph";
    GroupCodeEnum["WaterTemperature"] = "water_temperature";
    GroupCodeEnum["CorrectedPermeatedWaterFlow"] = "corrected_permeated_water_flow";
})(GroupCodeEnum = exports.GroupCodeEnum || (exports.GroupCodeEnum = {}));
/**
 * * `cf_in_pressure` - cf_in_pressure * `cf_out_pressure` - cf_out_pressure * `cf_diff_pressure` - cf_diff_pressure * `ro_in_pressure` - ro_in_pressure * `ro_1st_out_pressure` - ro_1st_out_pressure * `ro_2nd_out_pressure` - ro_2nd_out_pressure * `ro_3rd_out_pressure` - ro_3rd_out_pressure * `ro_permeated_water_pressure` - ro_permeated_water_pressure * `all_pressure_loss` - all_pressure_loss * `ro_1st_pressure_loss` - ro_1st_pressure_loss * `ro_2nd_pressure_loss` - ro_2nd_pressure_loss * `ro_3rd_pressure_loss` - ro_3rd_pressure_loss * `permeated_water_flow` - permeated_water_flow * `concentrated_water_flow` - concentrated_water_flow * `conductivity` - conductivity * `ph` - ph * `water_temperature` - water_temperature * `corrected_permeated_water_flow` - corrected_permeated_water_flow
 * @export
 * @enum {string}
 */
var ItemEnum;
(function (ItemEnum) {
    ItemEnum["CfInPressure"] = "cf_in_pressure";
    ItemEnum["CfOutPressure"] = "cf_out_pressure";
    ItemEnum["CfDiffPressure"] = "cf_diff_pressure";
    ItemEnum["RoInPressure"] = "ro_in_pressure";
    ItemEnum["Ro1stOutPressure"] = "ro_1st_out_pressure";
    ItemEnum["Ro2ndOutPressure"] = "ro_2nd_out_pressure";
    ItemEnum["Ro3rdOutPressure"] = "ro_3rd_out_pressure";
    ItemEnum["RoPermeatedWaterPressure"] = "ro_permeated_water_pressure";
    ItemEnum["AllPressureLoss"] = "all_pressure_loss";
    ItemEnum["Ro1stPressureLoss"] = "ro_1st_pressure_loss";
    ItemEnum["Ro2ndPressureLoss"] = "ro_2nd_pressure_loss";
    ItemEnum["Ro3rdPressureLoss"] = "ro_3rd_pressure_loss";
    ItemEnum["PermeatedWaterFlow"] = "permeated_water_flow";
    ItemEnum["ConcentratedWaterFlow"] = "concentrated_water_flow";
    ItemEnum["Conductivity"] = "conductivity";
    ItemEnum["Ph"] = "ph";
    ItemEnum["WaterTemperature"] = "water_temperature";
    ItemEnum["CorrectedPermeatedWaterFlow"] = "corrected_permeated_water_flow";
})(ItemEnum = exports.ItemEnum || (exports.ItemEnum = {}));
/**
 * * `pos` - pos * `neg` - neg * `pattern1` - pattern1 * `pattern2` - pattern2
 * @export
 * @enum {string}
 */
var JudgeTypeEnum;
(function (JudgeTypeEnum) {
    JudgeTypeEnum["Pos"] = "pos";
    JudgeTypeEnum["Neg"] = "neg";
    JudgeTypeEnum["Pattern1"] = "pattern1";
    JudgeTypeEnum["Pattern2"] = "pattern2";
})(JudgeTypeEnum = exports.JudgeTypeEnum || (exports.JudgeTypeEnum = {}));
/**
 * * `object_variable` - Object * `explanatory_variable` - Explanatory
 * @export
 * @enum {string}
 */
var MlVariableTypeEnum;
(function (MlVariableTypeEnum) {
    MlVariableTypeEnum["ObjectVariable"] = "object_variable";
    MlVariableTypeEnum["ExplanatoryVariable"] = "explanatory_variable";
})(MlVariableTypeEnum = exports.MlVariableTypeEnum || (exports.MlVariableTypeEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var NullEnum;
(function (NullEnum) {
    NullEnum["Null"] = "null";
})(NullEnum = exports.NullEnum || (exports.NullEnum = {}));
/**
 * * `M` - M * `Y` - Y * `null` - null
 * @export
 * @enum {string}
 */
var SplitByEnum;
(function (SplitByEnum) {
    SplitByEnum["M"] = "M";
    SplitByEnum["Y"] = "Y";
    SplitByEnum["Null"] = "null";
})(SplitByEnum = exports.SplitByEnum || (exports.SplitByEnum = {}));
/**
 * * `raw` - raw * `valid` - valid
 * @export
 * @enum {string}
 */
var UsageEnum;
(function (UsageEnum) {
    UsageEnum["Raw"] = "raw";
    UsageEnum["Valid"] = "valid";
})(UsageEnum = exports.UsageEnum || (exports.UsageEnum = {}));
/**
 * ApiApi - axios parameter creator
 * @export
 */
var ApiApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * OpenApi3 schema for this API. Format can be selected via content negotiation.  - YAML: application/vnd.oai.openapi - JSON: application/vnd.oai.openapi+json
         * @param {'json' | 'yaml'} [format]
         * @param {'af' | 'ar' | 'ar-dz' | 'ast' | 'az' | 'be' | 'bg' | 'bn' | 'br' | 'bs' | 'ca' | 'ckb' | 'cs' | 'cy' | 'da' | 'de' | 'dsb' | 'el' | 'en' | 'en-au' | 'en-gb' | 'eo' | 'es' | 'es-ar' | 'es-co' | 'es-mx' | 'es-ni' | 'es-ve' | 'et' | 'eu' | 'fa' | 'fi' | 'fr' | 'fy' | 'ga' | 'gd' | 'gl' | 'he' | 'hi' | 'hr' | 'hsb' | 'hu' | 'hy' | 'ia' | 'id' | 'ig' | 'io' | 'is' | 'it' | 'ja' | 'ka' | 'kab' | 'kk' | 'km' | 'kn' | 'ko' | 'ky' | 'lb' | 'lt' | 'lv' | 'mk' | 'ml' | 'mn' | 'mr' | 'ms' | 'my' | 'nb' | 'ne' | 'nl' | 'nn' | 'os' | 'pa' | 'pl' | 'pt' | 'pt-br' | 'ro' | 'ru' | 'sk' | 'sl' | 'sq' | 'sr' | 'sr-latn' | 'sv' | 'sw' | 'ta' | 'te' | 'tg' | 'th' | 'tk' | 'tr' | 'tt' | 'udm' | 'ug' | 'uk' | 'ur' | 'uz' | 'vi' | 'zh-hans' | 'zh-hant'} [lang]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchemaRetrieve: function (format, lang, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/api/schema/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (format !== undefined) {
                                localVarQueryParameter['format'] = format;
                            }
                            if (lang !== undefined) {
                                localVarQueryParameter['lang'] = lang;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ApiApiAxiosParamCreator = ApiApiAxiosParamCreator;
/**
 * ApiApi - functional programming interface
 * @export
 */
var ApiApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ApiApiAxiosParamCreator)(configuration);
    return {
        /**
         * OpenApi3 schema for this API. Format can be selected via content negotiation.  - YAML: application/vnd.oai.openapi - JSON: application/vnd.oai.openapi+json
         * @param {'json' | 'yaml'} [format]
         * @param {'af' | 'ar' | 'ar-dz' | 'ast' | 'az' | 'be' | 'bg' | 'bn' | 'br' | 'bs' | 'ca' | 'ckb' | 'cs' | 'cy' | 'da' | 'de' | 'dsb' | 'el' | 'en' | 'en-au' | 'en-gb' | 'eo' | 'es' | 'es-ar' | 'es-co' | 'es-mx' | 'es-ni' | 'es-ve' | 'et' | 'eu' | 'fa' | 'fi' | 'fr' | 'fy' | 'ga' | 'gd' | 'gl' | 'he' | 'hi' | 'hr' | 'hsb' | 'hu' | 'hy' | 'ia' | 'id' | 'ig' | 'io' | 'is' | 'it' | 'ja' | 'ka' | 'kab' | 'kk' | 'km' | 'kn' | 'ko' | 'ky' | 'lb' | 'lt' | 'lv' | 'mk' | 'ml' | 'mn' | 'mr' | 'ms' | 'my' | 'nb' | 'ne' | 'nl' | 'nn' | 'os' | 'pa' | 'pl' | 'pt' | 'pt-br' | 'ro' | 'ru' | 'sk' | 'sl' | 'sq' | 'sr' | 'sr-latn' | 'sv' | 'sw' | 'ta' | 'te' | 'tg' | 'th' | 'tk' | 'tr' | 'tt' | 'udm' | 'ug' | 'uk' | 'ur' | 'uz' | 'vi' | 'zh-hans' | 'zh-hant'} [lang]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchemaRetrieve: function (format, lang, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiSchemaRetrieve(format, lang, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ApiApiFp = ApiApiFp;
/**
 * ApiApi - factory interface
 * @export
 */
var ApiApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ApiApiFp)(configuration);
    return {
        /**
         * OpenApi3 schema for this API. Format can be selected via content negotiation.  - YAML: application/vnd.oai.openapi - JSON: application/vnd.oai.openapi+json
         * @param {'json' | 'yaml'} [format]
         * @param {'af' | 'ar' | 'ar-dz' | 'ast' | 'az' | 'be' | 'bg' | 'bn' | 'br' | 'bs' | 'ca' | 'ckb' | 'cs' | 'cy' | 'da' | 'de' | 'dsb' | 'el' | 'en' | 'en-au' | 'en-gb' | 'eo' | 'es' | 'es-ar' | 'es-co' | 'es-mx' | 'es-ni' | 'es-ve' | 'et' | 'eu' | 'fa' | 'fi' | 'fr' | 'fy' | 'ga' | 'gd' | 'gl' | 'he' | 'hi' | 'hr' | 'hsb' | 'hu' | 'hy' | 'ia' | 'id' | 'ig' | 'io' | 'is' | 'it' | 'ja' | 'ka' | 'kab' | 'kk' | 'km' | 'kn' | 'ko' | 'ky' | 'lb' | 'lt' | 'lv' | 'mk' | 'ml' | 'mn' | 'mr' | 'ms' | 'my' | 'nb' | 'ne' | 'nl' | 'nn' | 'os' | 'pa' | 'pl' | 'pt' | 'pt-br' | 'ro' | 'ru' | 'sk' | 'sl' | 'sq' | 'sr' | 'sr-latn' | 'sv' | 'sw' | 'ta' | 'te' | 'tg' | 'th' | 'tk' | 'tr' | 'tt' | 'udm' | 'ug' | 'uk' | 'ur' | 'uz' | 'vi' | 'zh-hans' | 'zh-hant'} [lang]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSchemaRetrieve: function (format, lang, options) {
            return localVarFp.apiSchemaRetrieve(format, lang, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ApiApiFactory = ApiApiFactory;
/**
 * ApiApi - object-oriented interface
 * @export
 * @class ApiApi
 * @extends {BaseAPI}
 */
var ApiApi = /** @class */ (function (_super) {
    __extends(ApiApi, _super);
    function ApiApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * OpenApi3 schema for this API. Format can be selected via content negotiation.  - YAML: application/vnd.oai.openapi - JSON: application/vnd.oai.openapi+json
     * @param {'json' | 'yaml'} [format]
     * @param {'af' | 'ar' | 'ar-dz' | 'ast' | 'az' | 'be' | 'bg' | 'bn' | 'br' | 'bs' | 'ca' | 'ckb' | 'cs' | 'cy' | 'da' | 'de' | 'dsb' | 'el' | 'en' | 'en-au' | 'en-gb' | 'eo' | 'es' | 'es-ar' | 'es-co' | 'es-mx' | 'es-ni' | 'es-ve' | 'et' | 'eu' | 'fa' | 'fi' | 'fr' | 'fy' | 'ga' | 'gd' | 'gl' | 'he' | 'hi' | 'hr' | 'hsb' | 'hu' | 'hy' | 'ia' | 'id' | 'ig' | 'io' | 'is' | 'it' | 'ja' | 'ka' | 'kab' | 'kk' | 'km' | 'kn' | 'ko' | 'ky' | 'lb' | 'lt' | 'lv' | 'mk' | 'ml' | 'mn' | 'mr' | 'ms' | 'my' | 'nb' | 'ne' | 'nl' | 'nn' | 'os' | 'pa' | 'pl' | 'pt' | 'pt-br' | 'ro' | 'ru' | 'sk' | 'sl' | 'sq' | 'sr' | 'sr-latn' | 'sv' | 'sw' | 'ta' | 'te' | 'tg' | 'th' | 'tk' | 'tr' | 'tt' | 'udm' | 'ug' | 'uk' | 'ur' | 'uz' | 'vi' | 'zh-hans' | 'zh-hant'} [lang]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    ApiApi.prototype.apiSchemaRetrieve = function (format, lang, options) {
        var _this = this;
        return (0, exports.ApiApiFp)(this.configuration).apiSchemaRetrieve(format, lang, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ApiApi;
}(base_1.BaseAPI));
exports.ApiApi = ApiApi;
/**
 * GraphicApi - axios parameter creator
 * @export
 */
var GraphicApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphicCssRetrieve: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/graphic/.*css";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphicHtmlRetrieve: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/graphic/.*html";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphicIcoRetrieve: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/graphic/.*ico";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphicJpgRetrieve: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/graphic/.*jpg";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphicJsRetrieve: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/graphic/.*js";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphicPngRetrieve: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/graphic/.*png";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphicRetrieve: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/graphic/.*";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.GraphicApiAxiosParamCreator = GraphicApiAxiosParamCreator;
/**
 * GraphicApi - functional programming interface
 * @export
 */
var GraphicApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.GraphicApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphicCssRetrieve: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.graphicCssRetrieve(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphicHtmlRetrieve: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.graphicHtmlRetrieve(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphicIcoRetrieve: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.graphicIcoRetrieve(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphicJpgRetrieve: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.graphicJpgRetrieve(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphicJsRetrieve: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.graphicJsRetrieve(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphicPngRetrieve: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.graphicPngRetrieve(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphicRetrieve: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.graphicRetrieve(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.GraphicApiFp = GraphicApiFp;
/**
 * GraphicApi - factory interface
 * @export
 */
var GraphicApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.GraphicApiFp)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphicCssRetrieve: function (options) {
            return localVarFp.graphicCssRetrieve(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphicHtmlRetrieve: function (options) {
            return localVarFp.graphicHtmlRetrieve(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphicIcoRetrieve: function (options) {
            return localVarFp.graphicIcoRetrieve(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphicJpgRetrieve: function (options) {
            return localVarFp.graphicJpgRetrieve(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphicJsRetrieve: function (options) {
            return localVarFp.graphicJsRetrieve(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphicPngRetrieve: function (options) {
            return localVarFp.graphicPngRetrieve(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphicRetrieve: function (options) {
            return localVarFp.graphicRetrieve(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.GraphicApiFactory = GraphicApiFactory;
/**
 * GraphicApi - object-oriented interface
 * @export
 * @class GraphicApi
 * @extends {BaseAPI}
 */
var GraphicApi = /** @class */ (function (_super) {
    __extends(GraphicApi, _super);
    function GraphicApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GraphicApi
     */
    GraphicApi.prototype.graphicCssRetrieve = function (options) {
        var _this = this;
        return (0, exports.GraphicApiFp)(this.configuration).graphicCssRetrieve(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GraphicApi
     */
    GraphicApi.prototype.graphicHtmlRetrieve = function (options) {
        var _this = this;
        return (0, exports.GraphicApiFp)(this.configuration).graphicHtmlRetrieve(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GraphicApi
     */
    GraphicApi.prototype.graphicIcoRetrieve = function (options) {
        var _this = this;
        return (0, exports.GraphicApiFp)(this.configuration).graphicIcoRetrieve(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GraphicApi
     */
    GraphicApi.prototype.graphicJpgRetrieve = function (options) {
        var _this = this;
        return (0, exports.GraphicApiFp)(this.configuration).graphicJpgRetrieve(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GraphicApi
     */
    GraphicApi.prototype.graphicJsRetrieve = function (options) {
        var _this = this;
        return (0, exports.GraphicApiFp)(this.configuration).graphicJsRetrieve(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GraphicApi
     */
    GraphicApi.prototype.graphicPngRetrieve = function (options) {
        var _this = this;
        return (0, exports.GraphicApiFp)(this.configuration).graphicPngRetrieve(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GraphicApi
     */
    GraphicApi.prototype.graphicRetrieve = function (options) {
        var _this = this;
        return (0, exports.GraphicApiFp)(this.configuration).graphicRetrieve(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return GraphicApi;
}(base_1.BaseAPI));
exports.GraphicApi = GraphicApi;
/**
 * HealthApi - axios parameter creator
 * @export
 */
var HealthApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthRetrieve: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/health/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.HealthApiAxiosParamCreator = HealthApiAxiosParamCreator;
/**
 * HealthApi - functional programming interface
 * @export
 */
var HealthApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.HealthApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthRetrieve: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.healthRetrieve(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.HealthApiFp = HealthApiFp;
/**
 * HealthApi - factory interface
 * @export
 */
var HealthApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.HealthApiFp)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthRetrieve: function (options) {
            return localVarFp.healthRetrieve(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.HealthApiFactory = HealthApiFactory;
/**
 * HealthApi - object-oriented interface
 * @export
 * @class HealthApi
 * @extends {BaseAPI}
 */
var HealthApi = /** @class */ (function (_super) {
    __extends(HealthApi, _super);
    function HealthApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthApi
     */
    HealthApi.prototype.healthRetrieve = function (options) {
        var _this = this;
        return (0, exports.HealthApiFp)(this.configuration).healthRetrieve(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return HealthApi;
}(base_1.BaseAPI));
exports.HealthApi = HealthApi;
/**
 * HealthAlwaysNgApi - axios parameter creator
 * @export
 */
var HealthAlwaysNgApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthAlwaysNgRetrieve: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/health-always-ng/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.HealthAlwaysNgApiAxiosParamCreator = HealthAlwaysNgApiAxiosParamCreator;
/**
 * HealthAlwaysNgApi - functional programming interface
 * @export
 */
var HealthAlwaysNgApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.HealthAlwaysNgApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthAlwaysNgRetrieve: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.healthAlwaysNgRetrieve(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.HealthAlwaysNgApiFp = HealthAlwaysNgApiFp;
/**
 * HealthAlwaysNgApi - factory interface
 * @export
 */
var HealthAlwaysNgApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.HealthAlwaysNgApiFp)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthAlwaysNgRetrieve: function (options) {
            return localVarFp.healthAlwaysNgRetrieve(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.HealthAlwaysNgApiFactory = HealthAlwaysNgApiFactory;
/**
 * HealthAlwaysNgApi - object-oriented interface
 * @export
 * @class HealthAlwaysNgApi
 * @extends {BaseAPI}
 */
var HealthAlwaysNgApi = /** @class */ (function (_super) {
    __extends(HealthAlwaysNgApi, _super);
    function HealthAlwaysNgApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthAlwaysNgApi
     */
    HealthAlwaysNgApi.prototype.healthAlwaysNgRetrieve = function (options) {
        var _this = this;
        return (0, exports.HealthAlwaysNgApiFp)(this.configuration).healthAlwaysNgRetrieve(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return HealthAlwaysNgApi;
}(base_1.BaseAPI));
exports.HealthAlwaysNgApi = HealthAlwaysNgApi;
/**
 * LoginApi - axios parameter creator
 * @export
 */
var LoginApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginEmailAuthCreate: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/login/email_auth/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginEmailAuthRetrieve: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/login/email_auth/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginExternalCreate: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/login/external/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginExternalRetrieve: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/login/external/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginMfaCreate: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/login/mfa/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginMfaRetrieve: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/login/mfa/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.LoginApiAxiosParamCreator = LoginApiAxiosParamCreator;
/**
 * LoginApi - functional programming interface
 * @export
 */
var LoginApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.LoginApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginEmailAuthCreate: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.loginEmailAuthCreate(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginEmailAuthRetrieve: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.loginEmailAuthRetrieve(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginExternalCreate: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.loginExternalCreate(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginExternalRetrieve: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.loginExternalRetrieve(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginMfaCreate: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.loginMfaCreate(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginMfaRetrieve: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.loginMfaRetrieve(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.LoginApiFp = LoginApiFp;
/**
 * LoginApi - factory interface
 * @export
 */
var LoginApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.LoginApiFp)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginEmailAuthCreate: function (options) {
            return localVarFp.loginEmailAuthCreate(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginEmailAuthRetrieve: function (options) {
            return localVarFp.loginEmailAuthRetrieve(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginExternalCreate: function (options) {
            return localVarFp.loginExternalCreate(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginExternalRetrieve: function (options) {
            return localVarFp.loginExternalRetrieve(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginMfaCreate: function (options) {
            return localVarFp.loginMfaCreate(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginMfaRetrieve: function (options) {
            return localVarFp.loginMfaRetrieve(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.LoginApiFactory = LoginApiFactory;
/**
 * LoginApi - object-oriented interface
 * @export
 * @class LoginApi
 * @extends {BaseAPI}
 */
var LoginApi = /** @class */ (function (_super) {
    __extends(LoginApi, _super);
    function LoginApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApi
     */
    LoginApi.prototype.loginEmailAuthCreate = function (options) {
        var _this = this;
        return (0, exports.LoginApiFp)(this.configuration).loginEmailAuthCreate(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApi
     */
    LoginApi.prototype.loginEmailAuthRetrieve = function (options) {
        var _this = this;
        return (0, exports.LoginApiFp)(this.configuration).loginEmailAuthRetrieve(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApi
     */
    LoginApi.prototype.loginExternalCreate = function (options) {
        var _this = this;
        return (0, exports.LoginApiFp)(this.configuration).loginExternalCreate(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApi
     */
    LoginApi.prototype.loginExternalRetrieve = function (options) {
        var _this = this;
        return (0, exports.LoginApiFp)(this.configuration).loginExternalRetrieve(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApi
     */
    LoginApi.prototype.loginMfaCreate = function (options) {
        var _this = this;
        return (0, exports.LoginApiFp)(this.configuration).loginMfaCreate(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApi
     */
    LoginApi.prototype.loginMfaRetrieve = function (options) {
        var _this = this;
        return (0, exports.LoginApiFp)(this.configuration).loginMfaRetrieve(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return LoginApi;
}(base_1.BaseAPI));
exports.LoginApi = LoginApi;
/**
 * LogoutApi - axios parameter creator
 * @export
 */
var LogoutApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutRetrieve: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/logout/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.LogoutApiAxiosParamCreator = LogoutApiAxiosParamCreator;
/**
 * LogoutApi - functional programming interface
 * @export
 */
var LogoutApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.LogoutApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutRetrieve: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.logoutRetrieve(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.LogoutApiFp = LogoutApiFp;
/**
 * LogoutApi - factory interface
 * @export
 */
var LogoutApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.LogoutApiFp)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutRetrieve: function (options) {
            return localVarFp.logoutRetrieve(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.LogoutApiFactory = LogoutApiFactory;
/**
 * LogoutApi - object-oriented interface
 * @export
 * @class LogoutApi
 * @extends {BaseAPI}
 */
var LogoutApi = /** @class */ (function (_super) {
    __extends(LogoutApi, _super);
    function LogoutApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogoutApi
     */
    LogoutApi.prototype.logoutRetrieve = function (options) {
        var _this = this;
        return (0, exports.LogoutApiFp)(this.configuration).logoutRetrieve(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return LogoutApi;
}(base_1.BaseAPI));
exports.LogoutApi = LogoutApi;
/**
 * ManualApi - axios parameter creator
 * @export
 */
var ManualApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manualCssRetrieve: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/manual/.*css";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manualHtmlRetrieve: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/manual/.*html";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manualIcoRetrieve: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/manual/.*ico";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manualJpgRetrieve: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/manual/.*jpg";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manualJsRetrieve: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/manual/.*js";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manualPngRetrieve: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/manual/.*png";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manualRetrieve: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/manual/.*";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ManualApiAxiosParamCreator = ManualApiAxiosParamCreator;
/**
 * ManualApi - functional programming interface
 * @export
 */
var ManualApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ManualApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manualCssRetrieve: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.manualCssRetrieve(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manualHtmlRetrieve: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.manualHtmlRetrieve(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manualIcoRetrieve: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.manualIcoRetrieve(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manualJpgRetrieve: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.manualJpgRetrieve(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manualJsRetrieve: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.manualJsRetrieve(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manualPngRetrieve: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.manualPngRetrieve(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manualRetrieve: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.manualRetrieve(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ManualApiFp = ManualApiFp;
/**
 * ManualApi - factory interface
 * @export
 */
var ManualApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ManualApiFp)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manualCssRetrieve: function (options) {
            return localVarFp.manualCssRetrieve(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manualHtmlRetrieve: function (options) {
            return localVarFp.manualHtmlRetrieve(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manualIcoRetrieve: function (options) {
            return localVarFp.manualIcoRetrieve(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manualJpgRetrieve: function (options) {
            return localVarFp.manualJpgRetrieve(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manualJsRetrieve: function (options) {
            return localVarFp.manualJsRetrieve(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manualPngRetrieve: function (options) {
            return localVarFp.manualPngRetrieve(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manualRetrieve: function (options) {
            return localVarFp.manualRetrieve(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ManualApiFactory = ManualApiFactory;
/**
 * ManualApi - object-oriented interface
 * @export
 * @class ManualApi
 * @extends {BaseAPI}
 */
var ManualApi = /** @class */ (function (_super) {
    __extends(ManualApi, _super);
    function ManualApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManualApi
     */
    ManualApi.prototype.manualCssRetrieve = function (options) {
        var _this = this;
        return (0, exports.ManualApiFp)(this.configuration).manualCssRetrieve(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManualApi
     */
    ManualApi.prototype.manualHtmlRetrieve = function (options) {
        var _this = this;
        return (0, exports.ManualApiFp)(this.configuration).manualHtmlRetrieve(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManualApi
     */
    ManualApi.prototype.manualIcoRetrieve = function (options) {
        var _this = this;
        return (0, exports.ManualApiFp)(this.configuration).manualIcoRetrieve(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManualApi
     */
    ManualApi.prototype.manualJpgRetrieve = function (options) {
        var _this = this;
        return (0, exports.ManualApiFp)(this.configuration).manualJpgRetrieve(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManualApi
     */
    ManualApi.prototype.manualJsRetrieve = function (options) {
        var _this = this;
        return (0, exports.ManualApiFp)(this.configuration).manualJsRetrieve(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManualApi
     */
    ManualApi.prototype.manualPngRetrieve = function (options) {
        var _this = this;
        return (0, exports.ManualApiFp)(this.configuration).manualPngRetrieve(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManualApi
     */
    ManualApi.prototype.manualRetrieve = function (options) {
        var _this = this;
        return (0, exports.ManualApiFp)(this.configuration).manualRetrieve(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ManualApi;
}(base_1.BaseAPI));
exports.ManualApi = ManualApi;
/**
 * MasterApi - axios parameter creator
 * @export
 */
var MasterApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {AnnouncementLevel} announcementLevel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementLevelCreate: function (announcementLevel, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'announcementLevel' is not null or undefined
                            (0, common_1.assertParamExists)('masterAnnouncementLevelCreate', 'announcementLevel', announcementLevel);
                            localVarPath = "/swc-api/master/announcement-level";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(announcementLevel, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this m_announcement_level.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementLevelDestroy: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterAnnouncementLevelDestroy', 'id', id);
                            localVarPath = "/swc-api/master/announcement-level/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementLevelList: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/master/announcement-level";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this m_announcement_level.
         * @param {PatchedAnnouncementLevel} [patchedAnnouncementLevel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementLevelPartialUpdate: function (id, patchedAnnouncementLevel, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterAnnouncementLevelPartialUpdate', 'id', id);
                            localVarPath = "/swc-api/master/announcement-level/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchedAnnouncementLevel, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this m_announcement_level.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementLevelRetrieve: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterAnnouncementLevelRetrieve', 'id', id);
                            localVarPath = "/swc-api/master/announcement-level/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this m_announcement_level.
         * @param {AnnouncementLevel} announcementLevel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementLevelUpdate: function (id, announcementLevel, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterAnnouncementLevelUpdate', 'id', id);
                            // verify required parameter 'announcementLevel' is not null or undefined
                            (0, common_1.assertParamExists)('masterAnnouncementLevelUpdate', 'announcementLevel', announcementLevel);
                            localVarPath = "/swc-api/master/announcement-level/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(announcementLevel, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {AnnouncementMaster} announcementMaster
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementLoginCreate: function (announcementMaster, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'announcementMaster' is not null or undefined
                            (0, common_1.assertParamExists)('masterAnnouncementLoginCreate', 'announcementMaster', announcementMaster);
                            localVarPath = "/swc-api/master/announcement-login";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(announcementMaster, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementLoginDestroy: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterAnnouncementLoginDestroy', 'id', id);
                            localVarPath = "/swc-api/master/announcement-login/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ログイン画面用お知らせマスタ情報一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementLoginList: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/master/announcement-login";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {PatchedAnnouncementMaster} [patchedAnnouncementMaster]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementLoginPartialUpdate: function (id, patchedAnnouncementMaster, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterAnnouncementLoginPartialUpdate', 'id', id);
                            localVarPath = "/swc-api/master/announcement-login/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchedAnnouncementMaster, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementLoginRetrieve: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterAnnouncementLoginRetrieve', 'id', id);
                            localVarPath = "/swc-api/master/announcement-login/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {AnnouncementMaster} announcementMaster
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementLoginUpdate: function (id, announcementMaster, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterAnnouncementLoginUpdate', 'id', id);
                            // verify required parameter 'announcementMaster' is not null or undefined
                            (0, common_1.assertParamExists)('masterAnnouncementLoginUpdate', 'announcementMaster', announcementMaster);
                            localVarPath = "/swc-api/master/announcement-login/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(announcementMaster, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * お知らせマスタ情報追加
         * @param {AnnouncementMaster} announcementMaster
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementMasterCreate: function (announcementMaster, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'announcementMaster' is not null or undefined
                            (0, common_1.assertParamExists)('masterAnnouncementMasterCreate', 'announcementMaster', announcementMaster);
                            localVarPath = "/swc-api/master/announcement-master";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(announcementMaster, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * お知らせマスタ情報削除
         * @param {number} id A unique integer value identifying this m_announcement_master.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementMasterDestroy: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterAnnouncementMasterDestroy', 'id', id);
                            localVarPath = "/swc-api/master/announcement-master/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * お知らせマスタ情報一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementMasterList: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/master/announcement-master";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * お知らせマスタ情報更新（一部）
         * @param {number} id A unique integer value identifying this m_announcement_master.
         * @param {PatchedAnnouncementMaster} [patchedAnnouncementMaster]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementMasterPartialUpdate: function (id, patchedAnnouncementMaster, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterAnnouncementMasterPartialUpdate', 'id', id);
                            localVarPath = "/swc-api/master/announcement-master/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchedAnnouncementMaster, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * お知らせマスタ情報詳細取得
         * @param {number} id A unique integer value identifying this m_announcement_master.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementMasterRetrieve: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterAnnouncementMasterRetrieve', 'id', id);
                            localVarPath = "/swc-api/master/announcement-master/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * お知らせマスタ情報更新
         * @param {number} id A unique integer value identifying this m_announcement_master.
         * @param {AnnouncementMaster} announcementMaster
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementMasterUpdate: function (id, announcementMaster, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterAnnouncementMasterUpdate', 'id', id);
                            // verify required parameter 'announcementMaster' is not null or undefined
                            (0, common_1.assertParamExists)('masterAnnouncementMasterUpdate', 'announcementMaster', announcementMaster);
                            localVarPath = "/swc-api/master/announcement-master/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(announcementMaster, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {AnnouncementType} announcementType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementTypeCreate: function (announcementType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'announcementType' is not null or undefined
                            (0, common_1.assertParamExists)('masterAnnouncementTypeCreate', 'announcementType', announcementType);
                            localVarPath = "/swc-api/master/announcement-type";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(announcementType, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this m_announcement_type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementTypeDestroy: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterAnnouncementTypeDestroy', 'id', id);
                            localVarPath = "/swc-api/master/announcement-type/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementTypeList: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/master/announcement-type";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this m_announcement_type.
         * @param {PatchedAnnouncementType} [patchedAnnouncementType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementTypePartialUpdate: function (id, patchedAnnouncementType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterAnnouncementTypePartialUpdate', 'id', id);
                            localVarPath = "/swc-api/master/announcement-type/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchedAnnouncementType, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this m_announcement_type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementTypeRetrieve: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterAnnouncementTypeRetrieve', 'id', id);
                            localVarPath = "/swc-api/master/announcement-type/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this m_announcement_type.
         * @param {AnnouncementType} announcementType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementTypeUpdate: function (id, announcementType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterAnnouncementTypeUpdate', 'id', id);
                            // verify required parameter 'announcementType' is not null or undefined
                            (0, common_1.assertParamExists)('masterAnnouncementTypeUpdate', 'announcementType', announcementType);
                            localVarPath = "/swc-api/master/announcement-type/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(announcementType, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * お知らせユーザー情報追加
         * @param {AnnouncementUserRequest} announcementUserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementUserCreate: function (announcementUserRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'announcementUserRequest' is not null or undefined
                            (0, common_1.assertParamExists)('masterAnnouncementUserCreate', 'announcementUserRequest', announcementUserRequest);
                            localVarPath = "/swc-api/master/announcement-user";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(announcementUserRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * お知らせユーザー情報削除
         * @param {number} id A unique integer value identifying this m_announcement_user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementUserDestroy: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterAnnouncementUserDestroy', 'id', id);
                            localVarPath = "/swc-api/master/announcement-user/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * お知らせユーザー情報一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementUserList: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/master/announcement-user";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * お知らせユーザー情報更新（一部）
         * @param {number} id A unique integer value identifying this m_announcement_user.
         * @param {PatchedAnnouncementUser} [patchedAnnouncementUser]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementUserPartialUpdate: function (id, patchedAnnouncementUser, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterAnnouncementUserPartialUpdate', 'id', id);
                            localVarPath = "/swc-api/master/announcement-user/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchedAnnouncementUser, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * お知らせユーザー情報詳細取得
         * @param {number} id A unique integer value identifying this m_announcement_user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementUserRetrieve: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterAnnouncementUserRetrieve', 'id', id);
                            localVarPath = "/swc-api/master/announcement-user/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * お知らせユーザー情報更新
         * @param {number} id A unique integer value identifying this m_announcement_user.
         * @param {AnnouncementUser} announcementUser
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementUserUpdate: function (id, announcementUser, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterAnnouncementUserUpdate', 'id', id);
                            // verify required parameter 'announcementUser' is not null or undefined
                            (0, common_1.assertParamExists)('masterAnnouncementUserUpdate', 'announcementUser', announcementUser);
                            localVarPath = "/swc-api/master/announcement-user/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(announcementUser, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * バッチ演算設定追加
         * @param {BatchCalculationSetting} batchCalculationSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCalculationSettingsCreate: function (batchCalculationSetting, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'batchCalculationSetting' is not null or undefined
                            (0, common_1.assertParamExists)('masterCalculationSettingsCreate', 'batchCalculationSetting', batchCalculationSetting);
                            localVarPath = "/swc-api/master/calculation-settings";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(batchCalculationSetting, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * バッチ演算設定削除
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCalculationSettingsDestroy: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterCalculationSettingsDestroy', 'id', id);
                            localVarPath = "/swc-api/master/calculation-settings/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * バッチ演算設定一覧取得
         * @param {number} [facilityGroupCode] 設備グループコード
         * @param {number} [plantId] 設備ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCalculationSettingsList: function (facilityGroupCode, plantId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/master/calculation-settings";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (facilityGroupCode !== undefined) {
                                localVarQueryParameter['facility_group_code'] = facilityGroupCode;
                            }
                            if (plantId !== undefined) {
                                localVarQueryParameter['plant_id'] = plantId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * バッチ演算設定更新（一部）
         * @param {string} id
         * @param {PatchedBatchCalculationSetting} [patchedBatchCalculationSetting]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCalculationSettingsPartialUpdate: function (id, patchedBatchCalculationSetting, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterCalculationSettingsPartialUpdate', 'id', id);
                            localVarPath = "/swc-api/master/calculation-settings/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchedBatchCalculationSetting, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * バッチ演算設定詳細取得
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCalculationSettingsRetrieve: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterCalculationSettingsRetrieve', 'id', id);
                            localVarPath = "/swc-api/master/calculation-settings/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * バッチ演算設定更新
         * @param {string} id
         * @param {BatchCalculationSetting} batchCalculationSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCalculationSettingsUpdate: function (id, batchCalculationSetting, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterCalculationSettingsUpdate', 'id', id);
                            // verify required parameter 'batchCalculationSetting' is not null or undefined
                            (0, common_1.assertParamExists)('masterCalculationSettingsUpdate', 'batchCalculationSetting', batchCalculationSetting);
                            localVarPath = "/swc-api/master/calculation-settings/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(batchCalculationSetting, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * カメラ型式追加
         * @param {CameraType} cameraType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCameraTypesCreate: function (cameraType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'cameraType' is not null or undefined
                            (0, common_1.assertParamExists)('masterCameraTypesCreate', 'cameraType', cameraType);
                            localVarPath = "/swc-api/master/camera-types";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(cameraType, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * カメラ型式削除
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCameraTypesDestroy: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterCameraTypesDestroy', 'id', id);
                            localVarPath = "/swc-api/master/camera-types/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * カメラ型式一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCameraTypesList: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/master/camera-types";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {PatchedCameraType} [patchedCameraType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCameraTypesPartialUpdate: function (id, patchedCameraType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterCameraTypesPartialUpdate', 'id', id);
                            localVarPath = "/swc-api/master/camera-types/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchedCameraType, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * カメラ型式詳細取得
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCameraTypesRetrieve: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterCameraTypesRetrieve', 'id', id);
                            localVarPath = "/swc-api/master/camera-types/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {CameraType} cameraType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCameraTypesUpdate: function (id, cameraType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterCameraTypesUpdate', 'id', id);
                            // verify required parameter 'cameraType' is not null or undefined
                            (0, common_1.assertParamExists)('masterCameraTypesUpdate', 'cameraType', cameraType);
                            localVarPath = "/swc-api/master/camera-types/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(cameraType, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * カメラ追加
         * @param {CameraCreate} cameraCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCamerasCreate: function (cameraCreate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'cameraCreate' is not null or undefined
                            (0, common_1.assertParamExists)('masterCamerasCreate', 'cameraCreate', cameraCreate);
                            localVarPath = "/swc-api/master/cameras";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(cameraCreate, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * カメラ登録CSVを使った一括カメラ登録
         * @param {CsvUserCreate} [csvUserCreate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCamerasCsvCameraCreateCreate: function (csvUserCreate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/master/cameras/csv_camera_create";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(csvUserCreate, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * カメラ登録CSVファイルへのバリデーションチェック
         * @param {CsvUserValidate} [csvUserValidate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCamerasCsvCheckValidateCreate: function (csvUserValidate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/master/cameras/csv_check_validate";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(csvUserValidate, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * カメラ削除
         * @param {number} id A unique integer value identifying this m_camera.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCamerasDestroy: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterCamerasDestroy', 'id', id);
                            localVarPath = "/swc-api/master/cameras/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * カメラ一覧取得
         * @param {boolean} [includeDeploymentInfo] モデル一覧と一緒にデプロイ情報も取得するかどうか
         * @param {string} [nodeId] 階層ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCamerasList: function (includeDeploymentInfo, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/master/cameras";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (includeDeploymentInfo !== undefined) {
                                localVarQueryParameter['include_deployment_info'] = includeDeploymentInfo;
                            }
                            if (nodeId !== undefined) {
                                localVarQueryParameter['node_id'] = nodeId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * カメラ更新（一部）
         * @param {number} id A unique integer value identifying this m_camera.
         * @param {PatchedCamera} [patchedCamera]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCamerasPartialUpdate: function (id, patchedCamera, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterCamerasPartialUpdate', 'id', id);
                            localVarPath = "/swc-api/master/cameras/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchedCamera, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * カメラ詳細取得
         * @param {number} id A unique integer value identifying this m_camera.
         * @param {boolean} [includeModelBuildCounts] 今月のモデルビルド数も合わせて取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCamerasRetrieve: function (id, includeModelBuildCounts, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterCamerasRetrieve', 'id', id);
                            localVarPath = "/swc-api/master/cameras/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (includeModelBuildCounts !== undefined) {
                                localVarQueryParameter['include_model_build_counts'] = includeModelBuildCounts;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * カメラ更新
         * @param {number} id A unique integer value identifying this m_camera.
         * @param {CameraCreate} cameraCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCamerasUpdate: function (id, cameraCreate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterCamerasUpdate', 'id', id);
                            // verify required parameter 'cameraCreate' is not null or undefined
                            (0, common_1.assertParamExists)('masterCamerasUpdate', 'cameraCreate', cameraCreate);
                            localVarPath = "/swc-api/master/cameras/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(cameraCreate, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {CustomerType} customerType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCustomerTypesCreate: function (customerType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'customerType' is not null or undefined
                            (0, common_1.assertParamExists)('masterCustomerTypesCreate', 'customerType', customerType);
                            localVarPath = "/swc-api/master/customer-types";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customerType, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCustomerTypesDestroy: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterCustomerTypesDestroy', 'id', id);
                            localVarPath = "/swc-api/master/customer-types/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCustomerTypesList: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/master/customer-types";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {PatchedCustomerType} [patchedCustomerType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCustomerTypesPartialUpdate: function (id, patchedCustomerType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterCustomerTypesPartialUpdate', 'id', id);
                            localVarPath = "/swc-api/master/customer-types/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchedCustomerType, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCustomerTypesRetrieve: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterCustomerTypesRetrieve', 'id', id);
                            localVarPath = "/swc-api/master/customer-types/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {CustomerType} customerType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCustomerTypesUpdate: function (id, customerType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterCustomerTypesUpdate', 'id', id);
                            // verify required parameter 'customerType' is not null or undefined
                            (0, common_1.assertParamExists)('masterCustomerTypesUpdate', 'customerType', customerType);
                            localVarPath = "/swc-api/master/customer-types/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customerType, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * デプロイコンポーネント設定追加
         * @param {DeploymentComponent} deploymentComponent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterDeployComponentsCreate: function (deploymentComponent, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'deploymentComponent' is not null or undefined
                            (0, common_1.assertParamExists)('masterDeployComponentsCreate', 'deploymentComponent', deploymentComponent);
                            localVarPath = "/swc-api/master/deploy-components";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(deploymentComponent, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * デプロイコンポーネント設定削除
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterDeployComponentsDestroy: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterDeployComponentsDestroy', 'id', id);
                            localVarPath = "/swc-api/master/deploy-components/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * デプロイコンポーネント設定一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterDeployComponentsList: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/master/deploy-components";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * デプロイコンポーネント設定更新（一部）
         * @param {string} id
         * @param {PatchedDeploymentComponent} [patchedDeploymentComponent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterDeployComponentsPartialUpdate: function (id, patchedDeploymentComponent, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterDeployComponentsPartialUpdate', 'id', id);
                            localVarPath = "/swc-api/master/deploy-components/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchedDeploymentComponent, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * デプロイコンポーネント設定詳細取得
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterDeployComponentsRetrieve: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterDeployComponentsRetrieve', 'id', id);
                            localVarPath = "/swc-api/master/deploy-components/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * デプロイコンポーネント設定更新
         * @param {string} id
         * @param {DeploymentComponent} deploymentComponent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterDeployComponentsUpdate: function (id, deploymentComponent, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterDeployComponentsUpdate', 'id', id);
                            // verify required parameter 'deploymentComponent' is not null or undefined
                            (0, common_1.assertParamExists)('masterDeployComponentsUpdate', 'deploymentComponent', deploymentComponent);
                            localVarPath = "/swc-api/master/deploy-components/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(deploymentComponent, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * デバイス設定追加
         * @param {Device} device
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterDevicesCreate: function (device, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'device' is not null or undefined
                            (0, common_1.assertParamExists)('masterDevicesCreate', 'device', device);
                            localVarPath = "/swc-api/master/devices";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(device, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * デバイス設定削除
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterDevicesDestroy: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterDevicesDestroy', 'id', id);
                            localVarPath = "/swc-api/master/devices/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * デバイス設定一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterDevicesList: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/master/devices";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * デバイス設定更新（一部）
         * @param {string} id
         * @param {PatchedDevice} [patchedDevice]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterDevicesPartialUpdate: function (id, patchedDevice, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterDevicesPartialUpdate', 'id', id);
                            localVarPath = "/swc-api/master/devices/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchedDevice, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * デバイス設定詳細取得
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterDevicesRetrieve: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterDevicesRetrieve', 'id', id);
                            localVarPath = "/swc-api/master/devices/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * デバイス設定更新
         * @param {string} id
         * @param {Device} device
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterDevicesUpdate: function (id, device, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterDevicesUpdate', 'id', id);
                            // verify required parameter 'device' is not null or undefined
                            (0, common_1.assertParamExists)('masterDevicesUpdate', 'device', device);
                            localVarPath = "/swc-api/master/devices/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(device, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 外部出力作成
         * @param {ExternalOutputInfoRequest} externalOutputInfoRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterExternalOutputInfoCreate: function (externalOutputInfoRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'externalOutputInfoRequest' is not null or undefined
                            (0, common_1.assertParamExists)('masterExternalOutputInfoCreate', 'externalOutputInfoRequest', externalOutputInfoRequest);
                            localVarPath = "/swc-api/master/external-output-info";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(externalOutputInfoRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 外部出力削除
         * @param {string} id データセットID
         * @param {number} nodeId 階層 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterExternalOutputInfoDestroy: function (id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterExternalOutputInfoDestroy', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('masterExternalOutputInfoDestroy', 'nodeId', nodeId);
                            localVarPath = "/swc-api/master/external-output-info/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (nodeId !== undefined) {
                                localVarQueryParameter['node_id'] = nodeId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 外部出力一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterExternalOutputInfoList: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/master/external-output-info";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 外部出力更新
         * @param {string} id
         * @param {ExternalOutputInfoRequest} externalOutputInfoRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterExternalOutputInfoUpdate: function (id, externalOutputInfoRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterExternalOutputInfoUpdate', 'id', id);
                            // verify required parameter 'externalOutputInfoRequest' is not null or undefined
                            (0, common_1.assertParamExists)('masterExternalOutputInfoUpdate', 'externalOutputInfoRequest', externalOutputInfoRequest);
                            localVarPath = "/swc-api/master/external-output-info/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(externalOutputInfoRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 設備グループ情報追加
         * @param {FacilityGroup} facilityGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterFacilityGroupsCreate: function (facilityGroup, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'facilityGroup' is not null or undefined
                            (0, common_1.assertParamExists)('masterFacilityGroupsCreate', 'facilityGroup', facilityGroup);
                            localVarPath = "/swc-api/master/facility-groups";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(facilityGroup, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 設備グループ情報削除
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterFacilityGroupsDestroy: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterFacilityGroupsDestroy', 'id', id);
                            localVarPath = "/swc-api/master/facility-groups/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 設備グループ情報一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterFacilityGroupsList: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/master/facility-groups";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 設備グループ情報更新（一部）
         * @param {string} id
         * @param {PatchedFacilityGroup} [patchedFacilityGroup]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterFacilityGroupsPartialUpdate: function (id, patchedFacilityGroup, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterFacilityGroupsPartialUpdate', 'id', id);
                            localVarPath = "/swc-api/master/facility-groups/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchedFacilityGroup, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 設備グループ情報詳細取得
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterFacilityGroupsRetrieve: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterFacilityGroupsRetrieve', 'id', id);
                            localVarPath = "/swc-api/master/facility-groups/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 設備グループ情報更新
         * @param {string} id
         * @param {FacilityGroup} facilityGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterFacilityGroupsUpdate: function (id, facilityGroup, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterFacilityGroupsUpdate', 'id', id);
                            // verify required parameter 'facilityGroup' is not null or undefined
                            (0, common_1.assertParamExists)('masterFacilityGroupsUpdate', 'facilityGroup', facilityGroup);
                            localVarPath = "/swc-api/master/facility-groups/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(facilityGroup, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Upload IF
         * @param {GatewayIFUploadRequest} gatewayIFUploadRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterGatewayIfCreate: function (gatewayIFUploadRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'gatewayIFUploadRequest' is not null or undefined
                            (0, common_1.assertParamExists)('masterGatewayIfCreate', 'gatewayIFUploadRequest', gatewayIFUploadRequest);
                            localVarPath = "/swc-api/master/gateway-if";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(gatewayIFUploadRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * フォーマットダウンロード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterGatewayIfDownloadFormatRetrieve: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/master/gateway-if/download_format";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * IFファイルダウンロード
         * @param {string} [s3Key] S3 Key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterGatewayIfDownloadIfRetrieve: function (s3Key, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/master/gateway-if/download_if";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (s3Key !== undefined) {
                                localVarQueryParameter['s3_key'] = s3Key;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Gateway変換設定 API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterGatewayIfList: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/master/gateway-if";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Validation IF
         * @param {string} id
         * @param {GatewayIFValidationRequest} gatewayIFValidationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterGatewayIfValidationCreate: function (id, gatewayIFValidationRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterGatewayIfValidationCreate', 'id', id);
                            // verify required parameter 'gatewayIFValidationRequest' is not null or undefined
                            (0, common_1.assertParamExists)('masterGatewayIfValidationCreate', 'gatewayIFValidationRequest', gatewayIFValidationRequest);
                            localVarPath = "/swc-api/master/gateway-if/{id}/validation"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(gatewayIFValidationRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 業種区分情報追加
         * @param {IndustryType} industryType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterIndustryTypesCreate: function (industryType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'industryType' is not null or undefined
                            (0, common_1.assertParamExists)('masterIndustryTypesCreate', 'industryType', industryType);
                            localVarPath = "/swc-api/master/industry-types";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(industryType, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 業種区分情報削除
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterIndustryTypesDestroy: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterIndustryTypesDestroy', 'id', id);
                            localVarPath = "/swc-api/master/industry-types/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 業種区分一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterIndustryTypesList: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/master/industry-types";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 業種区分情報更新（一部）
         * @param {string} id
         * @param {PatchedIndustryType} [patchedIndustryType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterIndustryTypesPartialUpdate: function (id, patchedIndustryType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterIndustryTypesPartialUpdate', 'id', id);
                            localVarPath = "/swc-api/master/industry-types/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchedIndustryType, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 業種区分情報詳細取得
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterIndustryTypesRetrieve: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterIndustryTypesRetrieve', 'id', id);
                            localVarPath = "/swc-api/master/industry-types/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 業種区分情報更新
         * @param {string} id
         * @param {IndustryType} industryType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterIndustryTypesUpdate: function (id, industryType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterIndustryTypesUpdate', 'id', id);
                            // verify required parameter 'industryType' is not null or undefined
                            (0, common_1.assertParamExists)('masterIndustryTypesUpdate', 'industryType', industryType);
                            localVarPath = "/swc-api/master/industry-types/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(industryType, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * マイダッシュボード設定追加
         * @param {number} nodeId 設備ID
         * @param {MyDashboardSetting} myDashboardSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyDashboardSettingsCreate: function (nodeId, myDashboardSetting, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('masterMyDashboardSettingsCreate', 'nodeId', nodeId);
                            // verify required parameter 'myDashboardSetting' is not null or undefined
                            (0, common_1.assertParamExists)('masterMyDashboardSettingsCreate', 'myDashboardSetting', myDashboardSetting);
                            localVarPath = "/swc-api/master/my-dashboard-settings";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (nodeId !== undefined) {
                                localVarQueryParameter['node_id'] = nodeId;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(myDashboardSetting, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * マイダッシュボード設定削除
         * @param {number} id A unique integer value identifying this m_my_dashboard_setting.
         * @param {number} nodeId 設備ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyDashboardSettingsDestroy: function (id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterMyDashboardSettingsDestroy', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('masterMyDashboardSettingsDestroy', 'nodeId', nodeId);
                            localVarPath = "/swc-api/master/my-dashboard-settings/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (nodeId !== undefined) {
                                localVarQueryParameter['node_id'] = nodeId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * マイダッシュボード設定一覧
         * @param {number} nodeId 設備ID
         * @param {number} userId ユーザID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyDashboardSettingsList: function (nodeId, userId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('masterMyDashboardSettingsList', 'nodeId', nodeId);
                            // verify required parameter 'userId' is not null or undefined
                            (0, common_1.assertParamExists)('masterMyDashboardSettingsList', 'userId', userId);
                            localVarPath = "/swc-api/master/my-dashboard-settings";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (nodeId !== undefined) {
                                localVarQueryParameter['node_id'] = nodeId;
                            }
                            if (userId !== undefined) {
                                localVarQueryParameter['user_id'] = userId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * マイダッシュボード設定更新（一部）
         * @param {number} id A unique integer value identifying this m_my_dashboard_setting.
         * @param {number} nodeId 設備ID
         * @param {PatchedMyDashboardSetting} [patchedMyDashboardSetting]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyDashboardSettingsPartialUpdate: function (id, nodeId, patchedMyDashboardSetting, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterMyDashboardSettingsPartialUpdate', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('masterMyDashboardSettingsPartialUpdate', 'nodeId', nodeId);
                            localVarPath = "/swc-api/master/my-dashboard-settings/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (nodeId !== undefined) {
                                localVarQueryParameter['node_id'] = nodeId;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchedMyDashboardSetting, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * マイダッシュボード設定詳細取得
         * @param {number} id A unique integer value identifying this m_my_dashboard_setting.
         * @param {number} nodeId 設備ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyDashboardSettingsRetrieve: function (id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterMyDashboardSettingsRetrieve', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('masterMyDashboardSettingsRetrieve', 'nodeId', nodeId);
                            localVarPath = "/swc-api/master/my-dashboard-settings/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (nodeId !== undefined) {
                                localVarQueryParameter['node_id'] = nodeId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * マイダッシュボード設定更新
         * @param {number} id A unique integer value identifying this m_my_dashboard_setting.
         * @param {number} nodeId 設備ID
         * @param {MyDashboardSetting} myDashboardSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyDashboardSettingsUpdate: function (id, nodeId, myDashboardSetting, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterMyDashboardSettingsUpdate', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('masterMyDashboardSettingsUpdate', 'nodeId', nodeId);
                            // verify required parameter 'myDashboardSetting' is not null or undefined
                            (0, common_1.assertParamExists)('masterMyDashboardSettingsUpdate', 'myDashboardSetting', myDashboardSetting);
                            localVarPath = "/swc-api/master/my-dashboard-settings/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (nodeId !== undefined) {
                                localVarQueryParameter['node_id'] = nodeId;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(myDashboardSetting, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * マイ長期トレンド設定追加
         * @param {number} nodeId 設備ID
         * @param {MyLongTermTrendSetting} myLongTermTrendSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyLongTermTrendSettingsCreate: function (nodeId, myLongTermTrendSetting, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('masterMyLongTermTrendSettingsCreate', 'nodeId', nodeId);
                            // verify required parameter 'myLongTermTrendSetting' is not null or undefined
                            (0, common_1.assertParamExists)('masterMyLongTermTrendSettingsCreate', 'myLongTermTrendSetting', myLongTermTrendSetting);
                            localVarPath = "/swc-api/master/my-long-term-trend-settings";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (nodeId !== undefined) {
                                localVarQueryParameter['node_id'] = nodeId;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(myLongTermTrendSetting, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * マイ長期トレンド設定削除
         * @param {number} id A unique integer value identifying this m_my_long_term_trend_setting.
         * @param {number} nodeId 設備ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyLongTermTrendSettingsDestroy: function (id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterMyLongTermTrendSettingsDestroy', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('masterMyLongTermTrendSettingsDestroy', 'nodeId', nodeId);
                            localVarPath = "/swc-api/master/my-long-term-trend-settings/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (nodeId !== undefined) {
                                localVarQueryParameter['node_id'] = nodeId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * マイ長期トレンド設定一覧
         * @param {number} nodeId 設備ID
         * @param {number} userId ユーザID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyLongTermTrendSettingsList: function (nodeId, userId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('masterMyLongTermTrendSettingsList', 'nodeId', nodeId);
                            // verify required parameter 'userId' is not null or undefined
                            (0, common_1.assertParamExists)('masterMyLongTermTrendSettingsList', 'userId', userId);
                            localVarPath = "/swc-api/master/my-long-term-trend-settings";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (nodeId !== undefined) {
                                localVarQueryParameter['node_id'] = nodeId;
                            }
                            if (userId !== undefined) {
                                localVarQueryParameter['user_id'] = userId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * マイ長期トレンド設定更新（一部）
         * @param {number} id A unique integer value identifying this m_my_long_term_trend_setting.
         * @param {number} nodeId 設備ID
         * @param {PatchedMyLongTermTrendSetting} [patchedMyLongTermTrendSetting]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyLongTermTrendSettingsPartialUpdate: function (id, nodeId, patchedMyLongTermTrendSetting, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterMyLongTermTrendSettingsPartialUpdate', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('masterMyLongTermTrendSettingsPartialUpdate', 'nodeId', nodeId);
                            localVarPath = "/swc-api/master/my-long-term-trend-settings/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (nodeId !== undefined) {
                                localVarQueryParameter['node_id'] = nodeId;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchedMyLongTermTrendSetting, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * マイ長期トレンド設定詳細取得
         * @param {number} id A unique integer value identifying this m_my_long_term_trend_setting.
         * @param {number} nodeId 設備ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyLongTermTrendSettingsRetrieve: function (id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterMyLongTermTrendSettingsRetrieve', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('masterMyLongTermTrendSettingsRetrieve', 'nodeId', nodeId);
                            localVarPath = "/swc-api/master/my-long-term-trend-settings/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (nodeId !== undefined) {
                                localVarQueryParameter['node_id'] = nodeId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * マイ長期トレンド設定更新
         * @param {number} id A unique integer value identifying this m_my_long_term_trend_setting.
         * @param {number} nodeId 設備ID
         * @param {MyLongTermTrendSetting} myLongTermTrendSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyLongTermTrendSettingsUpdate: function (id, nodeId, myLongTermTrendSetting, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterMyLongTermTrendSettingsUpdate', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('masterMyLongTermTrendSettingsUpdate', 'nodeId', nodeId);
                            // verify required parameter 'myLongTermTrendSetting' is not null or undefined
                            (0, common_1.assertParamExists)('masterMyLongTermTrendSettingsUpdate', 'myLongTermTrendSetting', myLongTermTrendSetting);
                            localVarPath = "/swc-api/master/my-long-term-trend-settings/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (nodeId !== undefined) {
                                localVarQueryParameter['node_id'] = nodeId;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(myLongTermTrendSetting, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 統計データ分析設定追加
         * @param {number} nodeId 階層ID
         * @param {MyScatterSetting} myScatterSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyScatterSettingsCreate: function (nodeId, myScatterSetting, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('masterMyScatterSettingsCreate', 'nodeId', nodeId);
                            // verify required parameter 'myScatterSetting' is not null or undefined
                            (0, common_1.assertParamExists)('masterMyScatterSettingsCreate', 'myScatterSetting', myScatterSetting);
                            localVarPath = "/swc-api/master/my-scatter-settings";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (nodeId !== undefined) {
                                localVarQueryParameter['node_id'] = nodeId;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(myScatterSetting, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 統計データ分析設定削除
         * @param {number} id A unique integer value identifying this m_my_scatter_setting.
         * @param {number} nodeId 階層ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyScatterSettingsDestroy: function (id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterMyScatterSettingsDestroy', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('masterMyScatterSettingsDestroy', 'nodeId', nodeId);
                            localVarPath = "/swc-api/master/my-scatter-settings/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (nodeId !== undefined) {
                                localVarQueryParameter['node_id'] = nodeId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 統計データ分析設定一覧
         * @param {number} nodeId 階層ID
         * @param {number} userId ユーザID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyScatterSettingsList: function (nodeId, userId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('masterMyScatterSettingsList', 'nodeId', nodeId);
                            // verify required parameter 'userId' is not null or undefined
                            (0, common_1.assertParamExists)('masterMyScatterSettingsList', 'userId', userId);
                            localVarPath = "/swc-api/master/my-scatter-settings";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (nodeId !== undefined) {
                                localVarQueryParameter['node_id'] = nodeId;
                            }
                            if (userId !== undefined) {
                                localVarQueryParameter['user_id'] = userId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 統計データ分析設定更新（一部）
         * @param {number} id A unique integer value identifying this m_my_scatter_setting.
         * @param {number} nodeId 階層ID
         * @param {PatchedMyScatterSetting} [patchedMyScatterSetting]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyScatterSettingsPartialUpdate: function (id, nodeId, patchedMyScatterSetting, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterMyScatterSettingsPartialUpdate', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('masterMyScatterSettingsPartialUpdate', 'nodeId', nodeId);
                            localVarPath = "/swc-api/master/my-scatter-settings/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (nodeId !== undefined) {
                                localVarQueryParameter['node_id'] = nodeId;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchedMyScatterSetting, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 統計データ分析設定詳細取得
         * @param {number} id A unique integer value identifying this m_my_scatter_setting.
         * @param {number} nodeId 階層ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyScatterSettingsRetrieve: function (id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterMyScatterSettingsRetrieve', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('masterMyScatterSettingsRetrieve', 'nodeId', nodeId);
                            localVarPath = "/swc-api/master/my-scatter-settings/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (nodeId !== undefined) {
                                localVarQueryParameter['node_id'] = nodeId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 統計データ分析設定更新
         * @param {number} id A unique integer value identifying this m_my_scatter_setting.
         * @param {number} nodeId 階層ID
         * @param {MyScatterSetting} myScatterSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyScatterSettingsUpdate: function (id, nodeId, myScatterSetting, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterMyScatterSettingsUpdate', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('masterMyScatterSettingsUpdate', 'nodeId', nodeId);
                            // verify required parameter 'myScatterSetting' is not null or undefined
                            (0, common_1.assertParamExists)('masterMyScatterSettingsUpdate', 'myScatterSetting', myScatterSetting);
                            localVarPath = "/swc-api/master/my-scatter-settings/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (nodeId !== undefined) {
                                localVarQueryParameter['node_id'] = nodeId;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(myScatterSetting, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ノード情報追加
         * @param {Node} node
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterNodesCreate: function (node, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'node' is not null or undefined
                            (0, common_1.assertParamExists)('masterNodesCreate', 'node', node);
                            localVarPath = "/swc-api/master/nodes";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(node, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ノード情報削除
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterNodesDestroy: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterNodesDestroy', 'id', id);
                            localVarPath = "/swc-api/master/nodes/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ノード情報一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterNodesList: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/master/nodes";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ノード情報更新（一部）
         * @param {string} id
         * @param {PatchedNode} [patchedNode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterNodesPartialUpdate: function (id, patchedNode, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterNodesPartialUpdate', 'id', id);
                            localVarPath = "/swc-api/master/nodes/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchedNode, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ノード情報詳細取得
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterNodesRetrieve: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterNodesRetrieve', 'id', id);
                            localVarPath = "/swc-api/master/nodes/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ノード情報更新
         * @param {string} id
         * @param {Node} node
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterNodesUpdate: function (id, node, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterNodesUpdate', 'id', id);
                            // verify required parameter 'node' is not null or undefined
                            (0, common_1.assertParamExists)('masterNodesUpdate', 'node', node);
                            localVarPath = "/swc-api/master/nodes/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(node, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 組織情報追加
         * @param {Organization} organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterOrganizationsCreate: function (organization, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'organization' is not null or undefined
                            (0, common_1.assertParamExists)('masterOrganizationsCreate', 'organization', organization);
                            localVarPath = "/swc-api/master/organizations";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(organization, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 組織情報削除
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterOrganizationsDestroy: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterOrganizationsDestroy', 'id', id);
                            localVarPath = "/swc-api/master/organizations/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 組織情報一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterOrganizationsList: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/master/organizations";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 組織情報更新（一部）
         * @param {string} id
         * @param {PatchedOrganization} [patchedOrganization]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterOrganizationsPartialUpdate: function (id, patchedOrganization, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterOrganizationsPartialUpdate', 'id', id);
                            localVarPath = "/swc-api/master/organizations/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchedOrganization, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 組織情報詳細取得
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterOrganizationsRetrieve: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterOrganizationsRetrieve', 'id', id);
                            localVarPath = "/swc-api/master/organizations/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 組織情報更新
         * @param {string} id
         * @param {Organization} organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterOrganizationsUpdate: function (id, organization, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterOrganizationsUpdate', 'id', id);
                            // verify required parameter 'organization' is not null or undefined
                            (0, common_1.assertParamExists)('masterOrganizationsUpdate', 'organization', organization);
                            localVarPath = "/swc-api/master/organizations/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(organization, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 出力用GW
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterOutputGatewayList: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/master/output-gateway";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * パトライト型式追加
         * @param {PatliteType} patliteType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterPatliteTypesCreate: function (patliteType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'patliteType' is not null or undefined
                            (0, common_1.assertParamExists)('masterPatliteTypesCreate', 'patliteType', patliteType);
                            localVarPath = "/swc-api/master/patlite-types";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patliteType, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * パトライト型式削除
         * @param {number} id A unique integer value identifying this m_patlite_type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterPatliteTypesDestroy: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterPatliteTypesDestroy', 'id', id);
                            localVarPath = "/swc-api/master/patlite-types/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * パトライト型式一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterPatliteTypesList: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/master/patlite-types";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * パトライト型式更新（一部）
         * @param {number} id A unique integer value identifying this m_patlite_type.
         * @param {PatchedPatliteType} [patchedPatliteType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterPatliteTypesPartialUpdate: function (id, patchedPatliteType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterPatliteTypesPartialUpdate', 'id', id);
                            localVarPath = "/swc-api/master/patlite-types/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchedPatliteType, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * パトライト型式詳細取得
         * @param {number} id A unique integer value identifying this m_patlite_type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterPatliteTypesRetrieve: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterPatliteTypesRetrieve', 'id', id);
                            localVarPath = "/swc-api/master/patlite-types/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * パトライト型式更新
         * @param {number} id A unique integer value identifying this m_patlite_type.
         * @param {PatliteType} patliteType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterPatliteTypesUpdate: function (id, patliteType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterPatliteTypesUpdate', 'id', id);
                            // verify required parameter 'patliteType' is not null or undefined
                            (0, common_1.assertParamExists)('masterPatliteTypesUpdate', 'patliteType', patliteType);
                            localVarPath = "/swc-api/master/patlite-types/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patliteType, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * パトライト追加
         * @param {Patlite} patlite
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterPatlitesCreate: function (patlite, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'patlite' is not null or undefined
                            (0, common_1.assertParamExists)('masterPatlitesCreate', 'patlite', patlite);
                            localVarPath = "/swc-api/master/patlites";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patlite, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * パトライト登録CSVファイルへのバリデーションチェック
         * @param {CsvPatlitValidate} [csvPatlitValidate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterPatlitesCsvCheckValidateCreate: function (csvPatlitValidate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/master/patlites/csv_check_validate";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(csvPatlitValidate, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * パトライト登録CSVを使った一括パトライト登録
         * @param {CsvPatlitCreate} [csvPatlitCreate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterPatlitesCsvPatlitCreateCreate: function (csvPatlitCreate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/master/patlites/csv_patlit_create";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(csvPatlitCreate, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * パトライト削除
         * @param {number} id A unique integer value identifying this m_patlite.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterPatlitesDestroy: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterPatlitesDestroy', 'id', id);
                            localVarPath = "/swc-api/master/patlites/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * パトライト API
         * @param {string} [nodeId] ルート階層
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterPatlitesList: function (nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/master/patlites";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (nodeId !== undefined) {
                                localVarQueryParameter['node_id'] = nodeId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * パトライト更新（一部）
         * @param {number} id A unique integer value identifying this m_patlite.
         * @param {PatchedPatlite} [patchedPatlite]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterPatlitesPartialUpdate: function (id, patchedPatlite, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterPatlitesPartialUpdate', 'id', id);
                            localVarPath = "/swc-api/master/patlites/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchedPatlite, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * パトライト詳細取得
         * @param {number} id A unique integer value identifying this m_patlite.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterPatlitesRetrieve: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterPatlitesRetrieve', 'id', id);
                            localVarPath = "/swc-api/master/patlites/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * パトライト更新
         * @param {number} id A unique integer value identifying this m_patlite.
         * @param {Patlite} patlite
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterPatlitesUpdate: function (id, patlite, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterPatlitesUpdate', 'id', id);
                            // verify required parameter 'patlite' is not null or undefined
                            (0, common_1.assertParamExists)('masterPatlitesUpdate', 'patlite', patlite);
                            localVarPath = "/swc-api/master/patlites/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patlite, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 逆転データ修復 データセット一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterRecreateDataList: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/master/recreate-data";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 逆転データ修復 データ修復ジョブ実行
         * @param {RecreateDataRunJob} recreateDataRunJob
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterRecreateDataRunJobRecreateDataCreate: function (recreateDataRunJob, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'recreateDataRunJob' is not null or undefined
                            (0, common_1.assertParamExists)('masterRecreateDataRunJobRecreateDataCreate', 'recreateDataRunJob', recreateDataRunJob);
                            localVarPath = "/swc-api/master/recreate-data/run_job_recreate_data";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(recreateDataRunJob, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 逆転データ修復 自動修復設定
         * @param {RecreateDataSetAutoDataRecover} recreateDataSetAutoDataRecover
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterRecreateDataSetAutoDataRecoverCreate: function (recreateDataSetAutoDataRecover, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'recreateDataSetAutoDataRecover' is not null or undefined
                            (0, common_1.assertParamExists)('masterRecreateDataSetAutoDataRecoverCreate', 'recreateDataSetAutoDataRecover', recreateDataSetAutoDataRecover);
                            localVarPath = "/swc-api/master/recreate-data/set_auto_data_recover";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(recreateDataSetAutoDataRecover, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {RootNode} rootNode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterRootNodesCreate: function (rootNode, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rootNode' is not null or undefined
                            (0, common_1.assertParamExists)('masterRootNodesCreate', 'rootNode', rootNode);
                            localVarPath = "/swc-api/master/root-nodes";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rootNode, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterRootNodesDestroy: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterRootNodesDestroy', 'id', id);
                            localVarPath = "/swc-api/master/root-nodes/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ルートノード情報一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterRootNodesList: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/master/root-nodes";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {PatchedRootNode} [patchedRootNode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterRootNodesPartialUpdate: function (id, patchedRootNode, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterRootNodesPartialUpdate', 'id', id);
                            localVarPath = "/swc-api/master/root-nodes/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchedRootNode, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterRootNodesRetrieve: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterRootNodesRetrieve', 'id', id);
                            localVarPath = "/swc-api/master/root-nodes/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {RootNode} rootNode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterRootNodesUpdate: function (id, rootNode, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterRootNodesUpdate', 'id', id);
                            // verify required parameter 'rootNode' is not null or undefined
                            (0, common_1.assertParamExists)('masterRootNodesUpdate', 'rootNode', rootNode);
                            localVarPath = "/swc-api/master/root-nodes/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rootNode, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {Setting} setting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterSettingCreate: function (setting, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'setting' is not null or undefined
                            (0, common_1.assertParamExists)('masterSettingCreate', 'setting', setting);
                            localVarPath = "/swc-api/master/setting";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(setting, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterSettingDestroy: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterSettingDestroy', 'id', id);
                            localVarPath = "/swc-api/master/setting/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 環境設定情報一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterSettingList: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/master/setting";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {PatchedSetting} [patchedSetting]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterSettingPartialUpdate: function (id, patchedSetting, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterSettingPartialUpdate', 'id', id);
                            localVarPath = "/swc-api/master/setting/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchedSetting, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 環境設定情報取得
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterSettingRetrieve: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterSettingRetrieve', 'id', id);
                            localVarPath = "/swc-api/master/setting/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {Setting} setting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterSettingUpdate: function (id, setting, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterSettingUpdate', 'id', id);
                            // verify required parameter 'setting' is not null or undefined
                            (0, common_1.assertParamExists)('masterSettingUpdate', 'setting', setting);
                            localVarPath = "/swc-api/master/setting/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(setting, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {SimpleNode} simpleNode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterSimpleNodesCreate: function (simpleNode, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'simpleNode' is not null or undefined
                            (0, common_1.assertParamExists)('masterSimpleNodesCreate', 'simpleNode', simpleNode);
                            localVarPath = "/swc-api/master/simple-nodes";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(simpleNode, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterSimpleNodesDestroy: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterSimpleNodesDestroy', 'id', id);
                            localVarPath = "/swc-api/master/simple-nodes/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ユーザーノード情報一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterSimpleNodesList: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/master/simple-nodes";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {PatchedSimpleNode} [patchedSimpleNode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterSimpleNodesPartialUpdate: function (id, patchedSimpleNode, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterSimpleNodesPartialUpdate', 'id', id);
                            localVarPath = "/swc-api/master/simple-nodes/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchedSimpleNode, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterSimpleNodesRetrieve: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterSimpleNodesRetrieve', 'id', id);
                            localVarPath = "/swc-api/master/simple-nodes/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {SimpleNode} simpleNode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterSimpleNodesUpdate: function (id, simpleNode, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterSimpleNodesUpdate', 'id', id);
                            // verify required parameter 'simpleNode' is not null or undefined
                            (0, common_1.assertParamExists)('masterSimpleNodesUpdate', 'simpleNode', simpleNode);
                            localVarPath = "/swc-api/master/simple-nodes/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(simpleNode, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * トレンドグラフ設定追加
         * @param {number} nodeId 設備ID
         * @param {TrendGraphSetting} trendGraphSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterTrendGraphSettingsCreate: function (nodeId, trendGraphSetting, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('masterTrendGraphSettingsCreate', 'nodeId', nodeId);
                            // verify required parameter 'trendGraphSetting' is not null or undefined
                            (0, common_1.assertParamExists)('masterTrendGraphSettingsCreate', 'trendGraphSetting', trendGraphSetting);
                            localVarPath = "/swc-api/master/trend-graph-settings";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (nodeId !== undefined) {
                                localVarQueryParameter['node_id'] = nodeId;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(trendGraphSetting, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * トレンドグラフ設定削除
         * @param {number} id A unique integer value identifying this m_trend_graph_setting.
         * @param {number} nodeId 設備ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterTrendGraphSettingsDestroy: function (id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterTrendGraphSettingsDestroy', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('masterTrendGraphSettingsDestroy', 'nodeId', nodeId);
                            localVarPath = "/swc-api/master/trend-graph-settings/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (nodeId !== undefined) {
                                localVarQueryParameter['node_id'] = nodeId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * トレンドグラフ設定一覧
         * @param {number} nodeId 設備ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterTrendGraphSettingsList: function (nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('masterTrendGraphSettingsList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/master/trend-graph-settings";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (nodeId !== undefined) {
                                localVarQueryParameter['node_id'] = nodeId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this m_trend_graph_setting.
         * @param {PatchedTrendGraphSetting} [patchedTrendGraphSetting]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterTrendGraphSettingsPartialUpdate: function (id, patchedTrendGraphSetting, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterTrendGraphSettingsPartialUpdate', 'id', id);
                            localVarPath = "/swc-api/master/trend-graph-settings/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchedTrendGraphSetting, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * トレンドグラフ設定詳細取得
         * @param {number} id A unique integer value identifying this m_trend_graph_setting.
         * @param {number} nodeId 設備ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterTrendGraphSettingsRetrieve: function (id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterTrendGraphSettingsRetrieve', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('masterTrendGraphSettingsRetrieve', 'nodeId', nodeId);
                            localVarPath = "/swc-api/master/trend-graph-settings/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (nodeId !== undefined) {
                                localVarQueryParameter['node_id'] = nodeId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * トレンドグラフ設定更新
         * @param {number} id A unique integer value identifying this m_trend_graph_setting.
         * @param {number} nodeId 設備ID
         * @param {TrendGraphSetting} trendGraphSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterTrendGraphSettingsUpdate: function (id, nodeId, trendGraphSetting, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterTrendGraphSettingsUpdate', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('masterTrendGraphSettingsUpdate', 'nodeId', nodeId);
                            // verify required parameter 'trendGraphSetting' is not null or undefined
                            (0, common_1.assertParamExists)('masterTrendGraphSettingsUpdate', 'trendGraphSetting', trendGraphSetting);
                            localVarPath = "/swc-api/master/trend-graph-settings/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (nodeId !== undefined) {
                                localVarQueryParameter['node_id'] = nodeId;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(trendGraphSetting, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {UserNode} userNode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeMenuCreate: function (userNode, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'userNode' is not null or undefined
                            (0, common_1.assertParamExists)('masterUserNodeMenuCreate', 'userNode', userNode);
                            localVarPath = "/swc-api/master/user-node-menu";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(userNode, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this m_user_node.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeMenuDestroy: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterUserNodeMenuDestroy', 'id', id);
                            localVarPath = "/swc-api/master/user-node-menu/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeMenuList: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/master/user-node-menu";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this m_user_node.
         * @param {PatchedUserNode} [patchedUserNode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeMenuPartialUpdate: function (id, patchedUserNode, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterUserNodeMenuPartialUpdate', 'id', id);
                            localVarPath = "/swc-api/master/user-node-menu/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchedUserNode, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ユーザノードメニュー情報詳細取得
         * @param {number} id A unique integer value identifying this m_user_node.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeMenuRetrieve: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterUserNodeMenuRetrieve', 'id', id);
                            localVarPath = "/swc-api/master/user-node-menu/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ユーザノードメニュー設定情報更新
         * @param {number} id A unique integer value identifying this m_user_node.
         * @param {UserNode} userNode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeMenuUpdate: function (id, userNode, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterUserNodeMenuUpdate', 'id', id);
                            // verify required parameter 'userNode' is not null or undefined
                            (0, common_1.assertParamExists)('masterUserNodeMenuUpdate', 'userNode', userNode);
                            localVarPath = "/swc-api/master/user-node-menu/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(userNode, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ユーザノードロール情報追加
         * @param {UserNodeRole} userNodeRole
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeRolesCreate: function (userNodeRole, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'userNodeRole' is not null or undefined
                            (0, common_1.assertParamExists)('masterUserNodeRolesCreate', 'userNodeRole', userNodeRole);
                            localVarPath = "/swc-api/master/user-node-roles";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(userNodeRole, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ユーザノードロール情報削除
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeRolesDestroy: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterUserNodeRolesDestroy', 'id', id);
                            localVarPath = "/swc-api/master/user-node-roles/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ユーザノードロール情報一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeRolesList: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/master/user-node-roles";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ユーザノードロール情報更新（一部）
         * @param {string} id
         * @param {PatchedUserNodeRole} [patchedUserNodeRole]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeRolesPartialUpdate: function (id, patchedUserNodeRole, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterUserNodeRolesPartialUpdate', 'id', id);
                            localVarPath = "/swc-api/master/user-node-roles/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchedUserNodeRole, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ユーザノードロール情報詳細取得
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeRolesRetrieve: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterUserNodeRolesRetrieve', 'id', id);
                            localVarPath = "/swc-api/master/user-node-roles/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ユーザノードロール情報更新
         * @param {string} id
         * @param {UserNodeRole} userNodeRole
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeRolesUpdate: function (id, userNodeRole, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterUserNodeRolesUpdate', 'id', id);
                            // verify required parameter 'userNodeRole' is not null or undefined
                            (0, common_1.assertParamExists)('masterUserNodeRolesUpdate', 'userNodeRole', userNodeRole);
                            localVarPath = "/swc-api/master/user-node-roles/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(userNodeRole, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ユーザー・ノード設定追加
         * @param {number} nodeId 設備ID
         * @param {UserNodeSetting} userNodeSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeSettingsCreate: function (nodeId, userNodeSetting, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('masterUserNodeSettingsCreate', 'nodeId', nodeId);
                            // verify required parameter 'userNodeSetting' is not null or undefined
                            (0, common_1.assertParamExists)('masterUserNodeSettingsCreate', 'userNodeSetting', userNodeSetting);
                            localVarPath = "/swc-api/master/user-node-settings";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (nodeId !== undefined) {
                                localVarQueryParameter['node_id'] = nodeId;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(userNodeSetting, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ユーザー・ノード設定削除
         * @param {number} id A unique integer value identifying this m_user_node_setting.
         * @param {number} nodeId 設備ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeSettingsDestroy: function (id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterUserNodeSettingsDestroy', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('masterUserNodeSettingsDestroy', 'nodeId', nodeId);
                            localVarPath = "/swc-api/master/user-node-settings/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (nodeId !== undefined) {
                                localVarQueryParameter['node_id'] = nodeId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ユーザー・ノード設定一覧
         * @param {number} nodeId 設備ID
         * @param {number} userId ユーザID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeSettingsList: function (nodeId, userId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('masterUserNodeSettingsList', 'nodeId', nodeId);
                            // verify required parameter 'userId' is not null or undefined
                            (0, common_1.assertParamExists)('masterUserNodeSettingsList', 'userId', userId);
                            localVarPath = "/swc-api/master/user-node-settings";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (nodeId !== undefined) {
                                localVarQueryParameter['node_id'] = nodeId;
                            }
                            if (userId !== undefined) {
                                localVarQueryParameter['user_id'] = userId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ユーザー・ノード設定更新（一部）
         * @param {number} id A unique integer value identifying this m_user_node_setting.
         * @param {number} nodeId 設備ID
         * @param {PatchedUserNodeSetting} [patchedUserNodeSetting]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeSettingsPartialUpdate: function (id, nodeId, patchedUserNodeSetting, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterUserNodeSettingsPartialUpdate', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('masterUserNodeSettingsPartialUpdate', 'nodeId', nodeId);
                            localVarPath = "/swc-api/master/user-node-settings/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (nodeId !== undefined) {
                                localVarQueryParameter['node_id'] = nodeId;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchedUserNodeSetting, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ユーザー・ノード設定詳細取得
         * @param {number} id A unique integer value identifying this m_user_node_setting.
         * @param {number} nodeId 設備ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeSettingsRetrieve: function (id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterUserNodeSettingsRetrieve', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('masterUserNodeSettingsRetrieve', 'nodeId', nodeId);
                            localVarPath = "/swc-api/master/user-node-settings/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (nodeId !== undefined) {
                                localVarQueryParameter['node_id'] = nodeId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ユーザー・ノード設定更新
         * @param {number} id A unique integer value identifying this m_user_node_setting.
         * @param {number} nodeId 設備ID
         * @param {UserNodeSetting} userNodeSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeSettingsUpdate: function (id, nodeId, userNodeSetting, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterUserNodeSettingsUpdate', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('masterUserNodeSettingsUpdate', 'nodeId', nodeId);
                            // verify required parameter 'userNodeSetting' is not null or undefined
                            (0, common_1.assertParamExists)('masterUserNodeSettingsUpdate', 'userNodeSetting', userNodeSetting);
                            localVarPath = "/swc-api/master/user-node-settings/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (nodeId !== undefined) {
                                localVarQueryParameter['node_id'] = nodeId;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(userNodeSetting, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ユーザノード情報追加
         * @param {SimpleNode} simpleNode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodesCreate: function (simpleNode, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'simpleNode' is not null or undefined
                            (0, common_1.assertParamExists)('masterUserNodesCreate', 'simpleNode', simpleNode);
                            localVarPath = "/swc-api/master/user-nodes";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(simpleNode, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ユーザノード情報削除
         * @param {number} id A unique integer value identifying this m_user_node.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodesDestroy: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterUserNodesDestroy', 'id', id);
                            localVarPath = "/swc-api/master/user-nodes/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ユーザノード情報一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodesList: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/master/user-nodes";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ユーザノード情報更新（一部）
         * @param {number} id A unique integer value identifying this m_user_node.
         * @param {PatchedSimpleNode} [patchedSimpleNode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodesPartialUpdate: function (id, patchedSimpleNode, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterUserNodesPartialUpdate', 'id', id);
                            localVarPath = "/swc-api/master/user-nodes/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchedSimpleNode, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ユーザノード情報詳細取得
         * @param {number} id A unique integer value identifying this m_user_node.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodesRetrieve: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterUserNodesRetrieve', 'id', id);
                            localVarPath = "/swc-api/master/user-nodes/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ユーザノード情報更新
         * @param {number} id A unique integer value identifying this m_user_node.
         * @param {SimpleNode} simpleNode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodesUpdate: function (id, simpleNode, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterUserNodesUpdate', 'id', id);
                            // verify required parameter 'simpleNode' is not null or undefined
                            (0, common_1.assertParamExists)('masterUserNodesUpdate', 'simpleNode', simpleNode);
                            localVarPath = "/swc-api/master/user-nodes/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(simpleNode, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ユーザロール情報追加
         * @param {UserRole} userRole
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserRolesCreate: function (userRole, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'userRole' is not null or undefined
                            (0, common_1.assertParamExists)('masterUserRolesCreate', 'userRole', userRole);
                            localVarPath = "/swc-api/master/user-roles";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(userRole, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ユーザロール情報削除
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserRolesDestroy: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterUserRolesDestroy', 'id', id);
                            localVarPath = "/swc-api/master/user-roles/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ユーザロール情報一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserRolesList: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/master/user-roles";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ユーザロール情報更新（一部）
         * @param {string} id
         * @param {PatchedUserRole} [patchedUserRole]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserRolesPartialUpdate: function (id, patchedUserRole, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterUserRolesPartialUpdate', 'id', id);
                            localVarPath = "/swc-api/master/user-roles/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchedUserRole, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ユーザロール情報詳細取得
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserRolesRetrieve: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterUserRolesRetrieve', 'id', id);
                            localVarPath = "/swc-api/master/user-roles/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ユーザロール情報更新
         * @param {string} id
         * @param {UserRole} userRole
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserRolesUpdate: function (id, userRole, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterUserRolesUpdate', 'id', id);
                            // verify required parameter 'userRole' is not null or undefined
                            (0, common_1.assertParamExists)('masterUserRolesUpdate', 'userRole', userRole);
                            localVarPath = "/swc-api/master/user-roles/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(userRole, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ユーザ情報追加
         * @param {User} user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUsersCreate: function (user, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'user' is not null or undefined
                            (0, common_1.assertParamExists)('masterUsersCreate', 'user', user);
                            localVarPath = "/swc-api/master/users";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(user, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ユーザー登録CSVファイルへのバリデーションチェック
         * @param {CsvUserValidate} [csvUserValidate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUsersCsvCheckValidateCreate: function (csvUserValidate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/master/users/csv_check_validate";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(csvUserValidate, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ユーザー登録CSVを使った一括ユーザー登録
         * @param {CsvUserCreate} [csvUserCreate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUsersCsvUserCreateCreate: function (csvUserCreate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/master/users/csv_user_create";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(csvUserCreate, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ユーザ情報削除
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUsersDestroy: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterUsersDestroy', 'id', id);
                            localVarPath = "/swc-api/master/users/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ユーザ情報一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUsersList: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/master/users";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ユーザ情報更新（一部）
         * @param {string} id
         * @param {PatchedUser} [patchedUser]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUsersPartialUpdate: function (id, patchedUser, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterUsersPartialUpdate', 'id', id);
                            localVarPath = "/swc-api/master/users/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchedUser, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ユーザ情報詳細取得
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUsersRetrieve: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterUsersRetrieve', 'id', id);
                            localVarPath = "/swc-api/master/users/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ユーザ情報更新
         * @param {string} id
         * @param {User} user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUsersUpdate: function (id, user, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('masterUsersUpdate', 'id', id);
                            // verify required parameter 'user' is not null or undefined
                            (0, common_1.assertParamExists)('masterUsersUpdate', 'user', user);
                            localVarPath = "/swc-api/master/users/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(user, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.MasterApiAxiosParamCreator = MasterApiAxiosParamCreator;
/**
 * MasterApi - functional programming interface
 * @export
 */
var MasterApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.MasterApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {AnnouncementLevel} announcementLevel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementLevelCreate: function (announcementLevel, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterAnnouncementLevelCreate(announcementLevel, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this m_announcement_level.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementLevelDestroy: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterAnnouncementLevelDestroy(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementLevelList: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterAnnouncementLevelList(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this m_announcement_level.
         * @param {PatchedAnnouncementLevel} [patchedAnnouncementLevel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementLevelPartialUpdate: function (id, patchedAnnouncementLevel, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterAnnouncementLevelPartialUpdate(id, patchedAnnouncementLevel, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this m_announcement_level.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementLevelRetrieve: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterAnnouncementLevelRetrieve(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this m_announcement_level.
         * @param {AnnouncementLevel} announcementLevel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementLevelUpdate: function (id, announcementLevel, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterAnnouncementLevelUpdate(id, announcementLevel, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {AnnouncementMaster} announcementMaster
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementLoginCreate: function (announcementMaster, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterAnnouncementLoginCreate(announcementMaster, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementLoginDestroy: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterAnnouncementLoginDestroy(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ログイン画面用お知らせマスタ情報一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementLoginList: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterAnnouncementLoginList(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {PatchedAnnouncementMaster} [patchedAnnouncementMaster]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementLoginPartialUpdate: function (id, patchedAnnouncementMaster, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterAnnouncementLoginPartialUpdate(id, patchedAnnouncementMaster, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementLoginRetrieve: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterAnnouncementLoginRetrieve(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {AnnouncementMaster} announcementMaster
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementLoginUpdate: function (id, announcementMaster, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterAnnouncementLoginUpdate(id, announcementMaster, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * お知らせマスタ情報追加
         * @param {AnnouncementMaster} announcementMaster
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementMasterCreate: function (announcementMaster, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterAnnouncementMasterCreate(announcementMaster, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * お知らせマスタ情報削除
         * @param {number} id A unique integer value identifying this m_announcement_master.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementMasterDestroy: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterAnnouncementMasterDestroy(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * お知らせマスタ情報一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementMasterList: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterAnnouncementMasterList(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * お知らせマスタ情報更新（一部）
         * @param {number} id A unique integer value identifying this m_announcement_master.
         * @param {PatchedAnnouncementMaster} [patchedAnnouncementMaster]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementMasterPartialUpdate: function (id, patchedAnnouncementMaster, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterAnnouncementMasterPartialUpdate(id, patchedAnnouncementMaster, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * お知らせマスタ情報詳細取得
         * @param {number} id A unique integer value identifying this m_announcement_master.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementMasterRetrieve: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterAnnouncementMasterRetrieve(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * お知らせマスタ情報更新
         * @param {number} id A unique integer value identifying this m_announcement_master.
         * @param {AnnouncementMaster} announcementMaster
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementMasterUpdate: function (id, announcementMaster, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterAnnouncementMasterUpdate(id, announcementMaster, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {AnnouncementType} announcementType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementTypeCreate: function (announcementType, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterAnnouncementTypeCreate(announcementType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this m_announcement_type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementTypeDestroy: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterAnnouncementTypeDestroy(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementTypeList: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterAnnouncementTypeList(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this m_announcement_type.
         * @param {PatchedAnnouncementType} [patchedAnnouncementType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementTypePartialUpdate: function (id, patchedAnnouncementType, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterAnnouncementTypePartialUpdate(id, patchedAnnouncementType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this m_announcement_type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementTypeRetrieve: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterAnnouncementTypeRetrieve(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this m_announcement_type.
         * @param {AnnouncementType} announcementType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementTypeUpdate: function (id, announcementType, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterAnnouncementTypeUpdate(id, announcementType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * お知らせユーザー情報追加
         * @param {AnnouncementUserRequest} announcementUserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementUserCreate: function (announcementUserRequest, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterAnnouncementUserCreate(announcementUserRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * お知らせユーザー情報削除
         * @param {number} id A unique integer value identifying this m_announcement_user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementUserDestroy: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterAnnouncementUserDestroy(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * お知らせユーザー情報一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementUserList: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterAnnouncementUserList(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * お知らせユーザー情報更新（一部）
         * @param {number} id A unique integer value identifying this m_announcement_user.
         * @param {PatchedAnnouncementUser} [patchedAnnouncementUser]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementUserPartialUpdate: function (id, patchedAnnouncementUser, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterAnnouncementUserPartialUpdate(id, patchedAnnouncementUser, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * お知らせユーザー情報詳細取得
         * @param {number} id A unique integer value identifying this m_announcement_user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementUserRetrieve: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterAnnouncementUserRetrieve(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * お知らせユーザー情報更新
         * @param {number} id A unique integer value identifying this m_announcement_user.
         * @param {AnnouncementUser} announcementUser
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementUserUpdate: function (id, announcementUser, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterAnnouncementUserUpdate(id, announcementUser, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * バッチ演算設定追加
         * @param {BatchCalculationSetting} batchCalculationSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCalculationSettingsCreate: function (batchCalculationSetting, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterCalculationSettingsCreate(batchCalculationSetting, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * バッチ演算設定削除
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCalculationSettingsDestroy: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterCalculationSettingsDestroy(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * バッチ演算設定一覧取得
         * @param {number} [facilityGroupCode] 設備グループコード
         * @param {number} [plantId] 設備ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCalculationSettingsList: function (facilityGroupCode, plantId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterCalculationSettingsList(facilityGroupCode, plantId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * バッチ演算設定更新（一部）
         * @param {string} id
         * @param {PatchedBatchCalculationSetting} [patchedBatchCalculationSetting]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCalculationSettingsPartialUpdate: function (id, patchedBatchCalculationSetting, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterCalculationSettingsPartialUpdate(id, patchedBatchCalculationSetting, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * バッチ演算設定詳細取得
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCalculationSettingsRetrieve: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterCalculationSettingsRetrieve(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * バッチ演算設定更新
         * @param {string} id
         * @param {BatchCalculationSetting} batchCalculationSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCalculationSettingsUpdate: function (id, batchCalculationSetting, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterCalculationSettingsUpdate(id, batchCalculationSetting, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * カメラ型式追加
         * @param {CameraType} cameraType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCameraTypesCreate: function (cameraType, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterCameraTypesCreate(cameraType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * カメラ型式削除
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCameraTypesDestroy: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterCameraTypesDestroy(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * カメラ型式一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCameraTypesList: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterCameraTypesList(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {PatchedCameraType} [patchedCameraType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCameraTypesPartialUpdate: function (id, patchedCameraType, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterCameraTypesPartialUpdate(id, patchedCameraType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * カメラ型式詳細取得
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCameraTypesRetrieve: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterCameraTypesRetrieve(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {CameraType} cameraType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCameraTypesUpdate: function (id, cameraType, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterCameraTypesUpdate(id, cameraType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * カメラ追加
         * @param {CameraCreate} cameraCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCamerasCreate: function (cameraCreate, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterCamerasCreate(cameraCreate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * カメラ登録CSVを使った一括カメラ登録
         * @param {CsvUserCreate} [csvUserCreate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCamerasCsvCameraCreateCreate: function (csvUserCreate, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterCamerasCsvCameraCreateCreate(csvUserCreate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * カメラ登録CSVファイルへのバリデーションチェック
         * @param {CsvUserValidate} [csvUserValidate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCamerasCsvCheckValidateCreate: function (csvUserValidate, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterCamerasCsvCheckValidateCreate(csvUserValidate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * カメラ削除
         * @param {number} id A unique integer value identifying this m_camera.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCamerasDestroy: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterCamerasDestroy(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * カメラ一覧取得
         * @param {boolean} [includeDeploymentInfo] モデル一覧と一緒にデプロイ情報も取得するかどうか
         * @param {string} [nodeId] 階層ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCamerasList: function (includeDeploymentInfo, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterCamerasList(includeDeploymentInfo, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * カメラ更新（一部）
         * @param {number} id A unique integer value identifying this m_camera.
         * @param {PatchedCamera} [patchedCamera]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCamerasPartialUpdate: function (id, patchedCamera, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterCamerasPartialUpdate(id, patchedCamera, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * カメラ詳細取得
         * @param {number} id A unique integer value identifying this m_camera.
         * @param {boolean} [includeModelBuildCounts] 今月のモデルビルド数も合わせて取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCamerasRetrieve: function (id, includeModelBuildCounts, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterCamerasRetrieve(id, includeModelBuildCounts, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * カメラ更新
         * @param {number} id A unique integer value identifying this m_camera.
         * @param {CameraCreate} cameraCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCamerasUpdate: function (id, cameraCreate, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterCamerasUpdate(id, cameraCreate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {CustomerType} customerType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCustomerTypesCreate: function (customerType, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterCustomerTypesCreate(customerType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCustomerTypesDestroy: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterCustomerTypesDestroy(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCustomerTypesList: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterCustomerTypesList(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {PatchedCustomerType} [patchedCustomerType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCustomerTypesPartialUpdate: function (id, patchedCustomerType, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterCustomerTypesPartialUpdate(id, patchedCustomerType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCustomerTypesRetrieve: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterCustomerTypesRetrieve(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {CustomerType} customerType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCustomerTypesUpdate: function (id, customerType, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterCustomerTypesUpdate(id, customerType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * デプロイコンポーネント設定追加
         * @param {DeploymentComponent} deploymentComponent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterDeployComponentsCreate: function (deploymentComponent, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterDeployComponentsCreate(deploymentComponent, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * デプロイコンポーネント設定削除
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterDeployComponentsDestroy: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterDeployComponentsDestroy(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * デプロイコンポーネント設定一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterDeployComponentsList: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterDeployComponentsList(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * デプロイコンポーネント設定更新（一部）
         * @param {string} id
         * @param {PatchedDeploymentComponent} [patchedDeploymentComponent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterDeployComponentsPartialUpdate: function (id, patchedDeploymentComponent, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterDeployComponentsPartialUpdate(id, patchedDeploymentComponent, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * デプロイコンポーネント設定詳細取得
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterDeployComponentsRetrieve: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterDeployComponentsRetrieve(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * デプロイコンポーネント設定更新
         * @param {string} id
         * @param {DeploymentComponent} deploymentComponent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterDeployComponentsUpdate: function (id, deploymentComponent, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterDeployComponentsUpdate(id, deploymentComponent, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * デバイス設定追加
         * @param {Device} device
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterDevicesCreate: function (device, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterDevicesCreate(device, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * デバイス設定削除
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterDevicesDestroy: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterDevicesDestroy(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * デバイス設定一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterDevicesList: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterDevicesList(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * デバイス設定更新（一部）
         * @param {string} id
         * @param {PatchedDevice} [patchedDevice]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterDevicesPartialUpdate: function (id, patchedDevice, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterDevicesPartialUpdate(id, patchedDevice, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * デバイス設定詳細取得
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterDevicesRetrieve: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterDevicesRetrieve(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * デバイス設定更新
         * @param {string} id
         * @param {Device} device
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterDevicesUpdate: function (id, device, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterDevicesUpdate(id, device, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 外部出力作成
         * @param {ExternalOutputInfoRequest} externalOutputInfoRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterExternalOutputInfoCreate: function (externalOutputInfoRequest, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterExternalOutputInfoCreate(externalOutputInfoRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 外部出力削除
         * @param {string} id データセットID
         * @param {number} nodeId 階層 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterExternalOutputInfoDestroy: function (id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterExternalOutputInfoDestroy(id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 外部出力一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterExternalOutputInfoList: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterExternalOutputInfoList(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 外部出力更新
         * @param {string} id
         * @param {ExternalOutputInfoRequest} externalOutputInfoRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterExternalOutputInfoUpdate: function (id, externalOutputInfoRequest, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterExternalOutputInfoUpdate(id, externalOutputInfoRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 設備グループ情報追加
         * @param {FacilityGroup} facilityGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterFacilityGroupsCreate: function (facilityGroup, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterFacilityGroupsCreate(facilityGroup, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 設備グループ情報削除
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterFacilityGroupsDestroy: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterFacilityGroupsDestroy(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 設備グループ情報一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterFacilityGroupsList: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterFacilityGroupsList(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 設備グループ情報更新（一部）
         * @param {string} id
         * @param {PatchedFacilityGroup} [patchedFacilityGroup]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterFacilityGroupsPartialUpdate: function (id, patchedFacilityGroup, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterFacilityGroupsPartialUpdate(id, patchedFacilityGroup, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 設備グループ情報詳細取得
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterFacilityGroupsRetrieve: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterFacilityGroupsRetrieve(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 設備グループ情報更新
         * @param {string} id
         * @param {FacilityGroup} facilityGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterFacilityGroupsUpdate: function (id, facilityGroup, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterFacilityGroupsUpdate(id, facilityGroup, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Upload IF
         * @param {GatewayIFUploadRequest} gatewayIFUploadRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterGatewayIfCreate: function (gatewayIFUploadRequest, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterGatewayIfCreate(gatewayIFUploadRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * フォーマットダウンロード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterGatewayIfDownloadFormatRetrieve: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterGatewayIfDownloadFormatRetrieve(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * IFファイルダウンロード
         * @param {string} [s3Key] S3 Key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterGatewayIfDownloadIfRetrieve: function (s3Key, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterGatewayIfDownloadIfRetrieve(s3Key, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Gateway変換設定 API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterGatewayIfList: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterGatewayIfList(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Validation IF
         * @param {string} id
         * @param {GatewayIFValidationRequest} gatewayIFValidationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterGatewayIfValidationCreate: function (id, gatewayIFValidationRequest, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterGatewayIfValidationCreate(id, gatewayIFValidationRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 業種区分情報追加
         * @param {IndustryType} industryType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterIndustryTypesCreate: function (industryType, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterIndustryTypesCreate(industryType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 業種区分情報削除
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterIndustryTypesDestroy: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterIndustryTypesDestroy(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 業種区分一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterIndustryTypesList: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterIndustryTypesList(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 業種区分情報更新（一部）
         * @param {string} id
         * @param {PatchedIndustryType} [patchedIndustryType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterIndustryTypesPartialUpdate: function (id, patchedIndustryType, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterIndustryTypesPartialUpdate(id, patchedIndustryType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 業種区分情報詳細取得
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterIndustryTypesRetrieve: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterIndustryTypesRetrieve(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 業種区分情報更新
         * @param {string} id
         * @param {IndustryType} industryType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterIndustryTypesUpdate: function (id, industryType, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterIndustryTypesUpdate(id, industryType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * マイダッシュボード設定追加
         * @param {number} nodeId 設備ID
         * @param {MyDashboardSetting} myDashboardSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyDashboardSettingsCreate: function (nodeId, myDashboardSetting, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterMyDashboardSettingsCreate(nodeId, myDashboardSetting, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * マイダッシュボード設定削除
         * @param {number} id A unique integer value identifying this m_my_dashboard_setting.
         * @param {number} nodeId 設備ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyDashboardSettingsDestroy: function (id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterMyDashboardSettingsDestroy(id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * マイダッシュボード設定一覧
         * @param {number} nodeId 設備ID
         * @param {number} userId ユーザID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyDashboardSettingsList: function (nodeId, userId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterMyDashboardSettingsList(nodeId, userId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * マイダッシュボード設定更新（一部）
         * @param {number} id A unique integer value identifying this m_my_dashboard_setting.
         * @param {number} nodeId 設備ID
         * @param {PatchedMyDashboardSetting} [patchedMyDashboardSetting]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyDashboardSettingsPartialUpdate: function (id, nodeId, patchedMyDashboardSetting, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterMyDashboardSettingsPartialUpdate(id, nodeId, patchedMyDashboardSetting, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * マイダッシュボード設定詳細取得
         * @param {number} id A unique integer value identifying this m_my_dashboard_setting.
         * @param {number} nodeId 設備ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyDashboardSettingsRetrieve: function (id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterMyDashboardSettingsRetrieve(id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * マイダッシュボード設定更新
         * @param {number} id A unique integer value identifying this m_my_dashboard_setting.
         * @param {number} nodeId 設備ID
         * @param {MyDashboardSetting} myDashboardSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyDashboardSettingsUpdate: function (id, nodeId, myDashboardSetting, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterMyDashboardSettingsUpdate(id, nodeId, myDashboardSetting, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * マイ長期トレンド設定追加
         * @param {number} nodeId 設備ID
         * @param {MyLongTermTrendSetting} myLongTermTrendSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyLongTermTrendSettingsCreate: function (nodeId, myLongTermTrendSetting, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterMyLongTermTrendSettingsCreate(nodeId, myLongTermTrendSetting, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * マイ長期トレンド設定削除
         * @param {number} id A unique integer value identifying this m_my_long_term_trend_setting.
         * @param {number} nodeId 設備ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyLongTermTrendSettingsDestroy: function (id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterMyLongTermTrendSettingsDestroy(id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * マイ長期トレンド設定一覧
         * @param {number} nodeId 設備ID
         * @param {number} userId ユーザID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyLongTermTrendSettingsList: function (nodeId, userId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterMyLongTermTrendSettingsList(nodeId, userId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * マイ長期トレンド設定更新（一部）
         * @param {number} id A unique integer value identifying this m_my_long_term_trend_setting.
         * @param {number} nodeId 設備ID
         * @param {PatchedMyLongTermTrendSetting} [patchedMyLongTermTrendSetting]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyLongTermTrendSettingsPartialUpdate: function (id, nodeId, patchedMyLongTermTrendSetting, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterMyLongTermTrendSettingsPartialUpdate(id, nodeId, patchedMyLongTermTrendSetting, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * マイ長期トレンド設定詳細取得
         * @param {number} id A unique integer value identifying this m_my_long_term_trend_setting.
         * @param {number} nodeId 設備ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyLongTermTrendSettingsRetrieve: function (id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterMyLongTermTrendSettingsRetrieve(id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * マイ長期トレンド設定更新
         * @param {number} id A unique integer value identifying this m_my_long_term_trend_setting.
         * @param {number} nodeId 設備ID
         * @param {MyLongTermTrendSetting} myLongTermTrendSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyLongTermTrendSettingsUpdate: function (id, nodeId, myLongTermTrendSetting, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterMyLongTermTrendSettingsUpdate(id, nodeId, myLongTermTrendSetting, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 統計データ分析設定追加
         * @param {number} nodeId 階層ID
         * @param {MyScatterSetting} myScatterSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyScatterSettingsCreate: function (nodeId, myScatterSetting, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterMyScatterSettingsCreate(nodeId, myScatterSetting, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 統計データ分析設定削除
         * @param {number} id A unique integer value identifying this m_my_scatter_setting.
         * @param {number} nodeId 階層ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyScatterSettingsDestroy: function (id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterMyScatterSettingsDestroy(id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 統計データ分析設定一覧
         * @param {number} nodeId 階層ID
         * @param {number} userId ユーザID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyScatterSettingsList: function (nodeId, userId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterMyScatterSettingsList(nodeId, userId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 統計データ分析設定更新（一部）
         * @param {number} id A unique integer value identifying this m_my_scatter_setting.
         * @param {number} nodeId 階層ID
         * @param {PatchedMyScatterSetting} [patchedMyScatterSetting]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyScatterSettingsPartialUpdate: function (id, nodeId, patchedMyScatterSetting, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterMyScatterSettingsPartialUpdate(id, nodeId, patchedMyScatterSetting, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 統計データ分析設定詳細取得
         * @param {number} id A unique integer value identifying this m_my_scatter_setting.
         * @param {number} nodeId 階層ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyScatterSettingsRetrieve: function (id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterMyScatterSettingsRetrieve(id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 統計データ分析設定更新
         * @param {number} id A unique integer value identifying this m_my_scatter_setting.
         * @param {number} nodeId 階層ID
         * @param {MyScatterSetting} myScatterSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyScatterSettingsUpdate: function (id, nodeId, myScatterSetting, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterMyScatterSettingsUpdate(id, nodeId, myScatterSetting, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ノード情報追加
         * @param {Node} node
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterNodesCreate: function (node, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterNodesCreate(node, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ノード情報削除
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterNodesDestroy: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterNodesDestroy(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ノード情報一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterNodesList: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterNodesList(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ノード情報更新（一部）
         * @param {string} id
         * @param {PatchedNode} [patchedNode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterNodesPartialUpdate: function (id, patchedNode, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterNodesPartialUpdate(id, patchedNode, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ノード情報詳細取得
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterNodesRetrieve: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterNodesRetrieve(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ノード情報更新
         * @param {string} id
         * @param {Node} node
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterNodesUpdate: function (id, node, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterNodesUpdate(id, node, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 組織情報追加
         * @param {Organization} organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterOrganizationsCreate: function (organization, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterOrganizationsCreate(organization, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 組織情報削除
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterOrganizationsDestroy: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterOrganizationsDestroy(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 組織情報一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterOrganizationsList: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterOrganizationsList(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 組織情報更新（一部）
         * @param {string} id
         * @param {PatchedOrganization} [patchedOrganization]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterOrganizationsPartialUpdate: function (id, patchedOrganization, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterOrganizationsPartialUpdate(id, patchedOrganization, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 組織情報詳細取得
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterOrganizationsRetrieve: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterOrganizationsRetrieve(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 組織情報更新
         * @param {string} id
         * @param {Organization} organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterOrganizationsUpdate: function (id, organization, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterOrganizationsUpdate(id, organization, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 出力用GW
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterOutputGatewayList: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterOutputGatewayList(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * パトライト型式追加
         * @param {PatliteType} patliteType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterPatliteTypesCreate: function (patliteType, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterPatliteTypesCreate(patliteType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * パトライト型式削除
         * @param {number} id A unique integer value identifying this m_patlite_type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterPatliteTypesDestroy: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterPatliteTypesDestroy(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * パトライト型式一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterPatliteTypesList: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterPatliteTypesList(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * パトライト型式更新（一部）
         * @param {number} id A unique integer value identifying this m_patlite_type.
         * @param {PatchedPatliteType} [patchedPatliteType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterPatliteTypesPartialUpdate: function (id, patchedPatliteType, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterPatliteTypesPartialUpdate(id, patchedPatliteType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * パトライト型式詳細取得
         * @param {number} id A unique integer value identifying this m_patlite_type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterPatliteTypesRetrieve: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterPatliteTypesRetrieve(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * パトライト型式更新
         * @param {number} id A unique integer value identifying this m_patlite_type.
         * @param {PatliteType} patliteType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterPatliteTypesUpdate: function (id, patliteType, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterPatliteTypesUpdate(id, patliteType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * パトライト追加
         * @param {Patlite} patlite
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterPatlitesCreate: function (patlite, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterPatlitesCreate(patlite, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * パトライト登録CSVファイルへのバリデーションチェック
         * @param {CsvPatlitValidate} [csvPatlitValidate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterPatlitesCsvCheckValidateCreate: function (csvPatlitValidate, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterPatlitesCsvCheckValidateCreate(csvPatlitValidate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * パトライト登録CSVを使った一括パトライト登録
         * @param {CsvPatlitCreate} [csvPatlitCreate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterPatlitesCsvPatlitCreateCreate: function (csvPatlitCreate, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterPatlitesCsvPatlitCreateCreate(csvPatlitCreate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * パトライト削除
         * @param {number} id A unique integer value identifying this m_patlite.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterPatlitesDestroy: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterPatlitesDestroy(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * パトライト API
         * @param {string} [nodeId] ルート階層
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterPatlitesList: function (nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterPatlitesList(nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * パトライト更新（一部）
         * @param {number} id A unique integer value identifying this m_patlite.
         * @param {PatchedPatlite} [patchedPatlite]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterPatlitesPartialUpdate: function (id, patchedPatlite, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterPatlitesPartialUpdate(id, patchedPatlite, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * パトライト詳細取得
         * @param {number} id A unique integer value identifying this m_patlite.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterPatlitesRetrieve: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterPatlitesRetrieve(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * パトライト更新
         * @param {number} id A unique integer value identifying this m_patlite.
         * @param {Patlite} patlite
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterPatlitesUpdate: function (id, patlite, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterPatlitesUpdate(id, patlite, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 逆転データ修復 データセット一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterRecreateDataList: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterRecreateDataList(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 逆転データ修復 データ修復ジョブ実行
         * @param {RecreateDataRunJob} recreateDataRunJob
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterRecreateDataRunJobRecreateDataCreate: function (recreateDataRunJob, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterRecreateDataRunJobRecreateDataCreate(recreateDataRunJob, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 逆転データ修復 自動修復設定
         * @param {RecreateDataSetAutoDataRecover} recreateDataSetAutoDataRecover
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterRecreateDataSetAutoDataRecoverCreate: function (recreateDataSetAutoDataRecover, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterRecreateDataSetAutoDataRecoverCreate(recreateDataSetAutoDataRecover, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {RootNode} rootNode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterRootNodesCreate: function (rootNode, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterRootNodesCreate(rootNode, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterRootNodesDestroy: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterRootNodesDestroy(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ルートノード情報一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterRootNodesList: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterRootNodesList(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {PatchedRootNode} [patchedRootNode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterRootNodesPartialUpdate: function (id, patchedRootNode, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterRootNodesPartialUpdate(id, patchedRootNode, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterRootNodesRetrieve: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterRootNodesRetrieve(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {RootNode} rootNode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterRootNodesUpdate: function (id, rootNode, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterRootNodesUpdate(id, rootNode, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {Setting} setting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterSettingCreate: function (setting, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterSettingCreate(setting, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterSettingDestroy: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterSettingDestroy(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 環境設定情報一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterSettingList: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterSettingList(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {PatchedSetting} [patchedSetting]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterSettingPartialUpdate: function (id, patchedSetting, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterSettingPartialUpdate(id, patchedSetting, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 環境設定情報取得
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterSettingRetrieve: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterSettingRetrieve(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {Setting} setting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterSettingUpdate: function (id, setting, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterSettingUpdate(id, setting, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {SimpleNode} simpleNode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterSimpleNodesCreate: function (simpleNode, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterSimpleNodesCreate(simpleNode, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterSimpleNodesDestroy: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterSimpleNodesDestroy(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ユーザーノード情報一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterSimpleNodesList: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterSimpleNodesList(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {PatchedSimpleNode} [patchedSimpleNode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterSimpleNodesPartialUpdate: function (id, patchedSimpleNode, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterSimpleNodesPartialUpdate(id, patchedSimpleNode, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterSimpleNodesRetrieve: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterSimpleNodesRetrieve(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {SimpleNode} simpleNode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterSimpleNodesUpdate: function (id, simpleNode, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterSimpleNodesUpdate(id, simpleNode, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * トレンドグラフ設定追加
         * @param {number} nodeId 設備ID
         * @param {TrendGraphSetting} trendGraphSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterTrendGraphSettingsCreate: function (nodeId, trendGraphSetting, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterTrendGraphSettingsCreate(nodeId, trendGraphSetting, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * トレンドグラフ設定削除
         * @param {number} id A unique integer value identifying this m_trend_graph_setting.
         * @param {number} nodeId 設備ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterTrendGraphSettingsDestroy: function (id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterTrendGraphSettingsDestroy(id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * トレンドグラフ設定一覧
         * @param {number} nodeId 設備ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterTrendGraphSettingsList: function (nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterTrendGraphSettingsList(nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this m_trend_graph_setting.
         * @param {PatchedTrendGraphSetting} [patchedTrendGraphSetting]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterTrendGraphSettingsPartialUpdate: function (id, patchedTrendGraphSetting, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterTrendGraphSettingsPartialUpdate(id, patchedTrendGraphSetting, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * トレンドグラフ設定詳細取得
         * @param {number} id A unique integer value identifying this m_trend_graph_setting.
         * @param {number} nodeId 設備ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterTrendGraphSettingsRetrieve: function (id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterTrendGraphSettingsRetrieve(id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * トレンドグラフ設定更新
         * @param {number} id A unique integer value identifying this m_trend_graph_setting.
         * @param {number} nodeId 設備ID
         * @param {TrendGraphSetting} trendGraphSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterTrendGraphSettingsUpdate: function (id, nodeId, trendGraphSetting, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterTrendGraphSettingsUpdate(id, nodeId, trendGraphSetting, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {UserNode} userNode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeMenuCreate: function (userNode, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterUserNodeMenuCreate(userNode, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this m_user_node.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeMenuDestroy: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterUserNodeMenuDestroy(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeMenuList: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterUserNodeMenuList(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this m_user_node.
         * @param {PatchedUserNode} [patchedUserNode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeMenuPartialUpdate: function (id, patchedUserNode, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterUserNodeMenuPartialUpdate(id, patchedUserNode, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ユーザノードメニュー情報詳細取得
         * @param {number} id A unique integer value identifying this m_user_node.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeMenuRetrieve: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterUserNodeMenuRetrieve(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ユーザノードメニュー設定情報更新
         * @param {number} id A unique integer value identifying this m_user_node.
         * @param {UserNode} userNode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeMenuUpdate: function (id, userNode, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterUserNodeMenuUpdate(id, userNode, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ユーザノードロール情報追加
         * @param {UserNodeRole} userNodeRole
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeRolesCreate: function (userNodeRole, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterUserNodeRolesCreate(userNodeRole, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ユーザノードロール情報削除
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeRolesDestroy: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterUserNodeRolesDestroy(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ユーザノードロール情報一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeRolesList: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterUserNodeRolesList(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ユーザノードロール情報更新（一部）
         * @param {string} id
         * @param {PatchedUserNodeRole} [patchedUserNodeRole]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeRolesPartialUpdate: function (id, patchedUserNodeRole, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterUserNodeRolesPartialUpdate(id, patchedUserNodeRole, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ユーザノードロール情報詳細取得
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeRolesRetrieve: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterUserNodeRolesRetrieve(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ユーザノードロール情報更新
         * @param {string} id
         * @param {UserNodeRole} userNodeRole
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeRolesUpdate: function (id, userNodeRole, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterUserNodeRolesUpdate(id, userNodeRole, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ユーザー・ノード設定追加
         * @param {number} nodeId 設備ID
         * @param {UserNodeSetting} userNodeSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeSettingsCreate: function (nodeId, userNodeSetting, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterUserNodeSettingsCreate(nodeId, userNodeSetting, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ユーザー・ノード設定削除
         * @param {number} id A unique integer value identifying this m_user_node_setting.
         * @param {number} nodeId 設備ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeSettingsDestroy: function (id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterUserNodeSettingsDestroy(id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ユーザー・ノード設定一覧
         * @param {number} nodeId 設備ID
         * @param {number} userId ユーザID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeSettingsList: function (nodeId, userId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterUserNodeSettingsList(nodeId, userId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ユーザー・ノード設定更新（一部）
         * @param {number} id A unique integer value identifying this m_user_node_setting.
         * @param {number} nodeId 設備ID
         * @param {PatchedUserNodeSetting} [patchedUserNodeSetting]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeSettingsPartialUpdate: function (id, nodeId, patchedUserNodeSetting, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterUserNodeSettingsPartialUpdate(id, nodeId, patchedUserNodeSetting, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ユーザー・ノード設定詳細取得
         * @param {number} id A unique integer value identifying this m_user_node_setting.
         * @param {number} nodeId 設備ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeSettingsRetrieve: function (id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterUserNodeSettingsRetrieve(id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ユーザー・ノード設定更新
         * @param {number} id A unique integer value identifying this m_user_node_setting.
         * @param {number} nodeId 設備ID
         * @param {UserNodeSetting} userNodeSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeSettingsUpdate: function (id, nodeId, userNodeSetting, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterUserNodeSettingsUpdate(id, nodeId, userNodeSetting, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ユーザノード情報追加
         * @param {SimpleNode} simpleNode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodesCreate: function (simpleNode, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterUserNodesCreate(simpleNode, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ユーザノード情報削除
         * @param {number} id A unique integer value identifying this m_user_node.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodesDestroy: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterUserNodesDestroy(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ユーザノード情報一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodesList: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterUserNodesList(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ユーザノード情報更新（一部）
         * @param {number} id A unique integer value identifying this m_user_node.
         * @param {PatchedSimpleNode} [patchedSimpleNode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodesPartialUpdate: function (id, patchedSimpleNode, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterUserNodesPartialUpdate(id, patchedSimpleNode, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ユーザノード情報詳細取得
         * @param {number} id A unique integer value identifying this m_user_node.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodesRetrieve: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterUserNodesRetrieve(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ユーザノード情報更新
         * @param {number} id A unique integer value identifying this m_user_node.
         * @param {SimpleNode} simpleNode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodesUpdate: function (id, simpleNode, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterUserNodesUpdate(id, simpleNode, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ユーザロール情報追加
         * @param {UserRole} userRole
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserRolesCreate: function (userRole, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterUserRolesCreate(userRole, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ユーザロール情報削除
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserRolesDestroy: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterUserRolesDestroy(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ユーザロール情報一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserRolesList: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterUserRolesList(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ユーザロール情報更新（一部）
         * @param {string} id
         * @param {PatchedUserRole} [patchedUserRole]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserRolesPartialUpdate: function (id, patchedUserRole, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterUserRolesPartialUpdate(id, patchedUserRole, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ユーザロール情報詳細取得
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserRolesRetrieve: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterUserRolesRetrieve(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ユーザロール情報更新
         * @param {string} id
         * @param {UserRole} userRole
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserRolesUpdate: function (id, userRole, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterUserRolesUpdate(id, userRole, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ユーザ情報追加
         * @param {User} user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUsersCreate: function (user, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterUsersCreate(user, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ユーザー登録CSVファイルへのバリデーションチェック
         * @param {CsvUserValidate} [csvUserValidate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUsersCsvCheckValidateCreate: function (csvUserValidate, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterUsersCsvCheckValidateCreate(csvUserValidate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ユーザー登録CSVを使った一括ユーザー登録
         * @param {CsvUserCreate} [csvUserCreate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUsersCsvUserCreateCreate: function (csvUserCreate, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterUsersCsvUserCreateCreate(csvUserCreate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ユーザ情報削除
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUsersDestroy: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterUsersDestroy(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ユーザ情報一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUsersList: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterUsersList(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ユーザ情報更新（一部）
         * @param {string} id
         * @param {PatchedUser} [patchedUser]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUsersPartialUpdate: function (id, patchedUser, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterUsersPartialUpdate(id, patchedUser, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ユーザ情報詳細取得
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUsersRetrieve: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterUsersRetrieve(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ユーザ情報更新
         * @param {string} id
         * @param {User} user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUsersUpdate: function (id, user, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.masterUsersUpdate(id, user, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.MasterApiFp = MasterApiFp;
/**
 * MasterApi - factory interface
 * @export
 */
var MasterApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.MasterApiFp)(configuration);
    return {
        /**
         *
         * @param {AnnouncementLevel} announcementLevel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementLevelCreate: function (announcementLevel, options) {
            return localVarFp.masterAnnouncementLevelCreate(announcementLevel, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this m_announcement_level.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementLevelDestroy: function (id, options) {
            return localVarFp.masterAnnouncementLevelDestroy(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementLevelList: function (options) {
            return localVarFp.masterAnnouncementLevelList(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this m_announcement_level.
         * @param {PatchedAnnouncementLevel} [patchedAnnouncementLevel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementLevelPartialUpdate: function (id, patchedAnnouncementLevel, options) {
            return localVarFp.masterAnnouncementLevelPartialUpdate(id, patchedAnnouncementLevel, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this m_announcement_level.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementLevelRetrieve: function (id, options) {
            return localVarFp.masterAnnouncementLevelRetrieve(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this m_announcement_level.
         * @param {AnnouncementLevel} announcementLevel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementLevelUpdate: function (id, announcementLevel, options) {
            return localVarFp.masterAnnouncementLevelUpdate(id, announcementLevel, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {AnnouncementMaster} announcementMaster
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementLoginCreate: function (announcementMaster, options) {
            return localVarFp.masterAnnouncementLoginCreate(announcementMaster, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementLoginDestroy: function (id, options) {
            return localVarFp.masterAnnouncementLoginDestroy(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ログイン画面用お知らせマスタ情報一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementLoginList: function (options) {
            return localVarFp.masterAnnouncementLoginList(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {PatchedAnnouncementMaster} [patchedAnnouncementMaster]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementLoginPartialUpdate: function (id, patchedAnnouncementMaster, options) {
            return localVarFp.masterAnnouncementLoginPartialUpdate(id, patchedAnnouncementMaster, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementLoginRetrieve: function (id, options) {
            return localVarFp.masterAnnouncementLoginRetrieve(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {AnnouncementMaster} announcementMaster
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementLoginUpdate: function (id, announcementMaster, options) {
            return localVarFp.masterAnnouncementLoginUpdate(id, announcementMaster, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * お知らせマスタ情報追加
         * @param {AnnouncementMaster} announcementMaster
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementMasterCreate: function (announcementMaster, options) {
            return localVarFp.masterAnnouncementMasterCreate(announcementMaster, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * お知らせマスタ情報削除
         * @param {number} id A unique integer value identifying this m_announcement_master.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementMasterDestroy: function (id, options) {
            return localVarFp.masterAnnouncementMasterDestroy(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * お知らせマスタ情報一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementMasterList: function (options) {
            return localVarFp.masterAnnouncementMasterList(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * お知らせマスタ情報更新（一部）
         * @param {number} id A unique integer value identifying this m_announcement_master.
         * @param {PatchedAnnouncementMaster} [patchedAnnouncementMaster]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementMasterPartialUpdate: function (id, patchedAnnouncementMaster, options) {
            return localVarFp.masterAnnouncementMasterPartialUpdate(id, patchedAnnouncementMaster, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * お知らせマスタ情報詳細取得
         * @param {number} id A unique integer value identifying this m_announcement_master.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementMasterRetrieve: function (id, options) {
            return localVarFp.masterAnnouncementMasterRetrieve(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * お知らせマスタ情報更新
         * @param {number} id A unique integer value identifying this m_announcement_master.
         * @param {AnnouncementMaster} announcementMaster
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementMasterUpdate: function (id, announcementMaster, options) {
            return localVarFp.masterAnnouncementMasterUpdate(id, announcementMaster, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {AnnouncementType} announcementType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementTypeCreate: function (announcementType, options) {
            return localVarFp.masterAnnouncementTypeCreate(announcementType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this m_announcement_type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementTypeDestroy: function (id, options) {
            return localVarFp.masterAnnouncementTypeDestroy(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementTypeList: function (options) {
            return localVarFp.masterAnnouncementTypeList(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this m_announcement_type.
         * @param {PatchedAnnouncementType} [patchedAnnouncementType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementTypePartialUpdate: function (id, patchedAnnouncementType, options) {
            return localVarFp.masterAnnouncementTypePartialUpdate(id, patchedAnnouncementType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this m_announcement_type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementTypeRetrieve: function (id, options) {
            return localVarFp.masterAnnouncementTypeRetrieve(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this m_announcement_type.
         * @param {AnnouncementType} announcementType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementTypeUpdate: function (id, announcementType, options) {
            return localVarFp.masterAnnouncementTypeUpdate(id, announcementType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * お知らせユーザー情報追加
         * @param {AnnouncementUserRequest} announcementUserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementUserCreate: function (announcementUserRequest, options) {
            return localVarFp.masterAnnouncementUserCreate(announcementUserRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * お知らせユーザー情報削除
         * @param {number} id A unique integer value identifying this m_announcement_user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementUserDestroy: function (id, options) {
            return localVarFp.masterAnnouncementUserDestroy(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * お知らせユーザー情報一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementUserList: function (options) {
            return localVarFp.masterAnnouncementUserList(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * お知らせユーザー情報更新（一部）
         * @param {number} id A unique integer value identifying this m_announcement_user.
         * @param {PatchedAnnouncementUser} [patchedAnnouncementUser]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementUserPartialUpdate: function (id, patchedAnnouncementUser, options) {
            return localVarFp.masterAnnouncementUserPartialUpdate(id, patchedAnnouncementUser, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * お知らせユーザー情報詳細取得
         * @param {number} id A unique integer value identifying this m_announcement_user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementUserRetrieve: function (id, options) {
            return localVarFp.masterAnnouncementUserRetrieve(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * お知らせユーザー情報更新
         * @param {number} id A unique integer value identifying this m_announcement_user.
         * @param {AnnouncementUser} announcementUser
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterAnnouncementUserUpdate: function (id, announcementUser, options) {
            return localVarFp.masterAnnouncementUserUpdate(id, announcementUser, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * バッチ演算設定追加
         * @param {BatchCalculationSetting} batchCalculationSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCalculationSettingsCreate: function (batchCalculationSetting, options) {
            return localVarFp.masterCalculationSettingsCreate(batchCalculationSetting, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * バッチ演算設定削除
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCalculationSettingsDestroy: function (id, options) {
            return localVarFp.masterCalculationSettingsDestroy(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * バッチ演算設定一覧取得
         * @param {number} [facilityGroupCode] 設備グループコード
         * @param {number} [plantId] 設備ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCalculationSettingsList: function (facilityGroupCode, plantId, options) {
            return localVarFp.masterCalculationSettingsList(facilityGroupCode, plantId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * バッチ演算設定更新（一部）
         * @param {string} id
         * @param {PatchedBatchCalculationSetting} [patchedBatchCalculationSetting]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCalculationSettingsPartialUpdate: function (id, patchedBatchCalculationSetting, options) {
            return localVarFp.masterCalculationSettingsPartialUpdate(id, patchedBatchCalculationSetting, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * バッチ演算設定詳細取得
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCalculationSettingsRetrieve: function (id, options) {
            return localVarFp.masterCalculationSettingsRetrieve(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * バッチ演算設定更新
         * @param {string} id
         * @param {BatchCalculationSetting} batchCalculationSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCalculationSettingsUpdate: function (id, batchCalculationSetting, options) {
            return localVarFp.masterCalculationSettingsUpdate(id, batchCalculationSetting, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * カメラ型式追加
         * @param {CameraType} cameraType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCameraTypesCreate: function (cameraType, options) {
            return localVarFp.masterCameraTypesCreate(cameraType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * カメラ型式削除
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCameraTypesDestroy: function (id, options) {
            return localVarFp.masterCameraTypesDestroy(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * カメラ型式一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCameraTypesList: function (options) {
            return localVarFp.masterCameraTypesList(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {PatchedCameraType} [patchedCameraType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCameraTypesPartialUpdate: function (id, patchedCameraType, options) {
            return localVarFp.masterCameraTypesPartialUpdate(id, patchedCameraType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * カメラ型式詳細取得
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCameraTypesRetrieve: function (id, options) {
            return localVarFp.masterCameraTypesRetrieve(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {CameraType} cameraType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCameraTypesUpdate: function (id, cameraType, options) {
            return localVarFp.masterCameraTypesUpdate(id, cameraType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * カメラ追加
         * @param {CameraCreate} cameraCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCamerasCreate: function (cameraCreate, options) {
            return localVarFp.masterCamerasCreate(cameraCreate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * カメラ登録CSVを使った一括カメラ登録
         * @param {CsvUserCreate} [csvUserCreate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCamerasCsvCameraCreateCreate: function (csvUserCreate, options) {
            return localVarFp.masterCamerasCsvCameraCreateCreate(csvUserCreate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * カメラ登録CSVファイルへのバリデーションチェック
         * @param {CsvUserValidate} [csvUserValidate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCamerasCsvCheckValidateCreate: function (csvUserValidate, options) {
            return localVarFp.masterCamerasCsvCheckValidateCreate(csvUserValidate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * カメラ削除
         * @param {number} id A unique integer value identifying this m_camera.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCamerasDestroy: function (id, options) {
            return localVarFp.masterCamerasDestroy(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * カメラ一覧取得
         * @param {boolean} [includeDeploymentInfo] モデル一覧と一緒にデプロイ情報も取得するかどうか
         * @param {string} [nodeId] 階層ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCamerasList: function (includeDeploymentInfo, nodeId, options) {
            return localVarFp.masterCamerasList(includeDeploymentInfo, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * カメラ更新（一部）
         * @param {number} id A unique integer value identifying this m_camera.
         * @param {PatchedCamera} [patchedCamera]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCamerasPartialUpdate: function (id, patchedCamera, options) {
            return localVarFp.masterCamerasPartialUpdate(id, patchedCamera, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * カメラ詳細取得
         * @param {number} id A unique integer value identifying this m_camera.
         * @param {boolean} [includeModelBuildCounts] 今月のモデルビルド数も合わせて取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCamerasRetrieve: function (id, includeModelBuildCounts, options) {
            return localVarFp.masterCamerasRetrieve(id, includeModelBuildCounts, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * カメラ更新
         * @param {number} id A unique integer value identifying this m_camera.
         * @param {CameraCreate} cameraCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCamerasUpdate: function (id, cameraCreate, options) {
            return localVarFp.masterCamerasUpdate(id, cameraCreate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {CustomerType} customerType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCustomerTypesCreate: function (customerType, options) {
            return localVarFp.masterCustomerTypesCreate(customerType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCustomerTypesDestroy: function (id, options) {
            return localVarFp.masterCustomerTypesDestroy(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCustomerTypesList: function (options) {
            return localVarFp.masterCustomerTypesList(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {PatchedCustomerType} [patchedCustomerType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCustomerTypesPartialUpdate: function (id, patchedCustomerType, options) {
            return localVarFp.masterCustomerTypesPartialUpdate(id, patchedCustomerType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCustomerTypesRetrieve: function (id, options) {
            return localVarFp.masterCustomerTypesRetrieve(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {CustomerType} customerType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterCustomerTypesUpdate: function (id, customerType, options) {
            return localVarFp.masterCustomerTypesUpdate(id, customerType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * デプロイコンポーネント設定追加
         * @param {DeploymentComponent} deploymentComponent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterDeployComponentsCreate: function (deploymentComponent, options) {
            return localVarFp.masterDeployComponentsCreate(deploymentComponent, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * デプロイコンポーネント設定削除
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterDeployComponentsDestroy: function (id, options) {
            return localVarFp.masterDeployComponentsDestroy(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * デプロイコンポーネント設定一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterDeployComponentsList: function (options) {
            return localVarFp.masterDeployComponentsList(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * デプロイコンポーネント設定更新（一部）
         * @param {string} id
         * @param {PatchedDeploymentComponent} [patchedDeploymentComponent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterDeployComponentsPartialUpdate: function (id, patchedDeploymentComponent, options) {
            return localVarFp.masterDeployComponentsPartialUpdate(id, patchedDeploymentComponent, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * デプロイコンポーネント設定詳細取得
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterDeployComponentsRetrieve: function (id, options) {
            return localVarFp.masterDeployComponentsRetrieve(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * デプロイコンポーネント設定更新
         * @param {string} id
         * @param {DeploymentComponent} deploymentComponent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterDeployComponentsUpdate: function (id, deploymentComponent, options) {
            return localVarFp.masterDeployComponentsUpdate(id, deploymentComponent, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * デバイス設定追加
         * @param {Device} device
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterDevicesCreate: function (device, options) {
            return localVarFp.masterDevicesCreate(device, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * デバイス設定削除
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterDevicesDestroy: function (id, options) {
            return localVarFp.masterDevicesDestroy(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * デバイス設定一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterDevicesList: function (options) {
            return localVarFp.masterDevicesList(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * デバイス設定更新（一部）
         * @param {string} id
         * @param {PatchedDevice} [patchedDevice]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterDevicesPartialUpdate: function (id, patchedDevice, options) {
            return localVarFp.masterDevicesPartialUpdate(id, patchedDevice, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * デバイス設定詳細取得
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterDevicesRetrieve: function (id, options) {
            return localVarFp.masterDevicesRetrieve(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * デバイス設定更新
         * @param {string} id
         * @param {Device} device
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterDevicesUpdate: function (id, device, options) {
            return localVarFp.masterDevicesUpdate(id, device, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 外部出力作成
         * @param {ExternalOutputInfoRequest} externalOutputInfoRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterExternalOutputInfoCreate: function (externalOutputInfoRequest, options) {
            return localVarFp.masterExternalOutputInfoCreate(externalOutputInfoRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 外部出力削除
         * @param {string} id データセットID
         * @param {number} nodeId 階層 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterExternalOutputInfoDestroy: function (id, nodeId, options) {
            return localVarFp.masterExternalOutputInfoDestroy(id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 外部出力一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterExternalOutputInfoList: function (options) {
            return localVarFp.masterExternalOutputInfoList(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 外部出力更新
         * @param {string} id
         * @param {ExternalOutputInfoRequest} externalOutputInfoRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterExternalOutputInfoUpdate: function (id, externalOutputInfoRequest, options) {
            return localVarFp.masterExternalOutputInfoUpdate(id, externalOutputInfoRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 設備グループ情報追加
         * @param {FacilityGroup} facilityGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterFacilityGroupsCreate: function (facilityGroup, options) {
            return localVarFp.masterFacilityGroupsCreate(facilityGroup, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 設備グループ情報削除
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterFacilityGroupsDestroy: function (id, options) {
            return localVarFp.masterFacilityGroupsDestroy(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 設備グループ情報一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterFacilityGroupsList: function (options) {
            return localVarFp.masterFacilityGroupsList(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 設備グループ情報更新（一部）
         * @param {string} id
         * @param {PatchedFacilityGroup} [patchedFacilityGroup]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterFacilityGroupsPartialUpdate: function (id, patchedFacilityGroup, options) {
            return localVarFp.masterFacilityGroupsPartialUpdate(id, patchedFacilityGroup, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 設備グループ情報詳細取得
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterFacilityGroupsRetrieve: function (id, options) {
            return localVarFp.masterFacilityGroupsRetrieve(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 設備グループ情報更新
         * @param {string} id
         * @param {FacilityGroup} facilityGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterFacilityGroupsUpdate: function (id, facilityGroup, options) {
            return localVarFp.masterFacilityGroupsUpdate(id, facilityGroup, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Upload IF
         * @param {GatewayIFUploadRequest} gatewayIFUploadRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterGatewayIfCreate: function (gatewayIFUploadRequest, options) {
            return localVarFp.masterGatewayIfCreate(gatewayIFUploadRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * フォーマットダウンロード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterGatewayIfDownloadFormatRetrieve: function (options) {
            return localVarFp.masterGatewayIfDownloadFormatRetrieve(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * IFファイルダウンロード
         * @param {string} [s3Key] S3 Key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterGatewayIfDownloadIfRetrieve: function (s3Key, options) {
            return localVarFp.masterGatewayIfDownloadIfRetrieve(s3Key, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Gateway変換設定 API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterGatewayIfList: function (options) {
            return localVarFp.masterGatewayIfList(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Validation IF
         * @param {string} id
         * @param {GatewayIFValidationRequest} gatewayIFValidationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterGatewayIfValidationCreate: function (id, gatewayIFValidationRequest, options) {
            return localVarFp.masterGatewayIfValidationCreate(id, gatewayIFValidationRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 業種区分情報追加
         * @param {IndustryType} industryType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterIndustryTypesCreate: function (industryType, options) {
            return localVarFp.masterIndustryTypesCreate(industryType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 業種区分情報削除
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterIndustryTypesDestroy: function (id, options) {
            return localVarFp.masterIndustryTypesDestroy(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 業種区分一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterIndustryTypesList: function (options) {
            return localVarFp.masterIndustryTypesList(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 業種区分情報更新（一部）
         * @param {string} id
         * @param {PatchedIndustryType} [patchedIndustryType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterIndustryTypesPartialUpdate: function (id, patchedIndustryType, options) {
            return localVarFp.masterIndustryTypesPartialUpdate(id, patchedIndustryType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 業種区分情報詳細取得
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterIndustryTypesRetrieve: function (id, options) {
            return localVarFp.masterIndustryTypesRetrieve(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 業種区分情報更新
         * @param {string} id
         * @param {IndustryType} industryType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterIndustryTypesUpdate: function (id, industryType, options) {
            return localVarFp.masterIndustryTypesUpdate(id, industryType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * マイダッシュボード設定追加
         * @param {number} nodeId 設備ID
         * @param {MyDashboardSetting} myDashboardSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyDashboardSettingsCreate: function (nodeId, myDashboardSetting, options) {
            return localVarFp.masterMyDashboardSettingsCreate(nodeId, myDashboardSetting, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * マイダッシュボード設定削除
         * @param {number} id A unique integer value identifying this m_my_dashboard_setting.
         * @param {number} nodeId 設備ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyDashboardSettingsDestroy: function (id, nodeId, options) {
            return localVarFp.masterMyDashboardSettingsDestroy(id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * マイダッシュボード設定一覧
         * @param {number} nodeId 設備ID
         * @param {number} userId ユーザID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyDashboardSettingsList: function (nodeId, userId, options) {
            return localVarFp.masterMyDashboardSettingsList(nodeId, userId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * マイダッシュボード設定更新（一部）
         * @param {number} id A unique integer value identifying this m_my_dashboard_setting.
         * @param {number} nodeId 設備ID
         * @param {PatchedMyDashboardSetting} [patchedMyDashboardSetting]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyDashboardSettingsPartialUpdate: function (id, nodeId, patchedMyDashboardSetting, options) {
            return localVarFp.masterMyDashboardSettingsPartialUpdate(id, nodeId, patchedMyDashboardSetting, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * マイダッシュボード設定詳細取得
         * @param {number} id A unique integer value identifying this m_my_dashboard_setting.
         * @param {number} nodeId 設備ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyDashboardSettingsRetrieve: function (id, nodeId, options) {
            return localVarFp.masterMyDashboardSettingsRetrieve(id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * マイダッシュボード設定更新
         * @param {number} id A unique integer value identifying this m_my_dashboard_setting.
         * @param {number} nodeId 設備ID
         * @param {MyDashboardSetting} myDashboardSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyDashboardSettingsUpdate: function (id, nodeId, myDashboardSetting, options) {
            return localVarFp.masterMyDashboardSettingsUpdate(id, nodeId, myDashboardSetting, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * マイ長期トレンド設定追加
         * @param {number} nodeId 設備ID
         * @param {MyLongTermTrendSetting} myLongTermTrendSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyLongTermTrendSettingsCreate: function (nodeId, myLongTermTrendSetting, options) {
            return localVarFp.masterMyLongTermTrendSettingsCreate(nodeId, myLongTermTrendSetting, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * マイ長期トレンド設定削除
         * @param {number} id A unique integer value identifying this m_my_long_term_trend_setting.
         * @param {number} nodeId 設備ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyLongTermTrendSettingsDestroy: function (id, nodeId, options) {
            return localVarFp.masterMyLongTermTrendSettingsDestroy(id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * マイ長期トレンド設定一覧
         * @param {number} nodeId 設備ID
         * @param {number} userId ユーザID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyLongTermTrendSettingsList: function (nodeId, userId, options) {
            return localVarFp.masterMyLongTermTrendSettingsList(nodeId, userId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * マイ長期トレンド設定更新（一部）
         * @param {number} id A unique integer value identifying this m_my_long_term_trend_setting.
         * @param {number} nodeId 設備ID
         * @param {PatchedMyLongTermTrendSetting} [patchedMyLongTermTrendSetting]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyLongTermTrendSettingsPartialUpdate: function (id, nodeId, patchedMyLongTermTrendSetting, options) {
            return localVarFp.masterMyLongTermTrendSettingsPartialUpdate(id, nodeId, patchedMyLongTermTrendSetting, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * マイ長期トレンド設定詳細取得
         * @param {number} id A unique integer value identifying this m_my_long_term_trend_setting.
         * @param {number} nodeId 設備ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyLongTermTrendSettingsRetrieve: function (id, nodeId, options) {
            return localVarFp.masterMyLongTermTrendSettingsRetrieve(id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * マイ長期トレンド設定更新
         * @param {number} id A unique integer value identifying this m_my_long_term_trend_setting.
         * @param {number} nodeId 設備ID
         * @param {MyLongTermTrendSetting} myLongTermTrendSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyLongTermTrendSettingsUpdate: function (id, nodeId, myLongTermTrendSetting, options) {
            return localVarFp.masterMyLongTermTrendSettingsUpdate(id, nodeId, myLongTermTrendSetting, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 統計データ分析設定追加
         * @param {number} nodeId 階層ID
         * @param {MyScatterSetting} myScatterSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyScatterSettingsCreate: function (nodeId, myScatterSetting, options) {
            return localVarFp.masterMyScatterSettingsCreate(nodeId, myScatterSetting, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 統計データ分析設定削除
         * @param {number} id A unique integer value identifying this m_my_scatter_setting.
         * @param {number} nodeId 階層ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyScatterSettingsDestroy: function (id, nodeId, options) {
            return localVarFp.masterMyScatterSettingsDestroy(id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 統計データ分析設定一覧
         * @param {number} nodeId 階層ID
         * @param {number} userId ユーザID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyScatterSettingsList: function (nodeId, userId, options) {
            return localVarFp.masterMyScatterSettingsList(nodeId, userId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 統計データ分析設定更新（一部）
         * @param {number} id A unique integer value identifying this m_my_scatter_setting.
         * @param {number} nodeId 階層ID
         * @param {PatchedMyScatterSetting} [patchedMyScatterSetting]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyScatterSettingsPartialUpdate: function (id, nodeId, patchedMyScatterSetting, options) {
            return localVarFp.masterMyScatterSettingsPartialUpdate(id, nodeId, patchedMyScatterSetting, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 統計データ分析設定詳細取得
         * @param {number} id A unique integer value identifying this m_my_scatter_setting.
         * @param {number} nodeId 階層ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyScatterSettingsRetrieve: function (id, nodeId, options) {
            return localVarFp.masterMyScatterSettingsRetrieve(id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 統計データ分析設定更新
         * @param {number} id A unique integer value identifying this m_my_scatter_setting.
         * @param {number} nodeId 階層ID
         * @param {MyScatterSetting} myScatterSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterMyScatterSettingsUpdate: function (id, nodeId, myScatterSetting, options) {
            return localVarFp.masterMyScatterSettingsUpdate(id, nodeId, myScatterSetting, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ノード情報追加
         * @param {Node} node
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterNodesCreate: function (node, options) {
            return localVarFp.masterNodesCreate(node, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ノード情報削除
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterNodesDestroy: function (id, options) {
            return localVarFp.masterNodesDestroy(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ノード情報一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterNodesList: function (options) {
            return localVarFp.masterNodesList(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ノード情報更新（一部）
         * @param {string} id
         * @param {PatchedNode} [patchedNode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterNodesPartialUpdate: function (id, patchedNode, options) {
            return localVarFp.masterNodesPartialUpdate(id, patchedNode, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ノード情報詳細取得
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterNodesRetrieve: function (id, options) {
            return localVarFp.masterNodesRetrieve(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ノード情報更新
         * @param {string} id
         * @param {Node} node
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterNodesUpdate: function (id, node, options) {
            return localVarFp.masterNodesUpdate(id, node, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 組織情報追加
         * @param {Organization} organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterOrganizationsCreate: function (organization, options) {
            return localVarFp.masterOrganizationsCreate(organization, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 組織情報削除
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterOrganizationsDestroy: function (id, options) {
            return localVarFp.masterOrganizationsDestroy(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 組織情報一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterOrganizationsList: function (options) {
            return localVarFp.masterOrganizationsList(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 組織情報更新（一部）
         * @param {string} id
         * @param {PatchedOrganization} [patchedOrganization]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterOrganizationsPartialUpdate: function (id, patchedOrganization, options) {
            return localVarFp.masterOrganizationsPartialUpdate(id, patchedOrganization, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 組織情報詳細取得
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterOrganizationsRetrieve: function (id, options) {
            return localVarFp.masterOrganizationsRetrieve(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 組織情報更新
         * @param {string} id
         * @param {Organization} organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterOrganizationsUpdate: function (id, organization, options) {
            return localVarFp.masterOrganizationsUpdate(id, organization, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 出力用GW
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterOutputGatewayList: function (options) {
            return localVarFp.masterOutputGatewayList(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * パトライト型式追加
         * @param {PatliteType} patliteType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterPatliteTypesCreate: function (patliteType, options) {
            return localVarFp.masterPatliteTypesCreate(patliteType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * パトライト型式削除
         * @param {number} id A unique integer value identifying this m_patlite_type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterPatliteTypesDestroy: function (id, options) {
            return localVarFp.masterPatliteTypesDestroy(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * パトライト型式一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterPatliteTypesList: function (options) {
            return localVarFp.masterPatliteTypesList(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * パトライト型式更新（一部）
         * @param {number} id A unique integer value identifying this m_patlite_type.
         * @param {PatchedPatliteType} [patchedPatliteType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterPatliteTypesPartialUpdate: function (id, patchedPatliteType, options) {
            return localVarFp.masterPatliteTypesPartialUpdate(id, patchedPatliteType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * パトライト型式詳細取得
         * @param {number} id A unique integer value identifying this m_patlite_type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterPatliteTypesRetrieve: function (id, options) {
            return localVarFp.masterPatliteTypesRetrieve(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * パトライト型式更新
         * @param {number} id A unique integer value identifying this m_patlite_type.
         * @param {PatliteType} patliteType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterPatliteTypesUpdate: function (id, patliteType, options) {
            return localVarFp.masterPatliteTypesUpdate(id, patliteType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * パトライト追加
         * @param {Patlite} patlite
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterPatlitesCreate: function (patlite, options) {
            return localVarFp.masterPatlitesCreate(patlite, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * パトライト登録CSVファイルへのバリデーションチェック
         * @param {CsvPatlitValidate} [csvPatlitValidate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterPatlitesCsvCheckValidateCreate: function (csvPatlitValidate, options) {
            return localVarFp.masterPatlitesCsvCheckValidateCreate(csvPatlitValidate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * パトライト登録CSVを使った一括パトライト登録
         * @param {CsvPatlitCreate} [csvPatlitCreate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterPatlitesCsvPatlitCreateCreate: function (csvPatlitCreate, options) {
            return localVarFp.masterPatlitesCsvPatlitCreateCreate(csvPatlitCreate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * パトライト削除
         * @param {number} id A unique integer value identifying this m_patlite.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterPatlitesDestroy: function (id, options) {
            return localVarFp.masterPatlitesDestroy(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * パトライト API
         * @param {string} [nodeId] ルート階層
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterPatlitesList: function (nodeId, options) {
            return localVarFp.masterPatlitesList(nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * パトライト更新（一部）
         * @param {number} id A unique integer value identifying this m_patlite.
         * @param {PatchedPatlite} [patchedPatlite]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterPatlitesPartialUpdate: function (id, patchedPatlite, options) {
            return localVarFp.masterPatlitesPartialUpdate(id, patchedPatlite, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * パトライト詳細取得
         * @param {number} id A unique integer value identifying this m_patlite.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterPatlitesRetrieve: function (id, options) {
            return localVarFp.masterPatlitesRetrieve(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * パトライト更新
         * @param {number} id A unique integer value identifying this m_patlite.
         * @param {Patlite} patlite
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterPatlitesUpdate: function (id, patlite, options) {
            return localVarFp.masterPatlitesUpdate(id, patlite, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 逆転データ修復 データセット一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterRecreateDataList: function (options) {
            return localVarFp.masterRecreateDataList(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 逆転データ修復 データ修復ジョブ実行
         * @param {RecreateDataRunJob} recreateDataRunJob
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterRecreateDataRunJobRecreateDataCreate: function (recreateDataRunJob, options) {
            return localVarFp.masterRecreateDataRunJobRecreateDataCreate(recreateDataRunJob, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 逆転データ修復 自動修復設定
         * @param {RecreateDataSetAutoDataRecover} recreateDataSetAutoDataRecover
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterRecreateDataSetAutoDataRecoverCreate: function (recreateDataSetAutoDataRecover, options) {
            return localVarFp.masterRecreateDataSetAutoDataRecoverCreate(recreateDataSetAutoDataRecover, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {RootNode} rootNode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterRootNodesCreate: function (rootNode, options) {
            return localVarFp.masterRootNodesCreate(rootNode, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterRootNodesDestroy: function (id, options) {
            return localVarFp.masterRootNodesDestroy(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ルートノード情報一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterRootNodesList: function (options) {
            return localVarFp.masterRootNodesList(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {PatchedRootNode} [patchedRootNode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterRootNodesPartialUpdate: function (id, patchedRootNode, options) {
            return localVarFp.masterRootNodesPartialUpdate(id, patchedRootNode, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterRootNodesRetrieve: function (id, options) {
            return localVarFp.masterRootNodesRetrieve(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {RootNode} rootNode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterRootNodesUpdate: function (id, rootNode, options) {
            return localVarFp.masterRootNodesUpdate(id, rootNode, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {Setting} setting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterSettingCreate: function (setting, options) {
            return localVarFp.masterSettingCreate(setting, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterSettingDestroy: function (id, options) {
            return localVarFp.masterSettingDestroy(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 環境設定情報一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterSettingList: function (options) {
            return localVarFp.masterSettingList(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {PatchedSetting} [patchedSetting]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterSettingPartialUpdate: function (id, patchedSetting, options) {
            return localVarFp.masterSettingPartialUpdate(id, patchedSetting, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 環境設定情報取得
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterSettingRetrieve: function (id, options) {
            return localVarFp.masterSettingRetrieve(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {Setting} setting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterSettingUpdate: function (id, setting, options) {
            return localVarFp.masterSettingUpdate(id, setting, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {SimpleNode} simpleNode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterSimpleNodesCreate: function (simpleNode, options) {
            return localVarFp.masterSimpleNodesCreate(simpleNode, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterSimpleNodesDestroy: function (id, options) {
            return localVarFp.masterSimpleNodesDestroy(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ユーザーノード情報一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterSimpleNodesList: function (options) {
            return localVarFp.masterSimpleNodesList(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {PatchedSimpleNode} [patchedSimpleNode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterSimpleNodesPartialUpdate: function (id, patchedSimpleNode, options) {
            return localVarFp.masterSimpleNodesPartialUpdate(id, patchedSimpleNode, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterSimpleNodesRetrieve: function (id, options) {
            return localVarFp.masterSimpleNodesRetrieve(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {SimpleNode} simpleNode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterSimpleNodesUpdate: function (id, simpleNode, options) {
            return localVarFp.masterSimpleNodesUpdate(id, simpleNode, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * トレンドグラフ設定追加
         * @param {number} nodeId 設備ID
         * @param {TrendGraphSetting} trendGraphSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterTrendGraphSettingsCreate: function (nodeId, trendGraphSetting, options) {
            return localVarFp.masterTrendGraphSettingsCreate(nodeId, trendGraphSetting, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * トレンドグラフ設定削除
         * @param {number} id A unique integer value identifying this m_trend_graph_setting.
         * @param {number} nodeId 設備ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterTrendGraphSettingsDestroy: function (id, nodeId, options) {
            return localVarFp.masterTrendGraphSettingsDestroy(id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * トレンドグラフ設定一覧
         * @param {number} nodeId 設備ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterTrendGraphSettingsList: function (nodeId, options) {
            return localVarFp.masterTrendGraphSettingsList(nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this m_trend_graph_setting.
         * @param {PatchedTrendGraphSetting} [patchedTrendGraphSetting]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterTrendGraphSettingsPartialUpdate: function (id, patchedTrendGraphSetting, options) {
            return localVarFp.masterTrendGraphSettingsPartialUpdate(id, patchedTrendGraphSetting, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * トレンドグラフ設定詳細取得
         * @param {number} id A unique integer value identifying this m_trend_graph_setting.
         * @param {number} nodeId 設備ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterTrendGraphSettingsRetrieve: function (id, nodeId, options) {
            return localVarFp.masterTrendGraphSettingsRetrieve(id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * トレンドグラフ設定更新
         * @param {number} id A unique integer value identifying this m_trend_graph_setting.
         * @param {number} nodeId 設備ID
         * @param {TrendGraphSetting} trendGraphSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterTrendGraphSettingsUpdate: function (id, nodeId, trendGraphSetting, options) {
            return localVarFp.masterTrendGraphSettingsUpdate(id, nodeId, trendGraphSetting, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {UserNode} userNode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeMenuCreate: function (userNode, options) {
            return localVarFp.masterUserNodeMenuCreate(userNode, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this m_user_node.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeMenuDestroy: function (id, options) {
            return localVarFp.masterUserNodeMenuDestroy(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeMenuList: function (options) {
            return localVarFp.masterUserNodeMenuList(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this m_user_node.
         * @param {PatchedUserNode} [patchedUserNode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeMenuPartialUpdate: function (id, patchedUserNode, options) {
            return localVarFp.masterUserNodeMenuPartialUpdate(id, patchedUserNode, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ユーザノードメニュー情報詳細取得
         * @param {number} id A unique integer value identifying this m_user_node.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeMenuRetrieve: function (id, options) {
            return localVarFp.masterUserNodeMenuRetrieve(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ユーザノードメニュー設定情報更新
         * @param {number} id A unique integer value identifying this m_user_node.
         * @param {UserNode} userNode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeMenuUpdate: function (id, userNode, options) {
            return localVarFp.masterUserNodeMenuUpdate(id, userNode, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ユーザノードロール情報追加
         * @param {UserNodeRole} userNodeRole
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeRolesCreate: function (userNodeRole, options) {
            return localVarFp.masterUserNodeRolesCreate(userNodeRole, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ユーザノードロール情報削除
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeRolesDestroy: function (id, options) {
            return localVarFp.masterUserNodeRolesDestroy(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ユーザノードロール情報一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeRolesList: function (options) {
            return localVarFp.masterUserNodeRolesList(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ユーザノードロール情報更新（一部）
         * @param {string} id
         * @param {PatchedUserNodeRole} [patchedUserNodeRole]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeRolesPartialUpdate: function (id, patchedUserNodeRole, options) {
            return localVarFp.masterUserNodeRolesPartialUpdate(id, patchedUserNodeRole, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ユーザノードロール情報詳細取得
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeRolesRetrieve: function (id, options) {
            return localVarFp.masterUserNodeRolesRetrieve(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ユーザノードロール情報更新
         * @param {string} id
         * @param {UserNodeRole} userNodeRole
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeRolesUpdate: function (id, userNodeRole, options) {
            return localVarFp.masterUserNodeRolesUpdate(id, userNodeRole, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ユーザー・ノード設定追加
         * @param {number} nodeId 設備ID
         * @param {UserNodeSetting} userNodeSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeSettingsCreate: function (nodeId, userNodeSetting, options) {
            return localVarFp.masterUserNodeSettingsCreate(nodeId, userNodeSetting, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ユーザー・ノード設定削除
         * @param {number} id A unique integer value identifying this m_user_node_setting.
         * @param {number} nodeId 設備ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeSettingsDestroy: function (id, nodeId, options) {
            return localVarFp.masterUserNodeSettingsDestroy(id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ユーザー・ノード設定一覧
         * @param {number} nodeId 設備ID
         * @param {number} userId ユーザID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeSettingsList: function (nodeId, userId, options) {
            return localVarFp.masterUserNodeSettingsList(nodeId, userId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ユーザー・ノード設定更新（一部）
         * @param {number} id A unique integer value identifying this m_user_node_setting.
         * @param {number} nodeId 設備ID
         * @param {PatchedUserNodeSetting} [patchedUserNodeSetting]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeSettingsPartialUpdate: function (id, nodeId, patchedUserNodeSetting, options) {
            return localVarFp.masterUserNodeSettingsPartialUpdate(id, nodeId, patchedUserNodeSetting, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ユーザー・ノード設定詳細取得
         * @param {number} id A unique integer value identifying this m_user_node_setting.
         * @param {number} nodeId 設備ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeSettingsRetrieve: function (id, nodeId, options) {
            return localVarFp.masterUserNodeSettingsRetrieve(id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ユーザー・ノード設定更新
         * @param {number} id A unique integer value identifying this m_user_node_setting.
         * @param {number} nodeId 設備ID
         * @param {UserNodeSetting} userNodeSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodeSettingsUpdate: function (id, nodeId, userNodeSetting, options) {
            return localVarFp.masterUserNodeSettingsUpdate(id, nodeId, userNodeSetting, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ユーザノード情報追加
         * @param {SimpleNode} simpleNode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodesCreate: function (simpleNode, options) {
            return localVarFp.masterUserNodesCreate(simpleNode, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ユーザノード情報削除
         * @param {number} id A unique integer value identifying this m_user_node.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodesDestroy: function (id, options) {
            return localVarFp.masterUserNodesDestroy(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ユーザノード情報一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodesList: function (options) {
            return localVarFp.masterUserNodesList(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ユーザノード情報更新（一部）
         * @param {number} id A unique integer value identifying this m_user_node.
         * @param {PatchedSimpleNode} [patchedSimpleNode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodesPartialUpdate: function (id, patchedSimpleNode, options) {
            return localVarFp.masterUserNodesPartialUpdate(id, patchedSimpleNode, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ユーザノード情報詳細取得
         * @param {number} id A unique integer value identifying this m_user_node.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodesRetrieve: function (id, options) {
            return localVarFp.masterUserNodesRetrieve(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ユーザノード情報更新
         * @param {number} id A unique integer value identifying this m_user_node.
         * @param {SimpleNode} simpleNode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserNodesUpdate: function (id, simpleNode, options) {
            return localVarFp.masterUserNodesUpdate(id, simpleNode, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ユーザロール情報追加
         * @param {UserRole} userRole
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserRolesCreate: function (userRole, options) {
            return localVarFp.masterUserRolesCreate(userRole, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ユーザロール情報削除
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserRolesDestroy: function (id, options) {
            return localVarFp.masterUserRolesDestroy(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ユーザロール情報一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserRolesList: function (options) {
            return localVarFp.masterUserRolesList(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ユーザロール情報更新（一部）
         * @param {string} id
         * @param {PatchedUserRole} [patchedUserRole]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserRolesPartialUpdate: function (id, patchedUserRole, options) {
            return localVarFp.masterUserRolesPartialUpdate(id, patchedUserRole, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ユーザロール情報詳細取得
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserRolesRetrieve: function (id, options) {
            return localVarFp.masterUserRolesRetrieve(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ユーザロール情報更新
         * @param {string} id
         * @param {UserRole} userRole
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUserRolesUpdate: function (id, userRole, options) {
            return localVarFp.masterUserRolesUpdate(id, userRole, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ユーザ情報追加
         * @param {User} user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUsersCreate: function (user, options) {
            return localVarFp.masterUsersCreate(user, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ユーザー登録CSVファイルへのバリデーションチェック
         * @param {CsvUserValidate} [csvUserValidate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUsersCsvCheckValidateCreate: function (csvUserValidate, options) {
            return localVarFp.masterUsersCsvCheckValidateCreate(csvUserValidate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ユーザー登録CSVを使った一括ユーザー登録
         * @param {CsvUserCreate} [csvUserCreate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUsersCsvUserCreateCreate: function (csvUserCreate, options) {
            return localVarFp.masterUsersCsvUserCreateCreate(csvUserCreate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ユーザ情報削除
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUsersDestroy: function (id, options) {
            return localVarFp.masterUsersDestroy(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ユーザ情報一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUsersList: function (options) {
            return localVarFp.masterUsersList(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ユーザ情報更新（一部）
         * @param {string} id
         * @param {PatchedUser} [patchedUser]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUsersPartialUpdate: function (id, patchedUser, options) {
            return localVarFp.masterUsersPartialUpdate(id, patchedUser, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ユーザ情報詳細取得
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUsersRetrieve: function (id, options) {
            return localVarFp.masterUsersRetrieve(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ユーザ情報更新
         * @param {string} id
         * @param {User} user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterUsersUpdate: function (id, user, options) {
            return localVarFp.masterUsersUpdate(id, user, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.MasterApiFactory = MasterApiFactory;
/**
 * MasterApi - object-oriented interface
 * @export
 * @class MasterApi
 * @extends {BaseAPI}
 */
var MasterApi = /** @class */ (function (_super) {
    __extends(MasterApi, _super);
    function MasterApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {AnnouncementLevel} announcementLevel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterAnnouncementLevelCreate = function (announcementLevel, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterAnnouncementLevelCreate(announcementLevel, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id A unique integer value identifying this m_announcement_level.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterAnnouncementLevelDestroy = function (id, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterAnnouncementLevelDestroy(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterAnnouncementLevelList = function (options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterAnnouncementLevelList(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id A unique integer value identifying this m_announcement_level.
     * @param {PatchedAnnouncementLevel} [patchedAnnouncementLevel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterAnnouncementLevelPartialUpdate = function (id, patchedAnnouncementLevel, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterAnnouncementLevelPartialUpdate(id, patchedAnnouncementLevel, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id A unique integer value identifying this m_announcement_level.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterAnnouncementLevelRetrieve = function (id, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterAnnouncementLevelRetrieve(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id A unique integer value identifying this m_announcement_level.
     * @param {AnnouncementLevel} announcementLevel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterAnnouncementLevelUpdate = function (id, announcementLevel, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterAnnouncementLevelUpdate(id, announcementLevel, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {AnnouncementMaster} announcementMaster
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterAnnouncementLoginCreate = function (announcementMaster, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterAnnouncementLoginCreate(announcementMaster, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterAnnouncementLoginDestroy = function (id, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterAnnouncementLoginDestroy(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ログイン画面用お知らせマスタ情報一覧取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterAnnouncementLoginList = function (options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterAnnouncementLoginList(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {PatchedAnnouncementMaster} [patchedAnnouncementMaster]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterAnnouncementLoginPartialUpdate = function (id, patchedAnnouncementMaster, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterAnnouncementLoginPartialUpdate(id, patchedAnnouncementMaster, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterAnnouncementLoginRetrieve = function (id, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterAnnouncementLoginRetrieve(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {AnnouncementMaster} announcementMaster
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterAnnouncementLoginUpdate = function (id, announcementMaster, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterAnnouncementLoginUpdate(id, announcementMaster, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * お知らせマスタ情報追加
     * @param {AnnouncementMaster} announcementMaster
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterAnnouncementMasterCreate = function (announcementMaster, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterAnnouncementMasterCreate(announcementMaster, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * お知らせマスタ情報削除
     * @param {number} id A unique integer value identifying this m_announcement_master.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterAnnouncementMasterDestroy = function (id, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterAnnouncementMasterDestroy(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * お知らせマスタ情報一覧取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterAnnouncementMasterList = function (options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterAnnouncementMasterList(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * お知らせマスタ情報更新（一部）
     * @param {number} id A unique integer value identifying this m_announcement_master.
     * @param {PatchedAnnouncementMaster} [patchedAnnouncementMaster]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterAnnouncementMasterPartialUpdate = function (id, patchedAnnouncementMaster, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterAnnouncementMasterPartialUpdate(id, patchedAnnouncementMaster, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * お知らせマスタ情報詳細取得
     * @param {number} id A unique integer value identifying this m_announcement_master.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterAnnouncementMasterRetrieve = function (id, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterAnnouncementMasterRetrieve(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * お知らせマスタ情報更新
     * @param {number} id A unique integer value identifying this m_announcement_master.
     * @param {AnnouncementMaster} announcementMaster
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterAnnouncementMasterUpdate = function (id, announcementMaster, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterAnnouncementMasterUpdate(id, announcementMaster, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {AnnouncementType} announcementType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterAnnouncementTypeCreate = function (announcementType, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterAnnouncementTypeCreate(announcementType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id A unique integer value identifying this m_announcement_type.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterAnnouncementTypeDestroy = function (id, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterAnnouncementTypeDestroy(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterAnnouncementTypeList = function (options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterAnnouncementTypeList(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id A unique integer value identifying this m_announcement_type.
     * @param {PatchedAnnouncementType} [patchedAnnouncementType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterAnnouncementTypePartialUpdate = function (id, patchedAnnouncementType, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterAnnouncementTypePartialUpdate(id, patchedAnnouncementType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id A unique integer value identifying this m_announcement_type.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterAnnouncementTypeRetrieve = function (id, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterAnnouncementTypeRetrieve(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id A unique integer value identifying this m_announcement_type.
     * @param {AnnouncementType} announcementType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterAnnouncementTypeUpdate = function (id, announcementType, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterAnnouncementTypeUpdate(id, announcementType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * お知らせユーザー情報追加
     * @param {AnnouncementUserRequest} announcementUserRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterAnnouncementUserCreate = function (announcementUserRequest, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterAnnouncementUserCreate(announcementUserRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * お知らせユーザー情報削除
     * @param {number} id A unique integer value identifying this m_announcement_user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterAnnouncementUserDestroy = function (id, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterAnnouncementUserDestroy(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * お知らせユーザー情報一覧取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterAnnouncementUserList = function (options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterAnnouncementUserList(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * お知らせユーザー情報更新（一部）
     * @param {number} id A unique integer value identifying this m_announcement_user.
     * @param {PatchedAnnouncementUser} [patchedAnnouncementUser]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterAnnouncementUserPartialUpdate = function (id, patchedAnnouncementUser, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterAnnouncementUserPartialUpdate(id, patchedAnnouncementUser, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * お知らせユーザー情報詳細取得
     * @param {number} id A unique integer value identifying this m_announcement_user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterAnnouncementUserRetrieve = function (id, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterAnnouncementUserRetrieve(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * お知らせユーザー情報更新
     * @param {number} id A unique integer value identifying this m_announcement_user.
     * @param {AnnouncementUser} announcementUser
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterAnnouncementUserUpdate = function (id, announcementUser, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterAnnouncementUserUpdate(id, announcementUser, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * バッチ演算設定追加
     * @param {BatchCalculationSetting} batchCalculationSetting
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterCalculationSettingsCreate = function (batchCalculationSetting, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterCalculationSettingsCreate(batchCalculationSetting, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * バッチ演算設定削除
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterCalculationSettingsDestroy = function (id, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterCalculationSettingsDestroy(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * バッチ演算設定一覧取得
     * @param {number} [facilityGroupCode] 設備グループコード
     * @param {number} [plantId] 設備ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterCalculationSettingsList = function (facilityGroupCode, plantId, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterCalculationSettingsList(facilityGroupCode, plantId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * バッチ演算設定更新（一部）
     * @param {string} id
     * @param {PatchedBatchCalculationSetting} [patchedBatchCalculationSetting]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterCalculationSettingsPartialUpdate = function (id, patchedBatchCalculationSetting, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterCalculationSettingsPartialUpdate(id, patchedBatchCalculationSetting, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * バッチ演算設定詳細取得
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterCalculationSettingsRetrieve = function (id, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterCalculationSettingsRetrieve(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * バッチ演算設定更新
     * @param {string} id
     * @param {BatchCalculationSetting} batchCalculationSetting
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterCalculationSettingsUpdate = function (id, batchCalculationSetting, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterCalculationSettingsUpdate(id, batchCalculationSetting, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * カメラ型式追加
     * @param {CameraType} cameraType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterCameraTypesCreate = function (cameraType, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterCameraTypesCreate(cameraType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * カメラ型式削除
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterCameraTypesDestroy = function (id, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterCameraTypesDestroy(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * カメラ型式一覧取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterCameraTypesList = function (options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterCameraTypesList(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {PatchedCameraType} [patchedCameraType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterCameraTypesPartialUpdate = function (id, patchedCameraType, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterCameraTypesPartialUpdate(id, patchedCameraType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * カメラ型式詳細取得
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterCameraTypesRetrieve = function (id, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterCameraTypesRetrieve(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {CameraType} cameraType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterCameraTypesUpdate = function (id, cameraType, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterCameraTypesUpdate(id, cameraType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * カメラ追加
     * @param {CameraCreate} cameraCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterCamerasCreate = function (cameraCreate, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterCamerasCreate(cameraCreate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * カメラ登録CSVを使った一括カメラ登録
     * @param {CsvUserCreate} [csvUserCreate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterCamerasCsvCameraCreateCreate = function (csvUserCreate, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterCamerasCsvCameraCreateCreate(csvUserCreate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * カメラ登録CSVファイルへのバリデーションチェック
     * @param {CsvUserValidate} [csvUserValidate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterCamerasCsvCheckValidateCreate = function (csvUserValidate, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterCamerasCsvCheckValidateCreate(csvUserValidate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * カメラ削除
     * @param {number} id A unique integer value identifying this m_camera.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterCamerasDestroy = function (id, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterCamerasDestroy(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * カメラ一覧取得
     * @param {boolean} [includeDeploymentInfo] モデル一覧と一緒にデプロイ情報も取得するかどうか
     * @param {string} [nodeId] 階層ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterCamerasList = function (includeDeploymentInfo, nodeId, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterCamerasList(includeDeploymentInfo, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * カメラ更新（一部）
     * @param {number} id A unique integer value identifying this m_camera.
     * @param {PatchedCamera} [patchedCamera]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterCamerasPartialUpdate = function (id, patchedCamera, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterCamerasPartialUpdate(id, patchedCamera, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * カメラ詳細取得
     * @param {number} id A unique integer value identifying this m_camera.
     * @param {boolean} [includeModelBuildCounts] 今月のモデルビルド数も合わせて取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterCamerasRetrieve = function (id, includeModelBuildCounts, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterCamerasRetrieve(id, includeModelBuildCounts, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * カメラ更新
     * @param {number} id A unique integer value identifying this m_camera.
     * @param {CameraCreate} cameraCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterCamerasUpdate = function (id, cameraCreate, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterCamerasUpdate(id, cameraCreate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {CustomerType} customerType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterCustomerTypesCreate = function (customerType, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterCustomerTypesCreate(customerType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterCustomerTypesDestroy = function (id, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterCustomerTypesDestroy(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterCustomerTypesList = function (options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterCustomerTypesList(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {PatchedCustomerType} [patchedCustomerType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterCustomerTypesPartialUpdate = function (id, patchedCustomerType, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterCustomerTypesPartialUpdate(id, patchedCustomerType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterCustomerTypesRetrieve = function (id, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterCustomerTypesRetrieve(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {CustomerType} customerType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterCustomerTypesUpdate = function (id, customerType, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterCustomerTypesUpdate(id, customerType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * デプロイコンポーネント設定追加
     * @param {DeploymentComponent} deploymentComponent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterDeployComponentsCreate = function (deploymentComponent, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterDeployComponentsCreate(deploymentComponent, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * デプロイコンポーネント設定削除
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterDeployComponentsDestroy = function (id, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterDeployComponentsDestroy(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * デプロイコンポーネント設定一覧取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterDeployComponentsList = function (options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterDeployComponentsList(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * デプロイコンポーネント設定更新（一部）
     * @param {string} id
     * @param {PatchedDeploymentComponent} [patchedDeploymentComponent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterDeployComponentsPartialUpdate = function (id, patchedDeploymentComponent, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterDeployComponentsPartialUpdate(id, patchedDeploymentComponent, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * デプロイコンポーネント設定詳細取得
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterDeployComponentsRetrieve = function (id, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterDeployComponentsRetrieve(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * デプロイコンポーネント設定更新
     * @param {string} id
     * @param {DeploymentComponent} deploymentComponent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterDeployComponentsUpdate = function (id, deploymentComponent, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterDeployComponentsUpdate(id, deploymentComponent, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * デバイス設定追加
     * @param {Device} device
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterDevicesCreate = function (device, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterDevicesCreate(device, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * デバイス設定削除
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterDevicesDestroy = function (id, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterDevicesDestroy(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * デバイス設定一覧取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterDevicesList = function (options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterDevicesList(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * デバイス設定更新（一部）
     * @param {string} id
     * @param {PatchedDevice} [patchedDevice]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterDevicesPartialUpdate = function (id, patchedDevice, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterDevicesPartialUpdate(id, patchedDevice, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * デバイス設定詳細取得
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterDevicesRetrieve = function (id, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterDevicesRetrieve(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * デバイス設定更新
     * @param {string} id
     * @param {Device} device
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterDevicesUpdate = function (id, device, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterDevicesUpdate(id, device, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 外部出力作成
     * @param {ExternalOutputInfoRequest} externalOutputInfoRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterExternalOutputInfoCreate = function (externalOutputInfoRequest, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterExternalOutputInfoCreate(externalOutputInfoRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 外部出力削除
     * @param {string} id データセットID
     * @param {number} nodeId 階層 ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterExternalOutputInfoDestroy = function (id, nodeId, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterExternalOutputInfoDestroy(id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 外部出力一覧
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterExternalOutputInfoList = function (options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterExternalOutputInfoList(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 外部出力更新
     * @param {string} id
     * @param {ExternalOutputInfoRequest} externalOutputInfoRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterExternalOutputInfoUpdate = function (id, externalOutputInfoRequest, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterExternalOutputInfoUpdate(id, externalOutputInfoRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 設備グループ情報追加
     * @param {FacilityGroup} facilityGroup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterFacilityGroupsCreate = function (facilityGroup, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterFacilityGroupsCreate(facilityGroup, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 設備グループ情報削除
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterFacilityGroupsDestroy = function (id, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterFacilityGroupsDestroy(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 設備グループ情報一覧取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterFacilityGroupsList = function (options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterFacilityGroupsList(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 設備グループ情報更新（一部）
     * @param {string} id
     * @param {PatchedFacilityGroup} [patchedFacilityGroup]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterFacilityGroupsPartialUpdate = function (id, patchedFacilityGroup, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterFacilityGroupsPartialUpdate(id, patchedFacilityGroup, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 設備グループ情報詳細取得
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterFacilityGroupsRetrieve = function (id, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterFacilityGroupsRetrieve(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 設備グループ情報更新
     * @param {string} id
     * @param {FacilityGroup} facilityGroup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterFacilityGroupsUpdate = function (id, facilityGroup, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterFacilityGroupsUpdate(id, facilityGroup, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Upload IF
     * @param {GatewayIFUploadRequest} gatewayIFUploadRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterGatewayIfCreate = function (gatewayIFUploadRequest, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterGatewayIfCreate(gatewayIFUploadRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * フォーマットダウンロード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterGatewayIfDownloadFormatRetrieve = function (options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterGatewayIfDownloadFormatRetrieve(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * IFファイルダウンロード
     * @param {string} [s3Key] S3 Key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterGatewayIfDownloadIfRetrieve = function (s3Key, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterGatewayIfDownloadIfRetrieve(s3Key, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Gateway変換設定 API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterGatewayIfList = function (options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterGatewayIfList(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Validation IF
     * @param {string} id
     * @param {GatewayIFValidationRequest} gatewayIFValidationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterGatewayIfValidationCreate = function (id, gatewayIFValidationRequest, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterGatewayIfValidationCreate(id, gatewayIFValidationRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 業種区分情報追加
     * @param {IndustryType} industryType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterIndustryTypesCreate = function (industryType, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterIndustryTypesCreate(industryType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 業種区分情報削除
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterIndustryTypesDestroy = function (id, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterIndustryTypesDestroy(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 業種区分一覧取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterIndustryTypesList = function (options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterIndustryTypesList(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 業種区分情報更新（一部）
     * @param {string} id
     * @param {PatchedIndustryType} [patchedIndustryType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterIndustryTypesPartialUpdate = function (id, patchedIndustryType, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterIndustryTypesPartialUpdate(id, patchedIndustryType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 業種区分情報詳細取得
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterIndustryTypesRetrieve = function (id, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterIndustryTypesRetrieve(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 業種区分情報更新
     * @param {string} id
     * @param {IndustryType} industryType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterIndustryTypesUpdate = function (id, industryType, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterIndustryTypesUpdate(id, industryType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * マイダッシュボード設定追加
     * @param {number} nodeId 設備ID
     * @param {MyDashboardSetting} myDashboardSetting
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterMyDashboardSettingsCreate = function (nodeId, myDashboardSetting, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterMyDashboardSettingsCreate(nodeId, myDashboardSetting, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * マイダッシュボード設定削除
     * @param {number} id A unique integer value identifying this m_my_dashboard_setting.
     * @param {number} nodeId 設備ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterMyDashboardSettingsDestroy = function (id, nodeId, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterMyDashboardSettingsDestroy(id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * マイダッシュボード設定一覧
     * @param {number} nodeId 設備ID
     * @param {number} userId ユーザID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterMyDashboardSettingsList = function (nodeId, userId, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterMyDashboardSettingsList(nodeId, userId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * マイダッシュボード設定更新（一部）
     * @param {number} id A unique integer value identifying this m_my_dashboard_setting.
     * @param {number} nodeId 設備ID
     * @param {PatchedMyDashboardSetting} [patchedMyDashboardSetting]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterMyDashboardSettingsPartialUpdate = function (id, nodeId, patchedMyDashboardSetting, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterMyDashboardSettingsPartialUpdate(id, nodeId, patchedMyDashboardSetting, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * マイダッシュボード設定詳細取得
     * @param {number} id A unique integer value identifying this m_my_dashboard_setting.
     * @param {number} nodeId 設備ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterMyDashboardSettingsRetrieve = function (id, nodeId, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterMyDashboardSettingsRetrieve(id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * マイダッシュボード設定更新
     * @param {number} id A unique integer value identifying this m_my_dashboard_setting.
     * @param {number} nodeId 設備ID
     * @param {MyDashboardSetting} myDashboardSetting
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterMyDashboardSettingsUpdate = function (id, nodeId, myDashboardSetting, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterMyDashboardSettingsUpdate(id, nodeId, myDashboardSetting, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * マイ長期トレンド設定追加
     * @param {number} nodeId 設備ID
     * @param {MyLongTermTrendSetting} myLongTermTrendSetting
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterMyLongTermTrendSettingsCreate = function (nodeId, myLongTermTrendSetting, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterMyLongTermTrendSettingsCreate(nodeId, myLongTermTrendSetting, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * マイ長期トレンド設定削除
     * @param {number} id A unique integer value identifying this m_my_long_term_trend_setting.
     * @param {number} nodeId 設備ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterMyLongTermTrendSettingsDestroy = function (id, nodeId, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterMyLongTermTrendSettingsDestroy(id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * マイ長期トレンド設定一覧
     * @param {number} nodeId 設備ID
     * @param {number} userId ユーザID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterMyLongTermTrendSettingsList = function (nodeId, userId, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterMyLongTermTrendSettingsList(nodeId, userId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * マイ長期トレンド設定更新（一部）
     * @param {number} id A unique integer value identifying this m_my_long_term_trend_setting.
     * @param {number} nodeId 設備ID
     * @param {PatchedMyLongTermTrendSetting} [patchedMyLongTermTrendSetting]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterMyLongTermTrendSettingsPartialUpdate = function (id, nodeId, patchedMyLongTermTrendSetting, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterMyLongTermTrendSettingsPartialUpdate(id, nodeId, patchedMyLongTermTrendSetting, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * マイ長期トレンド設定詳細取得
     * @param {number} id A unique integer value identifying this m_my_long_term_trend_setting.
     * @param {number} nodeId 設備ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterMyLongTermTrendSettingsRetrieve = function (id, nodeId, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterMyLongTermTrendSettingsRetrieve(id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * マイ長期トレンド設定更新
     * @param {number} id A unique integer value identifying this m_my_long_term_trend_setting.
     * @param {number} nodeId 設備ID
     * @param {MyLongTermTrendSetting} myLongTermTrendSetting
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterMyLongTermTrendSettingsUpdate = function (id, nodeId, myLongTermTrendSetting, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterMyLongTermTrendSettingsUpdate(id, nodeId, myLongTermTrendSetting, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 統計データ分析設定追加
     * @param {number} nodeId 階層ID
     * @param {MyScatterSetting} myScatterSetting
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterMyScatterSettingsCreate = function (nodeId, myScatterSetting, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterMyScatterSettingsCreate(nodeId, myScatterSetting, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 統計データ分析設定削除
     * @param {number} id A unique integer value identifying this m_my_scatter_setting.
     * @param {number} nodeId 階層ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterMyScatterSettingsDestroy = function (id, nodeId, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterMyScatterSettingsDestroy(id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 統計データ分析設定一覧
     * @param {number} nodeId 階層ID
     * @param {number} userId ユーザID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterMyScatterSettingsList = function (nodeId, userId, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterMyScatterSettingsList(nodeId, userId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 統計データ分析設定更新（一部）
     * @param {number} id A unique integer value identifying this m_my_scatter_setting.
     * @param {number} nodeId 階層ID
     * @param {PatchedMyScatterSetting} [patchedMyScatterSetting]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterMyScatterSettingsPartialUpdate = function (id, nodeId, patchedMyScatterSetting, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterMyScatterSettingsPartialUpdate(id, nodeId, patchedMyScatterSetting, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 統計データ分析設定詳細取得
     * @param {number} id A unique integer value identifying this m_my_scatter_setting.
     * @param {number} nodeId 階層ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterMyScatterSettingsRetrieve = function (id, nodeId, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterMyScatterSettingsRetrieve(id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 統計データ分析設定更新
     * @param {number} id A unique integer value identifying this m_my_scatter_setting.
     * @param {number} nodeId 階層ID
     * @param {MyScatterSetting} myScatterSetting
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterMyScatterSettingsUpdate = function (id, nodeId, myScatterSetting, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterMyScatterSettingsUpdate(id, nodeId, myScatterSetting, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ノード情報追加
     * @param {Node} node
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterNodesCreate = function (node, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterNodesCreate(node, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ノード情報削除
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterNodesDestroy = function (id, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterNodesDestroy(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ノード情報一覧取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterNodesList = function (options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterNodesList(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ノード情報更新（一部）
     * @param {string} id
     * @param {PatchedNode} [patchedNode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterNodesPartialUpdate = function (id, patchedNode, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterNodesPartialUpdate(id, patchedNode, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ノード情報詳細取得
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterNodesRetrieve = function (id, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterNodesRetrieve(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ノード情報更新
     * @param {string} id
     * @param {Node} node
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterNodesUpdate = function (id, node, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterNodesUpdate(id, node, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 組織情報追加
     * @param {Organization} organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterOrganizationsCreate = function (organization, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterOrganizationsCreate(organization, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 組織情報削除
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterOrganizationsDestroy = function (id, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterOrganizationsDestroy(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 組織情報一覧取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterOrganizationsList = function (options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterOrganizationsList(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 組織情報更新（一部）
     * @param {string} id
     * @param {PatchedOrganization} [patchedOrganization]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterOrganizationsPartialUpdate = function (id, patchedOrganization, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterOrganizationsPartialUpdate(id, patchedOrganization, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 組織情報詳細取得
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterOrganizationsRetrieve = function (id, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterOrganizationsRetrieve(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 組織情報更新
     * @param {string} id
     * @param {Organization} organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterOrganizationsUpdate = function (id, organization, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterOrganizationsUpdate(id, organization, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 出力用GW
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterOutputGatewayList = function (options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterOutputGatewayList(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * パトライト型式追加
     * @param {PatliteType} patliteType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterPatliteTypesCreate = function (patliteType, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterPatliteTypesCreate(patliteType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * パトライト型式削除
     * @param {number} id A unique integer value identifying this m_patlite_type.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterPatliteTypesDestroy = function (id, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterPatliteTypesDestroy(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * パトライト型式一覧取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterPatliteTypesList = function (options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterPatliteTypesList(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * パトライト型式更新（一部）
     * @param {number} id A unique integer value identifying this m_patlite_type.
     * @param {PatchedPatliteType} [patchedPatliteType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterPatliteTypesPartialUpdate = function (id, patchedPatliteType, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterPatliteTypesPartialUpdate(id, patchedPatliteType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * パトライト型式詳細取得
     * @param {number} id A unique integer value identifying this m_patlite_type.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterPatliteTypesRetrieve = function (id, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterPatliteTypesRetrieve(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * パトライト型式更新
     * @param {number} id A unique integer value identifying this m_patlite_type.
     * @param {PatliteType} patliteType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterPatliteTypesUpdate = function (id, patliteType, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterPatliteTypesUpdate(id, patliteType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * パトライト追加
     * @param {Patlite} patlite
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterPatlitesCreate = function (patlite, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterPatlitesCreate(patlite, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * パトライト登録CSVファイルへのバリデーションチェック
     * @param {CsvPatlitValidate} [csvPatlitValidate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterPatlitesCsvCheckValidateCreate = function (csvPatlitValidate, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterPatlitesCsvCheckValidateCreate(csvPatlitValidate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * パトライト登録CSVを使った一括パトライト登録
     * @param {CsvPatlitCreate} [csvPatlitCreate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterPatlitesCsvPatlitCreateCreate = function (csvPatlitCreate, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterPatlitesCsvPatlitCreateCreate(csvPatlitCreate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * パトライト削除
     * @param {number} id A unique integer value identifying this m_patlite.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterPatlitesDestroy = function (id, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterPatlitesDestroy(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * パトライト API
     * @param {string} [nodeId] ルート階層
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterPatlitesList = function (nodeId, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterPatlitesList(nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * パトライト更新（一部）
     * @param {number} id A unique integer value identifying this m_patlite.
     * @param {PatchedPatlite} [patchedPatlite]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterPatlitesPartialUpdate = function (id, patchedPatlite, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterPatlitesPartialUpdate(id, patchedPatlite, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * パトライト詳細取得
     * @param {number} id A unique integer value identifying this m_patlite.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterPatlitesRetrieve = function (id, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterPatlitesRetrieve(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * パトライト更新
     * @param {number} id A unique integer value identifying this m_patlite.
     * @param {Patlite} patlite
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterPatlitesUpdate = function (id, patlite, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterPatlitesUpdate(id, patlite, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 逆転データ修復 データセット一覧取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterRecreateDataList = function (options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterRecreateDataList(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 逆転データ修復 データ修復ジョブ実行
     * @param {RecreateDataRunJob} recreateDataRunJob
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterRecreateDataRunJobRecreateDataCreate = function (recreateDataRunJob, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterRecreateDataRunJobRecreateDataCreate(recreateDataRunJob, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 逆転データ修復 自動修復設定
     * @param {RecreateDataSetAutoDataRecover} recreateDataSetAutoDataRecover
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterRecreateDataSetAutoDataRecoverCreate = function (recreateDataSetAutoDataRecover, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterRecreateDataSetAutoDataRecoverCreate(recreateDataSetAutoDataRecover, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {RootNode} rootNode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterRootNodesCreate = function (rootNode, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterRootNodesCreate(rootNode, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterRootNodesDestroy = function (id, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterRootNodesDestroy(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ルートノード情報一覧取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterRootNodesList = function (options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterRootNodesList(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {PatchedRootNode} [patchedRootNode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterRootNodesPartialUpdate = function (id, patchedRootNode, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterRootNodesPartialUpdate(id, patchedRootNode, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterRootNodesRetrieve = function (id, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterRootNodesRetrieve(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {RootNode} rootNode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterRootNodesUpdate = function (id, rootNode, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterRootNodesUpdate(id, rootNode, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {Setting} setting
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterSettingCreate = function (setting, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterSettingCreate(setting, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterSettingDestroy = function (id, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterSettingDestroy(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 環境設定情報一覧取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterSettingList = function (options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterSettingList(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {PatchedSetting} [patchedSetting]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterSettingPartialUpdate = function (id, patchedSetting, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterSettingPartialUpdate(id, patchedSetting, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 環境設定情報取得
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterSettingRetrieve = function (id, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterSettingRetrieve(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {Setting} setting
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterSettingUpdate = function (id, setting, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterSettingUpdate(id, setting, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {SimpleNode} simpleNode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterSimpleNodesCreate = function (simpleNode, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterSimpleNodesCreate(simpleNode, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterSimpleNodesDestroy = function (id, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterSimpleNodesDestroy(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ユーザーノード情報一覧取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterSimpleNodesList = function (options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterSimpleNodesList(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {PatchedSimpleNode} [patchedSimpleNode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterSimpleNodesPartialUpdate = function (id, patchedSimpleNode, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterSimpleNodesPartialUpdate(id, patchedSimpleNode, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterSimpleNodesRetrieve = function (id, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterSimpleNodesRetrieve(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {SimpleNode} simpleNode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterSimpleNodesUpdate = function (id, simpleNode, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterSimpleNodesUpdate(id, simpleNode, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * トレンドグラフ設定追加
     * @param {number} nodeId 設備ID
     * @param {TrendGraphSetting} trendGraphSetting
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterTrendGraphSettingsCreate = function (nodeId, trendGraphSetting, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterTrendGraphSettingsCreate(nodeId, trendGraphSetting, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * トレンドグラフ設定削除
     * @param {number} id A unique integer value identifying this m_trend_graph_setting.
     * @param {number} nodeId 設備ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterTrendGraphSettingsDestroy = function (id, nodeId, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterTrendGraphSettingsDestroy(id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * トレンドグラフ設定一覧
     * @param {number} nodeId 設備ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterTrendGraphSettingsList = function (nodeId, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterTrendGraphSettingsList(nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id A unique integer value identifying this m_trend_graph_setting.
     * @param {PatchedTrendGraphSetting} [patchedTrendGraphSetting]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterTrendGraphSettingsPartialUpdate = function (id, patchedTrendGraphSetting, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterTrendGraphSettingsPartialUpdate(id, patchedTrendGraphSetting, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * トレンドグラフ設定詳細取得
     * @param {number} id A unique integer value identifying this m_trend_graph_setting.
     * @param {number} nodeId 設備ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterTrendGraphSettingsRetrieve = function (id, nodeId, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterTrendGraphSettingsRetrieve(id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * トレンドグラフ設定更新
     * @param {number} id A unique integer value identifying this m_trend_graph_setting.
     * @param {number} nodeId 設備ID
     * @param {TrendGraphSetting} trendGraphSetting
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterTrendGraphSettingsUpdate = function (id, nodeId, trendGraphSetting, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterTrendGraphSettingsUpdate(id, nodeId, trendGraphSetting, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {UserNode} userNode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterUserNodeMenuCreate = function (userNode, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterUserNodeMenuCreate(userNode, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id A unique integer value identifying this m_user_node.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterUserNodeMenuDestroy = function (id, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterUserNodeMenuDestroy(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterUserNodeMenuList = function (options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterUserNodeMenuList(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id A unique integer value identifying this m_user_node.
     * @param {PatchedUserNode} [patchedUserNode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterUserNodeMenuPartialUpdate = function (id, patchedUserNode, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterUserNodeMenuPartialUpdate(id, patchedUserNode, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ユーザノードメニュー情報詳細取得
     * @param {number} id A unique integer value identifying this m_user_node.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterUserNodeMenuRetrieve = function (id, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterUserNodeMenuRetrieve(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ユーザノードメニュー設定情報更新
     * @param {number} id A unique integer value identifying this m_user_node.
     * @param {UserNode} userNode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterUserNodeMenuUpdate = function (id, userNode, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterUserNodeMenuUpdate(id, userNode, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ユーザノードロール情報追加
     * @param {UserNodeRole} userNodeRole
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterUserNodeRolesCreate = function (userNodeRole, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterUserNodeRolesCreate(userNodeRole, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ユーザノードロール情報削除
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterUserNodeRolesDestroy = function (id, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterUserNodeRolesDestroy(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ユーザノードロール情報一覧取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterUserNodeRolesList = function (options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterUserNodeRolesList(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ユーザノードロール情報更新（一部）
     * @param {string} id
     * @param {PatchedUserNodeRole} [patchedUserNodeRole]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterUserNodeRolesPartialUpdate = function (id, patchedUserNodeRole, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterUserNodeRolesPartialUpdate(id, patchedUserNodeRole, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ユーザノードロール情報詳細取得
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterUserNodeRolesRetrieve = function (id, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterUserNodeRolesRetrieve(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ユーザノードロール情報更新
     * @param {string} id
     * @param {UserNodeRole} userNodeRole
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterUserNodeRolesUpdate = function (id, userNodeRole, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterUserNodeRolesUpdate(id, userNodeRole, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ユーザー・ノード設定追加
     * @param {number} nodeId 設備ID
     * @param {UserNodeSetting} userNodeSetting
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterUserNodeSettingsCreate = function (nodeId, userNodeSetting, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterUserNodeSettingsCreate(nodeId, userNodeSetting, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ユーザー・ノード設定削除
     * @param {number} id A unique integer value identifying this m_user_node_setting.
     * @param {number} nodeId 設備ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterUserNodeSettingsDestroy = function (id, nodeId, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterUserNodeSettingsDestroy(id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ユーザー・ノード設定一覧
     * @param {number} nodeId 設備ID
     * @param {number} userId ユーザID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterUserNodeSettingsList = function (nodeId, userId, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterUserNodeSettingsList(nodeId, userId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ユーザー・ノード設定更新（一部）
     * @param {number} id A unique integer value identifying this m_user_node_setting.
     * @param {number} nodeId 設備ID
     * @param {PatchedUserNodeSetting} [patchedUserNodeSetting]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterUserNodeSettingsPartialUpdate = function (id, nodeId, patchedUserNodeSetting, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterUserNodeSettingsPartialUpdate(id, nodeId, patchedUserNodeSetting, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ユーザー・ノード設定詳細取得
     * @param {number} id A unique integer value identifying this m_user_node_setting.
     * @param {number} nodeId 設備ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterUserNodeSettingsRetrieve = function (id, nodeId, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterUserNodeSettingsRetrieve(id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ユーザー・ノード設定更新
     * @param {number} id A unique integer value identifying this m_user_node_setting.
     * @param {number} nodeId 設備ID
     * @param {UserNodeSetting} userNodeSetting
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterUserNodeSettingsUpdate = function (id, nodeId, userNodeSetting, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterUserNodeSettingsUpdate(id, nodeId, userNodeSetting, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ユーザノード情報追加
     * @param {SimpleNode} simpleNode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterUserNodesCreate = function (simpleNode, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterUserNodesCreate(simpleNode, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ユーザノード情報削除
     * @param {number} id A unique integer value identifying this m_user_node.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterUserNodesDestroy = function (id, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterUserNodesDestroy(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ユーザノード情報一覧取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterUserNodesList = function (options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterUserNodesList(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ユーザノード情報更新（一部）
     * @param {number} id A unique integer value identifying this m_user_node.
     * @param {PatchedSimpleNode} [patchedSimpleNode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterUserNodesPartialUpdate = function (id, patchedSimpleNode, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterUserNodesPartialUpdate(id, patchedSimpleNode, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ユーザノード情報詳細取得
     * @param {number} id A unique integer value identifying this m_user_node.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterUserNodesRetrieve = function (id, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterUserNodesRetrieve(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ユーザノード情報更新
     * @param {number} id A unique integer value identifying this m_user_node.
     * @param {SimpleNode} simpleNode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterUserNodesUpdate = function (id, simpleNode, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterUserNodesUpdate(id, simpleNode, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ユーザロール情報追加
     * @param {UserRole} userRole
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterUserRolesCreate = function (userRole, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterUserRolesCreate(userRole, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ユーザロール情報削除
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterUserRolesDestroy = function (id, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterUserRolesDestroy(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ユーザロール情報一覧取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterUserRolesList = function (options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterUserRolesList(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ユーザロール情報更新（一部）
     * @param {string} id
     * @param {PatchedUserRole} [patchedUserRole]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterUserRolesPartialUpdate = function (id, patchedUserRole, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterUserRolesPartialUpdate(id, patchedUserRole, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ユーザロール情報詳細取得
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterUserRolesRetrieve = function (id, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterUserRolesRetrieve(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ユーザロール情報更新
     * @param {string} id
     * @param {UserRole} userRole
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterUserRolesUpdate = function (id, userRole, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterUserRolesUpdate(id, userRole, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ユーザ情報追加
     * @param {User} user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterUsersCreate = function (user, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterUsersCreate(user, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ユーザー登録CSVファイルへのバリデーションチェック
     * @param {CsvUserValidate} [csvUserValidate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterUsersCsvCheckValidateCreate = function (csvUserValidate, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterUsersCsvCheckValidateCreate(csvUserValidate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ユーザー登録CSVを使った一括ユーザー登録
     * @param {CsvUserCreate} [csvUserCreate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterUsersCsvUserCreateCreate = function (csvUserCreate, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterUsersCsvUserCreateCreate(csvUserCreate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ユーザ情報削除
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterUsersDestroy = function (id, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterUsersDestroy(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ユーザ情報一覧取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterUsersList = function (options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterUsersList(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ユーザ情報更新（一部）
     * @param {string} id
     * @param {PatchedUser} [patchedUser]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterUsersPartialUpdate = function (id, patchedUser, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterUsersPartialUpdate(id, patchedUser, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ユーザ情報詳細取得
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterUsersRetrieve = function (id, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterUsersRetrieve(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ユーザ情報更新
     * @param {string} id
     * @param {User} user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    MasterApi.prototype.masterUsersUpdate = function (id, user, options) {
        var _this = this;
        return (0, exports.MasterApiFp)(this.configuration).masterUsersUpdate(id, user, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return MasterApi;
}(base_1.BaseAPI));
exports.MasterApi = MasterApi;
/**
 * NodesApi - axios parameter creator
 * @export
 */
var NodesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * 警報履歴取得
         * @param {string} nodeId
         * @param {number} timeFrom 取得期間（開始）
         * @param {number} timeTo 取得期間（終了）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesAlarmHistoryList: function (nodeId, timeFrom, timeTo, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesAlarmHistoryList', 'nodeId', nodeId);
                            // verify required parameter 'timeFrom' is not null or undefined
                            (0, common_1.assertParamExists)('nodesAlarmHistoryList', 'timeFrom', timeFrom);
                            // verify required parameter 'timeTo' is not null or undefined
                            (0, common_1.assertParamExists)('nodesAlarmHistoryList', 'timeTo', timeTo);
                            localVarPath = "/swc-api/nodes/{node_id}/alarm-history"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (timeFrom !== undefined) {
                                localVarQueryParameter['time_from'] = timeFrom;
                            }
                            if (timeTo !== undefined) {
                                localVarQueryParameter['time_to'] = timeTo;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns list of algorithms.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraAiAlgorithmsList: function (nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCameraAiAlgorithmsList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/camera-ai-algorithms"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns algorithm.
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraAiAlgorithmsRetrieve: function (id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCameraAiAlgorithmsRetrieve', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCameraAiAlgorithmsRetrieve', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/camera-ai-algorithms/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns algorithm.
         * @param {string} algorithmName
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraAiAlgorithmsVersionsRetrieve: function (algorithmName, id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'algorithmName' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCameraAiAlgorithmsVersionsRetrieve', 'algorithmName', algorithmName);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCameraAiAlgorithmsVersionsRetrieve', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCameraAiAlgorithmsVersionsRetrieve', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/camera-ai-algorithms/{algorithm_name}/versions/{id}"
                                .replace("{".concat("algorithm_name", "}"), encodeURIComponent(String(algorithmName)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * カメラAIモデル追加
         * @param {string} nodeId
         * @param {CameraAIModel} cameraAIModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraAiModelsCreate: function (nodeId, cameraAIModel, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCameraAiModelsCreate', 'nodeId', nodeId);
                            // verify required parameter 'cameraAIModel' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCameraAiModelsCreate', 'cameraAIModel', cameraAIModel);
                            localVarPath = "/swc-api/nodes/{node_id}/camera-ai-models"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(cameraAIModel, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * カメラAIモデル削除
         * @param {number} id A unique integer value identifying this m_camera_ai_model.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraAiModelsDestroy: function (id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCameraAiModelsDestroy', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCameraAiModelsDestroy', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/camera-ai-models/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 最新MLPipelineID
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraAiModelsLatestPipelineIdRetrieve: function (nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCameraAiModelsLatestPipelineIdRetrieve', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/camera-ai-models/latest_pipeline_id"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * カメラ一AIモデル覧取得
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraAiModelsList: function (nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCameraAiModelsList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/camera-ai-models"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * カメラAIモデル更新（一部）
         * @param {number} id A unique integer value identifying this m_camera_ai_model.
         * @param {string} nodeId
         * @param {PatchedCameraAIModel} [patchedCameraAIModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraAiModelsPartialUpdate: function (id, nodeId, patchedCameraAIModel, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCameraAiModelsPartialUpdate', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCameraAiModelsPartialUpdate', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/camera-ai-models/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchedCameraAIModel, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * カメラAIモデル詳細取得
         * @param {number} id A unique integer value identifying this m_camera_ai_model.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraAiModelsRetrieve: function (id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCameraAiModelsRetrieve', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCameraAiModelsRetrieve', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/camera-ai-models/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * カメラAIモデル更新
         * @param {number} id A unique integer value identifying this m_camera_ai_model.
         * @param {string} nodeId
         * @param {CameraAIModel} cameraAIModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraAiModelsUpdate: function (id, nodeId, cameraAIModel, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCameraAiModelsUpdate', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCameraAiModelsUpdate', 'nodeId', nodeId);
                            // verify required parameter 'cameraAIModel' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCameraAiModelsUpdate', 'cameraAIModel', cameraAIModel);
                            localVarPath = "/swc-api/nodes/{node_id}/camera-ai-models/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(cameraAIModel, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * カメラThingデプロイ承認
         * @param {string} id
         * @param {string} nodeId
         * @param {string} thingName
         * @param {CameraThingDeploymentApprove} cameraThingDeploymentApprove
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraThingsDeploymentsApproveCreate: function (id, nodeId, thingName, cameraThingDeploymentApprove, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCameraThingsDeploymentsApproveCreate', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCameraThingsDeploymentsApproveCreate', 'nodeId', nodeId);
                            // verify required parameter 'thingName' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCameraThingsDeploymentsApproveCreate', 'thingName', thingName);
                            // verify required parameter 'cameraThingDeploymentApprove' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCameraThingsDeploymentsApproveCreate', 'cameraThingDeploymentApprove', cameraThingDeploymentApprove);
                            localVarPath = "/swc-api/nodes/{node_id}/camera-things/{thing_name}/deployments/{id}/approve"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)))
                                .replace("{".concat("thing_name", "}"), encodeURIComponent(String(thingName)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(cameraThingDeploymentApprove, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * カメラThingデプロイキャンセル
         * @param {string} id
         * @param {string} nodeId
         * @param {string} thingName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraThingsDeploymentsCancelCreate: function (id, nodeId, thingName, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCameraThingsDeploymentsCancelCreate', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCameraThingsDeploymentsCancelCreate', 'nodeId', nodeId);
                            // verify required parameter 'thingName' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCameraThingsDeploymentsCancelCreate', 'thingName', thingName);
                            localVarPath = "/swc-api/nodes/{node_id}/camera-things/{thing_name}/deployments/{id}/cancel"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)))
                                .replace("{".concat("thing_name", "}"), encodeURIComponent(String(thingName)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * カメラThingデプロイ作成
         * @param {string} nodeId
         * @param {string} thingName
         * @param {CameraThingDeployment} cameraThingDeployment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraThingsDeploymentsCreate: function (nodeId, thingName, cameraThingDeployment, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCameraThingsDeploymentsCreate', 'nodeId', nodeId);
                            // verify required parameter 'thingName' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCameraThingsDeploymentsCreate', 'thingName', thingName);
                            // verify required parameter 'cameraThingDeployment' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCameraThingsDeploymentsCreate', 'cameraThingDeployment', cameraThingDeployment);
                            localVarPath = "/swc-api/nodes/{node_id}/camera-things/{thing_name}/deployments"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)))
                                .replace("{".concat("thing_name", "}"), encodeURIComponent(String(thingName)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(cameraThingDeployment, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * カメラThingデプロイ設定
         * @param {string} nodeId
         * @param {string} thingName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraThingsDeploymentsCurrentRetrieve: function (nodeId, thingName, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCameraThingsDeploymentsCurrentRetrieve', 'nodeId', nodeId);
                            // verify required parameter 'thingName' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCameraThingsDeploymentsCurrentRetrieve', 'thingName', thingName);
                            localVarPath = "/swc-api/nodes/{node_id}/camera-things/{thing_name}/deployments/current"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)))
                                .replace("{".concat("thing_name", "}"), encodeURIComponent(String(thingName)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * カメラThingデプロイ一覧
         * @param {string} nodeId
         * @param {string} thingName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraThingsDeploymentsList: function (nodeId, thingName, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCameraThingsDeploymentsList', 'nodeId', nodeId);
                            // verify required parameter 'thingName' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCameraThingsDeploymentsList', 'thingName', thingName);
                            localVarPath = "/swc-api/nodes/{node_id}/camera-things/{thing_name}/deployments"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)))
                                .replace("{".concat("thing_name", "}"), encodeURIComponent(String(thingName)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * カメラThingデプロイ詳細
         * @param {string} id
         * @param {string} nodeId
         * @param {string} thingName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraThingsDeploymentsRetrieve: function (id, nodeId, thingName, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCameraThingsDeploymentsRetrieve', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCameraThingsDeploymentsRetrieve', 'nodeId', nodeId);
                            // verify required parameter 'thingName' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCameraThingsDeploymentsRetrieve', 'thingName', thingName);
                            localVarPath = "/swc-api/nodes/{node_id}/camera-things/{thing_name}/deployments/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)))
                                .replace("{".concat("thing_name", "}"), encodeURIComponent(String(thingName)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * カメラThingデプロイ再試行
         * @param {string} id
         * @param {string} nodeId
         * @param {string} thingName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraThingsDeploymentsRetryCreate: function (id, nodeId, thingName, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCameraThingsDeploymentsRetryCreate', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCameraThingsDeploymentsRetryCreate', 'nodeId', nodeId);
                            // verify required parameter 'thingName' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCameraThingsDeploymentsRetryCreate', 'thingName', thingName);
                            localVarPath = "/swc-api/nodes/{node_id}/camera-things/{thing_name}/deployments/{id}/retry"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)))
                                .replace("{".concat("thing_name", "}"), encodeURIComponent(String(thingName)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 環境取得
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraThingsEnvironmentRetrieve: function (id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCameraThingsEnvironmentRetrieve', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCameraThingsEnvironmentRetrieve', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/camera-things/{id}/environment"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * カメラThing
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraThingsList: function (nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCameraThingsList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/camera-things"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * カメラThing
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraThingsRetrieve: function (id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCameraThingsRetrieve', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCameraThingsRetrieve', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/camera-things/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * カメラAIモデル構築ジョブ承認
         * @param {string} cameraId
         * @param {string} id
         * @param {string} modelId
         * @param {string} nodeId
         * @param {CameraAIModelBuildJobApprove} cameraAIModelBuildJobApprove
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCamerasModelsBuildJobsApproveCreate: function (cameraId, id, modelId, nodeId, cameraAIModelBuildJobApprove, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'cameraId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsApproveCreate', 'cameraId', cameraId);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsApproveCreate', 'id', id);
                            // verify required parameter 'modelId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsApproveCreate', 'modelId', modelId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsApproveCreate', 'nodeId', nodeId);
                            // verify required parameter 'cameraAIModelBuildJobApprove' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsApproveCreate', 'cameraAIModelBuildJobApprove', cameraAIModelBuildJobApprove);
                            localVarPath = "/swc-api/nodes/{node_id}/cameras/{camera_id}/models/{model_id}/build-jobs/{id}/approve"
                                .replace("{".concat("camera_id", "}"), encodeURIComponent(String(cameraId)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("model_id", "}"), encodeURIComponent(String(modelId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(cameraAIModelBuildJobApprove, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * カメラAIモデル構築ジョブキャンセル
         * @param {string} cameraId
         * @param {string} id
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCamerasModelsBuildJobsCancelCreate: function (cameraId, id, modelId, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'cameraId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsCancelCreate', 'cameraId', cameraId);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsCancelCreate', 'id', id);
                            // verify required parameter 'modelId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsCancelCreate', 'modelId', modelId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsCancelCreate', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/cameras/{camera_id}/models/{model_id}/build-jobs/{id}/cancel"
                                .replace("{".concat("camera_id", "}"), encodeURIComponent(String(cameraId)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("model_id", "}"), encodeURIComponent(String(modelId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create comment.
         * @param {string} cameraId
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {CameraAIModelBuildJobComment} cameraAIModelBuildJobComment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCamerasModelsBuildJobsCommentsCreate: function (cameraId, jobId, modelId, nodeId, cameraAIModelBuildJobComment, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'cameraId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsCommentsCreate', 'cameraId', cameraId);
                            // verify required parameter 'jobId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsCommentsCreate', 'jobId', jobId);
                            // verify required parameter 'modelId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsCommentsCreate', 'modelId', modelId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsCommentsCreate', 'nodeId', nodeId);
                            // verify required parameter 'cameraAIModelBuildJobComment' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsCommentsCreate', 'cameraAIModelBuildJobComment', cameraAIModelBuildJobComment);
                            localVarPath = "/swc-api/nodes/{node_id}/cameras/{camera_id}/models/{model_id}/build-jobs/{job_id}/comments"
                                .replace("{".concat("camera_id", "}"), encodeURIComponent(String(cameraId)))
                                .replace("{".concat("job_id", "}"), encodeURIComponent(String(jobId)))
                                .replace("{".concat("model_id", "}"), encodeURIComponent(String(modelId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(cameraAIModelBuildJobComment, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete comment
         * @param {string} cameraId
         * @param {number} id A unique integer value identifying this t_camera_ai_model_build_job_comment.
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCamerasModelsBuildJobsCommentsDestroy: function (cameraId, id, jobId, modelId, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'cameraId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsCommentsDestroy', 'cameraId', cameraId);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsCommentsDestroy', 'id', id);
                            // verify required parameter 'jobId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsCommentsDestroy', 'jobId', jobId);
                            // verify required parameter 'modelId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsCommentsDestroy', 'modelId', modelId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsCommentsDestroy', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/cameras/{camera_id}/models/{model_id}/build-jobs/{job_id}/comments/{id}"
                                .replace("{".concat("camera_id", "}"), encodeURIComponent(String(cameraId)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("job_id", "}"), encodeURIComponent(String(jobId)))
                                .replace("{".concat("model_id", "}"), encodeURIComponent(String(modelId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns list of comments.
         * @param {string} cameraId
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCamerasModelsBuildJobsCommentsList: function (cameraId, jobId, modelId, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'cameraId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsCommentsList', 'cameraId', cameraId);
                            // verify required parameter 'jobId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsCommentsList', 'jobId', jobId);
                            // verify required parameter 'modelId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsCommentsList', 'modelId', modelId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsCommentsList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/cameras/{camera_id}/models/{model_id}/build-jobs/{job_id}/comments"
                                .replace("{".concat("camera_id", "}"), encodeURIComponent(String(cameraId)))
                                .replace("{".concat("job_id", "}"), encodeURIComponent(String(jobId)))
                                .replace("{".concat("model_id", "}"), encodeURIComponent(String(modelId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * カメラAIモデル構築ジョブコメント
         * @param {string} cameraId
         * @param {number} id A unique integer value identifying this t_camera_ai_model_build_job_comment.
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {PatchedCameraAIModelBuildJobComment} [patchedCameraAIModelBuildJobComment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCamerasModelsBuildJobsCommentsPartialUpdate: function (cameraId, id, jobId, modelId, nodeId, patchedCameraAIModelBuildJobComment, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'cameraId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsCommentsPartialUpdate', 'cameraId', cameraId);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsCommentsPartialUpdate', 'id', id);
                            // verify required parameter 'jobId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsCommentsPartialUpdate', 'jobId', jobId);
                            // verify required parameter 'modelId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsCommentsPartialUpdate', 'modelId', modelId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsCommentsPartialUpdate', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/cameras/{camera_id}/models/{model_id}/build-jobs/{job_id}/comments/{id}"
                                .replace("{".concat("camera_id", "}"), encodeURIComponent(String(cameraId)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("job_id", "}"), encodeURIComponent(String(jobId)))
                                .replace("{".concat("model_id", "}"), encodeURIComponent(String(modelId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchedCameraAIModelBuildJobComment, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * カメラAIモデル構築ジョブコメント
         * @param {string} cameraId
         * @param {number} id A unique integer value identifying this t_camera_ai_model_build_job_comment.
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCamerasModelsBuildJobsCommentsRetrieve: function (cameraId, id, jobId, modelId, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'cameraId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsCommentsRetrieve', 'cameraId', cameraId);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsCommentsRetrieve', 'id', id);
                            // verify required parameter 'jobId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsCommentsRetrieve', 'jobId', jobId);
                            // verify required parameter 'modelId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsCommentsRetrieve', 'modelId', modelId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsCommentsRetrieve', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/cameras/{camera_id}/models/{model_id}/build-jobs/{job_id}/comments/{id}"
                                .replace("{".concat("camera_id", "}"), encodeURIComponent(String(cameraId)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("job_id", "}"), encodeURIComponent(String(jobId)))
                                .replace("{".concat("model_id", "}"), encodeURIComponent(String(modelId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update comment.
         * @param {string} cameraId
         * @param {number} id A unique integer value identifying this t_camera_ai_model_build_job_comment.
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {CameraAIModelBuildJobComment} cameraAIModelBuildJobComment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCamerasModelsBuildJobsCommentsUpdate: function (cameraId, id, jobId, modelId, nodeId, cameraAIModelBuildJobComment, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'cameraId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsCommentsUpdate', 'cameraId', cameraId);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsCommentsUpdate', 'id', id);
                            // verify required parameter 'jobId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsCommentsUpdate', 'jobId', jobId);
                            // verify required parameter 'modelId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsCommentsUpdate', 'modelId', modelId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsCommentsUpdate', 'nodeId', nodeId);
                            // verify required parameter 'cameraAIModelBuildJobComment' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsCommentsUpdate', 'cameraAIModelBuildJobComment', cameraAIModelBuildJobComment);
                            localVarPath = "/swc-api/nodes/{node_id}/cameras/{camera_id}/models/{model_id}/build-jobs/{job_id}/comments/{id}"
                                .replace("{".concat("camera_id", "}"), encodeURIComponent(String(cameraId)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("job_id", "}"), encodeURIComponent(String(jobId)))
                                .replace("{".concat("model_id", "}"), encodeURIComponent(String(modelId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(cameraAIModelBuildJobComment, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * カメラAIモデル構築ジョブ作成
         * @param {string} cameraId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {CameraAIModelBuildJob} data
         * @param {any} [zipFile]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCamerasModelsBuildJobsCreate: function (cameraId, modelId, nodeId, data, zipFile, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'cameraId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsCreate', 'cameraId', cameraId);
                            // verify required parameter 'modelId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsCreate', 'modelId', modelId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsCreate', 'nodeId', nodeId);
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsCreate', 'data', data);
                            localVarPath = "/swc-api/nodes/{node_id}/cameras/{camera_id}/models/{model_id}/build-jobs"
                                .replace("{".concat("camera_id", "}"), encodeURIComponent(String(cameraId)))
                                .replace("{".concat("model_id", "}"), encodeURIComponent(String(modelId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (zipFile !== undefined) {
                                localVarFormParams.append('zip_file', zipFile);
                            }
                            if (data !== undefined) {
                                localVarFormParams.append('data', new Blob([JSON.stringify(data)], { type: "application/json", }));
                            }
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns list of images.
         * @param {string} cameraId
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCamerasModelsBuildJobsImagesList: function (cameraId, jobId, modelId, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'cameraId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsImagesList', 'cameraId', cameraId);
                            // verify required parameter 'jobId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsImagesList', 'jobId', jobId);
                            // verify required parameter 'modelId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsImagesList', 'modelId', modelId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsImagesList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/cameras/{camera_id}/models/{model_id}/build-jobs/{job_id}/images"
                                .replace("{".concat("camera_id", "}"), encodeURIComponent(String(cameraId)))
                                .replace("{".concat("job_id", "}"), encodeURIComponent(String(jobId)))
                                .replace("{".concat("model_id", "}"), encodeURIComponent(String(modelId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 画像取得
         * @param {string} cameraId
         * @param {string} id
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCamerasModelsBuildJobsImagesRetrieve: function (cameraId, id, jobId, modelId, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'cameraId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsImagesRetrieve', 'cameraId', cameraId);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsImagesRetrieve', 'id', id);
                            // verify required parameter 'jobId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsImagesRetrieve', 'jobId', jobId);
                            // verify required parameter 'modelId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsImagesRetrieve', 'modelId', modelId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsImagesRetrieve', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/cameras/{camera_id}/models/{model_id}/build-jobs/{job_id}/images/{id}"
                                .replace("{".concat("camera_id", "}"), encodeURIComponent(String(cameraId)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("job_id", "}"), encodeURIComponent(String(jobId)))
                                .replace("{".concat("model_id", "}"), encodeURIComponent(String(modelId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * カメラAIモデル構築ジョブ一覧
         * @param {string} cameraId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCamerasModelsBuildJobsList: function (cameraId, modelId, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'cameraId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsList', 'cameraId', cameraId);
                            // verify required parameter 'modelId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsList', 'modelId', modelId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/cameras/{camera_id}/models/{model_id}/build-jobs"
                                .replace("{".concat("camera_id", "}"), encodeURIComponent(String(cameraId)))
                                .replace("{".concat("model_id", "}"), encodeURIComponent(String(modelId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * カメラAIモデル構築ジョブ評価結果
         * @param {string} cameraId
         * @param {string} id
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCamerasModelsBuildJobsResultRetrieve: function (cameraId, id, modelId, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'cameraId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsResultRetrieve', 'cameraId', cameraId);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsResultRetrieve', 'id', id);
                            // verify required parameter 'modelId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsResultRetrieve', 'modelId', modelId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsResultRetrieve', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/cameras/{camera_id}/models/{model_id}/build-jobs/{id}/result"
                                .replace("{".concat("camera_id", "}"), encodeURIComponent(String(cameraId)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("model_id", "}"), encodeURIComponent(String(modelId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * カメラAIモデル構築ジョブ詳細
         * @param {string} cameraId
         * @param {string} id
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCamerasModelsBuildJobsRetrieve: function (cameraId, id, modelId, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'cameraId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsRetrieve', 'cameraId', cameraId);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsRetrieve', 'id', id);
                            // verify required parameter 'modelId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsRetrieve', 'modelId', modelId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsRetrieve', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/cameras/{camera_id}/models/{model_id}/build-jobs/{id}"
                                .replace("{".concat("camera_id", "}"), encodeURIComponent(String(cameraId)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("model_id", "}"), encodeURIComponent(String(modelId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * カメラAIモデル構築ジョブ再試行
         * @param {string} cameraId
         * @param {string} id
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCamerasModelsBuildJobsRetryCreate: function (cameraId, id, modelId, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'cameraId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsRetryCreate', 'cameraId', cameraId);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsRetryCreate', 'id', id);
                            // verify required parameter 'modelId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsRetryCreate', 'modelId', modelId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsRetryCreate', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/cameras/{camera_id}/models/{model_id}/build-jobs/{id}/retry"
                                .replace("{".concat("camera_id", "}"), encodeURIComponent(String(cameraId)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("model_id", "}"), encodeURIComponent(String(modelId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * カメラAIモデル構築ジョブ詳細
         * @param {string} cameraId
         * @param {string} id
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCamerasModelsBuildJobsStateRetrieve: function (cameraId, id, modelId, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'cameraId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsStateRetrieve', 'cameraId', cameraId);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsStateRetrieve', 'id', id);
                            // verify required parameter 'modelId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsStateRetrieve', 'modelId', modelId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesCamerasModelsBuildJobsStateRetrieve', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/cameras/{camera_id}/models/{model_id}/build-jobs/{id}/state"
                                .replace("{".concat("camera_id", "}"), encodeURIComponent(String(cameraId)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("model_id", "}"), encodeURIComponent(String(modelId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 帳票データ修正
         * @param {string} nodeId
         * @param {ChouhyoEdit} chouhyoEdit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesChouhyoEditCreate: function (nodeId, chouhyoEdit, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesChouhyoEditCreate', 'nodeId', nodeId);
                            // verify required parameter 'chouhyoEdit' is not null or undefined
                            (0, common_1.assertParamExists)('nodesChouhyoEditCreate', 'chouhyoEdit', chouhyoEdit);
                            localVarPath = "/swc-api/nodes/{node_id}/chouhyo-edit"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(chouhyoEdit, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} nodeId
         * @param {ChouhyoOutput} chouhyoOutput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesChouhyoOutputCreate: function (nodeId, chouhyoOutput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesChouhyoOutputCreate', 'nodeId', nodeId);
                            // verify required parameter 'chouhyoOutput' is not null or undefined
                            (0, common_1.assertParamExists)('nodesChouhyoOutputCreate', 'chouhyoOutput', chouhyoOutput);
                            localVarPath = "/swc-api/nodes/{node_id}/chouhyo-output"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(chouhyoOutput, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesChouhyoOutputDestroy: function (id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesChouhyoOutputDestroy', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesChouhyoOutputDestroy', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/chouhyo-output/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 帳票取得 API
         * @param {number} id 帳票ID
         * @param {string} nodeId
         * @param {number} timestamp 対象日付
         * @param {string} type 帳票種別（日報(D)/月報(M)/年報(Y)）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesChouhyoOutputList: function (id, nodeId, timestamp, type, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesChouhyoOutputList', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesChouhyoOutputList', 'nodeId', nodeId);
                            // verify required parameter 'timestamp' is not null or undefined
                            (0, common_1.assertParamExists)('nodesChouhyoOutputList', 'timestamp', timestamp);
                            // verify required parameter 'type' is not null or undefined
                            (0, common_1.assertParamExists)('nodesChouhyoOutputList', 'type', type);
                            localVarPath = "/swc-api/nodes/{node_id}/chouhyo-output"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (id !== undefined) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (timestamp !== undefined) {
                                localVarQueryParameter['timestamp'] = timestamp;
                            }
                            if (type !== undefined) {
                                localVarQueryParameter['type'] = type;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {string} nodeId
         * @param {PatchedChouhyoOutput} [patchedChouhyoOutput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesChouhyoOutputPartialUpdate: function (id, nodeId, patchedChouhyoOutput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesChouhyoOutputPartialUpdate', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesChouhyoOutputPartialUpdate', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/chouhyo-output/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchedChouhyoOutput, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesChouhyoOutputRetrieve: function (id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesChouhyoOutputRetrieve', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesChouhyoOutputRetrieve', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/chouhyo-output/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} nodeId
         * @param {ChouhyoOutputSetting} chouhyoOutputSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesChouhyoOutputSettingCreate: function (nodeId, chouhyoOutputSetting, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesChouhyoOutputSettingCreate', 'nodeId', nodeId);
                            // verify required parameter 'chouhyoOutputSetting' is not null or undefined
                            (0, common_1.assertParamExists)('nodesChouhyoOutputSettingCreate', 'chouhyoOutputSetting', chouhyoOutputSetting);
                            localVarPath = "/swc-api/nodes/{node_id}/chouhyo-output-setting"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(chouhyoOutputSetting, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this m_chouhyo_output_setting.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesChouhyoOutputSettingDestroy: function (id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesChouhyoOutputSettingDestroy', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesChouhyoOutputSettingDestroy', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/chouhyo-output-setting/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesChouhyoOutputSettingList: function (nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesChouhyoOutputSettingList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/chouhyo-output-setting"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this m_chouhyo_output_setting.
         * @param {string} nodeId
         * @param {PatchedChouhyoOutputSetting} [patchedChouhyoOutputSetting]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesChouhyoOutputSettingPartialUpdate: function (id, nodeId, patchedChouhyoOutputSetting, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesChouhyoOutputSettingPartialUpdate', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesChouhyoOutputSettingPartialUpdate', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/chouhyo-output-setting/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchedChouhyoOutputSetting, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this m_chouhyo_output_setting.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesChouhyoOutputSettingRetrieve: function (id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesChouhyoOutputSettingRetrieve', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesChouhyoOutputSettingRetrieve', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/chouhyo-output-setting/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this m_chouhyo_output_setting.
         * @param {string} nodeId
         * @param {ChouhyoOutputSetting} chouhyoOutputSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesChouhyoOutputSettingUpdate: function (id, nodeId, chouhyoOutputSetting, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesChouhyoOutputSettingUpdate', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesChouhyoOutputSettingUpdate', 'nodeId', nodeId);
                            // verify required parameter 'chouhyoOutputSetting' is not null or undefined
                            (0, common_1.assertParamExists)('nodesChouhyoOutputSettingUpdate', 'chouhyoOutputSetting', chouhyoOutputSetting);
                            localVarPath = "/swc-api/nodes/{node_id}/chouhyo-output-setting/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(chouhyoOutputSetting, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {string} nodeId
         * @param {ChouhyoOutput} chouhyoOutput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesChouhyoOutputUpdate: function (id, nodeId, chouhyoOutput, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesChouhyoOutputUpdate', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesChouhyoOutputUpdate', 'nodeId', nodeId);
                            // verify required parameter 'chouhyoOutput' is not null or undefined
                            (0, common_1.assertParamExists)('nodesChouhyoOutputUpdate', 'chouhyoOutput', chouhyoOutput);
                            localVarPath = "/swc-api/nodes/{node_id}/chouhyo-output/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(chouhyoOutput, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ダッシュボード設定追加
         * @param {string} nodeId
         * @param {DashboardSetting} dashboardSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDashboardSettingsCreate: function (nodeId, dashboardSetting, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDashboardSettingsCreate', 'nodeId', nodeId);
                            // verify required parameter 'dashboardSetting' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDashboardSettingsCreate', 'dashboardSetting', dashboardSetting);
                            localVarPath = "/swc-api/nodes/{node_id}/dashboard-settings"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(dashboardSetting, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ダッシュボード設定 API
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDashboardSettingsDestroy: function (id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDashboardSettingsDestroy', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDashboardSettingsDestroy', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/dashboard-settings/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ダッシュボード設定一覧
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDashboardSettingsList: function (nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDashboardSettingsList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/dashboard-settings"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ダッシュボード設定 API
         * @param {string} id
         * @param {string} nodeId
         * @param {PatchedDashboardSetting} [patchedDashboardSetting]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDashboardSettingsPartialUpdate: function (id, nodeId, patchedDashboardSetting, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDashboardSettingsPartialUpdate', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDashboardSettingsPartialUpdate', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/dashboard-settings/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchedDashboardSetting, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ダッシュボード設定 API
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDashboardSettingsRetrieve: function (id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDashboardSettingsRetrieve', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDashboardSettingsRetrieve', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/dashboard-settings/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ダッシュボード設定 API
         * @param {string} id
         * @param {string} nodeId
         * @param {DashboardSetting} dashboardSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDashboardSettingsUpdate: function (id, nodeId, dashboardSetting, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDashboardSettingsUpdate', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDashboardSettingsUpdate', 'nodeId', nodeId);
                            // verify required parameter 'dashboardSetting' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDashboardSettingsUpdate', 'dashboardSetting', dashboardSetting);
                            localVarPath = "/swc-api/nodes/{node_id}/dashboard-settings/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(dashboardSetting, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 連続時間積算履歴取得
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {number} timeFrom 取得期間（開始）
         * @param {number} timeTo 取得期間（終了）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsContinuousTotalHistoryList: function (datasetId, nodeId, timeFrom, timeTo, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'datasetId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsContinuousTotalHistoryList', 'datasetId', datasetId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsContinuousTotalHistoryList', 'nodeId', nodeId);
                            // verify required parameter 'timeFrom' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsContinuousTotalHistoryList', 'timeFrom', timeFrom);
                            // verify required parameter 'timeTo' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsContinuousTotalHistoryList', 'timeTo', timeTo);
                            localVarPath = "/swc-api/nodes/{node_id}/datasets/{dataset_id}/continuous-total/history"
                                .replace("{".concat("dataset_id", "}"), encodeURIComponent(String(datasetId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (timeFrom !== undefined) {
                                localVarQueryParameter['time_from'] = timeFrom;
                            }
                            if (timeTo !== undefined) {
                                localVarQueryParameter['time_to'] = timeTo;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * データ項目の設定
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {Array<FieldSettings>} fieldSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsFieldSettingsCreate: function (datasetId, nodeId, fieldSettings, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'datasetId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsFieldSettingsCreate', 'datasetId', datasetId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsFieldSettingsCreate', 'nodeId', nodeId);
                            // verify required parameter 'fieldSettings' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsFieldSettingsCreate', 'fieldSettings', fieldSettings);
                            localVarPath = "/swc-api/nodes/{node_id}/datasets/{dataset_id}/field-settings"
                                .replace("{".concat("dataset_id", "}"), encodeURIComponent(String(datasetId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(fieldSettings, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * データ設定項目の取得
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {string} [fieldNames] フィールド名
         * @param {string} [fieldTypes] フィールドタイプ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsFieldSettingsList: function (datasetId, nodeId, fieldNames, fieldTypes, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'datasetId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsFieldSettingsList', 'datasetId', datasetId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsFieldSettingsList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/datasets/{dataset_id}/field-settings"
                                .replace("{".concat("dataset_id", "}"), encodeURIComponent(String(datasetId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (fieldNames !== undefined) {
                                localVarQueryParameter['field_names'] = fieldNames;
                            }
                            if (fieldTypes !== undefined) {
                                localVarQueryParameter['field_types'] = fieldTypes;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 画像ダウンロード
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {ImageDownloadRequest} imageDownloadRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsImagesDownloadCreate: function (datasetId, nodeId, imageDownloadRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'datasetId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsImagesDownloadCreate', 'datasetId', datasetId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsImagesDownloadCreate', 'nodeId', nodeId);
                            // verify required parameter 'imageDownloadRequest' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsImagesDownloadCreate', 'imageDownloadRequest', imageDownloadRequest);
                            localVarPath = "/swc-api/nodes/{node_id}/datasets/{dataset_id}/images/download"
                                .replace("{".concat("dataset_id", "}"), encodeURIComponent(String(datasetId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(imageDownloadRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 最新画像取得
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsImagesLatestRetrieve: function (datasetId, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'datasetId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsImagesLatestRetrieve', 'datasetId', datasetId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsImagesLatestRetrieve', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/datasets/{dataset_id}/images/latest"
                                .replace("{".concat("dataset_id", "}"), encodeURIComponent(String(datasetId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 画像一覧取得
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {number} [timeFrom] 取得期間（開始）
         * @param {number} [timeTo] 取得期間（終了）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsImagesList: function (datasetId, nodeId, timeFrom, timeTo, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'datasetId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsImagesList', 'datasetId', datasetId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsImagesList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/datasets/{dataset_id}/images"
                                .replace("{".concat("dataset_id", "}"), encodeURIComponent(String(datasetId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (timeFrom !== undefined) {
                                localVarQueryParameter['time_from'] = timeFrom;
                            }
                            if (timeTo !== undefined) {
                                localVarQueryParameter['time_to'] = timeTo;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 画像取得
         * @param {string} datasetId
         * @param {string} id
         * @param {string} nodeId
         * @param {boolean} [lowQuality] 低画質
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsImagesRetrieve: function (datasetId, id, nodeId, lowQuality, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'datasetId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsImagesRetrieve', 'datasetId', datasetId);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsImagesRetrieve', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsImagesRetrieve', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/datasets/{dataset_id}/images/{id}"
                                .replace("{".concat("dataset_id", "}"), encodeURIComponent(String(datasetId)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (lowQuality !== undefined) {
                                localVarQueryParameter['low_quality'] = lowQuality;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ラベル一括変更
         * @param {string} datasetId
         * @param {string} modelName
         * @param {string} nodeId
         * @param {Array<GroundTruthWithIdPutRequest>} groundTruthWithIdPutRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsModelsGroundTruthsBulkUpdate: function (datasetId, modelName, nodeId, groundTruthWithIdPutRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'datasetId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsModelsGroundTruthsBulkUpdate', 'datasetId', datasetId);
                            // verify required parameter 'modelName' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsModelsGroundTruthsBulkUpdate', 'modelName', modelName);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsModelsGroundTruthsBulkUpdate', 'nodeId', nodeId);
                            // verify required parameter 'groundTruthWithIdPutRequest' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsModelsGroundTruthsBulkUpdate', 'groundTruthWithIdPutRequest', groundTruthWithIdPutRequest);
                            localVarPath = "/swc-api/nodes/{node_id}/datasets/{dataset_id}/models/{model_name}/ground-truths/bulk"
                                .replace("{".concat("dataset_id", "}"), encodeURIComponent(String(datasetId)))
                                .replace("{".concat("model_name", "}"), encodeURIComponent(String(modelName)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(groundTruthWithIdPutRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ラベル一覧取得
         * @param {string} datasetId
         * @param {string} modelName
         * @param {string} nodeId
         * @param {number} [timeFrom] 取得期間（開始）
         * @param {number} [timeTo] 取得期間（終了）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsModelsGroundTruthsList: function (datasetId, modelName, nodeId, timeFrom, timeTo, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'datasetId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsModelsGroundTruthsList', 'datasetId', datasetId);
                            // verify required parameter 'modelName' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsModelsGroundTruthsList', 'modelName', modelName);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsModelsGroundTruthsList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/datasets/{dataset_id}/models/{model_name}/ground-truths"
                                .replace("{".concat("dataset_id", "}"), encodeURIComponent(String(datasetId)))
                                .replace("{".concat("model_name", "}"), encodeURIComponent(String(modelName)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (timeFrom !== undefined) {
                                localVarQueryParameter['time_from'] = timeFrom;
                            }
                            if (timeTo !== undefined) {
                                localVarQueryParameter['time_to'] = timeTo;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ラベル変更
         * @param {string} datasetId
         * @param {string} id
         * @param {string} modelName
         * @param {string} nodeId
         * @param {GroundTruthPutRequest} groundTruthPutRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsModelsGroundTruthsUpdate: function (datasetId, id, modelName, nodeId, groundTruthPutRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'datasetId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsModelsGroundTruthsUpdate', 'datasetId', datasetId);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsModelsGroundTruthsUpdate', 'id', id);
                            // verify required parameter 'modelName' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsModelsGroundTruthsUpdate', 'modelName', modelName);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsModelsGroundTruthsUpdate', 'nodeId', nodeId);
                            // verify required parameter 'groundTruthPutRequest' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsModelsGroundTruthsUpdate', 'groundTruthPutRequest', groundTruthPutRequest);
                            localVarPath = "/swc-api/nodes/{node_id}/datasets/{dataset_id}/models/{model_name}/ground-truths/{id}"
                                .replace("{".concat("dataset_id", "}"), encodeURIComponent(String(datasetId)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("model_name", "}"), encodeURIComponent(String(modelName)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(groundTruthPutRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 移動平均時間の設定
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {Array<MonitoringTransformSettings>} monitoringTransformSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsMonitoringTransformSettingsCreate: function (datasetId, nodeId, monitoringTransformSettings, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'datasetId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsMonitoringTransformSettingsCreate', 'datasetId', datasetId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsMonitoringTransformSettingsCreate', 'nodeId', nodeId);
                            // verify required parameter 'monitoringTransformSettings' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsMonitoringTransformSettingsCreate', 'monitoringTransformSettings', monitoringTransformSettings);
                            localVarPath = "/swc-api/nodes/{node_id}/datasets/{dataset_id}/monitoring-transform-settings"
                                .replace("{".concat("dataset_id", "}"), encodeURIComponent(String(datasetId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(monitoringTransformSettings, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 移動平均時間の取得
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {string} [fieldNames] フィールド名
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsMonitoringTransformSettingsList: function (datasetId, nodeId, fieldNames, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'datasetId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsMonitoringTransformSettingsList', 'datasetId', datasetId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsMonitoringTransformSettingsList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/datasets/{dataset_id}/monitoring-transform-settings"
                                .replace("{".concat("dataset_id", "}"), encodeURIComponent(String(datasetId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (fieldNames !== undefined) {
                                localVarQueryParameter['field_names'] = fieldNames;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 定周期通信異常通知先設定（メール通知）
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {NotificationDataarrivalMailSettings} notificationDataarrivalMailSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsNotificationDataarrivalMailSettingsCreate: function (datasetId, nodeId, notificationDataarrivalMailSettings, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'datasetId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsNotificationDataarrivalMailSettingsCreate', 'datasetId', datasetId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsNotificationDataarrivalMailSettingsCreate', 'nodeId', nodeId);
                            // verify required parameter 'notificationDataarrivalMailSettings' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsNotificationDataarrivalMailSettingsCreate', 'notificationDataarrivalMailSettings', notificationDataarrivalMailSettings);
                            localVarPath = "/swc-api/nodes/{node_id}/datasets/{dataset_id}/notification-dataarrival-mail-settings"
                                .replace("{".concat("dataset_id", "}"), encodeURIComponent(String(datasetId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(notificationDataarrivalMailSettings, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 定周期通信異常通知先設定（パトランプ通知）
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {NotificationDataarrivalPatliteSettings} notificationDataarrivalPatliteSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsNotificationDataarrivalPatliteSettingsCreate: function (datasetId, nodeId, notificationDataarrivalPatliteSettings, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'datasetId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsNotificationDataarrivalPatliteSettingsCreate', 'datasetId', datasetId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsNotificationDataarrivalPatliteSettingsCreate', 'nodeId', nodeId);
                            // verify required parameter 'notificationDataarrivalPatliteSettings' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsNotificationDataarrivalPatliteSettingsCreate', 'notificationDataarrivalPatliteSettings', notificationDataarrivalPatliteSettings);
                            localVarPath = "/swc-api/nodes/{node_id}/datasets/{dataset_id}/notification-dataarrival-patlite-settings"
                                .replace("{".concat("dataset_id", "}"), encodeURIComponent(String(datasetId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(notificationDataarrivalPatliteSettings, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 定周期通信異常通知先設定（パトランプ通知） API
         * @param {string} datasetId
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsNotificationDataarrivalPatliteSettingsDestroy: function (datasetId, id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'datasetId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsNotificationDataarrivalPatliteSettingsDestroy', 'datasetId', datasetId);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsNotificationDataarrivalPatliteSettingsDestroy', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsNotificationDataarrivalPatliteSettingsDestroy', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/datasets/{dataset_id}/notification-dataarrival-patlite-settings/{id}"
                                .replace("{".concat("dataset_id", "}"), encodeURIComponent(String(datasetId)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 定周期通信異常通知先設定（パトランプ通知） API
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsNotificationDataarrivalPatliteSettingsList: function (datasetId, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'datasetId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsNotificationDataarrivalPatliteSettingsList', 'datasetId', datasetId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsNotificationDataarrivalPatliteSettingsList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/datasets/{dataset_id}/notification-dataarrival-patlite-settings"
                                .replace("{".concat("dataset_id", "}"), encodeURIComponent(String(datasetId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 遠隔操作設定
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {RemoteControl} remoteControl
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsRemoteControlCreate: function (datasetId, nodeId, remoteControl, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'datasetId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsRemoteControlCreate', 'datasetId', datasetId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsRemoteControlCreate', 'nodeId', nodeId);
                            // verify required parameter 'remoteControl' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsRemoteControlCreate', 'remoteControl', remoteControl);
                            localVarPath = "/swc-api/nodes/{node_id}/datasets/{dataset_id}/remote-control"
                                .replace("{".concat("dataset_id", "}"), encodeURIComponent(String(datasetId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(remoteControl, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 遠隔操作フェースプレート API
         * @param {string} datasetId
         * @param {string} gateway ゲートウェイ
         * @param {string} nodeId
         * @param {string} tags 状態取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsRemoteControlList: function (datasetId, gateway, nodeId, tags, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'datasetId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsRemoteControlList', 'datasetId', datasetId);
                            // verify required parameter 'gateway' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsRemoteControlList', 'gateway', gateway);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsRemoteControlList', 'nodeId', nodeId);
                            // verify required parameter 'tags' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsRemoteControlList', 'tags', tags);
                            localVarPath = "/swc-api/nodes/{node_id}/datasets/{dataset_id}/remote-control"
                                .replace("{".concat("dataset_id", "}"), encodeURIComponent(String(datasetId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (gateway !== undefined) {
                                localVarQueryParameter['gateway'] = gateway;
                            }
                            if (tags !== undefined) {
                                localVarQueryParameter['tags'] = tags;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 最新データ要求 TODO 一旦、`設計者`以上で。`監視者`以上にするなら、node_a_viewsに移動
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {RemoteControl} remoteControl
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsRemoteControlRecentDataCreate: function (datasetId, nodeId, remoteControl, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'datasetId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsRemoteControlRecentDataCreate', 'datasetId', datasetId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsRemoteControlRecentDataCreate', 'nodeId', nodeId);
                            // verify required parameter 'remoteControl' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsRemoteControlRecentDataCreate', 'remoteControl', remoteControl);
                            localVarPath = "/swc-api/nodes/{node_id}/datasets/{dataset_id}/remote-control/recent-data"
                                .replace("{".concat("dataset_id", "}"), encodeURIComponent(String(datasetId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(remoteControl, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 集計単位取得API
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsResampledSummariesList: function (datasetId, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'datasetId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsResampledSummariesList', 'datasetId', datasetId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsResampledSummariesList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/datasets/{dataset_id}/resampled-summaries"
                                .replace("{".concat("dataset_id", "}"), encodeURIComponent(String(datasetId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 積算値リセット
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {ResetAddup} resetAddup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsResetAddupCreate: function (datasetId, nodeId, resetAddup, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'datasetId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsResetAddupCreate', 'datasetId', datasetId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsResetAddupCreate', 'nodeId', nodeId);
                            // verify required parameter 'resetAddup' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsResetAddupCreate', 'resetAddup', resetAddup);
                            localVarPath = "/swc-api/nodes/{node_id}/datasets/{dataset_id}/reset-addup"
                                .replace("{".concat("dataset_id", "}"), encodeURIComponent(String(datasetId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(resetAddup, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ニアリアルタイムデータ取得
         * @param {string} id データセット ID
         * @param {string} nodeId
         * @param {number} timeFrom 取得期間（開始）
         * @param {number} timeTo 取得期間（終了）
         * @param {string} [fieldNames] 取得カラム
         * @param {string} [fieldTypes] 取得カラム型
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsRetrieve: function (id, nodeId, timeFrom, timeTo, fieldNames, fieldTypes, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsRetrieve', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsRetrieve', 'nodeId', nodeId);
                            // verify required parameter 'timeFrom' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsRetrieve', 'timeFrom', timeFrom);
                            // verify required parameter 'timeTo' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsRetrieve', 'timeTo', timeTo);
                            localVarPath = "/swc-api/nodes/{node_id}/datasets/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (fieldNames !== undefined) {
                                localVarQueryParameter['field_names'] = fieldNames;
                            }
                            if (fieldTypes !== undefined) {
                                localVarQueryParameter['field_types'] = fieldTypes;
                            }
                            if (timeFrom !== undefined) {
                                localVarQueryParameter['time_from'] = timeFrom;
                            }
                            if (timeTo !== undefined) {
                                localVarQueryParameter['time_to'] = timeTo;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * SaiCrew-ML フィールド
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {SaicrewMlFields} [saicrewMlFields]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsSaicrewMlFieldsCreate: function (datasetId, nodeId, saicrewMlFields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'datasetId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsSaicrewMlFieldsCreate', 'datasetId', datasetId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsSaicrewMlFieldsCreate', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/datasets/{dataset_id}/saicrew-ml-fields"
                                .replace("{".concat("dataset_id", "}"), encodeURIComponent(String(datasetId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(saicrewMlFields, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * SaiCrew-ML フィールド
         * @param {string} datasetId
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsSaicrewMlFieldsDestroy: function (datasetId, id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'datasetId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsSaicrewMlFieldsDestroy', 'datasetId', datasetId);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsSaicrewMlFieldsDestroy', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsSaicrewMlFieldsDestroy', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/datasets/{dataset_id}/saicrew-ml-fields/{id}"
                                .replace("{".concat("dataset_id", "}"), encodeURIComponent(String(datasetId)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * SaiCrew-ML フィールド
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsSaicrewMlFieldsList: function (datasetId, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'datasetId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsSaicrewMlFieldsList', 'datasetId', datasetId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsSaicrewMlFieldsList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/datasets/{dataset_id}/saicrew-ml-fields"
                                .replace("{".concat("dataset_id", "}"), encodeURIComponent(String(datasetId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * SaiCrew-ML フィールド
         * @param {string} datasetId
         * @param {string} id
         * @param {string} nodeId
         * @param {PatchedSaicrewMlFields} [patchedSaicrewMlFields]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsSaicrewMlFieldsPartialUpdate: function (datasetId, id, nodeId, patchedSaicrewMlFields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'datasetId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsSaicrewMlFieldsPartialUpdate', 'datasetId', datasetId);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsSaicrewMlFieldsPartialUpdate', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsSaicrewMlFieldsPartialUpdate', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/datasets/{dataset_id}/saicrew-ml-fields/{id}"
                                .replace("{".concat("dataset_id", "}"), encodeURIComponent(String(datasetId)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchedSaicrewMlFields, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * SaiCrew-ML フィールド
         * @param {string} datasetId
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsSaicrewMlFieldsRetrieve: function (datasetId, id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'datasetId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsSaicrewMlFieldsRetrieve', 'datasetId', datasetId);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsSaicrewMlFieldsRetrieve', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsSaicrewMlFieldsRetrieve', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/datasets/{dataset_id}/saicrew-ml-fields/{id}"
                                .replace("{".concat("dataset_id", "}"), encodeURIComponent(String(datasetId)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * SaiCrew-ML フィールド
         * @param {string} datasetId
         * @param {string} id
         * @param {string} nodeId
         * @param {SaicrewMlFields} [saicrewMlFields]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsSaicrewMlFieldsUpdate: function (datasetId, id, nodeId, saicrewMlFields, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'datasetId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsSaicrewMlFieldsUpdate', 'datasetId', datasetId);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsSaicrewMlFieldsUpdate', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsSaicrewMlFieldsUpdate', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/datasets/{dataset_id}/saicrew-ml-fields/{id}"
                                .replace("{".concat("dataset_id", "}"), encodeURIComponent(String(datasetId)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(saicrewMlFields, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * アップロード CSV
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {UploadCsvRequest} uploadCsvRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsUploadsCreate: function (datasetId, nodeId, uploadCsvRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'datasetId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsUploadsCreate', 'datasetId', datasetId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsUploadsCreate', 'nodeId', nodeId);
                            // verify required parameter 'uploadCsvRequest' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsUploadsCreate', 'uploadCsvRequest', uploadCsvRequest);
                            localVarPath = "/swc-api/nodes/{node_id}/datasets/{dataset_id}/uploads"
                                .replace("{".concat("dataset_id", "}"), encodeURIComponent(String(datasetId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(uploadCsvRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * CSV アップロード用フォーマットダウンロード
         * @param {string} datasetId
         * @param {string} formatType フォーマット種別
         * @param {string} nodeId
         * @param {number} [timeFrom] 取得期間（開始）
         * @param {number} [timeTo] 取得期間（終了）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsUploadsFormatRetrieve: function (datasetId, formatType, nodeId, timeFrom, timeTo, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'datasetId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsUploadsFormatRetrieve', 'datasetId', datasetId);
                            // verify required parameter 'formatType' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsUploadsFormatRetrieve', 'formatType', formatType);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsUploadsFormatRetrieve', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/datasets/{dataset_id}/uploads/format"
                                .replace("{".concat("dataset_id", "}"), encodeURIComponent(String(datasetId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (formatType !== undefined) {
                                localVarQueryParameter['format_type'] = formatType;
                            }
                            if (timeFrom !== undefined) {
                                localVarQueryParameter['time_from'] = timeFrom;
                            }
                            if (timeTo !== undefined) {
                                localVarQueryParameter['time_to'] = timeTo;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * アップロード履歴一覧取得
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsUploadsHistoryList: function (datasetId, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'datasetId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsUploadsHistoryList', 'datasetId', datasetId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsUploadsHistoryList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/datasets/{dataset_id}/uploads/history"
                                .replace("{".concat("dataset_id", "}"), encodeURIComponent(String(datasetId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * アップロードされた CSV データの処理を開始する API
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {ProcessUploadedCsvRequest} processUploadedCsvRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsUploadsProcessUploadedCsvCreate: function (datasetId, nodeId, processUploadedCsvRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'datasetId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsUploadsProcessUploadedCsvCreate', 'datasetId', datasetId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsUploadsProcessUploadedCsvCreate', 'nodeId', nodeId);
                            // verify required parameter 'processUploadedCsvRequest' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDatasetsUploadsProcessUploadedCsvCreate', 'processUploadedCsvRequest', processUploadedCsvRequest);
                            localVarPath = "/swc-api/nodes/{node_id}/datasets/{dataset_id}/uploads/process-uploaded-csv"
                                .replace("{".concat("dataset_id", "}"), encodeURIComponent(String(datasetId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(processUploadedCsvRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ドキュメント追加
         * @param {string} nodeId
         * @param {DocumentCreate} documentCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDocumentsCreate: function (nodeId, documentCreate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDocumentsCreate', 'nodeId', nodeId);
                            // verify required parameter 'documentCreate' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDocumentsCreate', 'documentCreate', documentCreate);
                            localVarPath = "/swc-api/nodes/{node_id}/documents"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(documentCreate, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ドキュメント削除
         * @param {string} id
         * @param {string} nodeId
         * @param {string} prefix 削除するドキュメントのパス
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDocumentsDestroy: function (id, nodeId, prefix, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDocumentsDestroy', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDocumentsDestroy', 'nodeId', nodeId);
                            // verify required parameter 'prefix' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDocumentsDestroy', 'prefix', prefix);
                            localVarPath = "/swc-api/nodes/{node_id}/documents/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (prefix !== undefined) {
                                localVarQueryParameter['prefix'] = prefix;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ドキュメント一覧取得
         * @param {string} nodeId
         * @param {string} [prefix] 取得対象のパス
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDocumentsList: function (nodeId, prefix, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDocumentsList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/documents"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (prefix !== undefined) {
                                localVarQueryParameter['prefix'] = prefix;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ドキュメント取得
         * @param {string} id
         * @param {string} nodeId
         * @param {string} prefix 取得するドキュメントのパス
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDocumentsRetrieve: function (id, nodeId, prefix, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDocumentsRetrieve', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDocumentsRetrieve', 'nodeId', nodeId);
                            // verify required parameter 'prefix' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDocumentsRetrieve', 'prefix', prefix);
                            localVarPath = "/swc-api/nodes/{node_id}/documents/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (prefix !== undefined) {
                                localVarQueryParameter['prefix'] = prefix;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ドキュメント更新
         * @param {string} id
         * @param {string} nodeId
         * @param {DocumentUpdate} documentUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDocumentsUpdate: function (id, nodeId, documentUpdate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDocumentsUpdate', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDocumentsUpdate', 'nodeId', nodeId);
                            // verify required parameter 'documentUpdate' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDocumentsUpdate', 'documentUpdate', documentUpdate);
                            localVarPath = "/swc-api/nodes/{node_id}/documents/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(documentUpdate, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * CSV ダウンロード API
         * @param {string} nodeId
         * @param {number} timeFrom 取得期間（開始）
         * @param {number} timeTo 取得期間（終了）
         * @param {CSVDownload} cSVDownload
         * @param {string} [sources]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDownloadsCreate: function (nodeId, timeFrom, timeTo, cSVDownload, sources, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDownloadsCreate', 'nodeId', nodeId);
                            // verify required parameter 'timeFrom' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDownloadsCreate', 'timeFrom', timeFrom);
                            // verify required parameter 'timeTo' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDownloadsCreate', 'timeTo', timeTo);
                            // verify required parameter 'cSVDownload' is not null or undefined
                            (0, common_1.assertParamExists)('nodesDownloadsCreate', 'cSVDownload', cSVDownload);
                            localVarPath = "/swc-api/nodes/{node_id}/downloads"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (sources !== undefined) {
                                localVarQueryParameter['sources'] = sources;
                            }
                            if (timeFrom !== undefined) {
                                localVarQueryParameter['time_from'] = timeFrom;
                            }
                            if (timeTo !== undefined) {
                                localVarQueryParameter['time_to'] = timeTo;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(cSVDownload, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * モデル結果(ファイル)一覧取得
         * @param {string} gatewayId
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {string} type 取得するデータのタイプ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesGatewayModelsBuildJobsFileList: function (gatewayId, jobId, modelId, nodeId, type, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'gatewayId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesGatewayModelsBuildJobsFileList', 'gatewayId', gatewayId);
                            // verify required parameter 'jobId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesGatewayModelsBuildJobsFileList', 'jobId', jobId);
                            // verify required parameter 'modelId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesGatewayModelsBuildJobsFileList', 'modelId', modelId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesGatewayModelsBuildJobsFileList', 'nodeId', nodeId);
                            // verify required parameter 'type' is not null or undefined
                            (0, common_1.assertParamExists)('nodesGatewayModelsBuildJobsFileList', 'type', type);
                            localVarPath = "/swc-api/nodes/{node_id}/gateway/{gateway_id}/models/{model_id}/build-jobs/{job_id}/file"
                                .replace("{".concat("gateway_id", "}"), encodeURIComponent(String(gatewayId)))
                                .replace("{".concat("job_id", "}"), encodeURIComponent(String(jobId)))
                                .replace("{".concat("model_id", "}"), encodeURIComponent(String(modelId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (type !== undefined) {
                                localVarQueryParameter['type'] = type;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * モデル結果(ファイル)取得
         * @param {string} gatewayId
         * @param {string} id
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {string} type 取得するデータのタイプ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesGatewayModelsBuildJobsFileRetrieve: function (gatewayId, id, jobId, modelId, nodeId, type, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'gatewayId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesGatewayModelsBuildJobsFileRetrieve', 'gatewayId', gatewayId);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesGatewayModelsBuildJobsFileRetrieve', 'id', id);
                            // verify required parameter 'jobId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesGatewayModelsBuildJobsFileRetrieve', 'jobId', jobId);
                            // verify required parameter 'modelId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesGatewayModelsBuildJobsFileRetrieve', 'modelId', modelId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesGatewayModelsBuildJobsFileRetrieve', 'nodeId', nodeId);
                            // verify required parameter 'type' is not null or undefined
                            (0, common_1.assertParamExists)('nodesGatewayModelsBuildJobsFileRetrieve', 'type', type);
                            localVarPath = "/swc-api/nodes/{node_id}/gateway/{gateway_id}/models/{model_id}/build-jobs/{job_id}/file/{id}"
                                .replace("{".concat("gateway_id", "}"), encodeURIComponent(String(gatewayId)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("job_id", "}"), encodeURIComponent(String(jobId)))
                                .replace("{".concat("model_id", "}"), encodeURIComponent(String(modelId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (type !== undefined) {
                                localVarQueryParameter['type'] = type;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * モデル結果一覧取得
         * @param {string} gatewayId
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {string} type 取得するデータのタイプ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesGatewayModelsBuildJobsResultList: function (gatewayId, jobId, modelId, nodeId, type, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'gatewayId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesGatewayModelsBuildJobsResultList', 'gatewayId', gatewayId);
                            // verify required parameter 'jobId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesGatewayModelsBuildJobsResultList', 'jobId', jobId);
                            // verify required parameter 'modelId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesGatewayModelsBuildJobsResultList', 'modelId', modelId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesGatewayModelsBuildJobsResultList', 'nodeId', nodeId);
                            // verify required parameter 'type' is not null or undefined
                            (0, common_1.assertParamExists)('nodesGatewayModelsBuildJobsResultList', 'type', type);
                            localVarPath = "/swc-api/nodes/{node_id}/gateway/{gateway_id}/models/{model_id}/build-jobs/{job_id}/result"
                                .replace("{".concat("gateway_id", "}"), encodeURIComponent(String(gatewayId)))
                                .replace("{".concat("job_id", "}"), encodeURIComponent(String(jobId)))
                                .replace("{".concat("model_id", "}"), encodeURIComponent(String(modelId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (type !== undefined) {
                                localVarQueryParameter['type'] = type;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * モデル結果取得
         * @param {string} gatewayId
         * @param {string} id
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {string} type 取得するデータのタイプ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesGatewayModelsBuildJobsResultRetrieve: function (gatewayId, id, jobId, modelId, nodeId, type, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'gatewayId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesGatewayModelsBuildJobsResultRetrieve', 'gatewayId', gatewayId);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesGatewayModelsBuildJobsResultRetrieve', 'id', id);
                            // verify required parameter 'jobId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesGatewayModelsBuildJobsResultRetrieve', 'jobId', jobId);
                            // verify required parameter 'modelId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesGatewayModelsBuildJobsResultRetrieve', 'modelId', modelId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesGatewayModelsBuildJobsResultRetrieve', 'nodeId', nodeId);
                            // verify required parameter 'type' is not null or undefined
                            (0, common_1.assertParamExists)('nodesGatewayModelsBuildJobsResultRetrieve', 'type', type);
                            localVarPath = "/swc-api/nodes/{node_id}/gateway/{gateway_id}/models/{model_id}/build-jobs/{job_id}/result/{id}"
                                .replace("{".concat("gateway_id", "}"), encodeURIComponent(String(gatewayId)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("job_id", "}"), encodeURIComponent(String(jobId)))
                                .replace("{".concat("model_id", "}"), encodeURIComponent(String(modelId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (type !== undefined) {
                                localVarQueryParameter['type'] = type;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * SaiCrew デプロイ設定 説明変数のシミュレーション範囲一覧取得
         * @param {string} gatewayId
         * @param {string} nodeId
         * @param {Array<SaicrewAIModelMlSimulationsRequest>} saicrewAIModelMlSimulationsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesGatewaySaicrewMlSimulationsMlListCreate: function (gatewayId, nodeId, saicrewAIModelMlSimulationsRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'gatewayId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesGatewaySaicrewMlSimulationsMlListCreate', 'gatewayId', gatewayId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesGatewaySaicrewMlSimulationsMlListCreate', 'nodeId', nodeId);
                            // verify required parameter 'saicrewAIModelMlSimulationsRequest' is not null or undefined
                            (0, common_1.assertParamExists)('nodesGatewaySaicrewMlSimulationsMlListCreate', 'saicrewAIModelMlSimulationsRequest', saicrewAIModelMlSimulationsRequest);
                            localVarPath = "/swc-api/nodes/{node_id}/gateway/{gateway_id}/saicrew-ml-simulations/ml_list"
                                .replace("{".concat("gateway_id", "}"), encodeURIComponent(String(gatewayId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(saicrewAIModelMlSimulationsRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} cameraId
         * @param {string} nodeId
         * @param {number} [timestamp] 基準時間
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesGraphicCameraList: function (cameraId, nodeId, timestamp, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'cameraId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesGraphicCameraList', 'cameraId', cameraId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesGraphicCameraList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/graphic-camera/{camera_id}"
                                .replace("{".concat("camera_id", "}"), encodeURIComponent(String(cameraId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (timestamp !== undefined) {
                                localVarQueryParameter['timestamp'] = timestamp;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} fileName
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesGraphicImageList: function (fileName, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'fileName' is not null or undefined
                            (0, common_1.assertParamExists)('nodesGraphicImageList', 'fileName', fileName);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesGraphicImageList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/graphic-image/{file_name}"
                                .replace("{".concat("file_name", "}"), encodeURIComponent(String(fileName)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesGraphicIntervalList: function (nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesGraphicIntervalList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/graphic-interval"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * グラフィックレコーダ用ジャーナル取得API
         * @param {string} nodeId
         * @param {number} timeFrom 取得期間（開始）
         * @param {number} timeTo 取得期間（終了）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesGraphicRecorderStatusRetrieve: function (nodeId, timeFrom, timeTo, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesGraphicRecorderStatusRetrieve', 'nodeId', nodeId);
                            // verify required parameter 'timeFrom' is not null or undefined
                            (0, common_1.assertParamExists)('nodesGraphicRecorderStatusRetrieve', 'timeFrom', timeFrom);
                            // verify required parameter 'timeTo' is not null or undefined
                            (0, common_1.assertParamExists)('nodesGraphicRecorderStatusRetrieve', 'timeTo', timeTo);
                            localVarPath = "/swc-api/nodes/{node_id}/graphic-recorder-status"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (timeFrom !== undefined) {
                                localVarQueryParameter['time_from'] = timeFrom;
                            }
                            if (timeTo !== undefined) {
                                localVarQueryParameter['time_to'] = timeTo;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * アップロードバリデーション
         * @param {string} nodeId
         * @param {string} tabIndex
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesGraphicTabsGraphicFilesCreate: function (nodeId, tabIndex, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesGraphicTabsGraphicFilesCreate', 'nodeId', nodeId);
                            // verify required parameter 'tabIndex' is not null or undefined
                            (0, common_1.assertParamExists)('nodesGraphicTabsGraphicFilesCreate', 'tabIndex', tabIndex);
                            localVarPath = "/swc-api/nodes/{node_id}/graphic-tabs/{tab_index}/graphic-files"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)))
                                .replace("{".concat("tab_index", "}"), encodeURIComponent(String(tabIndex)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 項目選択API
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesItemSelectionList: function (nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesItemSelectionList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/item-selection"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 最新ジャーナル取得API
         * @param {string} nodeId
         * @param {boolean} [includeDescendants] 子孫のデータセットを含むか
         * @param {boolean} [includeNotify] アナログ監視判定結果を含むか
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesLastestStatusList: function (nodeId, includeDescendants, includeNotify, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesLastestStatusList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/lastest-status"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (includeDescendants !== undefined) {
                                localVarQueryParameter['include_descendants'] = includeDescendants;
                            }
                            if (includeNotify !== undefined) {
                                localVarQueryParameter['include_notify'] = includeNotify;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 発生中警報情報取得
         * @param {string} nodeId
         * @param {boolean} [controlDashboardDispFlag] ダッシュボード表示フラグの制御有無
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesLatestAlarmList: function (nodeId, controlDashboardDispFlag, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesLatestAlarmList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/latest-alarm"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (controlDashboardDispFlag !== undefined) {
                                localVarQueryParameter['control_dashboard_disp_flag'] = controlDashboardDispFlag;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 発生中警報情報取得
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesLatestProcessList: function (nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesLatestProcessList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/latest-process"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * メール設定 グループ別送信テスト
         * @param {string} nodeId
         * @param {MailGroupTest} mailGroupTest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMailGroupTestCreate: function (nodeId, mailGroupTest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesMailGroupTestCreate', 'nodeId', nodeId);
                            // verify required parameter 'mailGroupTest' is not null or undefined
                            (0, common_1.assertParamExists)('nodesMailGroupTestCreate', 'mailGroupTest', mailGroupTest);
                            localVarPath = "/swc-api/nodes/{node_id}/mail-group-test"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(mailGroupTest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * シンプル記録追加
         * @param {string} nodeId
         * @param {MaintenanceHistory} maintenanceHistory
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMaintenanceHistoriesCreate: function (nodeId, maintenanceHistory, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesMaintenanceHistoriesCreate', 'nodeId', nodeId);
                            // verify required parameter 'maintenanceHistory' is not null or undefined
                            (0, common_1.assertParamExists)('nodesMaintenanceHistoriesCreate', 'maintenanceHistory', maintenanceHistory);
                            localVarPath = "/swc-api/nodes/{node_id}/maintenance-histories"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(maintenanceHistory, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * シンプル記録削除
         * @param {number} id A unique integer value identifying this t_maintenance_history.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMaintenanceHistoriesDestroy: function (id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesMaintenanceHistoriesDestroy', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesMaintenanceHistoriesDestroy', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/maintenance-histories/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * シンプル記録 API
         * @param {string} dateFrom 取得期間（開始）
         * @param {string} dateTo 取得期間（終了）
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMaintenanceHistoriesList: function (dateFrom, dateTo, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'dateFrom' is not null or undefined
                            (0, common_1.assertParamExists)('nodesMaintenanceHistoriesList', 'dateFrom', dateFrom);
                            // verify required parameter 'dateTo' is not null or undefined
                            (0, common_1.assertParamExists)('nodesMaintenanceHistoriesList', 'dateTo', dateTo);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesMaintenanceHistoriesList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/maintenance-histories"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (dateFrom !== undefined) {
                                localVarQueryParameter['date_from'] = dateFrom;
                            }
                            if (dateTo !== undefined) {
                                localVarQueryParameter['date_to'] = dateTo;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * シンプル記録更新（一部）
         * @param {number} id A unique integer value identifying this t_maintenance_history.
         * @param {string} nodeId
         * @param {PatchedMaintenanceHistory} [patchedMaintenanceHistory]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMaintenanceHistoriesPartialUpdate: function (id, nodeId, patchedMaintenanceHistory, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesMaintenanceHistoriesPartialUpdate', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesMaintenanceHistoriesPartialUpdate', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/maintenance-histories/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchedMaintenanceHistory, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * シンプル記録詳細取得
         * @param {number} id A unique integer value identifying this t_maintenance_history.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMaintenanceHistoriesRetrieve: function (id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesMaintenanceHistoriesRetrieve', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesMaintenanceHistoriesRetrieve', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/maintenance-histories/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * シンプル記録更新
         * @param {number} id A unique integer value identifying this t_maintenance_history.
         * @param {string} nodeId
         * @param {MaintenanceHistory} maintenanceHistory
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMaintenanceHistoriesUpdate: function (id, nodeId, maintenanceHistory, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesMaintenanceHistoriesUpdate', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesMaintenanceHistoriesUpdate', 'nodeId', nodeId);
                            // verify required parameter 'maintenanceHistory' is not null or undefined
                            (0, common_1.assertParamExists)('nodesMaintenanceHistoriesUpdate', 'maintenanceHistory', maintenanceHistory);
                            localVarPath = "/swc-api/nodes/{node_id}/maintenance-histories/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(maintenanceHistory, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * MBR 演算設定追加
         * @param {string} nodeId
         * @param {MbrCalculationSettings} mbrCalculationSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMbrCalculationSettingsCreate: function (nodeId, mbrCalculationSettings, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesMbrCalculationSettingsCreate', 'nodeId', nodeId);
                            // verify required parameter 'mbrCalculationSettings' is not null or undefined
                            (0, common_1.assertParamExists)('nodesMbrCalculationSettingsCreate', 'mbrCalculationSettings', mbrCalculationSettings);
                            localVarPath = "/swc-api/nodes/{node_id}/mbr/calculation-settings"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(mbrCalculationSettings, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * MBR 演算設定削除
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMbrCalculationSettingsDestroy: function (id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesMbrCalculationSettingsDestroy', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesMbrCalculationSettingsDestroy', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/mbr/calculation-settings/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * MBR 演算設定一覧
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMbrCalculationSettingsList: function (nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesMbrCalculationSettingsList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/mbr/calculation-settings"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * MBR 演算設定更新（一部）
         * @param {string} id
         * @param {string} nodeId
         * @param {PatchedMbrCalculationSettings} [patchedMbrCalculationSettings]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMbrCalculationSettingsPartialUpdate: function (id, nodeId, patchedMbrCalculationSettings, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesMbrCalculationSettingsPartialUpdate', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesMbrCalculationSettingsPartialUpdate', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/mbr/calculation-settings/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchedMbrCalculationSettings, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * MBR 演算設定 API
         * @param {string} id
         * @param {string} nodeId
         * @param {MbrCalculationSettings} mbrCalculationSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMbrCalculationSettingsUpdate: function (id, nodeId, mbrCalculationSettings, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesMbrCalculationSettingsUpdate', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesMbrCalculationSettingsUpdate', 'nodeId', nodeId);
                            // verify required parameter 'mbrCalculationSettings' is not null or undefined
                            (0, common_1.assertParamExists)('nodesMbrCalculationSettingsUpdate', 'mbrCalculationSettings', mbrCalculationSettings);
                            localVarPath = "/swc-api/nodes/{node_id}/mbr/calculation-settings/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(mbrCalculationSettings, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 傾向総合診断履歴 API
         * @param {string} nodeId
         * @param {MbrTechnicalReportJudgementHistory} mbrTechnicalReportJudgementHistory
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMbrTechnicalReportJudgementHistoriesCreate: function (nodeId, mbrTechnicalReportJudgementHistory, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesMbrTechnicalReportJudgementHistoriesCreate', 'nodeId', nodeId);
                            // verify required parameter 'mbrTechnicalReportJudgementHistory' is not null or undefined
                            (0, common_1.assertParamExists)('nodesMbrTechnicalReportJudgementHistoriesCreate', 'mbrTechnicalReportJudgementHistory', mbrTechnicalReportJudgementHistory);
                            localVarPath = "/swc-api/nodes/{node_id}/mbr/technical-report/judgement-histories"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(mbrTechnicalReportJudgementHistory, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 傾向総合診断履歴の取得
         * @param {string} nodeId
         * @param {number} timeFrom 取得期間（開始）
         * @param {number} timeTo 取得期間（終了）
         * @param {number} [calculationNo] 演算 No
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMbrTechnicalReportJudgementHistoriesList: function (nodeId, timeFrom, timeTo, calculationNo, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesMbrTechnicalReportJudgementHistoriesList', 'nodeId', nodeId);
                            // verify required parameter 'timeFrom' is not null or undefined
                            (0, common_1.assertParamExists)('nodesMbrTechnicalReportJudgementHistoriesList', 'timeFrom', timeFrom);
                            // verify required parameter 'timeTo' is not null or undefined
                            (0, common_1.assertParamExists)('nodesMbrTechnicalReportJudgementHistoriesList', 'timeTo', timeTo);
                            localVarPath = "/swc-api/nodes/{node_id}/mbr/technical-report/judgement-histories"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (calculationNo !== undefined) {
                                localVarQueryParameter['calculation_no'] = calculationNo;
                            }
                            if (timeFrom !== undefined) {
                                localVarQueryParameter['time_from'] = timeFrom;
                            }
                            if (timeTo !== undefined) {
                                localVarQueryParameter['time_to'] = timeTo;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 傾向総合診断追加
         * @param {string} nodeId
         * @param {MbrTechnicalReportJudgement} mbrTechnicalReportJudgement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMbrTechnicalReportJudgementsCreate: function (nodeId, mbrTechnicalReportJudgement, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesMbrTechnicalReportJudgementsCreate', 'nodeId', nodeId);
                            // verify required parameter 'mbrTechnicalReportJudgement' is not null or undefined
                            (0, common_1.assertParamExists)('nodesMbrTechnicalReportJudgementsCreate', 'mbrTechnicalReportJudgement', mbrTechnicalReportJudgement);
                            localVarPath = "/swc-api/nodes/{node_id}/mbr/technical-report/judgements"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(mbrTechnicalReportJudgement, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 傾向総合診断取得
         * @param {string} nodeId
         * @param {number} [calculationNo] 演算 No
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMbrTechnicalReportJudgementsList: function (nodeId, calculationNo, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesMbrTechnicalReportJudgementsList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/mbr/technical-report/judgements"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (calculationNo !== undefined) {
                                localVarQueryParameter['calculation_no'] = calculationNo;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 傾向総合診断の取得
         * @param {string} dateFrom 取得期間（開始）
         * @param {string} dateTo 取得期間（終了）
         * @param {string} nodeId
         * @param {number} [calculationNo] 演算 No
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMbrTechnicalReportResultsList: function (dateFrom, dateTo, nodeId, calculationNo, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'dateFrom' is not null or undefined
                            (0, common_1.assertParamExists)('nodesMbrTechnicalReportResultsList', 'dateFrom', dateFrom);
                            // verify required parameter 'dateTo' is not null or undefined
                            (0, common_1.assertParamExists)('nodesMbrTechnicalReportResultsList', 'dateTo', dateTo);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesMbrTechnicalReportResultsList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/mbr/technical-report/results"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (calculationNo !== undefined) {
                                localVarQueryParameter['calculation_no'] = calculationNo;
                            }
                            if (dateFrom !== undefined) {
                                localVarQueryParameter['date_from'] = dateFrom;
                            }
                            if (dateTo !== undefined) {
                                localVarQueryParameter['date_to'] = dateTo;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMonitorDatasetMetricsList: function (nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesMonitorDatasetMetricsList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/monitor-dataset-metrics"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMonitorDatasetMetricsRetrieve: function (id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesMonitorDatasetMetricsRetrieve', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesMonitorDatasetMetricsRetrieve', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/monitor-dataset-metrics/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 通知Gr1のオンオフ設定
         * @param {string} nodeId
         * @param {Array<MonitoringNotificationGr1Settings>} monitoringNotificationGr1Settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMonitorNotificationGr1SettingsCreate: function (nodeId, monitoringNotificationGr1Settings, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesMonitorNotificationGr1SettingsCreate', 'nodeId', nodeId);
                            // verify required parameter 'monitoringNotificationGr1Settings' is not null or undefined
                            (0, common_1.assertParamExists)('nodesMonitorNotificationGr1SettingsCreate', 'monitoringNotificationGr1Settings', monitoringNotificationGr1Settings);
                            localVarPath = "/swc-api/nodes/{node_id}/monitor-notification-gr1-settings"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(monitoringNotificationGr1Settings, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 通知Gr2のオンオフ設定
         * @param {string} nodeId
         * @param {Array<MonitoringNotificationGr2Settings>} monitoringNotificationGr2Settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMonitorNotificationGr2SettingsCreate: function (nodeId, monitoringNotificationGr2Settings, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesMonitorNotificationGr2SettingsCreate', 'nodeId', nodeId);
                            // verify required parameter 'monitoringNotificationGr2Settings' is not null or undefined
                            (0, common_1.assertParamExists)('nodesMonitorNotificationGr2SettingsCreate', 'monitoringNotificationGr2Settings', monitoringNotificationGr2Settings);
                            localVarPath = "/swc-api/nodes/{node_id}/monitor-notification-gr2-settings"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(monitoringNotificationGr2Settings, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * メール通知のオンオフ設定
         * @param {string} nodeId
         * @param {Array<MonitoringNotificationMailSettings>} monitoringNotificationMailSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMonitorNotificationMailSettingsGeneralCreate: function (nodeId, monitoringNotificationMailSettings, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesMonitorNotificationMailSettingsGeneralCreate', 'nodeId', nodeId);
                            // verify required parameter 'monitoringNotificationMailSettings' is not null or undefined
                            (0, common_1.assertParamExists)('nodesMonitorNotificationMailSettingsGeneralCreate', 'monitoringNotificationMailSettings', monitoringNotificationMailSettings);
                            localVarPath = "/swc-api/nodes/{node_id}/monitor-notification-mail-settings-general"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(monitoringNotificationMailSettings, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * データ項目の設定
         * @param {string} nodeId
         * @param {Array<MonitoringSettings>} monitoringSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMonitorSettingsCreate: function (nodeId, monitoringSettings, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesMonitorSettingsCreate', 'nodeId', nodeId);
                            // verify required parameter 'monitoringSettings' is not null or undefined
                            (0, common_1.assertParamExists)('nodesMonitorSettingsCreate', 'monitoringSettings', monitoringSettings);
                            localVarPath = "/swc-api/nodes/{node_id}/monitor-settings"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(monitoringSettings, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * クラウド設定警報取得 API
         * @param {string} nodeId
         * @param {string} [datasetId] データセットID
         * @param {string} [fieldNames] フィールド名
         * @param {string} [ruleNames] 条件
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMonitorSettingsList: function (nodeId, datasetId, fieldNames, ruleNames, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesMonitorSettingsList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/monitor-settings"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (datasetId !== undefined) {
                                localVarQueryParameter['dataset_id'] = datasetId;
                            }
                            if (fieldNames !== undefined) {
                                localVarQueryParameter['field_names'] = fieldNames;
                            }
                            if (ruleNames !== undefined) {
                                localVarQueryParameter['rule_names'] = ruleNames;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 通知Gr1の設定
         * @param {string} nodeId
         * @param {NotificationGr1Settings} [notificationGr1Settings]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesNotificationGr1SettingsCreate: function (nodeId, notificationGr1Settings, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesNotificationGr1SettingsCreate', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/notification-gr1-settings"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(notificationGr1Settings, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 通知Gr2の設定
         * @param {string} nodeId
         * @param {NotificationGr2Settings} [notificationGr2Settings]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesNotificationGr2SettingsCreate: function (nodeId, notificationGr2Settings, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesNotificationGr2SettingsCreate', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/notification-gr2-settings"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(notificationGr2Settings, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * メール配信設定
         * @param {string} nodeId
         * @param {NotificationMailSettings} [notificationMailSettings]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesNotificationMailSettingsCreate: function (nodeId, notificationMailSettings, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesNotificationMailSettingsCreate', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/notification-mail-settings"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(notificationMailSettings, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * SaiCrew通知設定（メール通知）
         * @param {string} nodeId
         * @param {NotificationSaiCrewMailSettings} [notificationSaiCrewMailSettings]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesNotificationSaicrewMailSettingsCreate: function (nodeId, notificationSaiCrewMailSettings, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesNotificationSaicrewMailSettingsCreate', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/notification-saicrew-mail-settings"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(notificationSaiCrewMailSettings, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * SaiIK通知設定（メール通知）
         * @param {string} nodeId
         * @param {NotificationSaiIKMailSettings} [notificationSaiIKMailSettings]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesNotificationSaiikMailSettingsCreate: function (nodeId, notificationSaiIKMailSettings, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesNotificationSaiikMailSettingsCreate', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/notification-saiik-mail-settings"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(notificationSaiIKMailSettings, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 設備の通知先の設定
         * @param {string} nodeId
         * @param {NotificationSettings} notificationSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesNotificationSettingsCreate: function (nodeId, notificationSettings, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesNotificationSettingsCreate', 'nodeId', nodeId);
                            // verify required parameter 'notificationSettings' is not null or undefined
                            (0, common_1.assertParamExists)('nodesNotificationSettingsCreate', 'notificationSettings', notificationSettings);
                            localVarPath = "/swc-api/nodes/{node_id}/notification-settings"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(notificationSettings, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 設備の通知設定の取得
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesNotificationSettingsList: function (nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesNotificationSettingsList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/notification-settings"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * システム警報異常通知先設定（メール通知）
         * @param {string} nodeId
         * @param {NotificationSystemMailSettings} [notificationSystemMailSettings]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesNotificationSystemMailSettingsCreate: function (nodeId, notificationSystemMailSettings, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesNotificationSystemMailSettingsCreate', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/notification-system-mail-settings"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(notificationSystemMailSettings, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * システム警報異常通知先設定（パトランプ通知）
         * @param {string} nodeId
         * @param {NotificationSystemPatliteSettings} notificationSystemPatliteSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesNotificationSystemPatliteSettingsCreate: function (nodeId, notificationSystemPatliteSettings, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesNotificationSystemPatliteSettingsCreate', 'nodeId', nodeId);
                            // verify required parameter 'notificationSystemPatliteSettings' is not null or undefined
                            (0, common_1.assertParamExists)('nodesNotificationSystemPatliteSettingsCreate', 'notificationSystemPatliteSettings', notificationSystemPatliteSettings);
                            localVarPath = "/swc-api/nodes/{node_id}/notification-system-patlite-settings"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(notificationSystemPatliteSettings, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * システム警報異常通知先設定（パトランプ通知） API
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesNotificationSystemPatliteSettingsDestroy: function (id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesNotificationSystemPatliteSettingsDestroy', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesNotificationSystemPatliteSettingsDestroy', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/notification-system-patlite-settings/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * システム警報異常通知先設定（パトランプ通知） API
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesNotificationSystemPatliteSettingsList: function (nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesNotificationSystemPatliteSettingsList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/notification-system-patlite-settings"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 運転履歴取得
         * @param {string} nodeId
         * @param {number} timeFrom 取得期間（開始）
         * @param {number} timeTo 取得期間（終了）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesOperatingHistoryList: function (nodeId, timeFrom, timeTo, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesOperatingHistoryList', 'nodeId', nodeId);
                            // verify required parameter 'timeFrom' is not null or undefined
                            (0, common_1.assertParamExists)('nodesOperatingHistoryList', 'timeFrom', timeFrom);
                            // verify required parameter 'timeTo' is not null or undefined
                            (0, common_1.assertParamExists)('nodesOperatingHistoryList', 'timeTo', timeTo);
                            localVarPath = "/swc-api/nodes/{node_id}/operating-history"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (timeFrom !== undefined) {
                                localVarQueryParameter['time_from'] = timeFrom;
                            }
                            if (timeTo !== undefined) {
                                localVarQueryParameter['time_to'] = timeTo;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 稼働情報取得
         * @param {string} nodeId
         * @param {number} timeFrom 取得期間（開始）
         * @param {number} timeTo 取得期間（終了）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesOperatingSummaryList: function (nodeId, timeFrom, timeTo, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesOperatingSummaryList', 'nodeId', nodeId);
                            // verify required parameter 'timeFrom' is not null or undefined
                            (0, common_1.assertParamExists)('nodesOperatingSummaryList', 'timeFrom', timeFrom);
                            // verify required parameter 'timeTo' is not null or undefined
                            (0, common_1.assertParamExists)('nodesOperatingSummaryList', 'timeTo', timeTo);
                            localVarPath = "/swc-api/nodes/{node_id}/operating-summary"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (timeFrom !== undefined) {
                                localVarQueryParameter['time_from'] = timeFrom;
                            }
                            if (timeTo !== undefined) {
                                localVarQueryParameter['time_to'] = timeTo;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * パトランプ通知追加
         * @param {string} datasetIds
         * @param {string} fieldNames
         * @param {string} nodeId
         * @param {Array<PatliteNotificationSetting>} patliteNotificationSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesPatliteNotificationSettingsCreate: function (datasetIds, fieldNames, nodeId, patliteNotificationSetting, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'datasetIds' is not null or undefined
                            (0, common_1.assertParamExists)('nodesPatliteNotificationSettingsCreate', 'datasetIds', datasetIds);
                            // verify required parameter 'fieldNames' is not null or undefined
                            (0, common_1.assertParamExists)('nodesPatliteNotificationSettingsCreate', 'fieldNames', fieldNames);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesPatliteNotificationSettingsCreate', 'nodeId', nodeId);
                            // verify required parameter 'patliteNotificationSetting' is not null or undefined
                            (0, common_1.assertParamExists)('nodesPatliteNotificationSettingsCreate', 'patliteNotificationSetting', patliteNotificationSetting);
                            localVarPath = "/swc-api/nodes/{node_id}/patlite-notification-settings"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (datasetIds !== undefined) {
                                localVarQueryParameter['dataset_ids'] = datasetIds;
                            }
                            if (fieldNames !== undefined) {
                                localVarQueryParameter['field_names'] = fieldNames;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patliteNotificationSetting, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * パトランプ通知削除
         * @param {number} id A unique integer value identifying this m_patlite_notification_setting.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesPatliteNotificationSettingsDestroy: function (id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesPatliteNotificationSettingsDestroy', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesPatliteNotificationSettingsDestroy', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/patlite-notification-settings/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * パトランプ通知 API
         * @param {string} nodeId
         * @param {string} [datasetId] データセット
         * @param {string} [fieldName] 項目
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesPatliteNotificationSettingsList: function (nodeId, datasetId, fieldName, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesPatliteNotificationSettingsList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/patlite-notification-settings"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (datasetId !== undefined) {
                                localVarQueryParameter['dataset_id'] = datasetId;
                            }
                            if (fieldName !== undefined) {
                                localVarQueryParameter['field_name'] = fieldName;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * パトランプ通知更新（一部）
         * @param {number} id A unique integer value identifying this m_patlite_notification_setting.
         * @param {string} nodeId
         * @param {PatchedPatliteNotificationSetting} [patchedPatliteNotificationSetting]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesPatliteNotificationSettingsPartialUpdate: function (id, nodeId, patchedPatliteNotificationSetting, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesPatliteNotificationSettingsPartialUpdate', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesPatliteNotificationSettingsPartialUpdate', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/patlite-notification-settings/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchedPatliteNotificationSetting, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * パトランプ通知詳細取得
         * @param {number} id A unique integer value identifying this m_patlite_notification_setting.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesPatliteNotificationSettingsRetrieve: function (id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesPatliteNotificationSettingsRetrieve', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesPatliteNotificationSettingsRetrieve', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/patlite-notification-settings/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * パトランプ通知更新
         * @param {number} id A unique integer value identifying this m_patlite_notification_setting.
         * @param {string} nodeId
         * @param {PatliteNotificationSetting} patliteNotificationSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesPatliteNotificationSettingsUpdate: function (id, nodeId, patliteNotificationSetting, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesPatliteNotificationSettingsUpdate', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesPatliteNotificationSettingsUpdate', 'nodeId', nodeId);
                            // verify required parameter 'patliteNotificationSetting' is not null or undefined
                            (0, common_1.assertParamExists)('nodesPatliteNotificationSettingsUpdate', 'patliteNotificationSetting', patliteNotificationSetting);
                            localVarPath = "/swc-api/nodes/{node_id}/patlite-notification-settings/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patliteNotificationSetting, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * パトランプ設定
         * @param {string} nodeId
         * @param {Array<NodePatliteSetting>} nodePatliteSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesPatliteSettingsCreate: function (nodeId, nodePatliteSetting, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesPatliteSettingsCreate', 'nodeId', nodeId);
                            // verify required parameter 'nodePatliteSetting' is not null or undefined
                            (0, common_1.assertParamExists)('nodesPatliteSettingsCreate', 'nodePatliteSetting', nodePatliteSetting);
                            localVarPath = "/swc-api/nodes/{node_id}/patlite-settings"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(nodePatliteSetting, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * パトランプ設定 API
         * @param {number} id A unique integer value identifying this m_node_patlite_setting.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesPatliteSettingsDestroy: function (id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesPatliteSettingsDestroy', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesPatliteSettingsDestroy', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/patlite-settings/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * パトランプ設定取得
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesPatliteSettingsList: function (nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesPatliteSettingsList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/patlite-settings"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * パトランプ設定 API
         * @param {number} id A unique integer value identifying this m_node_patlite_setting.
         * @param {string} nodeId
         * @param {PatchedNodePatliteSetting} [patchedNodePatliteSetting]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesPatliteSettingsPartialUpdate: function (id, nodeId, patchedNodePatliteSetting, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesPatliteSettingsPartialUpdate', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesPatliteSettingsPartialUpdate', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/patlite-settings/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchedNodePatliteSetting, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * パトランプ設定 API
         * @param {number} id A unique integer value identifying this m_node_patlite_setting.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesPatliteSettingsRetrieve: function (id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesPatliteSettingsRetrieve', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesPatliteSettingsRetrieve', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/patlite-settings/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * パトランプ設定 API
         * @param {number} id A unique integer value identifying this m_node_patlite_setting.
         * @param {string} nodeId
         * @param {NodePatliteSetting} nodePatliteSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesPatliteSettingsUpdate: function (id, nodeId, nodePatliteSetting, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesPatliteSettingsUpdate', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesPatliteSettingsUpdate', 'nodeId', nodeId);
                            // verify required parameter 'nodePatliteSetting' is not null or undefined
                            (0, common_1.assertParamExists)('nodesPatliteSettingsUpdate', 'nodePatliteSetting', nodePatliteSetting);
                            localVarPath = "/swc-api/nodes/{node_id}/patlite-settings/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(nodePatliteSetting, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * パトランプテスト
         * @param {string} nodeId
         * @param {string} patliteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesPatlitesTestCreate: function (nodeId, patliteId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesPatlitesTestCreate', 'nodeId', nodeId);
                            // verify required parameter 'patliteId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesPatlitesTestCreate', 'patliteId', patliteId);
                            localVarPath = "/swc-api/nodes/{node_id}/patlites/{patlite_id}/test"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)))
                                .replace("{".concat("patlite_id", "}"), encodeURIComponent(String(patliteId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 遠隔操作履歴 API
         * @param {number} dateFrom 取得期間（開始）
         * @param {number} dateTo 取得期間（終了）
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesRemoteControlHistoryList: function (dateFrom, dateTo, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'dateFrom' is not null or undefined
                            (0, common_1.assertParamExists)('nodesRemoteControlHistoryList', 'dateFrom', dateFrom);
                            // verify required parameter 'dateTo' is not null or undefined
                            (0, common_1.assertParamExists)('nodesRemoteControlHistoryList', 'dateTo', dateTo);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesRemoteControlHistoryList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/remote-control-history"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (dateFrom !== undefined) {
                                localVarQueryParameter['date_from'] = dateFrom;
                            }
                            if (dateTo !== undefined) {
                                localVarQueryParameter['date_to'] = dateTo;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this m_remote_control_history.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesRemoteControlHistoryRetrieve: function (id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesRemoteControlHistoryRetrieve', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesRemoteControlHistoryRetrieve', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/remote-control-history/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 長期データ取得
         * @param {string} id データセット ID
         * @param {string} nodeId
         * @param {string} [asFreq] 集約単位
         * @param {string} [fieldNames] 取得カラム
         * @param {string} [fieldTypes] 取得カラム型
         * @param {string} [method] 集約方法
         * @param {string} [splitBy] 表示単位
         * @param {string} [theLastPeriod] 直近〜（1W / 1M / 3M / 6M / 9M / 1Y / 3Y / 5Y）
         * @param {number} [timeFrom] 取得期間（開始）
         * @param {number} [timeTo] 取得期間（終了）
         * @param {string} [trendGraphFreq] トレンドグラフの集約単位
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesResampledDatasetsRetrieve: function (id, nodeId, asFreq, fieldNames, fieldTypes, method, splitBy, theLastPeriod, timeFrom, timeTo, trendGraphFreq, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesResampledDatasetsRetrieve', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesResampledDatasetsRetrieve', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/resampled-datasets/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (asFreq !== undefined) {
                                localVarQueryParameter['as_freq'] = asFreq;
                            }
                            if (fieldNames !== undefined) {
                                localVarQueryParameter['field_names'] = fieldNames;
                            }
                            if (fieldTypes !== undefined) {
                                localVarQueryParameter['field_types'] = fieldTypes;
                            }
                            if (method !== undefined) {
                                localVarQueryParameter['method'] = method;
                            }
                            if (splitBy !== undefined) {
                                localVarQueryParameter['split_by'] = splitBy;
                            }
                            if (theLastPeriod !== undefined) {
                                localVarQueryParameter['the_last_period'] = theLastPeriod;
                            }
                            if (timeFrom !== undefined) {
                                localVarQueryParameter['time_from'] = timeFrom;
                            }
                            if (timeTo !== undefined) {
                                localVarQueryParameter['time_to'] = timeTo;
                            }
                            if (trendGraphFreq !== undefined) {
                                localVarQueryParameter['trend_graph_freq'] = trendGraphFreq;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * RO 演算設定追加
         * @param {string} nodeId
         * @param {RoCalculationSettings} roCalculationSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesRoCalculationSettingsCreate: function (nodeId, roCalculationSettings, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesRoCalculationSettingsCreate', 'nodeId', nodeId);
                            // verify required parameter 'roCalculationSettings' is not null or undefined
                            (0, common_1.assertParamExists)('nodesRoCalculationSettingsCreate', 'roCalculationSettings', roCalculationSettings);
                            localVarPath = "/swc-api/nodes/{node_id}/ro/calculation-settings"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(roCalculationSettings, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * RO 演算設定削除
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesRoCalculationSettingsDestroy: function (id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesRoCalculationSettingsDestroy', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesRoCalculationSettingsDestroy', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/ro/calculation-settings/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * RO 演算設定一覧
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesRoCalculationSettingsList: function (nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesRoCalculationSettingsList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/ro/calculation-settings"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * RO 演算設定更新（一部）
         * @param {string} id
         * @param {string} nodeId
         * @param {PatchedRoCalculationSettings} [patchedRoCalculationSettings]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesRoCalculationSettingsPartialUpdate: function (id, nodeId, patchedRoCalculationSettings, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesRoCalculationSettingsPartialUpdate', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesRoCalculationSettingsPartialUpdate', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/ro/calculation-settings/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchedRoCalculationSettings, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * RO 演算設定 API
         * @param {string} id
         * @param {string} nodeId
         * @param {RoCalculationSettings} roCalculationSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesRoCalculationSettingsUpdate: function (id, nodeId, roCalculationSettings, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesRoCalculationSettingsUpdate', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesRoCalculationSettingsUpdate', 'nodeId', nodeId);
                            // verify required parameter 'roCalculationSettings' is not null or undefined
                            (0, common_1.assertParamExists)('nodesRoCalculationSettingsUpdate', 'roCalculationSettings', roCalculationSettings);
                            localVarPath = "/swc-api/nodes/{node_id}/ro/calculation-settings/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(roCalculationSettings, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ROテクニカルレポート
         * @param {string} nodeId
         * @param {string} [dateFrom] 取得期間（開始）
         * @param {string} [dateTo] 取得期間（終了）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesRoTechnicalReportResultsList: function (nodeId, dateFrom, dateTo, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesRoTechnicalReportResultsList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/ro/technical-report/results"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (dateFrom !== undefined) {
                                localVarQueryParameter['date_from'] = dateFrom;
                            }
                            if (dateTo !== undefined) {
                                localVarQueryParameter['date_to'] = dateTo;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns list of algorithms.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewAiAlgorithmsList: function (nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewAiAlgorithmsList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/saicrew-ai-algorithms"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns algorithm.
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewAiAlgorithmsRetrieve: function (id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewAiAlgorithmsRetrieve', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewAiAlgorithmsRetrieve', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/saicrew-ai-algorithms/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns algorithm.
         * @param {string} algorithmName
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewAiAlgorithmsVersionsRetrieve: function (algorithmName, id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'algorithmName' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewAiAlgorithmsVersionsRetrieve', 'algorithmName', algorithmName);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewAiAlgorithmsVersionsRetrieve', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewAiAlgorithmsVersionsRetrieve', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/saicrew-ai-algorithms/{algorithm_name}/versions/{id}"
                                .replace("{".concat("algorithm_name", "}"), encodeURIComponent(String(algorithmName)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * SaiCrew-AIモデル追加
         * @param {string} nodeId
         * @param {SaicrewAIModel} saicrewAIModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewAiModelsCreate: function (nodeId, saicrewAIModel, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewAiModelsCreate', 'nodeId', nodeId);
                            // verify required parameter 'saicrewAIModel' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewAiModelsCreate', 'saicrewAIModel', saicrewAIModel);
                            localVarPath = "/swc-api/nodes/{node_id}/saicrew-ai-models"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(saicrewAIModel, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * SaiCrew-AIモデル削除
         * @param {number} id A unique integer value identifying this m_saicrew_ai_model.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewAiModelsDestroy: function (id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewAiModelsDestroy', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewAiModelsDestroy', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/saicrew-ai-models/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 最新MLPipelineIDの取得
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewAiModelsLatestPipelineIdRetrieve: function (nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewAiModelsLatestPipelineIdRetrieve', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/saicrew-ai-models/latest_pipeline_id"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * SaiCrew-AIモデル覧取得
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewAiModelsList: function (nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewAiModelsList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/saicrew-ai-models"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * SaiCrew-AIモデル更新（一部）
         * @param {number} id A unique integer value identifying this m_saicrew_ai_model.
         * @param {string} nodeId
         * @param {PatchedSaicrewAIModel} [patchedSaicrewAIModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewAiModelsPartialUpdate: function (id, nodeId, patchedSaicrewAIModel, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewAiModelsPartialUpdate', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewAiModelsPartialUpdate', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/saicrew-ai-models/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchedSaicrewAIModel, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * SaiCrew-AIモデル詳細取得
         * @param {number} id A unique integer value identifying this m_saicrew_ai_model.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewAiModelsRetrieve: function (id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewAiModelsRetrieve', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewAiModelsRetrieve', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/saicrew-ai-models/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * SaiCrew-AIモデル更新
         * @param {number} id A unique integer value identifying this m_saicrew_ai_model.
         * @param {string} nodeId
         * @param {SaicrewAIModel} saicrewAIModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewAiModelsUpdate: function (id, nodeId, saicrewAIModel, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewAiModelsUpdate', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewAiModelsUpdate', 'nodeId', nodeId);
                            // verify required parameter 'saicrewAIModel' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewAiModelsUpdate', 'saicrewAIModel', saicrewAIModel);
                            localVarPath = "/swc-api/nodes/{node_id}/saicrew-ai-models/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(saicrewAIModel, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * List all SaiCrew node datasets in descendant nodes.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewDatasetsList: function (nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewDatasetsList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/saicrew-datasets"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * SaiCrew モデル構築・データ予測用の CSV フォーマットダウンロード
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {Array<string>} [mlNames] ML変数
         * @param {number} [timeFrom] 取得期間（開始）
         * @param {number} [timeTo] 取得期間（終了）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewDatasetsUploadsFormatRetrieve: function (datasetId, nodeId, mlNames, timeFrom, timeTo, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'datasetId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewDatasetsUploadsFormatRetrieve', 'datasetId', datasetId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewDatasetsUploadsFormatRetrieve', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/saicrew-datasets/{dataset_id}/uploads/format"
                                .replace("{".concat("dataset_id", "}"), encodeURIComponent(String(datasetId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (mlNames) {
                                localVarQueryParameter['ml_names'] = mlNames;
                            }
                            if (timeFrom !== undefined) {
                                localVarQueryParameter['time_from'] = timeFrom;
                            }
                            if (timeTo !== undefined) {
                                localVarQueryParameter['time_to'] = timeTo;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} edgeDevice
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewEdgeDeviceComponentList: function (edgeDevice, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'edgeDevice' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewEdgeDeviceComponentList', 'edgeDevice', edgeDevice);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewEdgeDeviceComponentList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/saicrew-edge-device/{edge_device}/component"
                                .replace("{".concat("edge_device", "}"), encodeURIComponent(String(edgeDevice)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} nodeId
         * @param {SaicrewEdgeDevice} saicrewEdgeDevice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewEdgeDeviceCreate: function (nodeId, saicrewEdgeDevice, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewEdgeDeviceCreate', 'nodeId', nodeId);
                            // verify required parameter 'saicrewEdgeDevice' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewEdgeDeviceCreate', 'saicrewEdgeDevice', saicrewEdgeDevice);
                            localVarPath = "/swc-api/nodes/{node_id}/saicrew-edge-device"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(saicrewEdgeDevice, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Saicrewデプロイ承認
         * @param {string} edgeDevice
         * @param {string} id
         * @param {string} nodeId
         * @param {SaicrewDeploymentApprove} saicrewDeploymentApprove
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewEdgeDeviceDeploymentsApproveCreate: function (edgeDevice, id, nodeId, saicrewDeploymentApprove, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'edgeDevice' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewEdgeDeviceDeploymentsApproveCreate', 'edgeDevice', edgeDevice);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewEdgeDeviceDeploymentsApproveCreate', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewEdgeDeviceDeploymentsApproveCreate', 'nodeId', nodeId);
                            // verify required parameter 'saicrewDeploymentApprove' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewEdgeDeviceDeploymentsApproveCreate', 'saicrewDeploymentApprove', saicrewDeploymentApprove);
                            localVarPath = "/swc-api/nodes/{node_id}/saicrew-edge-device/{edge_device}/deployments/{id}/approve"
                                .replace("{".concat("edge_device", "}"), encodeURIComponent(String(edgeDevice)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(saicrewDeploymentApprove, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Saicrewデプロイキャンセル
         * @param {string} edgeDevice
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewEdgeDeviceDeploymentsCancelCreate: function (edgeDevice, id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'edgeDevice' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewEdgeDeviceDeploymentsCancelCreate', 'edgeDevice', edgeDevice);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewEdgeDeviceDeploymentsCancelCreate', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewEdgeDeviceDeploymentsCancelCreate', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/saicrew-edge-device/{edge_device}/deployments/{id}/cancel"
                                .replace("{".concat("edge_device", "}"), encodeURIComponent(String(edgeDevice)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Saicrewデプロイ作成
         * @param {string} edgeDevice
         * @param {string} nodeId
         * @param {SaicrewDeployment} saicrewDeployment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewEdgeDeviceDeploymentsCreate: function (edgeDevice, nodeId, saicrewDeployment, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'edgeDevice' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewEdgeDeviceDeploymentsCreate', 'edgeDevice', edgeDevice);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewEdgeDeviceDeploymentsCreate', 'nodeId', nodeId);
                            // verify required parameter 'saicrewDeployment' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewEdgeDeviceDeploymentsCreate', 'saicrewDeployment', saicrewDeployment);
                            localVarPath = "/swc-api/nodes/{node_id}/saicrew-edge-device/{edge_device}/deployments"
                                .replace("{".concat("edge_device", "}"), encodeURIComponent(String(edgeDevice)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(saicrewDeployment, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * 環境取得
         * @param {string} edgeDevice
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewEdgeDeviceDeploymentsEnvironmentRetrieve: function (edgeDevice, id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'edgeDevice' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewEdgeDeviceDeploymentsEnvironmentRetrieve', 'edgeDevice', edgeDevice);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewEdgeDeviceDeploymentsEnvironmentRetrieve', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewEdgeDeviceDeploymentsEnvironmentRetrieve', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/saicrew-edge-device/{edge_device}/deployments/{id}/environment"
                                .replace("{".concat("edge_device", "}"), encodeURIComponent(String(edgeDevice)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Saicrewデプロイ一覧
         * @param {string} edgeDevice
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewEdgeDeviceDeploymentsList: function (edgeDevice, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'edgeDevice' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewEdgeDeviceDeploymentsList', 'edgeDevice', edgeDevice);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewEdgeDeviceDeploymentsList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/saicrew-edge-device/{edge_device}/deployments"
                                .replace("{".concat("edge_device", "}"), encodeURIComponent(String(edgeDevice)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Saicrewデプロイ
         * @param {string} edgeDevice
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewEdgeDeviceDeploymentsRetrieve: function (edgeDevice, id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'edgeDevice' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewEdgeDeviceDeploymentsRetrieve', 'edgeDevice', edgeDevice);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewEdgeDeviceDeploymentsRetrieve', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewEdgeDeviceDeploymentsRetrieve', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/saicrew-edge-device/{edge_device}/deployments/{id}"
                                .replace("{".concat("edge_device", "}"), encodeURIComponent(String(edgeDevice)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Saicrewデプロイ再試行
         * @param {string} edgeDevice
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewEdgeDeviceDeploymentsRetryCreate: function (edgeDevice, id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'edgeDevice' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewEdgeDeviceDeploymentsRetryCreate', 'edgeDevice', edgeDevice);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewEdgeDeviceDeploymentsRetryCreate', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewEdgeDeviceDeploymentsRetryCreate', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/saicrew-edge-device/{edge_device}/deployments/{id}/retry"
                                .replace("{".concat("edge_device", "}"), encodeURIComponent(String(edgeDevice)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewEdgeDeviceDestroy: function (id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewEdgeDeviceDestroy', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewEdgeDeviceDestroy', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/saicrew-edge-device/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Saicrewエッジデバイス詳細取得
         * @param {string} nodeId
         * @param {boolean} [includeDeploymentCounts] 今月のデプロイ数も合わせて取得
         * @param {boolean} [includeModelBuildCounts] 今月のモデルビルド数も合わせて取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewEdgeDeviceList: function (nodeId, includeDeploymentCounts, includeModelBuildCounts, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewEdgeDeviceList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/saicrew-edge-device"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (includeDeploymentCounts !== undefined) {
                                localVarQueryParameter['include_deployment_counts'] = includeDeploymentCounts;
                            }
                            if (includeModelBuildCounts !== undefined) {
                                localVarQueryParameter['include_model_build_counts'] = includeModelBuildCounts;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {string} nodeId
         * @param {PatchedSaicrewEdgeDevice} [patchedSaicrewEdgeDevice]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewEdgeDevicePartialUpdate: function (id, nodeId, patchedSaicrewEdgeDevice, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewEdgeDevicePartialUpdate', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewEdgeDevicePartialUpdate', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/saicrew-edge-device/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchedSaicrewEdgeDevice, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewEdgeDeviceRetrieve: function (id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewEdgeDeviceRetrieve', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewEdgeDeviceRetrieve', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/saicrew-edge-device/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {string} nodeId
         * @param {SaicrewEdgeDevice} saicrewEdgeDevice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewEdgeDeviceUpdate: function (id, nodeId, saicrewEdgeDevice, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewEdgeDeviceUpdate', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewEdgeDeviceUpdate', 'nodeId', nodeId);
                            // verify required parameter 'saicrewEdgeDevice' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewEdgeDeviceUpdate', 'saicrewEdgeDevice', saicrewEdgeDevice);
                            localVarPath = "/swc-api/nodes/{node_id}/saicrew-edge-device/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(saicrewEdgeDevice, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * SaiCrew-ML　Variables ViewSet.
         * @param {string} nodeId
         * @param {SaicrewMLVariables} saicrewMLVariables
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewMlVariablesCreate: function (nodeId, saicrewMLVariables, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewMlVariablesCreate', 'nodeId', nodeId);
                            // verify required parameter 'saicrewMLVariables' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewMlVariablesCreate', 'saicrewMLVariables', saicrewMLVariables);
                            localVarPath = "/swc-api/nodes/{node_id}/saicrew-ml-variables"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(saicrewMLVariables, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * SaiCrew-ML　Variables ViewSet.
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewMlVariablesDestroy: function (id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewMlVariablesDestroy', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewMlVariablesDestroy', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/saicrew-ml-variables/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * SaiCrew-ML　Variables ViewSet.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewMlVariablesList: function (nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewMlVariablesList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/saicrew-ml-variables"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * SaiCrew-ML　Variables ViewSet.
         * @param {string} id
         * @param {string} nodeId
         * @param {PatchedSaicrewMLVariables} [patchedSaicrewMLVariables]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewMlVariablesPartialUpdate: function (id, nodeId, patchedSaicrewMLVariables, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewMlVariablesPartialUpdate', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewMlVariablesPartialUpdate', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/saicrew-ml-variables/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchedSaicrewMLVariables, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * SaiCrew-ML　Variables ViewSet.
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewMlVariablesRetrieve: function (id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewMlVariablesRetrieve', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewMlVariablesRetrieve', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/saicrew-ml-variables/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * SaiCrew-ML　Variables ViewSet.
         * @param {string} id
         * @param {string} nodeId
         * @param {SaicrewMLVariables} saicrewMLVariables
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewMlVariablesUpdate: function (id, nodeId, saicrewMLVariables, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewMlVariablesUpdate', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewMlVariablesUpdate', 'nodeId', nodeId);
                            // verify required parameter 'saicrewMLVariables' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewMlVariablesUpdate', 'saicrewMLVariables', saicrewMLVariables);
                            localVarPath = "/swc-api/nodes/{node_id}/saicrew-ml-variables/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(saicrewMLVariables, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * SaiCrewAIモデル構築ジョブ承認
         * @param {string} gatewayId
         * @param {string} id
         * @param {string} modelId
         * @param {string} nodeId
         * @param {SaicrewAIModelBuildJobApprove} saicrewAIModelBuildJobApprove
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewModelsBuildJobsApproveCreate: function (gatewayId, id, modelId, nodeId, saicrewAIModelBuildJobApprove, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'gatewayId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsApproveCreate', 'gatewayId', gatewayId);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsApproveCreate', 'id', id);
                            // verify required parameter 'modelId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsApproveCreate', 'modelId', modelId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsApproveCreate', 'nodeId', nodeId);
                            // verify required parameter 'saicrewAIModelBuildJobApprove' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsApproveCreate', 'saicrewAIModelBuildJobApprove', saicrewAIModelBuildJobApprove);
                            localVarPath = "/swc-api/nodes/{node_id}/saicrew/{gateway_id}/models/{model_id}/build-jobs/{id}/approve"
                                .replace("{".concat("gateway_id", "}"), encodeURIComponent(String(gatewayId)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("model_id", "}"), encodeURIComponent(String(modelId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(saicrewAIModelBuildJobApprove, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * SaiCrewAIバッチ推論 構築ジョブキャンセル
         * @param {string} gatewayId
         * @param {string} id
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewModelsBuildJobsBatchInferenceCancelCreate: function (gatewayId, id, jobId, modelId, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'gatewayId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsBatchInferenceCancelCreate', 'gatewayId', gatewayId);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsBatchInferenceCancelCreate', 'id', id);
                            // verify required parameter 'jobId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsBatchInferenceCancelCreate', 'jobId', jobId);
                            // verify required parameter 'modelId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsBatchInferenceCancelCreate', 'modelId', modelId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsBatchInferenceCancelCreate', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/saicrew/{gateway_id}/models/{model_id}/build-jobs/{job_id}/batch-inference/{id}/cancel"
                                .replace("{".concat("gateway_id", "}"), encodeURIComponent(String(gatewayId)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("job_id", "}"), encodeURIComponent(String(jobId)))
                                .replace("{".concat("model_id", "}"), encodeURIComponent(String(modelId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * SaiCrew-AIバッチ推論 構築ジョブ作成
         * @param {string} gatewayId
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {SaiCrewAIModelBatchInferenceJob} data
         * @param {any} [zipFile]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewModelsBuildJobsBatchInferenceCreate: function (gatewayId, jobId, modelId, nodeId, data, zipFile, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'gatewayId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsBatchInferenceCreate', 'gatewayId', gatewayId);
                            // verify required parameter 'jobId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsBatchInferenceCreate', 'jobId', jobId);
                            // verify required parameter 'modelId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsBatchInferenceCreate', 'modelId', modelId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsBatchInferenceCreate', 'nodeId', nodeId);
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsBatchInferenceCreate', 'data', data);
                            localVarPath = "/swc-api/nodes/{node_id}/saicrew/{gateway_id}/models/{model_id}/build-jobs/{job_id}/batch-inference"
                                .replace("{".concat("gateway_id", "}"), encodeURIComponent(String(gatewayId)))
                                .replace("{".concat("job_id", "}"), encodeURIComponent(String(jobId)))
                                .replace("{".concat("model_id", "}"), encodeURIComponent(String(modelId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (zipFile !== undefined) {
                                localVarFormParams.append('zip_file', zipFile);
                            }
                            if (data !== undefined) {
                                localVarFormParams.append('data', new Blob([JSON.stringify(data)], { type: "application/json", }));
                            }
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Saicrew-AIバッチ推論 構築ジョブ一覧
         * @param {string} gatewayId
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewModelsBuildJobsBatchInferenceList: function (gatewayId, jobId, modelId, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'gatewayId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsBatchInferenceList', 'gatewayId', gatewayId);
                            // verify required parameter 'jobId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsBatchInferenceList', 'jobId', jobId);
                            // verify required parameter 'modelId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsBatchInferenceList', 'modelId', modelId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsBatchInferenceList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/saicrew/{gateway_id}/models/{model_id}/build-jobs/{job_id}/batch-inference"
                                .replace("{".concat("gateway_id", "}"), encodeURIComponent(String(gatewayId)))
                                .replace("{".concat("job_id", "}"), encodeURIComponent(String(jobId)))
                                .replace("{".concat("model_id", "}"), encodeURIComponent(String(modelId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Saicrew-AIバッチ推論 構築ジョブ詳細
         * @param {string} gatewayId
         * @param {string} id
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewModelsBuildJobsBatchInferenceRetrieve: function (gatewayId, id, jobId, modelId, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'gatewayId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsBatchInferenceRetrieve', 'gatewayId', gatewayId);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsBatchInferenceRetrieve', 'id', id);
                            // verify required parameter 'jobId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsBatchInferenceRetrieve', 'jobId', jobId);
                            // verify required parameter 'modelId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsBatchInferenceRetrieve', 'modelId', modelId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsBatchInferenceRetrieve', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/saicrew/{gateway_id}/models/{model_id}/build-jobs/{job_id}/batch-inference/{id}"
                                .replace("{".concat("gateway_id", "}"), encodeURIComponent(String(gatewayId)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("job_id", "}"), encodeURIComponent(String(jobId)))
                                .replace("{".concat("model_id", "}"), encodeURIComponent(String(modelId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * SaiCrewAIバッチ推論 構築ジョブ再試行
         * @param {string} gatewayId
         * @param {string} id
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewModelsBuildJobsBatchInferenceRetryCreate: function (gatewayId, id, jobId, modelId, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'gatewayId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsBatchInferenceRetryCreate', 'gatewayId', gatewayId);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsBatchInferenceRetryCreate', 'id', id);
                            // verify required parameter 'jobId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsBatchInferenceRetryCreate', 'jobId', jobId);
                            // verify required parameter 'modelId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsBatchInferenceRetryCreate', 'modelId', modelId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsBatchInferenceRetryCreate', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/saicrew/{gateway_id}/models/{model_id}/build-jobs/{job_id}/batch-inference/{id}/retry"
                                .replace("{".concat("gateway_id", "}"), encodeURIComponent(String(gatewayId)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("job_id", "}"), encodeURIComponent(String(jobId)))
                                .replace("{".concat("model_id", "}"), encodeURIComponent(String(modelId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * SaiCrewAIモデル構築ジョブキャンセル
         * @param {string} gatewayId
         * @param {string} id
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewModelsBuildJobsCancelCreate: function (gatewayId, id, modelId, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'gatewayId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsCancelCreate', 'gatewayId', gatewayId);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsCancelCreate', 'id', id);
                            // verify required parameter 'modelId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsCancelCreate', 'modelId', modelId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsCancelCreate', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/saicrew/{gateway_id}/models/{model_id}/build-jobs/{id}/cancel"
                                .replace("{".concat("gateway_id", "}"), encodeURIComponent(String(gatewayId)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("model_id", "}"), encodeURIComponent(String(modelId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create comment.
         * @param {string} gatewayId
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {SaicrewAIModelBuildJobComment} saicrewAIModelBuildJobComment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewModelsBuildJobsCommentsCreate: function (gatewayId, jobId, modelId, nodeId, saicrewAIModelBuildJobComment, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'gatewayId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsCommentsCreate', 'gatewayId', gatewayId);
                            // verify required parameter 'jobId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsCommentsCreate', 'jobId', jobId);
                            // verify required parameter 'modelId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsCommentsCreate', 'modelId', modelId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsCommentsCreate', 'nodeId', nodeId);
                            // verify required parameter 'saicrewAIModelBuildJobComment' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsCommentsCreate', 'saicrewAIModelBuildJobComment', saicrewAIModelBuildJobComment);
                            localVarPath = "/swc-api/nodes/{node_id}/saicrew/{gateway_id}/models/{model_id}/build-jobs/{job_id}/comments"
                                .replace("{".concat("gateway_id", "}"), encodeURIComponent(String(gatewayId)))
                                .replace("{".concat("job_id", "}"), encodeURIComponent(String(jobId)))
                                .replace("{".concat("model_id", "}"), encodeURIComponent(String(modelId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(saicrewAIModelBuildJobComment, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete comment
         * @param {string} gatewayId
         * @param {number} id A unique integer value identifying this t_saicrew_ai_model_build_job_comment.
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewModelsBuildJobsCommentsDestroy: function (gatewayId, id, jobId, modelId, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'gatewayId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsCommentsDestroy', 'gatewayId', gatewayId);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsCommentsDestroy', 'id', id);
                            // verify required parameter 'jobId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsCommentsDestroy', 'jobId', jobId);
                            // verify required parameter 'modelId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsCommentsDestroy', 'modelId', modelId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsCommentsDestroy', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/saicrew/{gateway_id}/models/{model_id}/build-jobs/{job_id}/comments/{id}"
                                .replace("{".concat("gateway_id", "}"), encodeURIComponent(String(gatewayId)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("job_id", "}"), encodeURIComponent(String(jobId)))
                                .replace("{".concat("model_id", "}"), encodeURIComponent(String(modelId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns list of comments.
         * @param {string} gatewayId
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewModelsBuildJobsCommentsList: function (gatewayId, jobId, modelId, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'gatewayId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsCommentsList', 'gatewayId', gatewayId);
                            // verify required parameter 'jobId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsCommentsList', 'jobId', jobId);
                            // verify required parameter 'modelId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsCommentsList', 'modelId', modelId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsCommentsList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/saicrew/{gateway_id}/models/{model_id}/build-jobs/{job_id}/comments"
                                .replace("{".concat("gateway_id", "}"), encodeURIComponent(String(gatewayId)))
                                .replace("{".concat("job_id", "}"), encodeURIComponent(String(jobId)))
                                .replace("{".concat("model_id", "}"), encodeURIComponent(String(modelId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * カメラAIモデル構築ジョブコメント
         * @param {string} gatewayId
         * @param {number} id A unique integer value identifying this t_saicrew_ai_model_build_job_comment.
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {PatchedSaicrewAIModelBuildJobComment} [patchedSaicrewAIModelBuildJobComment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewModelsBuildJobsCommentsPartialUpdate: function (gatewayId, id, jobId, modelId, nodeId, patchedSaicrewAIModelBuildJobComment, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'gatewayId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsCommentsPartialUpdate', 'gatewayId', gatewayId);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsCommentsPartialUpdate', 'id', id);
                            // verify required parameter 'jobId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsCommentsPartialUpdate', 'jobId', jobId);
                            // verify required parameter 'modelId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsCommentsPartialUpdate', 'modelId', modelId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsCommentsPartialUpdate', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/saicrew/{gateway_id}/models/{model_id}/build-jobs/{job_id}/comments/{id}"
                                .replace("{".concat("gateway_id", "}"), encodeURIComponent(String(gatewayId)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("job_id", "}"), encodeURIComponent(String(jobId)))
                                .replace("{".concat("model_id", "}"), encodeURIComponent(String(modelId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchedSaicrewAIModelBuildJobComment, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * カメラAIモデル構築ジョブコメント
         * @param {string} gatewayId
         * @param {number} id A unique integer value identifying this t_saicrew_ai_model_build_job_comment.
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewModelsBuildJobsCommentsRetrieve: function (gatewayId, id, jobId, modelId, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'gatewayId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsCommentsRetrieve', 'gatewayId', gatewayId);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsCommentsRetrieve', 'id', id);
                            // verify required parameter 'jobId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsCommentsRetrieve', 'jobId', jobId);
                            // verify required parameter 'modelId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsCommentsRetrieve', 'modelId', modelId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsCommentsRetrieve', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/saicrew/{gateway_id}/models/{model_id}/build-jobs/{job_id}/comments/{id}"
                                .replace("{".concat("gateway_id", "}"), encodeURIComponent(String(gatewayId)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("job_id", "}"), encodeURIComponent(String(jobId)))
                                .replace("{".concat("model_id", "}"), encodeURIComponent(String(modelId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update comment.
         * @param {string} gatewayId
         * @param {number} id A unique integer value identifying this t_saicrew_ai_model_build_job_comment.
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {SaicrewAIModelBuildJobComment} saicrewAIModelBuildJobComment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewModelsBuildJobsCommentsUpdate: function (gatewayId, id, jobId, modelId, nodeId, saicrewAIModelBuildJobComment, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'gatewayId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsCommentsUpdate', 'gatewayId', gatewayId);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsCommentsUpdate', 'id', id);
                            // verify required parameter 'jobId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsCommentsUpdate', 'jobId', jobId);
                            // verify required parameter 'modelId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsCommentsUpdate', 'modelId', modelId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsCommentsUpdate', 'nodeId', nodeId);
                            // verify required parameter 'saicrewAIModelBuildJobComment' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsCommentsUpdate', 'saicrewAIModelBuildJobComment', saicrewAIModelBuildJobComment);
                            localVarPath = "/swc-api/nodes/{node_id}/saicrew/{gateway_id}/models/{model_id}/build-jobs/{job_id}/comments/{id}"
                                .replace("{".concat("gateway_id", "}"), encodeURIComponent(String(gatewayId)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("job_id", "}"), encodeURIComponent(String(jobId)))
                                .replace("{".concat("model_id", "}"), encodeURIComponent(String(modelId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(saicrewAIModelBuildJobComment, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * SaiCrew-AIモデル構築ジョブ作成
         * @param {string} gatewayId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {SaicrewAIModelBuildJob} data
         * @param {any} [zipFile]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewModelsBuildJobsCreate: function (gatewayId, modelId, nodeId, data, zipFile, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'gatewayId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsCreate', 'gatewayId', gatewayId);
                            // verify required parameter 'modelId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsCreate', 'modelId', modelId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsCreate', 'nodeId', nodeId);
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsCreate', 'data', data);
                            localVarPath = "/swc-api/nodes/{node_id}/saicrew/{gateway_id}/models/{model_id}/build-jobs"
                                .replace("{".concat("gateway_id", "}"), encodeURIComponent(String(gatewayId)))
                                .replace("{".concat("model_id", "}"), encodeURIComponent(String(modelId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (zipFile !== undefined) {
                                localVarFormParams.append('zip_file', zipFile);
                            }
                            if (data !== undefined) {
                                localVarFormParams.append('data', new Blob([JSON.stringify(data)], { type: "application/json", }));
                            }
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Saicrew-AIモデル構築ジョブ一覧
         * @param {string} gatewayId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewModelsBuildJobsList: function (gatewayId, modelId, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'gatewayId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsList', 'gatewayId', gatewayId);
                            // verify required parameter 'modelId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsList', 'modelId', modelId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/saicrew/{gateway_id}/models/{model_id}/build-jobs"
                                .replace("{".concat("gateway_id", "}"), encodeURIComponent(String(gatewayId)))
                                .replace("{".concat("model_id", "}"), encodeURIComponent(String(modelId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Saicrew-AIAIモデル構築ジョブ詳細
         * @param {string} gatewayId
         * @param {string} id
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewModelsBuildJobsRetrieve: function (gatewayId, id, modelId, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'gatewayId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsRetrieve', 'gatewayId', gatewayId);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsRetrieve', 'id', id);
                            // verify required parameter 'modelId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsRetrieve', 'modelId', modelId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsRetrieve', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/saicrew/{gateway_id}/models/{model_id}/build-jobs/{id}"
                                .replace("{".concat("gateway_id", "}"), encodeURIComponent(String(gatewayId)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("model_id", "}"), encodeURIComponent(String(modelId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * SaiCrewAIモデル構築ジョブ再試行
         * @param {string} gatewayId
         * @param {string} id
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewModelsBuildJobsRetryCreate: function (gatewayId, id, modelId, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'gatewayId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsRetryCreate', 'gatewayId', gatewayId);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsRetryCreate', 'id', id);
                            // verify required parameter 'modelId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsRetryCreate', 'modelId', modelId);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaicrewModelsBuildJobsRetryCreate', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/saicrew/{gateway_id}/models/{model_id}/build-jobs/{id}/retry"
                                .replace("{".concat("gateway_id", "}"), encodeURIComponent(String(gatewayId)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("model_id", "}"), encodeURIComponent(String(modelId)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * SaiForce 演算設定追加
         * @param {string} nodeId
         * @param {SaiforceCalculationSettings} saiforceCalculationSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaiforceCalculationSettingsCreate: function (nodeId, saiforceCalculationSettings, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaiforceCalculationSettingsCreate', 'nodeId', nodeId);
                            // verify required parameter 'saiforceCalculationSettings' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaiforceCalculationSettingsCreate', 'saiforceCalculationSettings', saiforceCalculationSettings);
                            localVarPath = "/swc-api/nodes/{node_id}/saiforce/calculation-settings"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(saiforceCalculationSettings, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * SaiForce 演算設定削除
         * @param {number} id dataset_id
         * @param {number} nodeId 設備 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaiforceCalculationSettingsDestroy: function (id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaiforceCalculationSettingsDestroy', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaiforceCalculationSettingsDestroy', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/saiforce/calculation-settings/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * SaiForce 演算設定一覧
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaiforceCalculationSettingsList: function (nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSaiforceCalculationSettingsList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/saiforce/calculation-settings"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ゲートウェイ定周期通信異常判定
         * @param {string} nodeId
         * @param {number} timeFrom 取得期間（開始）
         * @param {number} timeTo 取得期間（終了）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSysalartHistoryJudgementRetrieve: function (nodeId, timeFrom, timeTo, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSysalartHistoryJudgementRetrieve', 'nodeId', nodeId);
                            // verify required parameter 'timeFrom' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSysalartHistoryJudgementRetrieve', 'timeFrom', timeFrom);
                            // verify required parameter 'timeTo' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSysalartHistoryJudgementRetrieve', 'timeTo', timeTo);
                            localVarPath = "/swc-api/nodes/{node_id}/sysalart-history/judgement"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (timeFrom !== undefined) {
                                localVarQueryParameter['time_from'] = timeFrom;
                            }
                            if (timeTo !== undefined) {
                                localVarQueryParameter['time_to'] = timeTo;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ゲートウェイ定周期通信異常情報取得
         * @param {string} nodeId
         * @param {number} timeFrom 取得期間（開始）
         * @param {number} timeTo 取得期間（終了）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSysalartHistoryList: function (nodeId, timeFrom, timeTo, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSysalartHistoryList', 'nodeId', nodeId);
                            // verify required parameter 'timeFrom' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSysalartHistoryList', 'timeFrom', timeFrom);
                            // verify required parameter 'timeTo' is not null or undefined
                            (0, common_1.assertParamExists)('nodesSysalartHistoryList', 'timeTo', timeTo);
                            localVarPath = "/swc-api/nodes/{node_id}/sysalart-history"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (timeFrom !== undefined) {
                                localVarQueryParameter['time_from'] = timeFrom;
                            }
                            if (timeTo !== undefined) {
                                localVarQueryParameter['time_to'] = timeTo;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * テクニカルレポートステータス
         * @param {string} nodeId
         * @param {boolean} [includeDescendants] 子孫のデータセットを含むか
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTechnicalReportStatusList: function (nodeId, includeDescendants, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesTechnicalReportStatusList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/technical-report/status"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (includeDescendants !== undefined) {
                                localVarQueryParameter['include_descendants'] = includeDescendants;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} nodeId
         * @param {string} technicalReportId
         * @param {TechnicalReportAttachments} [technicalReportAttachments]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTechnicalReportsAttachmentsCreate: function (nodeId, technicalReportId, technicalReportAttachments, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesTechnicalReportsAttachmentsCreate', 'nodeId', nodeId);
                            // verify required parameter 'technicalReportId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesTechnicalReportsAttachmentsCreate', 'technicalReportId', technicalReportId);
                            localVarPath = "/swc-api/nodes/{node_id}/technical-reports/{technical_report_id}/attachments"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)))
                                .replace("{".concat("technical_report_id", "}"), encodeURIComponent(String(technicalReportId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(technicalReportAttachments, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this t_technical_report.
         * @param {string} nodeId
         * @param {string} technicalReportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTechnicalReportsAttachmentsDestroy: function (id, nodeId, technicalReportId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesTechnicalReportsAttachmentsDestroy', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesTechnicalReportsAttachmentsDestroy', 'nodeId', nodeId);
                            // verify required parameter 'technicalReportId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesTechnicalReportsAttachmentsDestroy', 'technicalReportId', technicalReportId);
                            localVarPath = "/swc-api/nodes/{node_id}/technical-reports/{technical_report_id}/attachments/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)))
                                .replace("{".concat("technical_report_id", "}"), encodeURIComponent(String(technicalReportId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} nodeId
         * @param {string} technicalReportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTechnicalReportsAttachmentsList: function (nodeId, technicalReportId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesTechnicalReportsAttachmentsList', 'nodeId', nodeId);
                            // verify required parameter 'technicalReportId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesTechnicalReportsAttachmentsList', 'technicalReportId', technicalReportId);
                            localVarPath = "/swc-api/nodes/{node_id}/technical-reports/{technical_report_id}/attachments"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)))
                                .replace("{".concat("technical_report_id", "}"), encodeURIComponent(String(technicalReportId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this t_technical_report.
         * @param {string} nodeId
         * @param {string} technicalReportId
         * @param {PatchedTechnicalReportAttachments} [patchedTechnicalReportAttachments]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTechnicalReportsAttachmentsPartialUpdate: function (id, nodeId, technicalReportId, patchedTechnicalReportAttachments, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesTechnicalReportsAttachmentsPartialUpdate', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesTechnicalReportsAttachmentsPartialUpdate', 'nodeId', nodeId);
                            // verify required parameter 'technicalReportId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesTechnicalReportsAttachmentsPartialUpdate', 'technicalReportId', technicalReportId);
                            localVarPath = "/swc-api/nodes/{node_id}/technical-reports/{technical_report_id}/attachments/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)))
                                .replace("{".concat("technical_report_id", "}"), encodeURIComponent(String(technicalReportId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchedTechnicalReportAttachments, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * テクニカルレポート添付ファイル取得
         * @param {number} id A unique integer value identifying this t_technical_report.
         * @param {string} nodeId
         * @param {string} technicalReportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTechnicalReportsAttachmentsRetrieve: function (id, nodeId, technicalReportId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesTechnicalReportsAttachmentsRetrieve', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesTechnicalReportsAttachmentsRetrieve', 'nodeId', nodeId);
                            // verify required parameter 'technicalReportId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesTechnicalReportsAttachmentsRetrieve', 'technicalReportId', technicalReportId);
                            localVarPath = "/swc-api/nodes/{node_id}/technical-reports/{technical_report_id}/attachments/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)))
                                .replace("{".concat("technical_report_id", "}"), encodeURIComponent(String(technicalReportId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this t_technical_report.
         * @param {string} nodeId
         * @param {string} technicalReportId
         * @param {TechnicalReportAttachments} [technicalReportAttachments]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTechnicalReportsAttachmentsUpdate: function (id, nodeId, technicalReportId, technicalReportAttachments, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesTechnicalReportsAttachmentsUpdate', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesTechnicalReportsAttachmentsUpdate', 'nodeId', nodeId);
                            // verify required parameter 'technicalReportId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesTechnicalReportsAttachmentsUpdate', 'technicalReportId', technicalReportId);
                            localVarPath = "/swc-api/nodes/{node_id}/technical-reports/{technical_report_id}/attachments/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)))
                                .replace("{".concat("technical_report_id", "}"), encodeURIComponent(String(technicalReportId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(technicalReportAttachments, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * テクニカルレポート追加
         * @param {string} nodeId
         * @param {TechnicalReportRequest} technicalReportRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTechnicalReportsCreate: function (nodeId, technicalReportRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesTechnicalReportsCreate', 'nodeId', nodeId);
                            // verify required parameter 'technicalReportRequest' is not null or undefined
                            (0, common_1.assertParamExists)('nodesTechnicalReportsCreate', 'technicalReportRequest', technicalReportRequest);
                            localVarPath = "/swc-api/nodes/{node_id}/technical-reports"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(technicalReportRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * テクニカルレポート削除
         * @param {number} id A unique integer value identifying this t_technical_report.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTechnicalReportsDestroy: function (id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesTechnicalReportsDestroy', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesTechnicalReportsDestroy', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/technical-reports/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * テクニカルレポート API
         * @param {string} dateFrom 取得期間（開始）
         * @param {string} dateTo 取得期間（終了）
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTechnicalReportsList: function (dateFrom, dateTo, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'dateFrom' is not null or undefined
                            (0, common_1.assertParamExists)('nodesTechnicalReportsList', 'dateFrom', dateFrom);
                            // verify required parameter 'dateTo' is not null or undefined
                            (0, common_1.assertParamExists)('nodesTechnicalReportsList', 'dateTo', dateTo);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesTechnicalReportsList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/technical-reports"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (dateFrom !== undefined) {
                                localVarQueryParameter['date_from'] = dateFrom;
                            }
                            if (dateTo !== undefined) {
                                localVarQueryParameter['date_to'] = dateTo;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * テクニカルレポート更新（一部）
         * @param {number} id A unique integer value identifying this t_technical_report.
         * @param {string} nodeId
         * @param {PatchedTechnicalReportRequest} [patchedTechnicalReportRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTechnicalReportsPartialUpdate: function (id, nodeId, patchedTechnicalReportRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesTechnicalReportsPartialUpdate', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesTechnicalReportsPartialUpdate', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/technical-reports/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchedTechnicalReportRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * テクニカルレポート詳細取得
         * @param {number} id A unique integer value identifying this t_technical_report.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTechnicalReportsRetrieve: function (id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesTechnicalReportsRetrieve', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesTechnicalReportsRetrieve', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/technical-reports/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this t_technical_report.
         * @param {string} nodeId
         * @param {TechnicalReport} technicalReport
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTechnicalReportsUpdate: function (id, nodeId, technicalReport, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesTechnicalReportsUpdate', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesTechnicalReportsUpdate', 'nodeId', nodeId);
                            // verify required parameter 'technicalReport' is not null or undefined
                            (0, common_1.assertParamExists)('nodesTechnicalReportsUpdate', 'technicalReport', technicalReport);
                            localVarPath = "/swc-api/nodes/{node_id}/technical-reports/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(technicalReport, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} nodeId
         * @param {TotalUploadedDocumentSize} totalUploadedDocumentSize
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTotalUploadedDocumentSizeCreate: function (nodeId, totalUploadedDocumentSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesTotalUploadedDocumentSizeCreate', 'nodeId', nodeId);
                            // verify required parameter 'totalUploadedDocumentSize' is not null or undefined
                            (0, common_1.assertParamExists)('nodesTotalUploadedDocumentSizeCreate', 'totalUploadedDocumentSize', totalUploadedDocumentSize);
                            localVarPath = "/swc-api/nodes/{node_id}/total-uploaded-document-size"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(totalUploadedDocumentSize, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTotalUploadedDocumentSizeDestroy: function (id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesTotalUploadedDocumentSizeDestroy', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesTotalUploadedDocumentSizeDestroy', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/total-uploaded-document-size/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * アップロードされた全ドキュメントのルート階層単位でのサイズ取得
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTotalUploadedDocumentSizeList: function (nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesTotalUploadedDocumentSizeList', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/total-uploaded-document-size"
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {string} nodeId
         * @param {PatchedTotalUploadedDocumentSize} [patchedTotalUploadedDocumentSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTotalUploadedDocumentSizePartialUpdate: function (id, nodeId, patchedTotalUploadedDocumentSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesTotalUploadedDocumentSizePartialUpdate', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesTotalUploadedDocumentSizePartialUpdate', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/total-uploaded-document-size/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchedTotalUploadedDocumentSize, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTotalUploadedDocumentSizeRetrieve: function (id, nodeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesTotalUploadedDocumentSizeRetrieve', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesTotalUploadedDocumentSizeRetrieve', 'nodeId', nodeId);
                            localVarPath = "/swc-api/nodes/{node_id}/total-uploaded-document-size/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {string} nodeId
         * @param {TotalUploadedDocumentSize} totalUploadedDocumentSize
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTotalUploadedDocumentSizeUpdate: function (id, nodeId, totalUploadedDocumentSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('nodesTotalUploadedDocumentSizeUpdate', 'id', id);
                            // verify required parameter 'nodeId' is not null or undefined
                            (0, common_1.assertParamExists)('nodesTotalUploadedDocumentSizeUpdate', 'nodeId', nodeId);
                            // verify required parameter 'totalUploadedDocumentSize' is not null or undefined
                            (0, common_1.assertParamExists)('nodesTotalUploadedDocumentSizeUpdate', 'totalUploadedDocumentSize', totalUploadedDocumentSize);
                            localVarPath = "/swc-api/nodes/{node_id}/total-uploaded-document-size/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("node_id", "}"), encodeURIComponent(String(nodeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(totalUploadedDocumentSize, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.NodesApiAxiosParamCreator = NodesApiAxiosParamCreator;
/**
 * NodesApi - functional programming interface
 * @export
 */
var NodesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.NodesApiAxiosParamCreator)(configuration);
    return {
        /**
         * 警報履歴取得
         * @param {string} nodeId
         * @param {number} timeFrom 取得期間（開始）
         * @param {number} timeTo 取得期間（終了）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesAlarmHistoryList: function (nodeId, timeFrom, timeTo, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesAlarmHistoryList(nodeId, timeFrom, timeTo, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns list of algorithms.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraAiAlgorithmsList: function (nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesCameraAiAlgorithmsList(nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns algorithm.
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraAiAlgorithmsRetrieve: function (id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesCameraAiAlgorithmsRetrieve(id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns algorithm.
         * @param {string} algorithmName
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraAiAlgorithmsVersionsRetrieve: function (algorithmName, id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesCameraAiAlgorithmsVersionsRetrieve(algorithmName, id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * カメラAIモデル追加
         * @param {string} nodeId
         * @param {CameraAIModel} cameraAIModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraAiModelsCreate: function (nodeId, cameraAIModel, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesCameraAiModelsCreate(nodeId, cameraAIModel, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * カメラAIモデル削除
         * @param {number} id A unique integer value identifying this m_camera_ai_model.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraAiModelsDestroy: function (id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesCameraAiModelsDestroy(id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 最新MLPipelineID
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraAiModelsLatestPipelineIdRetrieve: function (nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesCameraAiModelsLatestPipelineIdRetrieve(nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * カメラ一AIモデル覧取得
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraAiModelsList: function (nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesCameraAiModelsList(nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * カメラAIモデル更新（一部）
         * @param {number} id A unique integer value identifying this m_camera_ai_model.
         * @param {string} nodeId
         * @param {PatchedCameraAIModel} [patchedCameraAIModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraAiModelsPartialUpdate: function (id, nodeId, patchedCameraAIModel, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesCameraAiModelsPartialUpdate(id, nodeId, patchedCameraAIModel, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * カメラAIモデル詳細取得
         * @param {number} id A unique integer value identifying this m_camera_ai_model.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraAiModelsRetrieve: function (id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesCameraAiModelsRetrieve(id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * カメラAIモデル更新
         * @param {number} id A unique integer value identifying this m_camera_ai_model.
         * @param {string} nodeId
         * @param {CameraAIModel} cameraAIModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraAiModelsUpdate: function (id, nodeId, cameraAIModel, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesCameraAiModelsUpdate(id, nodeId, cameraAIModel, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * カメラThingデプロイ承認
         * @param {string} id
         * @param {string} nodeId
         * @param {string} thingName
         * @param {CameraThingDeploymentApprove} cameraThingDeploymentApprove
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraThingsDeploymentsApproveCreate: function (id, nodeId, thingName, cameraThingDeploymentApprove, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesCameraThingsDeploymentsApproveCreate(id, nodeId, thingName, cameraThingDeploymentApprove, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * カメラThingデプロイキャンセル
         * @param {string} id
         * @param {string} nodeId
         * @param {string} thingName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraThingsDeploymentsCancelCreate: function (id, nodeId, thingName, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesCameraThingsDeploymentsCancelCreate(id, nodeId, thingName, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * カメラThingデプロイ作成
         * @param {string} nodeId
         * @param {string} thingName
         * @param {CameraThingDeployment} cameraThingDeployment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraThingsDeploymentsCreate: function (nodeId, thingName, cameraThingDeployment, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesCameraThingsDeploymentsCreate(nodeId, thingName, cameraThingDeployment, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * カメラThingデプロイ設定
         * @param {string} nodeId
         * @param {string} thingName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraThingsDeploymentsCurrentRetrieve: function (nodeId, thingName, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesCameraThingsDeploymentsCurrentRetrieve(nodeId, thingName, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * カメラThingデプロイ一覧
         * @param {string} nodeId
         * @param {string} thingName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraThingsDeploymentsList: function (nodeId, thingName, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesCameraThingsDeploymentsList(nodeId, thingName, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * カメラThingデプロイ詳細
         * @param {string} id
         * @param {string} nodeId
         * @param {string} thingName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraThingsDeploymentsRetrieve: function (id, nodeId, thingName, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesCameraThingsDeploymentsRetrieve(id, nodeId, thingName, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * カメラThingデプロイ再試行
         * @param {string} id
         * @param {string} nodeId
         * @param {string} thingName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraThingsDeploymentsRetryCreate: function (id, nodeId, thingName, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesCameraThingsDeploymentsRetryCreate(id, nodeId, thingName, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 環境取得
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraThingsEnvironmentRetrieve: function (id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesCameraThingsEnvironmentRetrieve(id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * カメラThing
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraThingsList: function (nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesCameraThingsList(nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * カメラThing
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraThingsRetrieve: function (id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesCameraThingsRetrieve(id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * カメラAIモデル構築ジョブ承認
         * @param {string} cameraId
         * @param {string} id
         * @param {string} modelId
         * @param {string} nodeId
         * @param {CameraAIModelBuildJobApprove} cameraAIModelBuildJobApprove
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCamerasModelsBuildJobsApproveCreate: function (cameraId, id, modelId, nodeId, cameraAIModelBuildJobApprove, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesCamerasModelsBuildJobsApproveCreate(cameraId, id, modelId, nodeId, cameraAIModelBuildJobApprove, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * カメラAIモデル構築ジョブキャンセル
         * @param {string} cameraId
         * @param {string} id
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCamerasModelsBuildJobsCancelCreate: function (cameraId, id, modelId, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesCamerasModelsBuildJobsCancelCreate(cameraId, id, modelId, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Create comment.
         * @param {string} cameraId
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {CameraAIModelBuildJobComment} cameraAIModelBuildJobComment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCamerasModelsBuildJobsCommentsCreate: function (cameraId, jobId, modelId, nodeId, cameraAIModelBuildJobComment, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesCamerasModelsBuildJobsCommentsCreate(cameraId, jobId, modelId, nodeId, cameraAIModelBuildJobComment, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete comment
         * @param {string} cameraId
         * @param {number} id A unique integer value identifying this t_camera_ai_model_build_job_comment.
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCamerasModelsBuildJobsCommentsDestroy: function (cameraId, id, jobId, modelId, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesCamerasModelsBuildJobsCommentsDestroy(cameraId, id, jobId, modelId, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns list of comments.
         * @param {string} cameraId
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCamerasModelsBuildJobsCommentsList: function (cameraId, jobId, modelId, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesCamerasModelsBuildJobsCommentsList(cameraId, jobId, modelId, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * カメラAIモデル構築ジョブコメント
         * @param {string} cameraId
         * @param {number} id A unique integer value identifying this t_camera_ai_model_build_job_comment.
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {PatchedCameraAIModelBuildJobComment} [patchedCameraAIModelBuildJobComment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCamerasModelsBuildJobsCommentsPartialUpdate: function (cameraId, id, jobId, modelId, nodeId, patchedCameraAIModelBuildJobComment, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesCamerasModelsBuildJobsCommentsPartialUpdate(cameraId, id, jobId, modelId, nodeId, patchedCameraAIModelBuildJobComment, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * カメラAIモデル構築ジョブコメント
         * @param {string} cameraId
         * @param {number} id A unique integer value identifying this t_camera_ai_model_build_job_comment.
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCamerasModelsBuildJobsCommentsRetrieve: function (cameraId, id, jobId, modelId, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesCamerasModelsBuildJobsCommentsRetrieve(cameraId, id, jobId, modelId, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update comment.
         * @param {string} cameraId
         * @param {number} id A unique integer value identifying this t_camera_ai_model_build_job_comment.
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {CameraAIModelBuildJobComment} cameraAIModelBuildJobComment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCamerasModelsBuildJobsCommentsUpdate: function (cameraId, id, jobId, modelId, nodeId, cameraAIModelBuildJobComment, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesCamerasModelsBuildJobsCommentsUpdate(cameraId, id, jobId, modelId, nodeId, cameraAIModelBuildJobComment, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * カメラAIモデル構築ジョブ作成
         * @param {string} cameraId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {CameraAIModelBuildJob} data
         * @param {any} [zipFile]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCamerasModelsBuildJobsCreate: function (cameraId, modelId, nodeId, data, zipFile, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesCamerasModelsBuildJobsCreate(cameraId, modelId, nodeId, data, zipFile, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns list of images.
         * @param {string} cameraId
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCamerasModelsBuildJobsImagesList: function (cameraId, jobId, modelId, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesCamerasModelsBuildJobsImagesList(cameraId, jobId, modelId, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 画像取得
         * @param {string} cameraId
         * @param {string} id
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCamerasModelsBuildJobsImagesRetrieve: function (cameraId, id, jobId, modelId, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesCamerasModelsBuildJobsImagesRetrieve(cameraId, id, jobId, modelId, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * カメラAIモデル構築ジョブ一覧
         * @param {string} cameraId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCamerasModelsBuildJobsList: function (cameraId, modelId, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesCamerasModelsBuildJobsList(cameraId, modelId, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * カメラAIモデル構築ジョブ評価結果
         * @param {string} cameraId
         * @param {string} id
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCamerasModelsBuildJobsResultRetrieve: function (cameraId, id, modelId, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesCamerasModelsBuildJobsResultRetrieve(cameraId, id, modelId, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * カメラAIモデル構築ジョブ詳細
         * @param {string} cameraId
         * @param {string} id
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCamerasModelsBuildJobsRetrieve: function (cameraId, id, modelId, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesCamerasModelsBuildJobsRetrieve(cameraId, id, modelId, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * カメラAIモデル構築ジョブ再試行
         * @param {string} cameraId
         * @param {string} id
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCamerasModelsBuildJobsRetryCreate: function (cameraId, id, modelId, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesCamerasModelsBuildJobsRetryCreate(cameraId, id, modelId, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * カメラAIモデル構築ジョブ詳細
         * @param {string} cameraId
         * @param {string} id
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCamerasModelsBuildJobsStateRetrieve: function (cameraId, id, modelId, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesCamerasModelsBuildJobsStateRetrieve(cameraId, id, modelId, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 帳票データ修正
         * @param {string} nodeId
         * @param {ChouhyoEdit} chouhyoEdit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesChouhyoEditCreate: function (nodeId, chouhyoEdit, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesChouhyoEditCreate(nodeId, chouhyoEdit, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} nodeId
         * @param {ChouhyoOutput} chouhyoOutput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesChouhyoOutputCreate: function (nodeId, chouhyoOutput, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesChouhyoOutputCreate(nodeId, chouhyoOutput, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesChouhyoOutputDestroy: function (id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesChouhyoOutputDestroy(id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 帳票取得 API
         * @param {number} id 帳票ID
         * @param {string} nodeId
         * @param {number} timestamp 対象日付
         * @param {string} type 帳票種別（日報(D)/月報(M)/年報(Y)）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesChouhyoOutputList: function (id, nodeId, timestamp, type, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesChouhyoOutputList(id, nodeId, timestamp, type, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {string} nodeId
         * @param {PatchedChouhyoOutput} [patchedChouhyoOutput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesChouhyoOutputPartialUpdate: function (id, nodeId, patchedChouhyoOutput, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesChouhyoOutputPartialUpdate(id, nodeId, patchedChouhyoOutput, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesChouhyoOutputRetrieve: function (id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesChouhyoOutputRetrieve(id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} nodeId
         * @param {ChouhyoOutputSetting} chouhyoOutputSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesChouhyoOutputSettingCreate: function (nodeId, chouhyoOutputSetting, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesChouhyoOutputSettingCreate(nodeId, chouhyoOutputSetting, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this m_chouhyo_output_setting.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesChouhyoOutputSettingDestroy: function (id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesChouhyoOutputSettingDestroy(id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesChouhyoOutputSettingList: function (nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesChouhyoOutputSettingList(nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this m_chouhyo_output_setting.
         * @param {string} nodeId
         * @param {PatchedChouhyoOutputSetting} [patchedChouhyoOutputSetting]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesChouhyoOutputSettingPartialUpdate: function (id, nodeId, patchedChouhyoOutputSetting, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesChouhyoOutputSettingPartialUpdate(id, nodeId, patchedChouhyoOutputSetting, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this m_chouhyo_output_setting.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesChouhyoOutputSettingRetrieve: function (id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesChouhyoOutputSettingRetrieve(id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this m_chouhyo_output_setting.
         * @param {string} nodeId
         * @param {ChouhyoOutputSetting} chouhyoOutputSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesChouhyoOutputSettingUpdate: function (id, nodeId, chouhyoOutputSetting, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesChouhyoOutputSettingUpdate(id, nodeId, chouhyoOutputSetting, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {string} nodeId
         * @param {ChouhyoOutput} chouhyoOutput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesChouhyoOutputUpdate: function (id, nodeId, chouhyoOutput, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesChouhyoOutputUpdate(id, nodeId, chouhyoOutput, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ダッシュボード設定追加
         * @param {string} nodeId
         * @param {DashboardSetting} dashboardSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDashboardSettingsCreate: function (nodeId, dashboardSetting, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesDashboardSettingsCreate(nodeId, dashboardSetting, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ダッシュボード設定 API
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDashboardSettingsDestroy: function (id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesDashboardSettingsDestroy(id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ダッシュボード設定一覧
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDashboardSettingsList: function (nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesDashboardSettingsList(nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ダッシュボード設定 API
         * @param {string} id
         * @param {string} nodeId
         * @param {PatchedDashboardSetting} [patchedDashboardSetting]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDashboardSettingsPartialUpdate: function (id, nodeId, patchedDashboardSetting, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesDashboardSettingsPartialUpdate(id, nodeId, patchedDashboardSetting, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ダッシュボード設定 API
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDashboardSettingsRetrieve: function (id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesDashboardSettingsRetrieve(id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ダッシュボード設定 API
         * @param {string} id
         * @param {string} nodeId
         * @param {DashboardSetting} dashboardSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDashboardSettingsUpdate: function (id, nodeId, dashboardSetting, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesDashboardSettingsUpdate(id, nodeId, dashboardSetting, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 連続時間積算履歴取得
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {number} timeFrom 取得期間（開始）
         * @param {number} timeTo 取得期間（終了）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsContinuousTotalHistoryList: function (datasetId, nodeId, timeFrom, timeTo, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesDatasetsContinuousTotalHistoryList(datasetId, nodeId, timeFrom, timeTo, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * データ項目の設定
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {Array<FieldSettings>} fieldSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsFieldSettingsCreate: function (datasetId, nodeId, fieldSettings, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesDatasetsFieldSettingsCreate(datasetId, nodeId, fieldSettings, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * データ設定項目の取得
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {string} [fieldNames] フィールド名
         * @param {string} [fieldTypes] フィールドタイプ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsFieldSettingsList: function (datasetId, nodeId, fieldNames, fieldTypes, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesDatasetsFieldSettingsList(datasetId, nodeId, fieldNames, fieldTypes, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 画像ダウンロード
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {ImageDownloadRequest} imageDownloadRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsImagesDownloadCreate: function (datasetId, nodeId, imageDownloadRequest, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesDatasetsImagesDownloadCreate(datasetId, nodeId, imageDownloadRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 最新画像取得
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsImagesLatestRetrieve: function (datasetId, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesDatasetsImagesLatestRetrieve(datasetId, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 画像一覧取得
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {number} [timeFrom] 取得期間（開始）
         * @param {number} [timeTo] 取得期間（終了）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsImagesList: function (datasetId, nodeId, timeFrom, timeTo, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesDatasetsImagesList(datasetId, nodeId, timeFrom, timeTo, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 画像取得
         * @param {string} datasetId
         * @param {string} id
         * @param {string} nodeId
         * @param {boolean} [lowQuality] 低画質
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsImagesRetrieve: function (datasetId, id, nodeId, lowQuality, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesDatasetsImagesRetrieve(datasetId, id, nodeId, lowQuality, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ラベル一括変更
         * @param {string} datasetId
         * @param {string} modelName
         * @param {string} nodeId
         * @param {Array<GroundTruthWithIdPutRequest>} groundTruthWithIdPutRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsModelsGroundTruthsBulkUpdate: function (datasetId, modelName, nodeId, groundTruthWithIdPutRequest, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesDatasetsModelsGroundTruthsBulkUpdate(datasetId, modelName, nodeId, groundTruthWithIdPutRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ラベル一覧取得
         * @param {string} datasetId
         * @param {string} modelName
         * @param {string} nodeId
         * @param {number} [timeFrom] 取得期間（開始）
         * @param {number} [timeTo] 取得期間（終了）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsModelsGroundTruthsList: function (datasetId, modelName, nodeId, timeFrom, timeTo, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesDatasetsModelsGroundTruthsList(datasetId, modelName, nodeId, timeFrom, timeTo, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ラベル変更
         * @param {string} datasetId
         * @param {string} id
         * @param {string} modelName
         * @param {string} nodeId
         * @param {GroundTruthPutRequest} groundTruthPutRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsModelsGroundTruthsUpdate: function (datasetId, id, modelName, nodeId, groundTruthPutRequest, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesDatasetsModelsGroundTruthsUpdate(datasetId, id, modelName, nodeId, groundTruthPutRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 移動平均時間の設定
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {Array<MonitoringTransformSettings>} monitoringTransformSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsMonitoringTransformSettingsCreate: function (datasetId, nodeId, monitoringTransformSettings, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesDatasetsMonitoringTransformSettingsCreate(datasetId, nodeId, monitoringTransformSettings, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 移動平均時間の取得
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {string} [fieldNames] フィールド名
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsMonitoringTransformSettingsList: function (datasetId, nodeId, fieldNames, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesDatasetsMonitoringTransformSettingsList(datasetId, nodeId, fieldNames, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 定周期通信異常通知先設定（メール通知）
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {NotificationDataarrivalMailSettings} notificationDataarrivalMailSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsNotificationDataarrivalMailSettingsCreate: function (datasetId, nodeId, notificationDataarrivalMailSettings, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesDatasetsNotificationDataarrivalMailSettingsCreate(datasetId, nodeId, notificationDataarrivalMailSettings, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 定周期通信異常通知先設定（パトランプ通知）
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {NotificationDataarrivalPatliteSettings} notificationDataarrivalPatliteSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsNotificationDataarrivalPatliteSettingsCreate: function (datasetId, nodeId, notificationDataarrivalPatliteSettings, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesDatasetsNotificationDataarrivalPatliteSettingsCreate(datasetId, nodeId, notificationDataarrivalPatliteSettings, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 定周期通信異常通知先設定（パトランプ通知） API
         * @param {string} datasetId
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsNotificationDataarrivalPatliteSettingsDestroy: function (datasetId, id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesDatasetsNotificationDataarrivalPatliteSettingsDestroy(datasetId, id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 定周期通信異常通知先設定（パトランプ通知） API
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsNotificationDataarrivalPatliteSettingsList: function (datasetId, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesDatasetsNotificationDataarrivalPatliteSettingsList(datasetId, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 遠隔操作設定
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {RemoteControl} remoteControl
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsRemoteControlCreate: function (datasetId, nodeId, remoteControl, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesDatasetsRemoteControlCreate(datasetId, nodeId, remoteControl, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 遠隔操作フェースプレート API
         * @param {string} datasetId
         * @param {string} gateway ゲートウェイ
         * @param {string} nodeId
         * @param {string} tags 状態取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsRemoteControlList: function (datasetId, gateway, nodeId, tags, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesDatasetsRemoteControlList(datasetId, gateway, nodeId, tags, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 最新データ要求 TODO 一旦、`設計者`以上で。`監視者`以上にするなら、node_a_viewsに移動
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {RemoteControl} remoteControl
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsRemoteControlRecentDataCreate: function (datasetId, nodeId, remoteControl, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesDatasetsRemoteControlRecentDataCreate(datasetId, nodeId, remoteControl, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 集計単位取得API
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsResampledSummariesList: function (datasetId, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesDatasetsResampledSummariesList(datasetId, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 積算値リセット
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {ResetAddup} resetAddup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsResetAddupCreate: function (datasetId, nodeId, resetAddup, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesDatasetsResetAddupCreate(datasetId, nodeId, resetAddup, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ニアリアルタイムデータ取得
         * @param {string} id データセット ID
         * @param {string} nodeId
         * @param {number} timeFrom 取得期間（開始）
         * @param {number} timeTo 取得期間（終了）
         * @param {string} [fieldNames] 取得カラム
         * @param {string} [fieldTypes] 取得カラム型
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsRetrieve: function (id, nodeId, timeFrom, timeTo, fieldNames, fieldTypes, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesDatasetsRetrieve(id, nodeId, timeFrom, timeTo, fieldNames, fieldTypes, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * SaiCrew-ML フィールド
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {SaicrewMlFields} [saicrewMlFields]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsSaicrewMlFieldsCreate: function (datasetId, nodeId, saicrewMlFields, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesDatasetsSaicrewMlFieldsCreate(datasetId, nodeId, saicrewMlFields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * SaiCrew-ML フィールド
         * @param {string} datasetId
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsSaicrewMlFieldsDestroy: function (datasetId, id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesDatasetsSaicrewMlFieldsDestroy(datasetId, id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * SaiCrew-ML フィールド
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsSaicrewMlFieldsList: function (datasetId, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesDatasetsSaicrewMlFieldsList(datasetId, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * SaiCrew-ML フィールド
         * @param {string} datasetId
         * @param {string} id
         * @param {string} nodeId
         * @param {PatchedSaicrewMlFields} [patchedSaicrewMlFields]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsSaicrewMlFieldsPartialUpdate: function (datasetId, id, nodeId, patchedSaicrewMlFields, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesDatasetsSaicrewMlFieldsPartialUpdate(datasetId, id, nodeId, patchedSaicrewMlFields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * SaiCrew-ML フィールド
         * @param {string} datasetId
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsSaicrewMlFieldsRetrieve: function (datasetId, id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesDatasetsSaicrewMlFieldsRetrieve(datasetId, id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * SaiCrew-ML フィールド
         * @param {string} datasetId
         * @param {string} id
         * @param {string} nodeId
         * @param {SaicrewMlFields} [saicrewMlFields]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsSaicrewMlFieldsUpdate: function (datasetId, id, nodeId, saicrewMlFields, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesDatasetsSaicrewMlFieldsUpdate(datasetId, id, nodeId, saicrewMlFields, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * アップロード CSV
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {UploadCsvRequest} uploadCsvRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsUploadsCreate: function (datasetId, nodeId, uploadCsvRequest, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesDatasetsUploadsCreate(datasetId, nodeId, uploadCsvRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * CSV アップロード用フォーマットダウンロード
         * @param {string} datasetId
         * @param {string} formatType フォーマット種別
         * @param {string} nodeId
         * @param {number} [timeFrom] 取得期間（開始）
         * @param {number} [timeTo] 取得期間（終了）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsUploadsFormatRetrieve: function (datasetId, formatType, nodeId, timeFrom, timeTo, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesDatasetsUploadsFormatRetrieve(datasetId, formatType, nodeId, timeFrom, timeTo, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * アップロード履歴一覧取得
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsUploadsHistoryList: function (datasetId, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesDatasetsUploadsHistoryList(datasetId, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * アップロードされた CSV データの処理を開始する API
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {ProcessUploadedCsvRequest} processUploadedCsvRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsUploadsProcessUploadedCsvCreate: function (datasetId, nodeId, processUploadedCsvRequest, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesDatasetsUploadsProcessUploadedCsvCreate(datasetId, nodeId, processUploadedCsvRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ドキュメント追加
         * @param {string} nodeId
         * @param {DocumentCreate} documentCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDocumentsCreate: function (nodeId, documentCreate, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesDocumentsCreate(nodeId, documentCreate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ドキュメント削除
         * @param {string} id
         * @param {string} nodeId
         * @param {string} prefix 削除するドキュメントのパス
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDocumentsDestroy: function (id, nodeId, prefix, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesDocumentsDestroy(id, nodeId, prefix, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ドキュメント一覧取得
         * @param {string} nodeId
         * @param {string} [prefix] 取得対象のパス
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDocumentsList: function (nodeId, prefix, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesDocumentsList(nodeId, prefix, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ドキュメント取得
         * @param {string} id
         * @param {string} nodeId
         * @param {string} prefix 取得するドキュメントのパス
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDocumentsRetrieve: function (id, nodeId, prefix, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesDocumentsRetrieve(id, nodeId, prefix, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ドキュメント更新
         * @param {string} id
         * @param {string} nodeId
         * @param {DocumentUpdate} documentUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDocumentsUpdate: function (id, nodeId, documentUpdate, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesDocumentsUpdate(id, nodeId, documentUpdate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * CSV ダウンロード API
         * @param {string} nodeId
         * @param {number} timeFrom 取得期間（開始）
         * @param {number} timeTo 取得期間（終了）
         * @param {CSVDownload} cSVDownload
         * @param {string} [sources]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDownloadsCreate: function (nodeId, timeFrom, timeTo, cSVDownload, sources, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesDownloadsCreate(nodeId, timeFrom, timeTo, cSVDownload, sources, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * モデル結果(ファイル)一覧取得
         * @param {string} gatewayId
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {string} type 取得するデータのタイプ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesGatewayModelsBuildJobsFileList: function (gatewayId, jobId, modelId, nodeId, type, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesGatewayModelsBuildJobsFileList(gatewayId, jobId, modelId, nodeId, type, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * モデル結果(ファイル)取得
         * @param {string} gatewayId
         * @param {string} id
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {string} type 取得するデータのタイプ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesGatewayModelsBuildJobsFileRetrieve: function (gatewayId, id, jobId, modelId, nodeId, type, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesGatewayModelsBuildJobsFileRetrieve(gatewayId, id, jobId, modelId, nodeId, type, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * モデル結果一覧取得
         * @param {string} gatewayId
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {string} type 取得するデータのタイプ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesGatewayModelsBuildJobsResultList: function (gatewayId, jobId, modelId, nodeId, type, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesGatewayModelsBuildJobsResultList(gatewayId, jobId, modelId, nodeId, type, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * モデル結果取得
         * @param {string} gatewayId
         * @param {string} id
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {string} type 取得するデータのタイプ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesGatewayModelsBuildJobsResultRetrieve: function (gatewayId, id, jobId, modelId, nodeId, type, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesGatewayModelsBuildJobsResultRetrieve(gatewayId, id, jobId, modelId, nodeId, type, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * SaiCrew デプロイ設定 説明変数のシミュレーション範囲一覧取得
         * @param {string} gatewayId
         * @param {string} nodeId
         * @param {Array<SaicrewAIModelMlSimulationsRequest>} saicrewAIModelMlSimulationsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesGatewaySaicrewMlSimulationsMlListCreate: function (gatewayId, nodeId, saicrewAIModelMlSimulationsRequest, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesGatewaySaicrewMlSimulationsMlListCreate(gatewayId, nodeId, saicrewAIModelMlSimulationsRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} cameraId
         * @param {string} nodeId
         * @param {number} [timestamp] 基準時間
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesGraphicCameraList: function (cameraId, nodeId, timestamp, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesGraphicCameraList(cameraId, nodeId, timestamp, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} fileName
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesGraphicImageList: function (fileName, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesGraphicImageList(fileName, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesGraphicIntervalList: function (nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesGraphicIntervalList(nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * グラフィックレコーダ用ジャーナル取得API
         * @param {string} nodeId
         * @param {number} timeFrom 取得期間（開始）
         * @param {number} timeTo 取得期間（終了）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesGraphicRecorderStatusRetrieve: function (nodeId, timeFrom, timeTo, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesGraphicRecorderStatusRetrieve(nodeId, timeFrom, timeTo, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * アップロードバリデーション
         * @param {string} nodeId
         * @param {string} tabIndex
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesGraphicTabsGraphicFilesCreate: function (nodeId, tabIndex, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesGraphicTabsGraphicFilesCreate(nodeId, tabIndex, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 項目選択API
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesItemSelectionList: function (nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesItemSelectionList(nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 最新ジャーナル取得API
         * @param {string} nodeId
         * @param {boolean} [includeDescendants] 子孫のデータセットを含むか
         * @param {boolean} [includeNotify] アナログ監視判定結果を含むか
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesLastestStatusList: function (nodeId, includeDescendants, includeNotify, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesLastestStatusList(nodeId, includeDescendants, includeNotify, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 発生中警報情報取得
         * @param {string} nodeId
         * @param {boolean} [controlDashboardDispFlag] ダッシュボード表示フラグの制御有無
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesLatestAlarmList: function (nodeId, controlDashboardDispFlag, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesLatestAlarmList(nodeId, controlDashboardDispFlag, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 発生中警報情報取得
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesLatestProcessList: function (nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesLatestProcessList(nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * メール設定 グループ別送信テスト
         * @param {string} nodeId
         * @param {MailGroupTest} mailGroupTest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMailGroupTestCreate: function (nodeId, mailGroupTest, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesMailGroupTestCreate(nodeId, mailGroupTest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * シンプル記録追加
         * @param {string} nodeId
         * @param {MaintenanceHistory} maintenanceHistory
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMaintenanceHistoriesCreate: function (nodeId, maintenanceHistory, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesMaintenanceHistoriesCreate(nodeId, maintenanceHistory, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * シンプル記録削除
         * @param {number} id A unique integer value identifying this t_maintenance_history.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMaintenanceHistoriesDestroy: function (id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesMaintenanceHistoriesDestroy(id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * シンプル記録 API
         * @param {string} dateFrom 取得期間（開始）
         * @param {string} dateTo 取得期間（終了）
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMaintenanceHistoriesList: function (dateFrom, dateTo, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesMaintenanceHistoriesList(dateFrom, dateTo, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * シンプル記録更新（一部）
         * @param {number} id A unique integer value identifying this t_maintenance_history.
         * @param {string} nodeId
         * @param {PatchedMaintenanceHistory} [patchedMaintenanceHistory]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMaintenanceHistoriesPartialUpdate: function (id, nodeId, patchedMaintenanceHistory, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesMaintenanceHistoriesPartialUpdate(id, nodeId, patchedMaintenanceHistory, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * シンプル記録詳細取得
         * @param {number} id A unique integer value identifying this t_maintenance_history.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMaintenanceHistoriesRetrieve: function (id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesMaintenanceHistoriesRetrieve(id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * シンプル記録更新
         * @param {number} id A unique integer value identifying this t_maintenance_history.
         * @param {string} nodeId
         * @param {MaintenanceHistory} maintenanceHistory
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMaintenanceHistoriesUpdate: function (id, nodeId, maintenanceHistory, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesMaintenanceHistoriesUpdate(id, nodeId, maintenanceHistory, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * MBR 演算設定追加
         * @param {string} nodeId
         * @param {MbrCalculationSettings} mbrCalculationSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMbrCalculationSettingsCreate: function (nodeId, mbrCalculationSettings, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesMbrCalculationSettingsCreate(nodeId, mbrCalculationSettings, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * MBR 演算設定削除
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMbrCalculationSettingsDestroy: function (id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesMbrCalculationSettingsDestroy(id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * MBR 演算設定一覧
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMbrCalculationSettingsList: function (nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesMbrCalculationSettingsList(nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * MBR 演算設定更新（一部）
         * @param {string} id
         * @param {string} nodeId
         * @param {PatchedMbrCalculationSettings} [patchedMbrCalculationSettings]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMbrCalculationSettingsPartialUpdate: function (id, nodeId, patchedMbrCalculationSettings, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesMbrCalculationSettingsPartialUpdate(id, nodeId, patchedMbrCalculationSettings, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * MBR 演算設定 API
         * @param {string} id
         * @param {string} nodeId
         * @param {MbrCalculationSettings} mbrCalculationSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMbrCalculationSettingsUpdate: function (id, nodeId, mbrCalculationSettings, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesMbrCalculationSettingsUpdate(id, nodeId, mbrCalculationSettings, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 傾向総合診断履歴 API
         * @param {string} nodeId
         * @param {MbrTechnicalReportJudgementHistory} mbrTechnicalReportJudgementHistory
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMbrTechnicalReportJudgementHistoriesCreate: function (nodeId, mbrTechnicalReportJudgementHistory, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesMbrTechnicalReportJudgementHistoriesCreate(nodeId, mbrTechnicalReportJudgementHistory, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 傾向総合診断履歴の取得
         * @param {string} nodeId
         * @param {number} timeFrom 取得期間（開始）
         * @param {number} timeTo 取得期間（終了）
         * @param {number} [calculationNo] 演算 No
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMbrTechnicalReportJudgementHistoriesList: function (nodeId, timeFrom, timeTo, calculationNo, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesMbrTechnicalReportJudgementHistoriesList(nodeId, timeFrom, timeTo, calculationNo, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 傾向総合診断追加
         * @param {string} nodeId
         * @param {MbrTechnicalReportJudgement} mbrTechnicalReportJudgement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMbrTechnicalReportJudgementsCreate: function (nodeId, mbrTechnicalReportJudgement, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesMbrTechnicalReportJudgementsCreate(nodeId, mbrTechnicalReportJudgement, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 傾向総合診断取得
         * @param {string} nodeId
         * @param {number} [calculationNo] 演算 No
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMbrTechnicalReportJudgementsList: function (nodeId, calculationNo, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesMbrTechnicalReportJudgementsList(nodeId, calculationNo, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 傾向総合診断の取得
         * @param {string} dateFrom 取得期間（開始）
         * @param {string} dateTo 取得期間（終了）
         * @param {string} nodeId
         * @param {number} [calculationNo] 演算 No
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMbrTechnicalReportResultsList: function (dateFrom, dateTo, nodeId, calculationNo, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesMbrTechnicalReportResultsList(dateFrom, dateTo, nodeId, calculationNo, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMonitorDatasetMetricsList: function (nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesMonitorDatasetMetricsList(nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMonitorDatasetMetricsRetrieve: function (id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesMonitorDatasetMetricsRetrieve(id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 通知Gr1のオンオフ設定
         * @param {string} nodeId
         * @param {Array<MonitoringNotificationGr1Settings>} monitoringNotificationGr1Settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMonitorNotificationGr1SettingsCreate: function (nodeId, monitoringNotificationGr1Settings, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesMonitorNotificationGr1SettingsCreate(nodeId, monitoringNotificationGr1Settings, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 通知Gr2のオンオフ設定
         * @param {string} nodeId
         * @param {Array<MonitoringNotificationGr2Settings>} monitoringNotificationGr2Settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMonitorNotificationGr2SettingsCreate: function (nodeId, monitoringNotificationGr2Settings, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesMonitorNotificationGr2SettingsCreate(nodeId, monitoringNotificationGr2Settings, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * メール通知のオンオフ設定
         * @param {string} nodeId
         * @param {Array<MonitoringNotificationMailSettings>} monitoringNotificationMailSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMonitorNotificationMailSettingsGeneralCreate: function (nodeId, monitoringNotificationMailSettings, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesMonitorNotificationMailSettingsGeneralCreate(nodeId, monitoringNotificationMailSettings, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * データ項目の設定
         * @param {string} nodeId
         * @param {Array<MonitoringSettings>} monitoringSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMonitorSettingsCreate: function (nodeId, monitoringSettings, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesMonitorSettingsCreate(nodeId, monitoringSettings, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * クラウド設定警報取得 API
         * @param {string} nodeId
         * @param {string} [datasetId] データセットID
         * @param {string} [fieldNames] フィールド名
         * @param {string} [ruleNames] 条件
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMonitorSettingsList: function (nodeId, datasetId, fieldNames, ruleNames, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesMonitorSettingsList(nodeId, datasetId, fieldNames, ruleNames, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 通知Gr1の設定
         * @param {string} nodeId
         * @param {NotificationGr1Settings} [notificationGr1Settings]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesNotificationGr1SettingsCreate: function (nodeId, notificationGr1Settings, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesNotificationGr1SettingsCreate(nodeId, notificationGr1Settings, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 通知Gr2の設定
         * @param {string} nodeId
         * @param {NotificationGr2Settings} [notificationGr2Settings]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesNotificationGr2SettingsCreate: function (nodeId, notificationGr2Settings, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesNotificationGr2SettingsCreate(nodeId, notificationGr2Settings, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * メール配信設定
         * @param {string} nodeId
         * @param {NotificationMailSettings} [notificationMailSettings]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesNotificationMailSettingsCreate: function (nodeId, notificationMailSettings, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesNotificationMailSettingsCreate(nodeId, notificationMailSettings, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * SaiCrew通知設定（メール通知）
         * @param {string} nodeId
         * @param {NotificationSaiCrewMailSettings} [notificationSaiCrewMailSettings]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesNotificationSaicrewMailSettingsCreate: function (nodeId, notificationSaiCrewMailSettings, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesNotificationSaicrewMailSettingsCreate(nodeId, notificationSaiCrewMailSettings, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * SaiIK通知設定（メール通知）
         * @param {string} nodeId
         * @param {NotificationSaiIKMailSettings} [notificationSaiIKMailSettings]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesNotificationSaiikMailSettingsCreate: function (nodeId, notificationSaiIKMailSettings, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesNotificationSaiikMailSettingsCreate(nodeId, notificationSaiIKMailSettings, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 設備の通知先の設定
         * @param {string} nodeId
         * @param {NotificationSettings} notificationSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesNotificationSettingsCreate: function (nodeId, notificationSettings, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesNotificationSettingsCreate(nodeId, notificationSettings, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 設備の通知設定の取得
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesNotificationSettingsList: function (nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesNotificationSettingsList(nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * システム警報異常通知先設定（メール通知）
         * @param {string} nodeId
         * @param {NotificationSystemMailSettings} [notificationSystemMailSettings]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesNotificationSystemMailSettingsCreate: function (nodeId, notificationSystemMailSettings, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesNotificationSystemMailSettingsCreate(nodeId, notificationSystemMailSettings, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * システム警報異常通知先設定（パトランプ通知）
         * @param {string} nodeId
         * @param {NotificationSystemPatliteSettings} notificationSystemPatliteSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesNotificationSystemPatliteSettingsCreate: function (nodeId, notificationSystemPatliteSettings, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesNotificationSystemPatliteSettingsCreate(nodeId, notificationSystemPatliteSettings, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * システム警報異常通知先設定（パトランプ通知） API
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesNotificationSystemPatliteSettingsDestroy: function (id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesNotificationSystemPatliteSettingsDestroy(id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * システム警報異常通知先設定（パトランプ通知） API
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesNotificationSystemPatliteSettingsList: function (nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesNotificationSystemPatliteSettingsList(nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 運転履歴取得
         * @param {string} nodeId
         * @param {number} timeFrom 取得期間（開始）
         * @param {number} timeTo 取得期間（終了）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesOperatingHistoryList: function (nodeId, timeFrom, timeTo, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesOperatingHistoryList(nodeId, timeFrom, timeTo, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 稼働情報取得
         * @param {string} nodeId
         * @param {number} timeFrom 取得期間（開始）
         * @param {number} timeTo 取得期間（終了）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesOperatingSummaryList: function (nodeId, timeFrom, timeTo, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesOperatingSummaryList(nodeId, timeFrom, timeTo, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * パトランプ通知追加
         * @param {string} datasetIds
         * @param {string} fieldNames
         * @param {string} nodeId
         * @param {Array<PatliteNotificationSetting>} patliteNotificationSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesPatliteNotificationSettingsCreate: function (datasetIds, fieldNames, nodeId, patliteNotificationSetting, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesPatliteNotificationSettingsCreate(datasetIds, fieldNames, nodeId, patliteNotificationSetting, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * パトランプ通知削除
         * @param {number} id A unique integer value identifying this m_patlite_notification_setting.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesPatliteNotificationSettingsDestroy: function (id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesPatliteNotificationSettingsDestroy(id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * パトランプ通知 API
         * @param {string} nodeId
         * @param {string} [datasetId] データセット
         * @param {string} [fieldName] 項目
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesPatliteNotificationSettingsList: function (nodeId, datasetId, fieldName, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesPatliteNotificationSettingsList(nodeId, datasetId, fieldName, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * パトランプ通知更新（一部）
         * @param {number} id A unique integer value identifying this m_patlite_notification_setting.
         * @param {string} nodeId
         * @param {PatchedPatliteNotificationSetting} [patchedPatliteNotificationSetting]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesPatliteNotificationSettingsPartialUpdate: function (id, nodeId, patchedPatliteNotificationSetting, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesPatliteNotificationSettingsPartialUpdate(id, nodeId, patchedPatliteNotificationSetting, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * パトランプ通知詳細取得
         * @param {number} id A unique integer value identifying this m_patlite_notification_setting.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesPatliteNotificationSettingsRetrieve: function (id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesPatliteNotificationSettingsRetrieve(id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * パトランプ通知更新
         * @param {number} id A unique integer value identifying this m_patlite_notification_setting.
         * @param {string} nodeId
         * @param {PatliteNotificationSetting} patliteNotificationSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesPatliteNotificationSettingsUpdate: function (id, nodeId, patliteNotificationSetting, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesPatliteNotificationSettingsUpdate(id, nodeId, patliteNotificationSetting, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * パトランプ設定
         * @param {string} nodeId
         * @param {Array<NodePatliteSetting>} nodePatliteSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesPatliteSettingsCreate: function (nodeId, nodePatliteSetting, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesPatliteSettingsCreate(nodeId, nodePatliteSetting, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * パトランプ設定 API
         * @param {number} id A unique integer value identifying this m_node_patlite_setting.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesPatliteSettingsDestroy: function (id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesPatliteSettingsDestroy(id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * パトランプ設定取得
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesPatliteSettingsList: function (nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesPatliteSettingsList(nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * パトランプ設定 API
         * @param {number} id A unique integer value identifying this m_node_patlite_setting.
         * @param {string} nodeId
         * @param {PatchedNodePatliteSetting} [patchedNodePatliteSetting]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesPatliteSettingsPartialUpdate: function (id, nodeId, patchedNodePatliteSetting, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesPatliteSettingsPartialUpdate(id, nodeId, patchedNodePatliteSetting, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * パトランプ設定 API
         * @param {number} id A unique integer value identifying this m_node_patlite_setting.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesPatliteSettingsRetrieve: function (id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesPatliteSettingsRetrieve(id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * パトランプ設定 API
         * @param {number} id A unique integer value identifying this m_node_patlite_setting.
         * @param {string} nodeId
         * @param {NodePatliteSetting} nodePatliteSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesPatliteSettingsUpdate: function (id, nodeId, nodePatliteSetting, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesPatliteSettingsUpdate(id, nodeId, nodePatliteSetting, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * パトランプテスト
         * @param {string} nodeId
         * @param {string} patliteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesPatlitesTestCreate: function (nodeId, patliteId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesPatlitesTestCreate(nodeId, patliteId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 遠隔操作履歴 API
         * @param {number} dateFrom 取得期間（開始）
         * @param {number} dateTo 取得期間（終了）
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesRemoteControlHistoryList: function (dateFrom, dateTo, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesRemoteControlHistoryList(dateFrom, dateTo, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this m_remote_control_history.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesRemoteControlHistoryRetrieve: function (id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesRemoteControlHistoryRetrieve(id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 長期データ取得
         * @param {string} id データセット ID
         * @param {string} nodeId
         * @param {string} [asFreq] 集約単位
         * @param {string} [fieldNames] 取得カラム
         * @param {string} [fieldTypes] 取得カラム型
         * @param {string} [method] 集約方法
         * @param {string} [splitBy] 表示単位
         * @param {string} [theLastPeriod] 直近〜（1W / 1M / 3M / 6M / 9M / 1Y / 3Y / 5Y）
         * @param {number} [timeFrom] 取得期間（開始）
         * @param {number} [timeTo] 取得期間（終了）
         * @param {string} [trendGraphFreq] トレンドグラフの集約単位
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesResampledDatasetsRetrieve: function (id, nodeId, asFreq, fieldNames, fieldTypes, method, splitBy, theLastPeriod, timeFrom, timeTo, trendGraphFreq, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesResampledDatasetsRetrieve(id, nodeId, asFreq, fieldNames, fieldTypes, method, splitBy, theLastPeriod, timeFrom, timeTo, trendGraphFreq, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * RO 演算設定追加
         * @param {string} nodeId
         * @param {RoCalculationSettings} roCalculationSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesRoCalculationSettingsCreate: function (nodeId, roCalculationSettings, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesRoCalculationSettingsCreate(nodeId, roCalculationSettings, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * RO 演算設定削除
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesRoCalculationSettingsDestroy: function (id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesRoCalculationSettingsDestroy(id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * RO 演算設定一覧
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesRoCalculationSettingsList: function (nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesRoCalculationSettingsList(nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * RO 演算設定更新（一部）
         * @param {string} id
         * @param {string} nodeId
         * @param {PatchedRoCalculationSettings} [patchedRoCalculationSettings]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesRoCalculationSettingsPartialUpdate: function (id, nodeId, patchedRoCalculationSettings, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesRoCalculationSettingsPartialUpdate(id, nodeId, patchedRoCalculationSettings, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * RO 演算設定 API
         * @param {string} id
         * @param {string} nodeId
         * @param {RoCalculationSettings} roCalculationSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesRoCalculationSettingsUpdate: function (id, nodeId, roCalculationSettings, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesRoCalculationSettingsUpdate(id, nodeId, roCalculationSettings, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ROテクニカルレポート
         * @param {string} nodeId
         * @param {string} [dateFrom] 取得期間（開始）
         * @param {string} [dateTo] 取得期間（終了）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesRoTechnicalReportResultsList: function (nodeId, dateFrom, dateTo, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesRoTechnicalReportResultsList(nodeId, dateFrom, dateTo, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns list of algorithms.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewAiAlgorithmsList: function (nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaicrewAiAlgorithmsList(nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns algorithm.
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewAiAlgorithmsRetrieve: function (id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaicrewAiAlgorithmsRetrieve(id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns algorithm.
         * @param {string} algorithmName
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewAiAlgorithmsVersionsRetrieve: function (algorithmName, id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaicrewAiAlgorithmsVersionsRetrieve(algorithmName, id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * SaiCrew-AIモデル追加
         * @param {string} nodeId
         * @param {SaicrewAIModel} saicrewAIModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewAiModelsCreate: function (nodeId, saicrewAIModel, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaicrewAiModelsCreate(nodeId, saicrewAIModel, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * SaiCrew-AIモデル削除
         * @param {number} id A unique integer value identifying this m_saicrew_ai_model.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewAiModelsDestroy: function (id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaicrewAiModelsDestroy(id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 最新MLPipelineIDの取得
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewAiModelsLatestPipelineIdRetrieve: function (nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaicrewAiModelsLatestPipelineIdRetrieve(nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * SaiCrew-AIモデル覧取得
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewAiModelsList: function (nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaicrewAiModelsList(nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * SaiCrew-AIモデル更新（一部）
         * @param {number} id A unique integer value identifying this m_saicrew_ai_model.
         * @param {string} nodeId
         * @param {PatchedSaicrewAIModel} [patchedSaicrewAIModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewAiModelsPartialUpdate: function (id, nodeId, patchedSaicrewAIModel, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaicrewAiModelsPartialUpdate(id, nodeId, patchedSaicrewAIModel, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * SaiCrew-AIモデル詳細取得
         * @param {number} id A unique integer value identifying this m_saicrew_ai_model.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewAiModelsRetrieve: function (id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaicrewAiModelsRetrieve(id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * SaiCrew-AIモデル更新
         * @param {number} id A unique integer value identifying this m_saicrew_ai_model.
         * @param {string} nodeId
         * @param {SaicrewAIModel} saicrewAIModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewAiModelsUpdate: function (id, nodeId, saicrewAIModel, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaicrewAiModelsUpdate(id, nodeId, saicrewAIModel, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * List all SaiCrew node datasets in descendant nodes.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewDatasetsList: function (nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaicrewDatasetsList(nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * SaiCrew モデル構築・データ予測用の CSV フォーマットダウンロード
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {Array<string>} [mlNames] ML変数
         * @param {number} [timeFrom] 取得期間（開始）
         * @param {number} [timeTo] 取得期間（終了）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewDatasetsUploadsFormatRetrieve: function (datasetId, nodeId, mlNames, timeFrom, timeTo, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaicrewDatasetsUploadsFormatRetrieve(datasetId, nodeId, mlNames, timeFrom, timeTo, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} edgeDevice
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewEdgeDeviceComponentList: function (edgeDevice, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaicrewEdgeDeviceComponentList(edgeDevice, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} nodeId
         * @param {SaicrewEdgeDevice} saicrewEdgeDevice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewEdgeDeviceCreate: function (nodeId, saicrewEdgeDevice, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaicrewEdgeDeviceCreate(nodeId, saicrewEdgeDevice, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Saicrewデプロイ承認
         * @param {string} edgeDevice
         * @param {string} id
         * @param {string} nodeId
         * @param {SaicrewDeploymentApprove} saicrewDeploymentApprove
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewEdgeDeviceDeploymentsApproveCreate: function (edgeDevice, id, nodeId, saicrewDeploymentApprove, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaicrewEdgeDeviceDeploymentsApproveCreate(edgeDevice, id, nodeId, saicrewDeploymentApprove, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Saicrewデプロイキャンセル
         * @param {string} edgeDevice
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewEdgeDeviceDeploymentsCancelCreate: function (edgeDevice, id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaicrewEdgeDeviceDeploymentsCancelCreate(edgeDevice, id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Saicrewデプロイ作成
         * @param {string} edgeDevice
         * @param {string} nodeId
         * @param {SaicrewDeployment} saicrewDeployment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewEdgeDeviceDeploymentsCreate: function (edgeDevice, nodeId, saicrewDeployment, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaicrewEdgeDeviceDeploymentsCreate(edgeDevice, nodeId, saicrewDeployment, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * 環境取得
         * @param {string} edgeDevice
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewEdgeDeviceDeploymentsEnvironmentRetrieve: function (edgeDevice, id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaicrewEdgeDeviceDeploymentsEnvironmentRetrieve(edgeDevice, id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Saicrewデプロイ一覧
         * @param {string} edgeDevice
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewEdgeDeviceDeploymentsList: function (edgeDevice, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaicrewEdgeDeviceDeploymentsList(edgeDevice, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Saicrewデプロイ
         * @param {string} edgeDevice
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewEdgeDeviceDeploymentsRetrieve: function (edgeDevice, id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaicrewEdgeDeviceDeploymentsRetrieve(edgeDevice, id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Saicrewデプロイ再試行
         * @param {string} edgeDevice
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewEdgeDeviceDeploymentsRetryCreate: function (edgeDevice, id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaicrewEdgeDeviceDeploymentsRetryCreate(edgeDevice, id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewEdgeDeviceDestroy: function (id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaicrewEdgeDeviceDestroy(id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Saicrewエッジデバイス詳細取得
         * @param {string} nodeId
         * @param {boolean} [includeDeploymentCounts] 今月のデプロイ数も合わせて取得
         * @param {boolean} [includeModelBuildCounts] 今月のモデルビルド数も合わせて取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewEdgeDeviceList: function (nodeId, includeDeploymentCounts, includeModelBuildCounts, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaicrewEdgeDeviceList(nodeId, includeDeploymentCounts, includeModelBuildCounts, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {string} nodeId
         * @param {PatchedSaicrewEdgeDevice} [patchedSaicrewEdgeDevice]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewEdgeDevicePartialUpdate: function (id, nodeId, patchedSaicrewEdgeDevice, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaicrewEdgeDevicePartialUpdate(id, nodeId, patchedSaicrewEdgeDevice, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewEdgeDeviceRetrieve: function (id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaicrewEdgeDeviceRetrieve(id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {string} nodeId
         * @param {SaicrewEdgeDevice} saicrewEdgeDevice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewEdgeDeviceUpdate: function (id, nodeId, saicrewEdgeDevice, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaicrewEdgeDeviceUpdate(id, nodeId, saicrewEdgeDevice, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * SaiCrew-ML　Variables ViewSet.
         * @param {string} nodeId
         * @param {SaicrewMLVariables} saicrewMLVariables
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewMlVariablesCreate: function (nodeId, saicrewMLVariables, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaicrewMlVariablesCreate(nodeId, saicrewMLVariables, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * SaiCrew-ML　Variables ViewSet.
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewMlVariablesDestroy: function (id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaicrewMlVariablesDestroy(id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * SaiCrew-ML　Variables ViewSet.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewMlVariablesList: function (nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaicrewMlVariablesList(nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * SaiCrew-ML　Variables ViewSet.
         * @param {string} id
         * @param {string} nodeId
         * @param {PatchedSaicrewMLVariables} [patchedSaicrewMLVariables]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewMlVariablesPartialUpdate: function (id, nodeId, patchedSaicrewMLVariables, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaicrewMlVariablesPartialUpdate(id, nodeId, patchedSaicrewMLVariables, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * SaiCrew-ML　Variables ViewSet.
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewMlVariablesRetrieve: function (id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaicrewMlVariablesRetrieve(id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * SaiCrew-ML　Variables ViewSet.
         * @param {string} id
         * @param {string} nodeId
         * @param {SaicrewMLVariables} saicrewMLVariables
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewMlVariablesUpdate: function (id, nodeId, saicrewMLVariables, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaicrewMlVariablesUpdate(id, nodeId, saicrewMLVariables, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * SaiCrewAIモデル構築ジョブ承認
         * @param {string} gatewayId
         * @param {string} id
         * @param {string} modelId
         * @param {string} nodeId
         * @param {SaicrewAIModelBuildJobApprove} saicrewAIModelBuildJobApprove
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewModelsBuildJobsApproveCreate: function (gatewayId, id, modelId, nodeId, saicrewAIModelBuildJobApprove, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaicrewModelsBuildJobsApproveCreate(gatewayId, id, modelId, nodeId, saicrewAIModelBuildJobApprove, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * SaiCrewAIバッチ推論 構築ジョブキャンセル
         * @param {string} gatewayId
         * @param {string} id
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewModelsBuildJobsBatchInferenceCancelCreate: function (gatewayId, id, jobId, modelId, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaicrewModelsBuildJobsBatchInferenceCancelCreate(gatewayId, id, jobId, modelId, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * SaiCrew-AIバッチ推論 構築ジョブ作成
         * @param {string} gatewayId
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {SaiCrewAIModelBatchInferenceJob} data
         * @param {any} [zipFile]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewModelsBuildJobsBatchInferenceCreate: function (gatewayId, jobId, modelId, nodeId, data, zipFile, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaicrewModelsBuildJobsBatchInferenceCreate(gatewayId, jobId, modelId, nodeId, data, zipFile, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Saicrew-AIバッチ推論 構築ジョブ一覧
         * @param {string} gatewayId
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewModelsBuildJobsBatchInferenceList: function (gatewayId, jobId, modelId, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaicrewModelsBuildJobsBatchInferenceList(gatewayId, jobId, modelId, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Saicrew-AIバッチ推論 構築ジョブ詳細
         * @param {string} gatewayId
         * @param {string} id
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewModelsBuildJobsBatchInferenceRetrieve: function (gatewayId, id, jobId, modelId, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaicrewModelsBuildJobsBatchInferenceRetrieve(gatewayId, id, jobId, modelId, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * SaiCrewAIバッチ推論 構築ジョブ再試行
         * @param {string} gatewayId
         * @param {string} id
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewModelsBuildJobsBatchInferenceRetryCreate: function (gatewayId, id, jobId, modelId, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaicrewModelsBuildJobsBatchInferenceRetryCreate(gatewayId, id, jobId, modelId, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * SaiCrewAIモデル構築ジョブキャンセル
         * @param {string} gatewayId
         * @param {string} id
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewModelsBuildJobsCancelCreate: function (gatewayId, id, modelId, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaicrewModelsBuildJobsCancelCreate(gatewayId, id, modelId, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Create comment.
         * @param {string} gatewayId
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {SaicrewAIModelBuildJobComment} saicrewAIModelBuildJobComment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewModelsBuildJobsCommentsCreate: function (gatewayId, jobId, modelId, nodeId, saicrewAIModelBuildJobComment, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaicrewModelsBuildJobsCommentsCreate(gatewayId, jobId, modelId, nodeId, saicrewAIModelBuildJobComment, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete comment
         * @param {string} gatewayId
         * @param {number} id A unique integer value identifying this t_saicrew_ai_model_build_job_comment.
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewModelsBuildJobsCommentsDestroy: function (gatewayId, id, jobId, modelId, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaicrewModelsBuildJobsCommentsDestroy(gatewayId, id, jobId, modelId, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns list of comments.
         * @param {string} gatewayId
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewModelsBuildJobsCommentsList: function (gatewayId, jobId, modelId, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaicrewModelsBuildJobsCommentsList(gatewayId, jobId, modelId, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * カメラAIモデル構築ジョブコメント
         * @param {string} gatewayId
         * @param {number} id A unique integer value identifying this t_saicrew_ai_model_build_job_comment.
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {PatchedSaicrewAIModelBuildJobComment} [patchedSaicrewAIModelBuildJobComment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewModelsBuildJobsCommentsPartialUpdate: function (gatewayId, id, jobId, modelId, nodeId, patchedSaicrewAIModelBuildJobComment, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaicrewModelsBuildJobsCommentsPartialUpdate(gatewayId, id, jobId, modelId, nodeId, patchedSaicrewAIModelBuildJobComment, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * カメラAIモデル構築ジョブコメント
         * @param {string} gatewayId
         * @param {number} id A unique integer value identifying this t_saicrew_ai_model_build_job_comment.
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewModelsBuildJobsCommentsRetrieve: function (gatewayId, id, jobId, modelId, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaicrewModelsBuildJobsCommentsRetrieve(gatewayId, id, jobId, modelId, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update comment.
         * @param {string} gatewayId
         * @param {number} id A unique integer value identifying this t_saicrew_ai_model_build_job_comment.
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {SaicrewAIModelBuildJobComment} saicrewAIModelBuildJobComment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewModelsBuildJobsCommentsUpdate: function (gatewayId, id, jobId, modelId, nodeId, saicrewAIModelBuildJobComment, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaicrewModelsBuildJobsCommentsUpdate(gatewayId, id, jobId, modelId, nodeId, saicrewAIModelBuildJobComment, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * SaiCrew-AIモデル構築ジョブ作成
         * @param {string} gatewayId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {SaicrewAIModelBuildJob} data
         * @param {any} [zipFile]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewModelsBuildJobsCreate: function (gatewayId, modelId, nodeId, data, zipFile, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaicrewModelsBuildJobsCreate(gatewayId, modelId, nodeId, data, zipFile, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Saicrew-AIモデル構築ジョブ一覧
         * @param {string} gatewayId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewModelsBuildJobsList: function (gatewayId, modelId, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaicrewModelsBuildJobsList(gatewayId, modelId, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Saicrew-AIAIモデル構築ジョブ詳細
         * @param {string} gatewayId
         * @param {string} id
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewModelsBuildJobsRetrieve: function (gatewayId, id, modelId, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaicrewModelsBuildJobsRetrieve(gatewayId, id, modelId, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * SaiCrewAIモデル構築ジョブ再試行
         * @param {string} gatewayId
         * @param {string} id
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewModelsBuildJobsRetryCreate: function (gatewayId, id, modelId, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaicrewModelsBuildJobsRetryCreate(gatewayId, id, modelId, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * SaiForce 演算設定追加
         * @param {string} nodeId
         * @param {SaiforceCalculationSettings} saiforceCalculationSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaiforceCalculationSettingsCreate: function (nodeId, saiforceCalculationSettings, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaiforceCalculationSettingsCreate(nodeId, saiforceCalculationSettings, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * SaiForce 演算設定削除
         * @param {number} id dataset_id
         * @param {number} nodeId 設備 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaiforceCalculationSettingsDestroy: function (id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaiforceCalculationSettingsDestroy(id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * SaiForce 演算設定一覧
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaiforceCalculationSettingsList: function (nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSaiforceCalculationSettingsList(nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ゲートウェイ定周期通信異常判定
         * @param {string} nodeId
         * @param {number} timeFrom 取得期間（開始）
         * @param {number} timeTo 取得期間（終了）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSysalartHistoryJudgementRetrieve: function (nodeId, timeFrom, timeTo, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSysalartHistoryJudgementRetrieve(nodeId, timeFrom, timeTo, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ゲートウェイ定周期通信異常情報取得
         * @param {string} nodeId
         * @param {number} timeFrom 取得期間（開始）
         * @param {number} timeTo 取得期間（終了）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSysalartHistoryList: function (nodeId, timeFrom, timeTo, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesSysalartHistoryList(nodeId, timeFrom, timeTo, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * テクニカルレポートステータス
         * @param {string} nodeId
         * @param {boolean} [includeDescendants] 子孫のデータセットを含むか
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTechnicalReportStatusList: function (nodeId, includeDescendants, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesTechnicalReportStatusList(nodeId, includeDescendants, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} nodeId
         * @param {string} technicalReportId
         * @param {TechnicalReportAttachments} [technicalReportAttachments]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTechnicalReportsAttachmentsCreate: function (nodeId, technicalReportId, technicalReportAttachments, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesTechnicalReportsAttachmentsCreate(nodeId, technicalReportId, technicalReportAttachments, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this t_technical_report.
         * @param {string} nodeId
         * @param {string} technicalReportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTechnicalReportsAttachmentsDestroy: function (id, nodeId, technicalReportId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesTechnicalReportsAttachmentsDestroy(id, nodeId, technicalReportId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} nodeId
         * @param {string} technicalReportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTechnicalReportsAttachmentsList: function (nodeId, technicalReportId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesTechnicalReportsAttachmentsList(nodeId, technicalReportId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this t_technical_report.
         * @param {string} nodeId
         * @param {string} technicalReportId
         * @param {PatchedTechnicalReportAttachments} [patchedTechnicalReportAttachments]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTechnicalReportsAttachmentsPartialUpdate: function (id, nodeId, technicalReportId, patchedTechnicalReportAttachments, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesTechnicalReportsAttachmentsPartialUpdate(id, nodeId, technicalReportId, patchedTechnicalReportAttachments, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * テクニカルレポート添付ファイル取得
         * @param {number} id A unique integer value identifying this t_technical_report.
         * @param {string} nodeId
         * @param {string} technicalReportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTechnicalReportsAttachmentsRetrieve: function (id, nodeId, technicalReportId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesTechnicalReportsAttachmentsRetrieve(id, nodeId, technicalReportId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this t_technical_report.
         * @param {string} nodeId
         * @param {string} technicalReportId
         * @param {TechnicalReportAttachments} [technicalReportAttachments]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTechnicalReportsAttachmentsUpdate: function (id, nodeId, technicalReportId, technicalReportAttachments, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesTechnicalReportsAttachmentsUpdate(id, nodeId, technicalReportId, technicalReportAttachments, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * テクニカルレポート追加
         * @param {string} nodeId
         * @param {TechnicalReportRequest} technicalReportRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTechnicalReportsCreate: function (nodeId, technicalReportRequest, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesTechnicalReportsCreate(nodeId, technicalReportRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * テクニカルレポート削除
         * @param {number} id A unique integer value identifying this t_technical_report.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTechnicalReportsDestroy: function (id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesTechnicalReportsDestroy(id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * テクニカルレポート API
         * @param {string} dateFrom 取得期間（開始）
         * @param {string} dateTo 取得期間（終了）
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTechnicalReportsList: function (dateFrom, dateTo, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesTechnicalReportsList(dateFrom, dateTo, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * テクニカルレポート更新（一部）
         * @param {number} id A unique integer value identifying this t_technical_report.
         * @param {string} nodeId
         * @param {PatchedTechnicalReportRequest} [patchedTechnicalReportRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTechnicalReportsPartialUpdate: function (id, nodeId, patchedTechnicalReportRequest, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesTechnicalReportsPartialUpdate(id, nodeId, patchedTechnicalReportRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * テクニカルレポート詳細取得
         * @param {number} id A unique integer value identifying this t_technical_report.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTechnicalReportsRetrieve: function (id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesTechnicalReportsRetrieve(id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this t_technical_report.
         * @param {string} nodeId
         * @param {TechnicalReport} technicalReport
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTechnicalReportsUpdate: function (id, nodeId, technicalReport, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesTechnicalReportsUpdate(id, nodeId, technicalReport, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} nodeId
         * @param {TotalUploadedDocumentSize} totalUploadedDocumentSize
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTotalUploadedDocumentSizeCreate: function (nodeId, totalUploadedDocumentSize, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesTotalUploadedDocumentSizeCreate(nodeId, totalUploadedDocumentSize, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTotalUploadedDocumentSizeDestroy: function (id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesTotalUploadedDocumentSizeDestroy(id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * アップロードされた全ドキュメントのルート階層単位でのサイズ取得
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTotalUploadedDocumentSizeList: function (nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesTotalUploadedDocumentSizeList(nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {string} nodeId
         * @param {PatchedTotalUploadedDocumentSize} [patchedTotalUploadedDocumentSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTotalUploadedDocumentSizePartialUpdate: function (id, nodeId, patchedTotalUploadedDocumentSize, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesTotalUploadedDocumentSizePartialUpdate(id, nodeId, patchedTotalUploadedDocumentSize, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTotalUploadedDocumentSizeRetrieve: function (id, nodeId, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesTotalUploadedDocumentSizeRetrieve(id, nodeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {string} nodeId
         * @param {TotalUploadedDocumentSize} totalUploadedDocumentSize
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTotalUploadedDocumentSizeUpdate: function (id, nodeId, totalUploadedDocumentSize, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.nodesTotalUploadedDocumentSizeUpdate(id, nodeId, totalUploadedDocumentSize, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.NodesApiFp = NodesApiFp;
/**
 * NodesApi - factory interface
 * @export
 */
var NodesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.NodesApiFp)(configuration);
    return {
        /**
         * 警報履歴取得
         * @param {string} nodeId
         * @param {number} timeFrom 取得期間（開始）
         * @param {number} timeTo 取得期間（終了）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesAlarmHistoryList: function (nodeId, timeFrom, timeTo, options) {
            return localVarFp.nodesAlarmHistoryList(nodeId, timeFrom, timeTo, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns list of algorithms.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraAiAlgorithmsList: function (nodeId, options) {
            return localVarFp.nodesCameraAiAlgorithmsList(nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns algorithm.
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraAiAlgorithmsRetrieve: function (id, nodeId, options) {
            return localVarFp.nodesCameraAiAlgorithmsRetrieve(id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns algorithm.
         * @param {string} algorithmName
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraAiAlgorithmsVersionsRetrieve: function (algorithmName, id, nodeId, options) {
            return localVarFp.nodesCameraAiAlgorithmsVersionsRetrieve(algorithmName, id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * カメラAIモデル追加
         * @param {string} nodeId
         * @param {CameraAIModel} cameraAIModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraAiModelsCreate: function (nodeId, cameraAIModel, options) {
            return localVarFp.nodesCameraAiModelsCreate(nodeId, cameraAIModel, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * カメラAIモデル削除
         * @param {number} id A unique integer value identifying this m_camera_ai_model.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraAiModelsDestroy: function (id, nodeId, options) {
            return localVarFp.nodesCameraAiModelsDestroy(id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 最新MLPipelineID
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraAiModelsLatestPipelineIdRetrieve: function (nodeId, options) {
            return localVarFp.nodesCameraAiModelsLatestPipelineIdRetrieve(nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * カメラ一AIモデル覧取得
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraAiModelsList: function (nodeId, options) {
            return localVarFp.nodesCameraAiModelsList(nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * カメラAIモデル更新（一部）
         * @param {number} id A unique integer value identifying this m_camera_ai_model.
         * @param {string} nodeId
         * @param {PatchedCameraAIModel} [patchedCameraAIModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraAiModelsPartialUpdate: function (id, nodeId, patchedCameraAIModel, options) {
            return localVarFp.nodesCameraAiModelsPartialUpdate(id, nodeId, patchedCameraAIModel, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * カメラAIモデル詳細取得
         * @param {number} id A unique integer value identifying this m_camera_ai_model.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraAiModelsRetrieve: function (id, nodeId, options) {
            return localVarFp.nodesCameraAiModelsRetrieve(id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * カメラAIモデル更新
         * @param {number} id A unique integer value identifying this m_camera_ai_model.
         * @param {string} nodeId
         * @param {CameraAIModel} cameraAIModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraAiModelsUpdate: function (id, nodeId, cameraAIModel, options) {
            return localVarFp.nodesCameraAiModelsUpdate(id, nodeId, cameraAIModel, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * カメラThingデプロイ承認
         * @param {string} id
         * @param {string} nodeId
         * @param {string} thingName
         * @param {CameraThingDeploymentApprove} cameraThingDeploymentApprove
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraThingsDeploymentsApproveCreate: function (id, nodeId, thingName, cameraThingDeploymentApprove, options) {
            return localVarFp.nodesCameraThingsDeploymentsApproveCreate(id, nodeId, thingName, cameraThingDeploymentApprove, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * カメラThingデプロイキャンセル
         * @param {string} id
         * @param {string} nodeId
         * @param {string} thingName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraThingsDeploymentsCancelCreate: function (id, nodeId, thingName, options) {
            return localVarFp.nodesCameraThingsDeploymentsCancelCreate(id, nodeId, thingName, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * カメラThingデプロイ作成
         * @param {string} nodeId
         * @param {string} thingName
         * @param {CameraThingDeployment} cameraThingDeployment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraThingsDeploymentsCreate: function (nodeId, thingName, cameraThingDeployment, options) {
            return localVarFp.nodesCameraThingsDeploymentsCreate(nodeId, thingName, cameraThingDeployment, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * カメラThingデプロイ設定
         * @param {string} nodeId
         * @param {string} thingName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraThingsDeploymentsCurrentRetrieve: function (nodeId, thingName, options) {
            return localVarFp.nodesCameraThingsDeploymentsCurrentRetrieve(nodeId, thingName, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * カメラThingデプロイ一覧
         * @param {string} nodeId
         * @param {string} thingName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraThingsDeploymentsList: function (nodeId, thingName, options) {
            return localVarFp.nodesCameraThingsDeploymentsList(nodeId, thingName, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * カメラThingデプロイ詳細
         * @param {string} id
         * @param {string} nodeId
         * @param {string} thingName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraThingsDeploymentsRetrieve: function (id, nodeId, thingName, options) {
            return localVarFp.nodesCameraThingsDeploymentsRetrieve(id, nodeId, thingName, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * カメラThingデプロイ再試行
         * @param {string} id
         * @param {string} nodeId
         * @param {string} thingName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraThingsDeploymentsRetryCreate: function (id, nodeId, thingName, options) {
            return localVarFp.nodesCameraThingsDeploymentsRetryCreate(id, nodeId, thingName, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 環境取得
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraThingsEnvironmentRetrieve: function (id, nodeId, options) {
            return localVarFp.nodesCameraThingsEnvironmentRetrieve(id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * カメラThing
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraThingsList: function (nodeId, options) {
            return localVarFp.nodesCameraThingsList(nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * カメラThing
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCameraThingsRetrieve: function (id, nodeId, options) {
            return localVarFp.nodesCameraThingsRetrieve(id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * カメラAIモデル構築ジョブ承認
         * @param {string} cameraId
         * @param {string} id
         * @param {string} modelId
         * @param {string} nodeId
         * @param {CameraAIModelBuildJobApprove} cameraAIModelBuildJobApprove
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCamerasModelsBuildJobsApproveCreate: function (cameraId, id, modelId, nodeId, cameraAIModelBuildJobApprove, options) {
            return localVarFp.nodesCamerasModelsBuildJobsApproveCreate(cameraId, id, modelId, nodeId, cameraAIModelBuildJobApprove, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * カメラAIモデル構築ジョブキャンセル
         * @param {string} cameraId
         * @param {string} id
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCamerasModelsBuildJobsCancelCreate: function (cameraId, id, modelId, nodeId, options) {
            return localVarFp.nodesCamerasModelsBuildJobsCancelCreate(cameraId, id, modelId, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create comment.
         * @param {string} cameraId
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {CameraAIModelBuildJobComment} cameraAIModelBuildJobComment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCamerasModelsBuildJobsCommentsCreate: function (cameraId, jobId, modelId, nodeId, cameraAIModelBuildJobComment, options) {
            return localVarFp.nodesCamerasModelsBuildJobsCommentsCreate(cameraId, jobId, modelId, nodeId, cameraAIModelBuildJobComment, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete comment
         * @param {string} cameraId
         * @param {number} id A unique integer value identifying this t_camera_ai_model_build_job_comment.
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCamerasModelsBuildJobsCommentsDestroy: function (cameraId, id, jobId, modelId, nodeId, options) {
            return localVarFp.nodesCamerasModelsBuildJobsCommentsDestroy(cameraId, id, jobId, modelId, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns list of comments.
         * @param {string} cameraId
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCamerasModelsBuildJobsCommentsList: function (cameraId, jobId, modelId, nodeId, options) {
            return localVarFp.nodesCamerasModelsBuildJobsCommentsList(cameraId, jobId, modelId, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * カメラAIモデル構築ジョブコメント
         * @param {string} cameraId
         * @param {number} id A unique integer value identifying this t_camera_ai_model_build_job_comment.
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {PatchedCameraAIModelBuildJobComment} [patchedCameraAIModelBuildJobComment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCamerasModelsBuildJobsCommentsPartialUpdate: function (cameraId, id, jobId, modelId, nodeId, patchedCameraAIModelBuildJobComment, options) {
            return localVarFp.nodesCamerasModelsBuildJobsCommentsPartialUpdate(cameraId, id, jobId, modelId, nodeId, patchedCameraAIModelBuildJobComment, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * カメラAIモデル構築ジョブコメント
         * @param {string} cameraId
         * @param {number} id A unique integer value identifying this t_camera_ai_model_build_job_comment.
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCamerasModelsBuildJobsCommentsRetrieve: function (cameraId, id, jobId, modelId, nodeId, options) {
            return localVarFp.nodesCamerasModelsBuildJobsCommentsRetrieve(cameraId, id, jobId, modelId, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update comment.
         * @param {string} cameraId
         * @param {number} id A unique integer value identifying this t_camera_ai_model_build_job_comment.
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {CameraAIModelBuildJobComment} cameraAIModelBuildJobComment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCamerasModelsBuildJobsCommentsUpdate: function (cameraId, id, jobId, modelId, nodeId, cameraAIModelBuildJobComment, options) {
            return localVarFp.nodesCamerasModelsBuildJobsCommentsUpdate(cameraId, id, jobId, modelId, nodeId, cameraAIModelBuildJobComment, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * カメラAIモデル構築ジョブ作成
         * @param {string} cameraId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {CameraAIModelBuildJob} data
         * @param {any} [zipFile]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCamerasModelsBuildJobsCreate: function (cameraId, modelId, nodeId, data, zipFile, options) {
            return localVarFp.nodesCamerasModelsBuildJobsCreate(cameraId, modelId, nodeId, data, zipFile, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns list of images.
         * @param {string} cameraId
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCamerasModelsBuildJobsImagesList: function (cameraId, jobId, modelId, nodeId, options) {
            return localVarFp.nodesCamerasModelsBuildJobsImagesList(cameraId, jobId, modelId, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 画像取得
         * @param {string} cameraId
         * @param {string} id
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCamerasModelsBuildJobsImagesRetrieve: function (cameraId, id, jobId, modelId, nodeId, options) {
            return localVarFp.nodesCamerasModelsBuildJobsImagesRetrieve(cameraId, id, jobId, modelId, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * カメラAIモデル構築ジョブ一覧
         * @param {string} cameraId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCamerasModelsBuildJobsList: function (cameraId, modelId, nodeId, options) {
            return localVarFp.nodesCamerasModelsBuildJobsList(cameraId, modelId, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * カメラAIモデル構築ジョブ評価結果
         * @param {string} cameraId
         * @param {string} id
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCamerasModelsBuildJobsResultRetrieve: function (cameraId, id, modelId, nodeId, options) {
            return localVarFp.nodesCamerasModelsBuildJobsResultRetrieve(cameraId, id, modelId, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * カメラAIモデル構築ジョブ詳細
         * @param {string} cameraId
         * @param {string} id
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCamerasModelsBuildJobsRetrieve: function (cameraId, id, modelId, nodeId, options) {
            return localVarFp.nodesCamerasModelsBuildJobsRetrieve(cameraId, id, modelId, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * カメラAIモデル構築ジョブ再試行
         * @param {string} cameraId
         * @param {string} id
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCamerasModelsBuildJobsRetryCreate: function (cameraId, id, modelId, nodeId, options) {
            return localVarFp.nodesCamerasModelsBuildJobsRetryCreate(cameraId, id, modelId, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * カメラAIモデル構築ジョブ詳細
         * @param {string} cameraId
         * @param {string} id
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesCamerasModelsBuildJobsStateRetrieve: function (cameraId, id, modelId, nodeId, options) {
            return localVarFp.nodesCamerasModelsBuildJobsStateRetrieve(cameraId, id, modelId, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 帳票データ修正
         * @param {string} nodeId
         * @param {ChouhyoEdit} chouhyoEdit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesChouhyoEditCreate: function (nodeId, chouhyoEdit, options) {
            return localVarFp.nodesChouhyoEditCreate(nodeId, chouhyoEdit, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} nodeId
         * @param {ChouhyoOutput} chouhyoOutput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesChouhyoOutputCreate: function (nodeId, chouhyoOutput, options) {
            return localVarFp.nodesChouhyoOutputCreate(nodeId, chouhyoOutput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesChouhyoOutputDestroy: function (id, nodeId, options) {
            return localVarFp.nodesChouhyoOutputDestroy(id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 帳票取得 API
         * @param {number} id 帳票ID
         * @param {string} nodeId
         * @param {number} timestamp 対象日付
         * @param {string} type 帳票種別（日報(D)/月報(M)/年報(Y)）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesChouhyoOutputList: function (id, nodeId, timestamp, type, options) {
            return localVarFp.nodesChouhyoOutputList(id, nodeId, timestamp, type, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {string} nodeId
         * @param {PatchedChouhyoOutput} [patchedChouhyoOutput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesChouhyoOutputPartialUpdate: function (id, nodeId, patchedChouhyoOutput, options) {
            return localVarFp.nodesChouhyoOutputPartialUpdate(id, nodeId, patchedChouhyoOutput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesChouhyoOutputRetrieve: function (id, nodeId, options) {
            return localVarFp.nodesChouhyoOutputRetrieve(id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} nodeId
         * @param {ChouhyoOutputSetting} chouhyoOutputSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesChouhyoOutputSettingCreate: function (nodeId, chouhyoOutputSetting, options) {
            return localVarFp.nodesChouhyoOutputSettingCreate(nodeId, chouhyoOutputSetting, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this m_chouhyo_output_setting.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesChouhyoOutputSettingDestroy: function (id, nodeId, options) {
            return localVarFp.nodesChouhyoOutputSettingDestroy(id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesChouhyoOutputSettingList: function (nodeId, options) {
            return localVarFp.nodesChouhyoOutputSettingList(nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this m_chouhyo_output_setting.
         * @param {string} nodeId
         * @param {PatchedChouhyoOutputSetting} [patchedChouhyoOutputSetting]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesChouhyoOutputSettingPartialUpdate: function (id, nodeId, patchedChouhyoOutputSetting, options) {
            return localVarFp.nodesChouhyoOutputSettingPartialUpdate(id, nodeId, patchedChouhyoOutputSetting, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this m_chouhyo_output_setting.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesChouhyoOutputSettingRetrieve: function (id, nodeId, options) {
            return localVarFp.nodesChouhyoOutputSettingRetrieve(id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this m_chouhyo_output_setting.
         * @param {string} nodeId
         * @param {ChouhyoOutputSetting} chouhyoOutputSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesChouhyoOutputSettingUpdate: function (id, nodeId, chouhyoOutputSetting, options) {
            return localVarFp.nodesChouhyoOutputSettingUpdate(id, nodeId, chouhyoOutputSetting, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {string} nodeId
         * @param {ChouhyoOutput} chouhyoOutput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesChouhyoOutputUpdate: function (id, nodeId, chouhyoOutput, options) {
            return localVarFp.nodesChouhyoOutputUpdate(id, nodeId, chouhyoOutput, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ダッシュボード設定追加
         * @param {string} nodeId
         * @param {DashboardSetting} dashboardSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDashboardSettingsCreate: function (nodeId, dashboardSetting, options) {
            return localVarFp.nodesDashboardSettingsCreate(nodeId, dashboardSetting, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ダッシュボード設定 API
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDashboardSettingsDestroy: function (id, nodeId, options) {
            return localVarFp.nodesDashboardSettingsDestroy(id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ダッシュボード設定一覧
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDashboardSettingsList: function (nodeId, options) {
            return localVarFp.nodesDashboardSettingsList(nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ダッシュボード設定 API
         * @param {string} id
         * @param {string} nodeId
         * @param {PatchedDashboardSetting} [patchedDashboardSetting]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDashboardSettingsPartialUpdate: function (id, nodeId, patchedDashboardSetting, options) {
            return localVarFp.nodesDashboardSettingsPartialUpdate(id, nodeId, patchedDashboardSetting, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ダッシュボード設定 API
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDashboardSettingsRetrieve: function (id, nodeId, options) {
            return localVarFp.nodesDashboardSettingsRetrieve(id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ダッシュボード設定 API
         * @param {string} id
         * @param {string} nodeId
         * @param {DashboardSetting} dashboardSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDashboardSettingsUpdate: function (id, nodeId, dashboardSetting, options) {
            return localVarFp.nodesDashboardSettingsUpdate(id, nodeId, dashboardSetting, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 連続時間積算履歴取得
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {number} timeFrom 取得期間（開始）
         * @param {number} timeTo 取得期間（終了）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsContinuousTotalHistoryList: function (datasetId, nodeId, timeFrom, timeTo, options) {
            return localVarFp.nodesDatasetsContinuousTotalHistoryList(datasetId, nodeId, timeFrom, timeTo, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * データ項目の設定
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {Array<FieldSettings>} fieldSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsFieldSettingsCreate: function (datasetId, nodeId, fieldSettings, options) {
            return localVarFp.nodesDatasetsFieldSettingsCreate(datasetId, nodeId, fieldSettings, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * データ設定項目の取得
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {string} [fieldNames] フィールド名
         * @param {string} [fieldTypes] フィールドタイプ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsFieldSettingsList: function (datasetId, nodeId, fieldNames, fieldTypes, options) {
            return localVarFp.nodesDatasetsFieldSettingsList(datasetId, nodeId, fieldNames, fieldTypes, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 画像ダウンロード
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {ImageDownloadRequest} imageDownloadRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsImagesDownloadCreate: function (datasetId, nodeId, imageDownloadRequest, options) {
            return localVarFp.nodesDatasetsImagesDownloadCreate(datasetId, nodeId, imageDownloadRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 最新画像取得
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsImagesLatestRetrieve: function (datasetId, nodeId, options) {
            return localVarFp.nodesDatasetsImagesLatestRetrieve(datasetId, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 画像一覧取得
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {number} [timeFrom] 取得期間（開始）
         * @param {number} [timeTo] 取得期間（終了）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsImagesList: function (datasetId, nodeId, timeFrom, timeTo, options) {
            return localVarFp.nodesDatasetsImagesList(datasetId, nodeId, timeFrom, timeTo, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 画像取得
         * @param {string} datasetId
         * @param {string} id
         * @param {string} nodeId
         * @param {boolean} [lowQuality] 低画質
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsImagesRetrieve: function (datasetId, id, nodeId, lowQuality, options) {
            return localVarFp.nodesDatasetsImagesRetrieve(datasetId, id, nodeId, lowQuality, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ラベル一括変更
         * @param {string} datasetId
         * @param {string} modelName
         * @param {string} nodeId
         * @param {Array<GroundTruthWithIdPutRequest>} groundTruthWithIdPutRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsModelsGroundTruthsBulkUpdate: function (datasetId, modelName, nodeId, groundTruthWithIdPutRequest, options) {
            return localVarFp.nodesDatasetsModelsGroundTruthsBulkUpdate(datasetId, modelName, nodeId, groundTruthWithIdPutRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ラベル一覧取得
         * @param {string} datasetId
         * @param {string} modelName
         * @param {string} nodeId
         * @param {number} [timeFrom] 取得期間（開始）
         * @param {number} [timeTo] 取得期間（終了）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsModelsGroundTruthsList: function (datasetId, modelName, nodeId, timeFrom, timeTo, options) {
            return localVarFp.nodesDatasetsModelsGroundTruthsList(datasetId, modelName, nodeId, timeFrom, timeTo, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ラベル変更
         * @param {string} datasetId
         * @param {string} id
         * @param {string} modelName
         * @param {string} nodeId
         * @param {GroundTruthPutRequest} groundTruthPutRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsModelsGroundTruthsUpdate: function (datasetId, id, modelName, nodeId, groundTruthPutRequest, options) {
            return localVarFp.nodesDatasetsModelsGroundTruthsUpdate(datasetId, id, modelName, nodeId, groundTruthPutRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 移動平均時間の設定
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {Array<MonitoringTransformSettings>} monitoringTransformSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsMonitoringTransformSettingsCreate: function (datasetId, nodeId, monitoringTransformSettings, options) {
            return localVarFp.nodesDatasetsMonitoringTransformSettingsCreate(datasetId, nodeId, monitoringTransformSettings, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 移動平均時間の取得
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {string} [fieldNames] フィールド名
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsMonitoringTransformSettingsList: function (datasetId, nodeId, fieldNames, options) {
            return localVarFp.nodesDatasetsMonitoringTransformSettingsList(datasetId, nodeId, fieldNames, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 定周期通信異常通知先設定（メール通知）
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {NotificationDataarrivalMailSettings} notificationDataarrivalMailSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsNotificationDataarrivalMailSettingsCreate: function (datasetId, nodeId, notificationDataarrivalMailSettings, options) {
            return localVarFp.nodesDatasetsNotificationDataarrivalMailSettingsCreate(datasetId, nodeId, notificationDataarrivalMailSettings, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 定周期通信異常通知先設定（パトランプ通知）
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {NotificationDataarrivalPatliteSettings} notificationDataarrivalPatliteSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsNotificationDataarrivalPatliteSettingsCreate: function (datasetId, nodeId, notificationDataarrivalPatliteSettings, options) {
            return localVarFp.nodesDatasetsNotificationDataarrivalPatliteSettingsCreate(datasetId, nodeId, notificationDataarrivalPatliteSettings, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 定周期通信異常通知先設定（パトランプ通知） API
         * @param {string} datasetId
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsNotificationDataarrivalPatliteSettingsDestroy: function (datasetId, id, nodeId, options) {
            return localVarFp.nodesDatasetsNotificationDataarrivalPatliteSettingsDestroy(datasetId, id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 定周期通信異常通知先設定（パトランプ通知） API
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsNotificationDataarrivalPatliteSettingsList: function (datasetId, nodeId, options) {
            return localVarFp.nodesDatasetsNotificationDataarrivalPatliteSettingsList(datasetId, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 遠隔操作設定
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {RemoteControl} remoteControl
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsRemoteControlCreate: function (datasetId, nodeId, remoteControl, options) {
            return localVarFp.nodesDatasetsRemoteControlCreate(datasetId, nodeId, remoteControl, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 遠隔操作フェースプレート API
         * @param {string} datasetId
         * @param {string} gateway ゲートウェイ
         * @param {string} nodeId
         * @param {string} tags 状態取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsRemoteControlList: function (datasetId, gateway, nodeId, tags, options) {
            return localVarFp.nodesDatasetsRemoteControlList(datasetId, gateway, nodeId, tags, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 最新データ要求 TODO 一旦、`設計者`以上で。`監視者`以上にするなら、node_a_viewsに移動
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {RemoteControl} remoteControl
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsRemoteControlRecentDataCreate: function (datasetId, nodeId, remoteControl, options) {
            return localVarFp.nodesDatasetsRemoteControlRecentDataCreate(datasetId, nodeId, remoteControl, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 集計単位取得API
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsResampledSummariesList: function (datasetId, nodeId, options) {
            return localVarFp.nodesDatasetsResampledSummariesList(datasetId, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 積算値リセット
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {ResetAddup} resetAddup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsResetAddupCreate: function (datasetId, nodeId, resetAddup, options) {
            return localVarFp.nodesDatasetsResetAddupCreate(datasetId, nodeId, resetAddup, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ニアリアルタイムデータ取得
         * @param {string} id データセット ID
         * @param {string} nodeId
         * @param {number} timeFrom 取得期間（開始）
         * @param {number} timeTo 取得期間（終了）
         * @param {string} [fieldNames] 取得カラム
         * @param {string} [fieldTypes] 取得カラム型
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsRetrieve: function (id, nodeId, timeFrom, timeTo, fieldNames, fieldTypes, options) {
            return localVarFp.nodesDatasetsRetrieve(id, nodeId, timeFrom, timeTo, fieldNames, fieldTypes, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * SaiCrew-ML フィールド
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {SaicrewMlFields} [saicrewMlFields]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsSaicrewMlFieldsCreate: function (datasetId, nodeId, saicrewMlFields, options) {
            return localVarFp.nodesDatasetsSaicrewMlFieldsCreate(datasetId, nodeId, saicrewMlFields, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * SaiCrew-ML フィールド
         * @param {string} datasetId
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsSaicrewMlFieldsDestroy: function (datasetId, id, nodeId, options) {
            return localVarFp.nodesDatasetsSaicrewMlFieldsDestroy(datasetId, id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * SaiCrew-ML フィールド
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsSaicrewMlFieldsList: function (datasetId, nodeId, options) {
            return localVarFp.nodesDatasetsSaicrewMlFieldsList(datasetId, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * SaiCrew-ML フィールド
         * @param {string} datasetId
         * @param {string} id
         * @param {string} nodeId
         * @param {PatchedSaicrewMlFields} [patchedSaicrewMlFields]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsSaicrewMlFieldsPartialUpdate: function (datasetId, id, nodeId, patchedSaicrewMlFields, options) {
            return localVarFp.nodesDatasetsSaicrewMlFieldsPartialUpdate(datasetId, id, nodeId, patchedSaicrewMlFields, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * SaiCrew-ML フィールド
         * @param {string} datasetId
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsSaicrewMlFieldsRetrieve: function (datasetId, id, nodeId, options) {
            return localVarFp.nodesDatasetsSaicrewMlFieldsRetrieve(datasetId, id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * SaiCrew-ML フィールド
         * @param {string} datasetId
         * @param {string} id
         * @param {string} nodeId
         * @param {SaicrewMlFields} [saicrewMlFields]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsSaicrewMlFieldsUpdate: function (datasetId, id, nodeId, saicrewMlFields, options) {
            return localVarFp.nodesDatasetsSaicrewMlFieldsUpdate(datasetId, id, nodeId, saicrewMlFields, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * アップロード CSV
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {UploadCsvRequest} uploadCsvRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsUploadsCreate: function (datasetId, nodeId, uploadCsvRequest, options) {
            return localVarFp.nodesDatasetsUploadsCreate(datasetId, nodeId, uploadCsvRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * CSV アップロード用フォーマットダウンロード
         * @param {string} datasetId
         * @param {string} formatType フォーマット種別
         * @param {string} nodeId
         * @param {number} [timeFrom] 取得期間（開始）
         * @param {number} [timeTo] 取得期間（終了）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsUploadsFormatRetrieve: function (datasetId, formatType, nodeId, timeFrom, timeTo, options) {
            return localVarFp.nodesDatasetsUploadsFormatRetrieve(datasetId, formatType, nodeId, timeFrom, timeTo, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * アップロード履歴一覧取得
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsUploadsHistoryList: function (datasetId, nodeId, options) {
            return localVarFp.nodesDatasetsUploadsHistoryList(datasetId, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * アップロードされた CSV データの処理を開始する API
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {ProcessUploadedCsvRequest} processUploadedCsvRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDatasetsUploadsProcessUploadedCsvCreate: function (datasetId, nodeId, processUploadedCsvRequest, options) {
            return localVarFp.nodesDatasetsUploadsProcessUploadedCsvCreate(datasetId, nodeId, processUploadedCsvRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ドキュメント追加
         * @param {string} nodeId
         * @param {DocumentCreate} documentCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDocumentsCreate: function (nodeId, documentCreate, options) {
            return localVarFp.nodesDocumentsCreate(nodeId, documentCreate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ドキュメント削除
         * @param {string} id
         * @param {string} nodeId
         * @param {string} prefix 削除するドキュメントのパス
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDocumentsDestroy: function (id, nodeId, prefix, options) {
            return localVarFp.nodesDocumentsDestroy(id, nodeId, prefix, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ドキュメント一覧取得
         * @param {string} nodeId
         * @param {string} [prefix] 取得対象のパス
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDocumentsList: function (nodeId, prefix, options) {
            return localVarFp.nodesDocumentsList(nodeId, prefix, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ドキュメント取得
         * @param {string} id
         * @param {string} nodeId
         * @param {string} prefix 取得するドキュメントのパス
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDocumentsRetrieve: function (id, nodeId, prefix, options) {
            return localVarFp.nodesDocumentsRetrieve(id, nodeId, prefix, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ドキュメント更新
         * @param {string} id
         * @param {string} nodeId
         * @param {DocumentUpdate} documentUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDocumentsUpdate: function (id, nodeId, documentUpdate, options) {
            return localVarFp.nodesDocumentsUpdate(id, nodeId, documentUpdate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * CSV ダウンロード API
         * @param {string} nodeId
         * @param {number} timeFrom 取得期間（開始）
         * @param {number} timeTo 取得期間（終了）
         * @param {CSVDownload} cSVDownload
         * @param {string} [sources]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesDownloadsCreate: function (nodeId, timeFrom, timeTo, cSVDownload, sources, options) {
            return localVarFp.nodesDownloadsCreate(nodeId, timeFrom, timeTo, cSVDownload, sources, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * モデル結果(ファイル)一覧取得
         * @param {string} gatewayId
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {string} type 取得するデータのタイプ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesGatewayModelsBuildJobsFileList: function (gatewayId, jobId, modelId, nodeId, type, options) {
            return localVarFp.nodesGatewayModelsBuildJobsFileList(gatewayId, jobId, modelId, nodeId, type, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * モデル結果(ファイル)取得
         * @param {string} gatewayId
         * @param {string} id
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {string} type 取得するデータのタイプ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesGatewayModelsBuildJobsFileRetrieve: function (gatewayId, id, jobId, modelId, nodeId, type, options) {
            return localVarFp.nodesGatewayModelsBuildJobsFileRetrieve(gatewayId, id, jobId, modelId, nodeId, type, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * モデル結果一覧取得
         * @param {string} gatewayId
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {string} type 取得するデータのタイプ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesGatewayModelsBuildJobsResultList: function (gatewayId, jobId, modelId, nodeId, type, options) {
            return localVarFp.nodesGatewayModelsBuildJobsResultList(gatewayId, jobId, modelId, nodeId, type, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * モデル結果取得
         * @param {string} gatewayId
         * @param {string} id
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {string} type 取得するデータのタイプ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesGatewayModelsBuildJobsResultRetrieve: function (gatewayId, id, jobId, modelId, nodeId, type, options) {
            return localVarFp.nodesGatewayModelsBuildJobsResultRetrieve(gatewayId, id, jobId, modelId, nodeId, type, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * SaiCrew デプロイ設定 説明変数のシミュレーション範囲一覧取得
         * @param {string} gatewayId
         * @param {string} nodeId
         * @param {Array<SaicrewAIModelMlSimulationsRequest>} saicrewAIModelMlSimulationsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesGatewaySaicrewMlSimulationsMlListCreate: function (gatewayId, nodeId, saicrewAIModelMlSimulationsRequest, options) {
            return localVarFp.nodesGatewaySaicrewMlSimulationsMlListCreate(gatewayId, nodeId, saicrewAIModelMlSimulationsRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} cameraId
         * @param {string} nodeId
         * @param {number} [timestamp] 基準時間
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesGraphicCameraList: function (cameraId, nodeId, timestamp, options) {
            return localVarFp.nodesGraphicCameraList(cameraId, nodeId, timestamp, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} fileName
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesGraphicImageList: function (fileName, nodeId, options) {
            return localVarFp.nodesGraphicImageList(fileName, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesGraphicIntervalList: function (nodeId, options) {
            return localVarFp.nodesGraphicIntervalList(nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * グラフィックレコーダ用ジャーナル取得API
         * @param {string} nodeId
         * @param {number} timeFrom 取得期間（開始）
         * @param {number} timeTo 取得期間（終了）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesGraphicRecorderStatusRetrieve: function (nodeId, timeFrom, timeTo, options) {
            return localVarFp.nodesGraphicRecorderStatusRetrieve(nodeId, timeFrom, timeTo, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * アップロードバリデーション
         * @param {string} nodeId
         * @param {string} tabIndex
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesGraphicTabsGraphicFilesCreate: function (nodeId, tabIndex, options) {
            return localVarFp.nodesGraphicTabsGraphicFilesCreate(nodeId, tabIndex, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 項目選択API
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesItemSelectionList: function (nodeId, options) {
            return localVarFp.nodesItemSelectionList(nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 最新ジャーナル取得API
         * @param {string} nodeId
         * @param {boolean} [includeDescendants] 子孫のデータセットを含むか
         * @param {boolean} [includeNotify] アナログ監視判定結果を含むか
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesLastestStatusList: function (nodeId, includeDescendants, includeNotify, options) {
            return localVarFp.nodesLastestStatusList(nodeId, includeDescendants, includeNotify, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 発生中警報情報取得
         * @param {string} nodeId
         * @param {boolean} [controlDashboardDispFlag] ダッシュボード表示フラグの制御有無
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesLatestAlarmList: function (nodeId, controlDashboardDispFlag, options) {
            return localVarFp.nodesLatestAlarmList(nodeId, controlDashboardDispFlag, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 発生中警報情報取得
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesLatestProcessList: function (nodeId, options) {
            return localVarFp.nodesLatestProcessList(nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * メール設定 グループ別送信テスト
         * @param {string} nodeId
         * @param {MailGroupTest} mailGroupTest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMailGroupTestCreate: function (nodeId, mailGroupTest, options) {
            return localVarFp.nodesMailGroupTestCreate(nodeId, mailGroupTest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * シンプル記録追加
         * @param {string} nodeId
         * @param {MaintenanceHistory} maintenanceHistory
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMaintenanceHistoriesCreate: function (nodeId, maintenanceHistory, options) {
            return localVarFp.nodesMaintenanceHistoriesCreate(nodeId, maintenanceHistory, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * シンプル記録削除
         * @param {number} id A unique integer value identifying this t_maintenance_history.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMaintenanceHistoriesDestroy: function (id, nodeId, options) {
            return localVarFp.nodesMaintenanceHistoriesDestroy(id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * シンプル記録 API
         * @param {string} dateFrom 取得期間（開始）
         * @param {string} dateTo 取得期間（終了）
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMaintenanceHistoriesList: function (dateFrom, dateTo, nodeId, options) {
            return localVarFp.nodesMaintenanceHistoriesList(dateFrom, dateTo, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * シンプル記録更新（一部）
         * @param {number} id A unique integer value identifying this t_maintenance_history.
         * @param {string} nodeId
         * @param {PatchedMaintenanceHistory} [patchedMaintenanceHistory]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMaintenanceHistoriesPartialUpdate: function (id, nodeId, patchedMaintenanceHistory, options) {
            return localVarFp.nodesMaintenanceHistoriesPartialUpdate(id, nodeId, patchedMaintenanceHistory, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * シンプル記録詳細取得
         * @param {number} id A unique integer value identifying this t_maintenance_history.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMaintenanceHistoriesRetrieve: function (id, nodeId, options) {
            return localVarFp.nodesMaintenanceHistoriesRetrieve(id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * シンプル記録更新
         * @param {number} id A unique integer value identifying this t_maintenance_history.
         * @param {string} nodeId
         * @param {MaintenanceHistory} maintenanceHistory
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMaintenanceHistoriesUpdate: function (id, nodeId, maintenanceHistory, options) {
            return localVarFp.nodesMaintenanceHistoriesUpdate(id, nodeId, maintenanceHistory, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * MBR 演算設定追加
         * @param {string} nodeId
         * @param {MbrCalculationSettings} mbrCalculationSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMbrCalculationSettingsCreate: function (nodeId, mbrCalculationSettings, options) {
            return localVarFp.nodesMbrCalculationSettingsCreate(nodeId, mbrCalculationSettings, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * MBR 演算設定削除
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMbrCalculationSettingsDestroy: function (id, nodeId, options) {
            return localVarFp.nodesMbrCalculationSettingsDestroy(id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * MBR 演算設定一覧
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMbrCalculationSettingsList: function (nodeId, options) {
            return localVarFp.nodesMbrCalculationSettingsList(nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * MBR 演算設定更新（一部）
         * @param {string} id
         * @param {string} nodeId
         * @param {PatchedMbrCalculationSettings} [patchedMbrCalculationSettings]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMbrCalculationSettingsPartialUpdate: function (id, nodeId, patchedMbrCalculationSettings, options) {
            return localVarFp.nodesMbrCalculationSettingsPartialUpdate(id, nodeId, patchedMbrCalculationSettings, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * MBR 演算設定 API
         * @param {string} id
         * @param {string} nodeId
         * @param {MbrCalculationSettings} mbrCalculationSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMbrCalculationSettingsUpdate: function (id, nodeId, mbrCalculationSettings, options) {
            return localVarFp.nodesMbrCalculationSettingsUpdate(id, nodeId, mbrCalculationSettings, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 傾向総合診断履歴 API
         * @param {string} nodeId
         * @param {MbrTechnicalReportJudgementHistory} mbrTechnicalReportJudgementHistory
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMbrTechnicalReportJudgementHistoriesCreate: function (nodeId, mbrTechnicalReportJudgementHistory, options) {
            return localVarFp.nodesMbrTechnicalReportJudgementHistoriesCreate(nodeId, mbrTechnicalReportJudgementHistory, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 傾向総合診断履歴の取得
         * @param {string} nodeId
         * @param {number} timeFrom 取得期間（開始）
         * @param {number} timeTo 取得期間（終了）
         * @param {number} [calculationNo] 演算 No
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMbrTechnicalReportJudgementHistoriesList: function (nodeId, timeFrom, timeTo, calculationNo, options) {
            return localVarFp.nodesMbrTechnicalReportJudgementHistoriesList(nodeId, timeFrom, timeTo, calculationNo, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 傾向総合診断追加
         * @param {string} nodeId
         * @param {MbrTechnicalReportJudgement} mbrTechnicalReportJudgement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMbrTechnicalReportJudgementsCreate: function (nodeId, mbrTechnicalReportJudgement, options) {
            return localVarFp.nodesMbrTechnicalReportJudgementsCreate(nodeId, mbrTechnicalReportJudgement, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 傾向総合診断取得
         * @param {string} nodeId
         * @param {number} [calculationNo] 演算 No
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMbrTechnicalReportJudgementsList: function (nodeId, calculationNo, options) {
            return localVarFp.nodesMbrTechnicalReportJudgementsList(nodeId, calculationNo, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 傾向総合診断の取得
         * @param {string} dateFrom 取得期間（開始）
         * @param {string} dateTo 取得期間（終了）
         * @param {string} nodeId
         * @param {number} [calculationNo] 演算 No
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMbrTechnicalReportResultsList: function (dateFrom, dateTo, nodeId, calculationNo, options) {
            return localVarFp.nodesMbrTechnicalReportResultsList(dateFrom, dateTo, nodeId, calculationNo, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMonitorDatasetMetricsList: function (nodeId, options) {
            return localVarFp.nodesMonitorDatasetMetricsList(nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMonitorDatasetMetricsRetrieve: function (id, nodeId, options) {
            return localVarFp.nodesMonitorDatasetMetricsRetrieve(id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 通知Gr1のオンオフ設定
         * @param {string} nodeId
         * @param {Array<MonitoringNotificationGr1Settings>} monitoringNotificationGr1Settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMonitorNotificationGr1SettingsCreate: function (nodeId, monitoringNotificationGr1Settings, options) {
            return localVarFp.nodesMonitorNotificationGr1SettingsCreate(nodeId, monitoringNotificationGr1Settings, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 通知Gr2のオンオフ設定
         * @param {string} nodeId
         * @param {Array<MonitoringNotificationGr2Settings>} monitoringNotificationGr2Settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMonitorNotificationGr2SettingsCreate: function (nodeId, monitoringNotificationGr2Settings, options) {
            return localVarFp.nodesMonitorNotificationGr2SettingsCreate(nodeId, monitoringNotificationGr2Settings, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * メール通知のオンオフ設定
         * @param {string} nodeId
         * @param {Array<MonitoringNotificationMailSettings>} monitoringNotificationMailSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMonitorNotificationMailSettingsGeneralCreate: function (nodeId, monitoringNotificationMailSettings, options) {
            return localVarFp.nodesMonitorNotificationMailSettingsGeneralCreate(nodeId, monitoringNotificationMailSettings, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * データ項目の設定
         * @param {string} nodeId
         * @param {Array<MonitoringSettings>} monitoringSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMonitorSettingsCreate: function (nodeId, monitoringSettings, options) {
            return localVarFp.nodesMonitorSettingsCreate(nodeId, monitoringSettings, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * クラウド設定警報取得 API
         * @param {string} nodeId
         * @param {string} [datasetId] データセットID
         * @param {string} [fieldNames] フィールド名
         * @param {string} [ruleNames] 条件
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesMonitorSettingsList: function (nodeId, datasetId, fieldNames, ruleNames, options) {
            return localVarFp.nodesMonitorSettingsList(nodeId, datasetId, fieldNames, ruleNames, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 通知Gr1の設定
         * @param {string} nodeId
         * @param {NotificationGr1Settings} [notificationGr1Settings]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesNotificationGr1SettingsCreate: function (nodeId, notificationGr1Settings, options) {
            return localVarFp.nodesNotificationGr1SettingsCreate(nodeId, notificationGr1Settings, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 通知Gr2の設定
         * @param {string} nodeId
         * @param {NotificationGr2Settings} [notificationGr2Settings]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesNotificationGr2SettingsCreate: function (nodeId, notificationGr2Settings, options) {
            return localVarFp.nodesNotificationGr2SettingsCreate(nodeId, notificationGr2Settings, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * メール配信設定
         * @param {string} nodeId
         * @param {NotificationMailSettings} [notificationMailSettings]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesNotificationMailSettingsCreate: function (nodeId, notificationMailSettings, options) {
            return localVarFp.nodesNotificationMailSettingsCreate(nodeId, notificationMailSettings, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * SaiCrew通知設定（メール通知）
         * @param {string} nodeId
         * @param {NotificationSaiCrewMailSettings} [notificationSaiCrewMailSettings]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesNotificationSaicrewMailSettingsCreate: function (nodeId, notificationSaiCrewMailSettings, options) {
            return localVarFp.nodesNotificationSaicrewMailSettingsCreate(nodeId, notificationSaiCrewMailSettings, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * SaiIK通知設定（メール通知）
         * @param {string} nodeId
         * @param {NotificationSaiIKMailSettings} [notificationSaiIKMailSettings]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesNotificationSaiikMailSettingsCreate: function (nodeId, notificationSaiIKMailSettings, options) {
            return localVarFp.nodesNotificationSaiikMailSettingsCreate(nodeId, notificationSaiIKMailSettings, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 設備の通知先の設定
         * @param {string} nodeId
         * @param {NotificationSettings} notificationSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesNotificationSettingsCreate: function (nodeId, notificationSettings, options) {
            return localVarFp.nodesNotificationSettingsCreate(nodeId, notificationSettings, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 設備の通知設定の取得
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesNotificationSettingsList: function (nodeId, options) {
            return localVarFp.nodesNotificationSettingsList(nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * システム警報異常通知先設定（メール通知）
         * @param {string} nodeId
         * @param {NotificationSystemMailSettings} [notificationSystemMailSettings]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesNotificationSystemMailSettingsCreate: function (nodeId, notificationSystemMailSettings, options) {
            return localVarFp.nodesNotificationSystemMailSettingsCreate(nodeId, notificationSystemMailSettings, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * システム警報異常通知先設定（パトランプ通知）
         * @param {string} nodeId
         * @param {NotificationSystemPatliteSettings} notificationSystemPatliteSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesNotificationSystemPatliteSettingsCreate: function (nodeId, notificationSystemPatliteSettings, options) {
            return localVarFp.nodesNotificationSystemPatliteSettingsCreate(nodeId, notificationSystemPatliteSettings, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * システム警報異常通知先設定（パトランプ通知） API
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesNotificationSystemPatliteSettingsDestroy: function (id, nodeId, options) {
            return localVarFp.nodesNotificationSystemPatliteSettingsDestroy(id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * システム警報異常通知先設定（パトランプ通知） API
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesNotificationSystemPatliteSettingsList: function (nodeId, options) {
            return localVarFp.nodesNotificationSystemPatliteSettingsList(nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 運転履歴取得
         * @param {string} nodeId
         * @param {number} timeFrom 取得期間（開始）
         * @param {number} timeTo 取得期間（終了）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesOperatingHistoryList: function (nodeId, timeFrom, timeTo, options) {
            return localVarFp.nodesOperatingHistoryList(nodeId, timeFrom, timeTo, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 稼働情報取得
         * @param {string} nodeId
         * @param {number} timeFrom 取得期間（開始）
         * @param {number} timeTo 取得期間（終了）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesOperatingSummaryList: function (nodeId, timeFrom, timeTo, options) {
            return localVarFp.nodesOperatingSummaryList(nodeId, timeFrom, timeTo, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * パトランプ通知追加
         * @param {string} datasetIds
         * @param {string} fieldNames
         * @param {string} nodeId
         * @param {Array<PatliteNotificationSetting>} patliteNotificationSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesPatliteNotificationSettingsCreate: function (datasetIds, fieldNames, nodeId, patliteNotificationSetting, options) {
            return localVarFp.nodesPatliteNotificationSettingsCreate(datasetIds, fieldNames, nodeId, patliteNotificationSetting, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * パトランプ通知削除
         * @param {number} id A unique integer value identifying this m_patlite_notification_setting.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesPatliteNotificationSettingsDestroy: function (id, nodeId, options) {
            return localVarFp.nodesPatliteNotificationSettingsDestroy(id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * パトランプ通知 API
         * @param {string} nodeId
         * @param {string} [datasetId] データセット
         * @param {string} [fieldName] 項目
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesPatliteNotificationSettingsList: function (nodeId, datasetId, fieldName, options) {
            return localVarFp.nodesPatliteNotificationSettingsList(nodeId, datasetId, fieldName, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * パトランプ通知更新（一部）
         * @param {number} id A unique integer value identifying this m_patlite_notification_setting.
         * @param {string} nodeId
         * @param {PatchedPatliteNotificationSetting} [patchedPatliteNotificationSetting]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesPatliteNotificationSettingsPartialUpdate: function (id, nodeId, patchedPatliteNotificationSetting, options) {
            return localVarFp.nodesPatliteNotificationSettingsPartialUpdate(id, nodeId, patchedPatliteNotificationSetting, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * パトランプ通知詳細取得
         * @param {number} id A unique integer value identifying this m_patlite_notification_setting.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesPatliteNotificationSettingsRetrieve: function (id, nodeId, options) {
            return localVarFp.nodesPatliteNotificationSettingsRetrieve(id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * パトランプ通知更新
         * @param {number} id A unique integer value identifying this m_patlite_notification_setting.
         * @param {string} nodeId
         * @param {PatliteNotificationSetting} patliteNotificationSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesPatliteNotificationSettingsUpdate: function (id, nodeId, patliteNotificationSetting, options) {
            return localVarFp.nodesPatliteNotificationSettingsUpdate(id, nodeId, patliteNotificationSetting, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * パトランプ設定
         * @param {string} nodeId
         * @param {Array<NodePatliteSetting>} nodePatliteSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesPatliteSettingsCreate: function (nodeId, nodePatliteSetting, options) {
            return localVarFp.nodesPatliteSettingsCreate(nodeId, nodePatliteSetting, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * パトランプ設定 API
         * @param {number} id A unique integer value identifying this m_node_patlite_setting.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesPatliteSettingsDestroy: function (id, nodeId, options) {
            return localVarFp.nodesPatliteSettingsDestroy(id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * パトランプ設定取得
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesPatliteSettingsList: function (nodeId, options) {
            return localVarFp.nodesPatliteSettingsList(nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * パトランプ設定 API
         * @param {number} id A unique integer value identifying this m_node_patlite_setting.
         * @param {string} nodeId
         * @param {PatchedNodePatliteSetting} [patchedNodePatliteSetting]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesPatliteSettingsPartialUpdate: function (id, nodeId, patchedNodePatliteSetting, options) {
            return localVarFp.nodesPatliteSettingsPartialUpdate(id, nodeId, patchedNodePatliteSetting, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * パトランプ設定 API
         * @param {number} id A unique integer value identifying this m_node_patlite_setting.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesPatliteSettingsRetrieve: function (id, nodeId, options) {
            return localVarFp.nodesPatliteSettingsRetrieve(id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * パトランプ設定 API
         * @param {number} id A unique integer value identifying this m_node_patlite_setting.
         * @param {string} nodeId
         * @param {NodePatliteSetting} nodePatliteSetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesPatliteSettingsUpdate: function (id, nodeId, nodePatliteSetting, options) {
            return localVarFp.nodesPatliteSettingsUpdate(id, nodeId, nodePatliteSetting, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * パトランプテスト
         * @param {string} nodeId
         * @param {string} patliteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesPatlitesTestCreate: function (nodeId, patliteId, options) {
            return localVarFp.nodesPatlitesTestCreate(nodeId, patliteId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 遠隔操作履歴 API
         * @param {number} dateFrom 取得期間（開始）
         * @param {number} dateTo 取得期間（終了）
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesRemoteControlHistoryList: function (dateFrom, dateTo, nodeId, options) {
            return localVarFp.nodesRemoteControlHistoryList(dateFrom, dateTo, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this m_remote_control_history.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesRemoteControlHistoryRetrieve: function (id, nodeId, options) {
            return localVarFp.nodesRemoteControlHistoryRetrieve(id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 長期データ取得
         * @param {string} id データセット ID
         * @param {string} nodeId
         * @param {string} [asFreq] 集約単位
         * @param {string} [fieldNames] 取得カラム
         * @param {string} [fieldTypes] 取得カラム型
         * @param {string} [method] 集約方法
         * @param {string} [splitBy] 表示単位
         * @param {string} [theLastPeriod] 直近〜（1W / 1M / 3M / 6M / 9M / 1Y / 3Y / 5Y）
         * @param {number} [timeFrom] 取得期間（開始）
         * @param {number} [timeTo] 取得期間（終了）
         * @param {string} [trendGraphFreq] トレンドグラフの集約単位
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesResampledDatasetsRetrieve: function (id, nodeId, asFreq, fieldNames, fieldTypes, method, splitBy, theLastPeriod, timeFrom, timeTo, trendGraphFreq, options) {
            return localVarFp.nodesResampledDatasetsRetrieve(id, nodeId, asFreq, fieldNames, fieldTypes, method, splitBy, theLastPeriod, timeFrom, timeTo, trendGraphFreq, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * RO 演算設定追加
         * @param {string} nodeId
         * @param {RoCalculationSettings} roCalculationSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesRoCalculationSettingsCreate: function (nodeId, roCalculationSettings, options) {
            return localVarFp.nodesRoCalculationSettingsCreate(nodeId, roCalculationSettings, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * RO 演算設定削除
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesRoCalculationSettingsDestroy: function (id, nodeId, options) {
            return localVarFp.nodesRoCalculationSettingsDestroy(id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * RO 演算設定一覧
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesRoCalculationSettingsList: function (nodeId, options) {
            return localVarFp.nodesRoCalculationSettingsList(nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * RO 演算設定更新（一部）
         * @param {string} id
         * @param {string} nodeId
         * @param {PatchedRoCalculationSettings} [patchedRoCalculationSettings]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesRoCalculationSettingsPartialUpdate: function (id, nodeId, patchedRoCalculationSettings, options) {
            return localVarFp.nodesRoCalculationSettingsPartialUpdate(id, nodeId, patchedRoCalculationSettings, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * RO 演算設定 API
         * @param {string} id
         * @param {string} nodeId
         * @param {RoCalculationSettings} roCalculationSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesRoCalculationSettingsUpdate: function (id, nodeId, roCalculationSettings, options) {
            return localVarFp.nodesRoCalculationSettingsUpdate(id, nodeId, roCalculationSettings, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ROテクニカルレポート
         * @param {string} nodeId
         * @param {string} [dateFrom] 取得期間（開始）
         * @param {string} [dateTo] 取得期間（終了）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesRoTechnicalReportResultsList: function (nodeId, dateFrom, dateTo, options) {
            return localVarFp.nodesRoTechnicalReportResultsList(nodeId, dateFrom, dateTo, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns list of algorithms.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewAiAlgorithmsList: function (nodeId, options) {
            return localVarFp.nodesSaicrewAiAlgorithmsList(nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns algorithm.
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewAiAlgorithmsRetrieve: function (id, nodeId, options) {
            return localVarFp.nodesSaicrewAiAlgorithmsRetrieve(id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns algorithm.
         * @param {string} algorithmName
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewAiAlgorithmsVersionsRetrieve: function (algorithmName, id, nodeId, options) {
            return localVarFp.nodesSaicrewAiAlgorithmsVersionsRetrieve(algorithmName, id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * SaiCrew-AIモデル追加
         * @param {string} nodeId
         * @param {SaicrewAIModel} saicrewAIModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewAiModelsCreate: function (nodeId, saicrewAIModel, options) {
            return localVarFp.nodesSaicrewAiModelsCreate(nodeId, saicrewAIModel, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * SaiCrew-AIモデル削除
         * @param {number} id A unique integer value identifying this m_saicrew_ai_model.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewAiModelsDestroy: function (id, nodeId, options) {
            return localVarFp.nodesSaicrewAiModelsDestroy(id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 最新MLPipelineIDの取得
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewAiModelsLatestPipelineIdRetrieve: function (nodeId, options) {
            return localVarFp.nodesSaicrewAiModelsLatestPipelineIdRetrieve(nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * SaiCrew-AIモデル覧取得
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewAiModelsList: function (nodeId, options) {
            return localVarFp.nodesSaicrewAiModelsList(nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * SaiCrew-AIモデル更新（一部）
         * @param {number} id A unique integer value identifying this m_saicrew_ai_model.
         * @param {string} nodeId
         * @param {PatchedSaicrewAIModel} [patchedSaicrewAIModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewAiModelsPartialUpdate: function (id, nodeId, patchedSaicrewAIModel, options) {
            return localVarFp.nodesSaicrewAiModelsPartialUpdate(id, nodeId, patchedSaicrewAIModel, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * SaiCrew-AIモデル詳細取得
         * @param {number} id A unique integer value identifying this m_saicrew_ai_model.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewAiModelsRetrieve: function (id, nodeId, options) {
            return localVarFp.nodesSaicrewAiModelsRetrieve(id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * SaiCrew-AIモデル更新
         * @param {number} id A unique integer value identifying this m_saicrew_ai_model.
         * @param {string} nodeId
         * @param {SaicrewAIModel} saicrewAIModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewAiModelsUpdate: function (id, nodeId, saicrewAIModel, options) {
            return localVarFp.nodesSaicrewAiModelsUpdate(id, nodeId, saicrewAIModel, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * List all SaiCrew node datasets in descendant nodes.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewDatasetsList: function (nodeId, options) {
            return localVarFp.nodesSaicrewDatasetsList(nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * SaiCrew モデル構築・データ予測用の CSV フォーマットダウンロード
         * @param {string} datasetId
         * @param {string} nodeId
         * @param {Array<string>} [mlNames] ML変数
         * @param {number} [timeFrom] 取得期間（開始）
         * @param {number} [timeTo] 取得期間（終了）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewDatasetsUploadsFormatRetrieve: function (datasetId, nodeId, mlNames, timeFrom, timeTo, options) {
            return localVarFp.nodesSaicrewDatasetsUploadsFormatRetrieve(datasetId, nodeId, mlNames, timeFrom, timeTo, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} edgeDevice
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewEdgeDeviceComponentList: function (edgeDevice, nodeId, options) {
            return localVarFp.nodesSaicrewEdgeDeviceComponentList(edgeDevice, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} nodeId
         * @param {SaicrewEdgeDevice} saicrewEdgeDevice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewEdgeDeviceCreate: function (nodeId, saicrewEdgeDevice, options) {
            return localVarFp.nodesSaicrewEdgeDeviceCreate(nodeId, saicrewEdgeDevice, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Saicrewデプロイ承認
         * @param {string} edgeDevice
         * @param {string} id
         * @param {string} nodeId
         * @param {SaicrewDeploymentApprove} saicrewDeploymentApprove
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewEdgeDeviceDeploymentsApproveCreate: function (edgeDevice, id, nodeId, saicrewDeploymentApprove, options) {
            return localVarFp.nodesSaicrewEdgeDeviceDeploymentsApproveCreate(edgeDevice, id, nodeId, saicrewDeploymentApprove, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Saicrewデプロイキャンセル
         * @param {string} edgeDevice
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewEdgeDeviceDeploymentsCancelCreate: function (edgeDevice, id, nodeId, options) {
            return localVarFp.nodesSaicrewEdgeDeviceDeploymentsCancelCreate(edgeDevice, id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Saicrewデプロイ作成
         * @param {string} edgeDevice
         * @param {string} nodeId
         * @param {SaicrewDeployment} saicrewDeployment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewEdgeDeviceDeploymentsCreate: function (edgeDevice, nodeId, saicrewDeployment, options) {
            return localVarFp.nodesSaicrewEdgeDeviceDeploymentsCreate(edgeDevice, nodeId, saicrewDeployment, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * 環境取得
         * @param {string} edgeDevice
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewEdgeDeviceDeploymentsEnvironmentRetrieve: function (edgeDevice, id, nodeId, options) {
            return localVarFp.nodesSaicrewEdgeDeviceDeploymentsEnvironmentRetrieve(edgeDevice, id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Saicrewデプロイ一覧
         * @param {string} edgeDevice
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewEdgeDeviceDeploymentsList: function (edgeDevice, nodeId, options) {
            return localVarFp.nodesSaicrewEdgeDeviceDeploymentsList(edgeDevice, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Saicrewデプロイ
         * @param {string} edgeDevice
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewEdgeDeviceDeploymentsRetrieve: function (edgeDevice, id, nodeId, options) {
            return localVarFp.nodesSaicrewEdgeDeviceDeploymentsRetrieve(edgeDevice, id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Saicrewデプロイ再試行
         * @param {string} edgeDevice
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewEdgeDeviceDeploymentsRetryCreate: function (edgeDevice, id, nodeId, options) {
            return localVarFp.nodesSaicrewEdgeDeviceDeploymentsRetryCreate(edgeDevice, id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewEdgeDeviceDestroy: function (id, nodeId, options) {
            return localVarFp.nodesSaicrewEdgeDeviceDestroy(id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Saicrewエッジデバイス詳細取得
         * @param {string} nodeId
         * @param {boolean} [includeDeploymentCounts] 今月のデプロイ数も合わせて取得
         * @param {boolean} [includeModelBuildCounts] 今月のモデルビルド数も合わせて取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewEdgeDeviceList: function (nodeId, includeDeploymentCounts, includeModelBuildCounts, options) {
            return localVarFp.nodesSaicrewEdgeDeviceList(nodeId, includeDeploymentCounts, includeModelBuildCounts, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {string} nodeId
         * @param {PatchedSaicrewEdgeDevice} [patchedSaicrewEdgeDevice]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewEdgeDevicePartialUpdate: function (id, nodeId, patchedSaicrewEdgeDevice, options) {
            return localVarFp.nodesSaicrewEdgeDevicePartialUpdate(id, nodeId, patchedSaicrewEdgeDevice, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewEdgeDeviceRetrieve: function (id, nodeId, options) {
            return localVarFp.nodesSaicrewEdgeDeviceRetrieve(id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {string} nodeId
         * @param {SaicrewEdgeDevice} saicrewEdgeDevice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewEdgeDeviceUpdate: function (id, nodeId, saicrewEdgeDevice, options) {
            return localVarFp.nodesSaicrewEdgeDeviceUpdate(id, nodeId, saicrewEdgeDevice, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * SaiCrew-ML　Variables ViewSet.
         * @param {string} nodeId
         * @param {SaicrewMLVariables} saicrewMLVariables
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewMlVariablesCreate: function (nodeId, saicrewMLVariables, options) {
            return localVarFp.nodesSaicrewMlVariablesCreate(nodeId, saicrewMLVariables, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * SaiCrew-ML　Variables ViewSet.
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewMlVariablesDestroy: function (id, nodeId, options) {
            return localVarFp.nodesSaicrewMlVariablesDestroy(id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * SaiCrew-ML　Variables ViewSet.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewMlVariablesList: function (nodeId, options) {
            return localVarFp.nodesSaicrewMlVariablesList(nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * SaiCrew-ML　Variables ViewSet.
         * @param {string} id
         * @param {string} nodeId
         * @param {PatchedSaicrewMLVariables} [patchedSaicrewMLVariables]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewMlVariablesPartialUpdate: function (id, nodeId, patchedSaicrewMLVariables, options) {
            return localVarFp.nodesSaicrewMlVariablesPartialUpdate(id, nodeId, patchedSaicrewMLVariables, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * SaiCrew-ML　Variables ViewSet.
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewMlVariablesRetrieve: function (id, nodeId, options) {
            return localVarFp.nodesSaicrewMlVariablesRetrieve(id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * SaiCrew-ML　Variables ViewSet.
         * @param {string} id
         * @param {string} nodeId
         * @param {SaicrewMLVariables} saicrewMLVariables
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewMlVariablesUpdate: function (id, nodeId, saicrewMLVariables, options) {
            return localVarFp.nodesSaicrewMlVariablesUpdate(id, nodeId, saicrewMLVariables, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * SaiCrewAIモデル構築ジョブ承認
         * @param {string} gatewayId
         * @param {string} id
         * @param {string} modelId
         * @param {string} nodeId
         * @param {SaicrewAIModelBuildJobApprove} saicrewAIModelBuildJobApprove
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewModelsBuildJobsApproveCreate: function (gatewayId, id, modelId, nodeId, saicrewAIModelBuildJobApprove, options) {
            return localVarFp.nodesSaicrewModelsBuildJobsApproveCreate(gatewayId, id, modelId, nodeId, saicrewAIModelBuildJobApprove, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * SaiCrewAIバッチ推論 構築ジョブキャンセル
         * @param {string} gatewayId
         * @param {string} id
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewModelsBuildJobsBatchInferenceCancelCreate: function (gatewayId, id, jobId, modelId, nodeId, options) {
            return localVarFp.nodesSaicrewModelsBuildJobsBatchInferenceCancelCreate(gatewayId, id, jobId, modelId, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * SaiCrew-AIバッチ推論 構築ジョブ作成
         * @param {string} gatewayId
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {SaiCrewAIModelBatchInferenceJob} data
         * @param {any} [zipFile]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewModelsBuildJobsBatchInferenceCreate: function (gatewayId, jobId, modelId, nodeId, data, zipFile, options) {
            return localVarFp.nodesSaicrewModelsBuildJobsBatchInferenceCreate(gatewayId, jobId, modelId, nodeId, data, zipFile, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Saicrew-AIバッチ推論 構築ジョブ一覧
         * @param {string} gatewayId
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewModelsBuildJobsBatchInferenceList: function (gatewayId, jobId, modelId, nodeId, options) {
            return localVarFp.nodesSaicrewModelsBuildJobsBatchInferenceList(gatewayId, jobId, modelId, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Saicrew-AIバッチ推論 構築ジョブ詳細
         * @param {string} gatewayId
         * @param {string} id
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewModelsBuildJobsBatchInferenceRetrieve: function (gatewayId, id, jobId, modelId, nodeId, options) {
            return localVarFp.nodesSaicrewModelsBuildJobsBatchInferenceRetrieve(gatewayId, id, jobId, modelId, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * SaiCrewAIバッチ推論 構築ジョブ再試行
         * @param {string} gatewayId
         * @param {string} id
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewModelsBuildJobsBatchInferenceRetryCreate: function (gatewayId, id, jobId, modelId, nodeId, options) {
            return localVarFp.nodesSaicrewModelsBuildJobsBatchInferenceRetryCreate(gatewayId, id, jobId, modelId, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * SaiCrewAIモデル構築ジョブキャンセル
         * @param {string} gatewayId
         * @param {string} id
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewModelsBuildJobsCancelCreate: function (gatewayId, id, modelId, nodeId, options) {
            return localVarFp.nodesSaicrewModelsBuildJobsCancelCreate(gatewayId, id, modelId, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create comment.
         * @param {string} gatewayId
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {SaicrewAIModelBuildJobComment} saicrewAIModelBuildJobComment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewModelsBuildJobsCommentsCreate: function (gatewayId, jobId, modelId, nodeId, saicrewAIModelBuildJobComment, options) {
            return localVarFp.nodesSaicrewModelsBuildJobsCommentsCreate(gatewayId, jobId, modelId, nodeId, saicrewAIModelBuildJobComment, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete comment
         * @param {string} gatewayId
         * @param {number} id A unique integer value identifying this t_saicrew_ai_model_build_job_comment.
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewModelsBuildJobsCommentsDestroy: function (gatewayId, id, jobId, modelId, nodeId, options) {
            return localVarFp.nodesSaicrewModelsBuildJobsCommentsDestroy(gatewayId, id, jobId, modelId, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns list of comments.
         * @param {string} gatewayId
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewModelsBuildJobsCommentsList: function (gatewayId, jobId, modelId, nodeId, options) {
            return localVarFp.nodesSaicrewModelsBuildJobsCommentsList(gatewayId, jobId, modelId, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * カメラAIモデル構築ジョブコメント
         * @param {string} gatewayId
         * @param {number} id A unique integer value identifying this t_saicrew_ai_model_build_job_comment.
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {PatchedSaicrewAIModelBuildJobComment} [patchedSaicrewAIModelBuildJobComment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewModelsBuildJobsCommentsPartialUpdate: function (gatewayId, id, jobId, modelId, nodeId, patchedSaicrewAIModelBuildJobComment, options) {
            return localVarFp.nodesSaicrewModelsBuildJobsCommentsPartialUpdate(gatewayId, id, jobId, modelId, nodeId, patchedSaicrewAIModelBuildJobComment, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * カメラAIモデル構築ジョブコメント
         * @param {string} gatewayId
         * @param {number} id A unique integer value identifying this t_saicrew_ai_model_build_job_comment.
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewModelsBuildJobsCommentsRetrieve: function (gatewayId, id, jobId, modelId, nodeId, options) {
            return localVarFp.nodesSaicrewModelsBuildJobsCommentsRetrieve(gatewayId, id, jobId, modelId, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update comment.
         * @param {string} gatewayId
         * @param {number} id A unique integer value identifying this t_saicrew_ai_model_build_job_comment.
         * @param {string} jobId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {SaicrewAIModelBuildJobComment} saicrewAIModelBuildJobComment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewModelsBuildJobsCommentsUpdate: function (gatewayId, id, jobId, modelId, nodeId, saicrewAIModelBuildJobComment, options) {
            return localVarFp.nodesSaicrewModelsBuildJobsCommentsUpdate(gatewayId, id, jobId, modelId, nodeId, saicrewAIModelBuildJobComment, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * SaiCrew-AIモデル構築ジョブ作成
         * @param {string} gatewayId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {SaicrewAIModelBuildJob} data
         * @param {any} [zipFile]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewModelsBuildJobsCreate: function (gatewayId, modelId, nodeId, data, zipFile, options) {
            return localVarFp.nodesSaicrewModelsBuildJobsCreate(gatewayId, modelId, nodeId, data, zipFile, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Saicrew-AIモデル構築ジョブ一覧
         * @param {string} gatewayId
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewModelsBuildJobsList: function (gatewayId, modelId, nodeId, options) {
            return localVarFp.nodesSaicrewModelsBuildJobsList(gatewayId, modelId, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Saicrew-AIAIモデル構築ジョブ詳細
         * @param {string} gatewayId
         * @param {string} id
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewModelsBuildJobsRetrieve: function (gatewayId, id, modelId, nodeId, options) {
            return localVarFp.nodesSaicrewModelsBuildJobsRetrieve(gatewayId, id, modelId, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * SaiCrewAIモデル構築ジョブ再試行
         * @param {string} gatewayId
         * @param {string} id
         * @param {string} modelId
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaicrewModelsBuildJobsRetryCreate: function (gatewayId, id, modelId, nodeId, options) {
            return localVarFp.nodesSaicrewModelsBuildJobsRetryCreate(gatewayId, id, modelId, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * SaiForce 演算設定追加
         * @param {string} nodeId
         * @param {SaiforceCalculationSettings} saiforceCalculationSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaiforceCalculationSettingsCreate: function (nodeId, saiforceCalculationSettings, options) {
            return localVarFp.nodesSaiforceCalculationSettingsCreate(nodeId, saiforceCalculationSettings, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * SaiForce 演算設定削除
         * @param {number} id dataset_id
         * @param {number} nodeId 設備 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaiforceCalculationSettingsDestroy: function (id, nodeId, options) {
            return localVarFp.nodesSaiforceCalculationSettingsDestroy(id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * SaiForce 演算設定一覧
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSaiforceCalculationSettingsList: function (nodeId, options) {
            return localVarFp.nodesSaiforceCalculationSettingsList(nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ゲートウェイ定周期通信異常判定
         * @param {string} nodeId
         * @param {number} timeFrom 取得期間（開始）
         * @param {number} timeTo 取得期間（終了）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSysalartHistoryJudgementRetrieve: function (nodeId, timeFrom, timeTo, options) {
            return localVarFp.nodesSysalartHistoryJudgementRetrieve(nodeId, timeFrom, timeTo, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ゲートウェイ定周期通信異常情報取得
         * @param {string} nodeId
         * @param {number} timeFrom 取得期間（開始）
         * @param {number} timeTo 取得期間（終了）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesSysalartHistoryList: function (nodeId, timeFrom, timeTo, options) {
            return localVarFp.nodesSysalartHistoryList(nodeId, timeFrom, timeTo, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * テクニカルレポートステータス
         * @param {string} nodeId
         * @param {boolean} [includeDescendants] 子孫のデータセットを含むか
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTechnicalReportStatusList: function (nodeId, includeDescendants, options) {
            return localVarFp.nodesTechnicalReportStatusList(nodeId, includeDescendants, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} nodeId
         * @param {string} technicalReportId
         * @param {TechnicalReportAttachments} [technicalReportAttachments]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTechnicalReportsAttachmentsCreate: function (nodeId, technicalReportId, technicalReportAttachments, options) {
            return localVarFp.nodesTechnicalReportsAttachmentsCreate(nodeId, technicalReportId, technicalReportAttachments, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this t_technical_report.
         * @param {string} nodeId
         * @param {string} technicalReportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTechnicalReportsAttachmentsDestroy: function (id, nodeId, technicalReportId, options) {
            return localVarFp.nodesTechnicalReportsAttachmentsDestroy(id, nodeId, technicalReportId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} nodeId
         * @param {string} technicalReportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTechnicalReportsAttachmentsList: function (nodeId, technicalReportId, options) {
            return localVarFp.nodesTechnicalReportsAttachmentsList(nodeId, technicalReportId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this t_technical_report.
         * @param {string} nodeId
         * @param {string} technicalReportId
         * @param {PatchedTechnicalReportAttachments} [patchedTechnicalReportAttachments]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTechnicalReportsAttachmentsPartialUpdate: function (id, nodeId, technicalReportId, patchedTechnicalReportAttachments, options) {
            return localVarFp.nodesTechnicalReportsAttachmentsPartialUpdate(id, nodeId, technicalReportId, patchedTechnicalReportAttachments, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * テクニカルレポート添付ファイル取得
         * @param {number} id A unique integer value identifying this t_technical_report.
         * @param {string} nodeId
         * @param {string} technicalReportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTechnicalReportsAttachmentsRetrieve: function (id, nodeId, technicalReportId, options) {
            return localVarFp.nodesTechnicalReportsAttachmentsRetrieve(id, nodeId, technicalReportId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this t_technical_report.
         * @param {string} nodeId
         * @param {string} technicalReportId
         * @param {TechnicalReportAttachments} [technicalReportAttachments]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTechnicalReportsAttachmentsUpdate: function (id, nodeId, technicalReportId, technicalReportAttachments, options) {
            return localVarFp.nodesTechnicalReportsAttachmentsUpdate(id, nodeId, technicalReportId, technicalReportAttachments, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * テクニカルレポート追加
         * @param {string} nodeId
         * @param {TechnicalReportRequest} technicalReportRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTechnicalReportsCreate: function (nodeId, technicalReportRequest, options) {
            return localVarFp.nodesTechnicalReportsCreate(nodeId, technicalReportRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * テクニカルレポート削除
         * @param {number} id A unique integer value identifying this t_technical_report.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTechnicalReportsDestroy: function (id, nodeId, options) {
            return localVarFp.nodesTechnicalReportsDestroy(id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * テクニカルレポート API
         * @param {string} dateFrom 取得期間（開始）
         * @param {string} dateTo 取得期間（終了）
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTechnicalReportsList: function (dateFrom, dateTo, nodeId, options) {
            return localVarFp.nodesTechnicalReportsList(dateFrom, dateTo, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * テクニカルレポート更新（一部）
         * @param {number} id A unique integer value identifying this t_technical_report.
         * @param {string} nodeId
         * @param {PatchedTechnicalReportRequest} [patchedTechnicalReportRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTechnicalReportsPartialUpdate: function (id, nodeId, patchedTechnicalReportRequest, options) {
            return localVarFp.nodesTechnicalReportsPartialUpdate(id, nodeId, patchedTechnicalReportRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * テクニカルレポート詳細取得
         * @param {number} id A unique integer value identifying this t_technical_report.
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTechnicalReportsRetrieve: function (id, nodeId, options) {
            return localVarFp.nodesTechnicalReportsRetrieve(id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id A unique integer value identifying this t_technical_report.
         * @param {string} nodeId
         * @param {TechnicalReport} technicalReport
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTechnicalReportsUpdate: function (id, nodeId, technicalReport, options) {
            return localVarFp.nodesTechnicalReportsUpdate(id, nodeId, technicalReport, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} nodeId
         * @param {TotalUploadedDocumentSize} totalUploadedDocumentSize
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTotalUploadedDocumentSizeCreate: function (nodeId, totalUploadedDocumentSize, options) {
            return localVarFp.nodesTotalUploadedDocumentSizeCreate(nodeId, totalUploadedDocumentSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTotalUploadedDocumentSizeDestroy: function (id, nodeId, options) {
            return localVarFp.nodesTotalUploadedDocumentSizeDestroy(id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * アップロードされた全ドキュメントのルート階層単位でのサイズ取得
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTotalUploadedDocumentSizeList: function (nodeId, options) {
            return localVarFp.nodesTotalUploadedDocumentSizeList(nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {string} nodeId
         * @param {PatchedTotalUploadedDocumentSize} [patchedTotalUploadedDocumentSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTotalUploadedDocumentSizePartialUpdate: function (id, nodeId, patchedTotalUploadedDocumentSize, options) {
            return localVarFp.nodesTotalUploadedDocumentSizePartialUpdate(id, nodeId, patchedTotalUploadedDocumentSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {string} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTotalUploadedDocumentSizeRetrieve: function (id, nodeId, options) {
            return localVarFp.nodesTotalUploadedDocumentSizeRetrieve(id, nodeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {string} nodeId
         * @param {TotalUploadedDocumentSize} totalUploadedDocumentSize
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodesTotalUploadedDocumentSizeUpdate: function (id, nodeId, totalUploadedDocumentSize, options) {
            return localVarFp.nodesTotalUploadedDocumentSizeUpdate(id, nodeId, totalUploadedDocumentSize, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.NodesApiFactory = NodesApiFactory;
/**
 * NodesApi - object-oriented interface
 * @export
 * @class NodesApi
 * @extends {BaseAPI}
 */
var NodesApi = /** @class */ (function (_super) {
    __extends(NodesApi, _super);
    function NodesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 警報履歴取得
     * @param {string} nodeId
     * @param {number} timeFrom 取得期間（開始）
     * @param {number} timeTo 取得期間（終了）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesAlarmHistoryList = function (nodeId, timeFrom, timeTo, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesAlarmHistoryList(nodeId, timeFrom, timeTo, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns list of algorithms.
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesCameraAiAlgorithmsList = function (nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesCameraAiAlgorithmsList(nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns algorithm.
     * @param {string} id
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesCameraAiAlgorithmsRetrieve = function (id, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesCameraAiAlgorithmsRetrieve(id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns algorithm.
     * @param {string} algorithmName
     * @param {string} id
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesCameraAiAlgorithmsVersionsRetrieve = function (algorithmName, id, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesCameraAiAlgorithmsVersionsRetrieve(algorithmName, id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * カメラAIモデル追加
     * @param {string} nodeId
     * @param {CameraAIModel} cameraAIModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesCameraAiModelsCreate = function (nodeId, cameraAIModel, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesCameraAiModelsCreate(nodeId, cameraAIModel, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * カメラAIモデル削除
     * @param {number} id A unique integer value identifying this m_camera_ai_model.
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesCameraAiModelsDestroy = function (id, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesCameraAiModelsDestroy(id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 最新MLPipelineID
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesCameraAiModelsLatestPipelineIdRetrieve = function (nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesCameraAiModelsLatestPipelineIdRetrieve(nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * カメラ一AIモデル覧取得
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesCameraAiModelsList = function (nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesCameraAiModelsList(nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * カメラAIモデル更新（一部）
     * @param {number} id A unique integer value identifying this m_camera_ai_model.
     * @param {string} nodeId
     * @param {PatchedCameraAIModel} [patchedCameraAIModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesCameraAiModelsPartialUpdate = function (id, nodeId, patchedCameraAIModel, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesCameraAiModelsPartialUpdate(id, nodeId, patchedCameraAIModel, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * カメラAIモデル詳細取得
     * @param {number} id A unique integer value identifying this m_camera_ai_model.
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesCameraAiModelsRetrieve = function (id, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesCameraAiModelsRetrieve(id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * カメラAIモデル更新
     * @param {number} id A unique integer value identifying this m_camera_ai_model.
     * @param {string} nodeId
     * @param {CameraAIModel} cameraAIModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesCameraAiModelsUpdate = function (id, nodeId, cameraAIModel, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesCameraAiModelsUpdate(id, nodeId, cameraAIModel, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * カメラThingデプロイ承認
     * @param {string} id
     * @param {string} nodeId
     * @param {string} thingName
     * @param {CameraThingDeploymentApprove} cameraThingDeploymentApprove
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesCameraThingsDeploymentsApproveCreate = function (id, nodeId, thingName, cameraThingDeploymentApprove, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesCameraThingsDeploymentsApproveCreate(id, nodeId, thingName, cameraThingDeploymentApprove, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * カメラThingデプロイキャンセル
     * @param {string} id
     * @param {string} nodeId
     * @param {string} thingName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesCameraThingsDeploymentsCancelCreate = function (id, nodeId, thingName, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesCameraThingsDeploymentsCancelCreate(id, nodeId, thingName, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * カメラThingデプロイ作成
     * @param {string} nodeId
     * @param {string} thingName
     * @param {CameraThingDeployment} cameraThingDeployment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesCameraThingsDeploymentsCreate = function (nodeId, thingName, cameraThingDeployment, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesCameraThingsDeploymentsCreate(nodeId, thingName, cameraThingDeployment, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * カメラThingデプロイ設定
     * @param {string} nodeId
     * @param {string} thingName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesCameraThingsDeploymentsCurrentRetrieve = function (nodeId, thingName, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesCameraThingsDeploymentsCurrentRetrieve(nodeId, thingName, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * カメラThingデプロイ一覧
     * @param {string} nodeId
     * @param {string} thingName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesCameraThingsDeploymentsList = function (nodeId, thingName, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesCameraThingsDeploymentsList(nodeId, thingName, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * カメラThingデプロイ詳細
     * @param {string} id
     * @param {string} nodeId
     * @param {string} thingName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesCameraThingsDeploymentsRetrieve = function (id, nodeId, thingName, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesCameraThingsDeploymentsRetrieve(id, nodeId, thingName, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * カメラThingデプロイ再試行
     * @param {string} id
     * @param {string} nodeId
     * @param {string} thingName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesCameraThingsDeploymentsRetryCreate = function (id, nodeId, thingName, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesCameraThingsDeploymentsRetryCreate(id, nodeId, thingName, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 環境取得
     * @param {string} id
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesCameraThingsEnvironmentRetrieve = function (id, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesCameraThingsEnvironmentRetrieve(id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * カメラThing
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesCameraThingsList = function (nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesCameraThingsList(nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * カメラThing
     * @param {string} id
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesCameraThingsRetrieve = function (id, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesCameraThingsRetrieve(id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * カメラAIモデル構築ジョブ承認
     * @param {string} cameraId
     * @param {string} id
     * @param {string} modelId
     * @param {string} nodeId
     * @param {CameraAIModelBuildJobApprove} cameraAIModelBuildJobApprove
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesCamerasModelsBuildJobsApproveCreate = function (cameraId, id, modelId, nodeId, cameraAIModelBuildJobApprove, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesCamerasModelsBuildJobsApproveCreate(cameraId, id, modelId, nodeId, cameraAIModelBuildJobApprove, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * カメラAIモデル構築ジョブキャンセル
     * @param {string} cameraId
     * @param {string} id
     * @param {string} modelId
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesCamerasModelsBuildJobsCancelCreate = function (cameraId, id, modelId, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesCamerasModelsBuildJobsCancelCreate(cameraId, id, modelId, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create comment.
     * @param {string} cameraId
     * @param {string} jobId
     * @param {string} modelId
     * @param {string} nodeId
     * @param {CameraAIModelBuildJobComment} cameraAIModelBuildJobComment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesCamerasModelsBuildJobsCommentsCreate = function (cameraId, jobId, modelId, nodeId, cameraAIModelBuildJobComment, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesCamerasModelsBuildJobsCommentsCreate(cameraId, jobId, modelId, nodeId, cameraAIModelBuildJobComment, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete comment
     * @param {string} cameraId
     * @param {number} id A unique integer value identifying this t_camera_ai_model_build_job_comment.
     * @param {string} jobId
     * @param {string} modelId
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesCamerasModelsBuildJobsCommentsDestroy = function (cameraId, id, jobId, modelId, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesCamerasModelsBuildJobsCommentsDestroy(cameraId, id, jobId, modelId, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns list of comments.
     * @param {string} cameraId
     * @param {string} jobId
     * @param {string} modelId
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesCamerasModelsBuildJobsCommentsList = function (cameraId, jobId, modelId, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesCamerasModelsBuildJobsCommentsList(cameraId, jobId, modelId, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * カメラAIモデル構築ジョブコメント
     * @param {string} cameraId
     * @param {number} id A unique integer value identifying this t_camera_ai_model_build_job_comment.
     * @param {string} jobId
     * @param {string} modelId
     * @param {string} nodeId
     * @param {PatchedCameraAIModelBuildJobComment} [patchedCameraAIModelBuildJobComment]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesCamerasModelsBuildJobsCommentsPartialUpdate = function (cameraId, id, jobId, modelId, nodeId, patchedCameraAIModelBuildJobComment, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesCamerasModelsBuildJobsCommentsPartialUpdate(cameraId, id, jobId, modelId, nodeId, patchedCameraAIModelBuildJobComment, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * カメラAIモデル構築ジョブコメント
     * @param {string} cameraId
     * @param {number} id A unique integer value identifying this t_camera_ai_model_build_job_comment.
     * @param {string} jobId
     * @param {string} modelId
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesCamerasModelsBuildJobsCommentsRetrieve = function (cameraId, id, jobId, modelId, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesCamerasModelsBuildJobsCommentsRetrieve(cameraId, id, jobId, modelId, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update comment.
     * @param {string} cameraId
     * @param {number} id A unique integer value identifying this t_camera_ai_model_build_job_comment.
     * @param {string} jobId
     * @param {string} modelId
     * @param {string} nodeId
     * @param {CameraAIModelBuildJobComment} cameraAIModelBuildJobComment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesCamerasModelsBuildJobsCommentsUpdate = function (cameraId, id, jobId, modelId, nodeId, cameraAIModelBuildJobComment, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesCamerasModelsBuildJobsCommentsUpdate(cameraId, id, jobId, modelId, nodeId, cameraAIModelBuildJobComment, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * カメラAIモデル構築ジョブ作成
     * @param {string} cameraId
     * @param {string} modelId
     * @param {string} nodeId
     * @param {CameraAIModelBuildJob} data
     * @param {any} [zipFile]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesCamerasModelsBuildJobsCreate = function (cameraId, modelId, nodeId, data, zipFile, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesCamerasModelsBuildJobsCreate(cameraId, modelId, nodeId, data, zipFile, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns list of images.
     * @param {string} cameraId
     * @param {string} jobId
     * @param {string} modelId
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesCamerasModelsBuildJobsImagesList = function (cameraId, jobId, modelId, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesCamerasModelsBuildJobsImagesList(cameraId, jobId, modelId, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 画像取得
     * @param {string} cameraId
     * @param {string} id
     * @param {string} jobId
     * @param {string} modelId
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesCamerasModelsBuildJobsImagesRetrieve = function (cameraId, id, jobId, modelId, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesCamerasModelsBuildJobsImagesRetrieve(cameraId, id, jobId, modelId, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * カメラAIモデル構築ジョブ一覧
     * @param {string} cameraId
     * @param {string} modelId
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesCamerasModelsBuildJobsList = function (cameraId, modelId, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesCamerasModelsBuildJobsList(cameraId, modelId, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * カメラAIモデル構築ジョブ評価結果
     * @param {string} cameraId
     * @param {string} id
     * @param {string} modelId
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesCamerasModelsBuildJobsResultRetrieve = function (cameraId, id, modelId, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesCamerasModelsBuildJobsResultRetrieve(cameraId, id, modelId, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * カメラAIモデル構築ジョブ詳細
     * @param {string} cameraId
     * @param {string} id
     * @param {string} modelId
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesCamerasModelsBuildJobsRetrieve = function (cameraId, id, modelId, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesCamerasModelsBuildJobsRetrieve(cameraId, id, modelId, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * カメラAIモデル構築ジョブ再試行
     * @param {string} cameraId
     * @param {string} id
     * @param {string} modelId
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesCamerasModelsBuildJobsRetryCreate = function (cameraId, id, modelId, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesCamerasModelsBuildJobsRetryCreate(cameraId, id, modelId, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * カメラAIモデル構築ジョブ詳細
     * @param {string} cameraId
     * @param {string} id
     * @param {string} modelId
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesCamerasModelsBuildJobsStateRetrieve = function (cameraId, id, modelId, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesCamerasModelsBuildJobsStateRetrieve(cameraId, id, modelId, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 帳票データ修正
     * @param {string} nodeId
     * @param {ChouhyoEdit} chouhyoEdit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesChouhyoEditCreate = function (nodeId, chouhyoEdit, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesChouhyoEditCreate(nodeId, chouhyoEdit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} nodeId
     * @param {ChouhyoOutput} chouhyoOutput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesChouhyoOutputCreate = function (nodeId, chouhyoOutput, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesChouhyoOutputCreate(nodeId, chouhyoOutput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesChouhyoOutputDestroy = function (id, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesChouhyoOutputDestroy(id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 帳票取得 API
     * @param {number} id 帳票ID
     * @param {string} nodeId
     * @param {number} timestamp 対象日付
     * @param {string} type 帳票種別（日報(D)/月報(M)/年報(Y)）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesChouhyoOutputList = function (id, nodeId, timestamp, type, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesChouhyoOutputList(id, nodeId, timestamp, type, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {string} nodeId
     * @param {PatchedChouhyoOutput} [patchedChouhyoOutput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesChouhyoOutputPartialUpdate = function (id, nodeId, patchedChouhyoOutput, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesChouhyoOutputPartialUpdate(id, nodeId, patchedChouhyoOutput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesChouhyoOutputRetrieve = function (id, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesChouhyoOutputRetrieve(id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} nodeId
     * @param {ChouhyoOutputSetting} chouhyoOutputSetting
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesChouhyoOutputSettingCreate = function (nodeId, chouhyoOutputSetting, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesChouhyoOutputSettingCreate(nodeId, chouhyoOutputSetting, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id A unique integer value identifying this m_chouhyo_output_setting.
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesChouhyoOutputSettingDestroy = function (id, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesChouhyoOutputSettingDestroy(id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesChouhyoOutputSettingList = function (nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesChouhyoOutputSettingList(nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id A unique integer value identifying this m_chouhyo_output_setting.
     * @param {string} nodeId
     * @param {PatchedChouhyoOutputSetting} [patchedChouhyoOutputSetting]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesChouhyoOutputSettingPartialUpdate = function (id, nodeId, patchedChouhyoOutputSetting, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesChouhyoOutputSettingPartialUpdate(id, nodeId, patchedChouhyoOutputSetting, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id A unique integer value identifying this m_chouhyo_output_setting.
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesChouhyoOutputSettingRetrieve = function (id, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesChouhyoOutputSettingRetrieve(id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id A unique integer value identifying this m_chouhyo_output_setting.
     * @param {string} nodeId
     * @param {ChouhyoOutputSetting} chouhyoOutputSetting
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesChouhyoOutputSettingUpdate = function (id, nodeId, chouhyoOutputSetting, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesChouhyoOutputSettingUpdate(id, nodeId, chouhyoOutputSetting, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {string} nodeId
     * @param {ChouhyoOutput} chouhyoOutput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesChouhyoOutputUpdate = function (id, nodeId, chouhyoOutput, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesChouhyoOutputUpdate(id, nodeId, chouhyoOutput, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ダッシュボード設定追加
     * @param {string} nodeId
     * @param {DashboardSetting} dashboardSetting
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesDashboardSettingsCreate = function (nodeId, dashboardSetting, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesDashboardSettingsCreate(nodeId, dashboardSetting, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ダッシュボード設定 API
     * @param {string} id
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesDashboardSettingsDestroy = function (id, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesDashboardSettingsDestroy(id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ダッシュボード設定一覧
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesDashboardSettingsList = function (nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesDashboardSettingsList(nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ダッシュボード設定 API
     * @param {string} id
     * @param {string} nodeId
     * @param {PatchedDashboardSetting} [patchedDashboardSetting]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesDashboardSettingsPartialUpdate = function (id, nodeId, patchedDashboardSetting, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesDashboardSettingsPartialUpdate(id, nodeId, patchedDashboardSetting, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ダッシュボード設定 API
     * @param {string} id
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesDashboardSettingsRetrieve = function (id, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesDashboardSettingsRetrieve(id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ダッシュボード設定 API
     * @param {string} id
     * @param {string} nodeId
     * @param {DashboardSetting} dashboardSetting
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesDashboardSettingsUpdate = function (id, nodeId, dashboardSetting, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesDashboardSettingsUpdate(id, nodeId, dashboardSetting, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 連続時間積算履歴取得
     * @param {string} datasetId
     * @param {string} nodeId
     * @param {number} timeFrom 取得期間（開始）
     * @param {number} timeTo 取得期間（終了）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesDatasetsContinuousTotalHistoryList = function (datasetId, nodeId, timeFrom, timeTo, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesDatasetsContinuousTotalHistoryList(datasetId, nodeId, timeFrom, timeTo, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * データ項目の設定
     * @param {string} datasetId
     * @param {string} nodeId
     * @param {Array<FieldSettings>} fieldSettings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesDatasetsFieldSettingsCreate = function (datasetId, nodeId, fieldSettings, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesDatasetsFieldSettingsCreate(datasetId, nodeId, fieldSettings, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * データ設定項目の取得
     * @param {string} datasetId
     * @param {string} nodeId
     * @param {string} [fieldNames] フィールド名
     * @param {string} [fieldTypes] フィールドタイプ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesDatasetsFieldSettingsList = function (datasetId, nodeId, fieldNames, fieldTypes, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesDatasetsFieldSettingsList(datasetId, nodeId, fieldNames, fieldTypes, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 画像ダウンロード
     * @param {string} datasetId
     * @param {string} nodeId
     * @param {ImageDownloadRequest} imageDownloadRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesDatasetsImagesDownloadCreate = function (datasetId, nodeId, imageDownloadRequest, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesDatasetsImagesDownloadCreate(datasetId, nodeId, imageDownloadRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 最新画像取得
     * @param {string} datasetId
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesDatasetsImagesLatestRetrieve = function (datasetId, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesDatasetsImagesLatestRetrieve(datasetId, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 画像一覧取得
     * @param {string} datasetId
     * @param {string} nodeId
     * @param {number} [timeFrom] 取得期間（開始）
     * @param {number} [timeTo] 取得期間（終了）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesDatasetsImagesList = function (datasetId, nodeId, timeFrom, timeTo, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesDatasetsImagesList(datasetId, nodeId, timeFrom, timeTo, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 画像取得
     * @param {string} datasetId
     * @param {string} id
     * @param {string} nodeId
     * @param {boolean} [lowQuality] 低画質
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesDatasetsImagesRetrieve = function (datasetId, id, nodeId, lowQuality, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesDatasetsImagesRetrieve(datasetId, id, nodeId, lowQuality, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ラベル一括変更
     * @param {string} datasetId
     * @param {string} modelName
     * @param {string} nodeId
     * @param {Array<GroundTruthWithIdPutRequest>} groundTruthWithIdPutRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesDatasetsModelsGroundTruthsBulkUpdate = function (datasetId, modelName, nodeId, groundTruthWithIdPutRequest, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesDatasetsModelsGroundTruthsBulkUpdate(datasetId, modelName, nodeId, groundTruthWithIdPutRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ラベル一覧取得
     * @param {string} datasetId
     * @param {string} modelName
     * @param {string} nodeId
     * @param {number} [timeFrom] 取得期間（開始）
     * @param {number} [timeTo] 取得期間（終了）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesDatasetsModelsGroundTruthsList = function (datasetId, modelName, nodeId, timeFrom, timeTo, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesDatasetsModelsGroundTruthsList(datasetId, modelName, nodeId, timeFrom, timeTo, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ラベル変更
     * @param {string} datasetId
     * @param {string} id
     * @param {string} modelName
     * @param {string} nodeId
     * @param {GroundTruthPutRequest} groundTruthPutRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesDatasetsModelsGroundTruthsUpdate = function (datasetId, id, modelName, nodeId, groundTruthPutRequest, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesDatasetsModelsGroundTruthsUpdate(datasetId, id, modelName, nodeId, groundTruthPutRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 移動平均時間の設定
     * @param {string} datasetId
     * @param {string} nodeId
     * @param {Array<MonitoringTransformSettings>} monitoringTransformSettings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesDatasetsMonitoringTransformSettingsCreate = function (datasetId, nodeId, monitoringTransformSettings, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesDatasetsMonitoringTransformSettingsCreate(datasetId, nodeId, monitoringTransformSettings, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 移動平均時間の取得
     * @param {string} datasetId
     * @param {string} nodeId
     * @param {string} [fieldNames] フィールド名
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesDatasetsMonitoringTransformSettingsList = function (datasetId, nodeId, fieldNames, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesDatasetsMonitoringTransformSettingsList(datasetId, nodeId, fieldNames, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 定周期通信異常通知先設定（メール通知）
     * @param {string} datasetId
     * @param {string} nodeId
     * @param {NotificationDataarrivalMailSettings} notificationDataarrivalMailSettings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesDatasetsNotificationDataarrivalMailSettingsCreate = function (datasetId, nodeId, notificationDataarrivalMailSettings, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesDatasetsNotificationDataarrivalMailSettingsCreate(datasetId, nodeId, notificationDataarrivalMailSettings, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 定周期通信異常通知先設定（パトランプ通知）
     * @param {string} datasetId
     * @param {string} nodeId
     * @param {NotificationDataarrivalPatliteSettings} notificationDataarrivalPatliteSettings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesDatasetsNotificationDataarrivalPatliteSettingsCreate = function (datasetId, nodeId, notificationDataarrivalPatliteSettings, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesDatasetsNotificationDataarrivalPatliteSettingsCreate(datasetId, nodeId, notificationDataarrivalPatliteSettings, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 定周期通信異常通知先設定（パトランプ通知） API
     * @param {string} datasetId
     * @param {string} id
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesDatasetsNotificationDataarrivalPatliteSettingsDestroy = function (datasetId, id, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesDatasetsNotificationDataarrivalPatliteSettingsDestroy(datasetId, id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 定周期通信異常通知先設定（パトランプ通知） API
     * @param {string} datasetId
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesDatasetsNotificationDataarrivalPatliteSettingsList = function (datasetId, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesDatasetsNotificationDataarrivalPatliteSettingsList(datasetId, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 遠隔操作設定
     * @param {string} datasetId
     * @param {string} nodeId
     * @param {RemoteControl} remoteControl
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesDatasetsRemoteControlCreate = function (datasetId, nodeId, remoteControl, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesDatasetsRemoteControlCreate(datasetId, nodeId, remoteControl, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 遠隔操作フェースプレート API
     * @param {string} datasetId
     * @param {string} gateway ゲートウェイ
     * @param {string} nodeId
     * @param {string} tags 状態取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesDatasetsRemoteControlList = function (datasetId, gateway, nodeId, tags, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesDatasetsRemoteControlList(datasetId, gateway, nodeId, tags, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 最新データ要求 TODO 一旦、`設計者`以上で。`監視者`以上にするなら、node_a_viewsに移動
     * @param {string} datasetId
     * @param {string} nodeId
     * @param {RemoteControl} remoteControl
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesDatasetsRemoteControlRecentDataCreate = function (datasetId, nodeId, remoteControl, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesDatasetsRemoteControlRecentDataCreate(datasetId, nodeId, remoteControl, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 集計単位取得API
     * @param {string} datasetId
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesDatasetsResampledSummariesList = function (datasetId, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesDatasetsResampledSummariesList(datasetId, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 積算値リセット
     * @param {string} datasetId
     * @param {string} nodeId
     * @param {ResetAddup} resetAddup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesDatasetsResetAddupCreate = function (datasetId, nodeId, resetAddup, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesDatasetsResetAddupCreate(datasetId, nodeId, resetAddup, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ニアリアルタイムデータ取得
     * @param {string} id データセット ID
     * @param {string} nodeId
     * @param {number} timeFrom 取得期間（開始）
     * @param {number} timeTo 取得期間（終了）
     * @param {string} [fieldNames] 取得カラム
     * @param {string} [fieldTypes] 取得カラム型
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesDatasetsRetrieve = function (id, nodeId, timeFrom, timeTo, fieldNames, fieldTypes, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesDatasetsRetrieve(id, nodeId, timeFrom, timeTo, fieldNames, fieldTypes, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * SaiCrew-ML フィールド
     * @param {string} datasetId
     * @param {string} nodeId
     * @param {SaicrewMlFields} [saicrewMlFields]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesDatasetsSaicrewMlFieldsCreate = function (datasetId, nodeId, saicrewMlFields, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesDatasetsSaicrewMlFieldsCreate(datasetId, nodeId, saicrewMlFields, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * SaiCrew-ML フィールド
     * @param {string} datasetId
     * @param {string} id
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesDatasetsSaicrewMlFieldsDestroy = function (datasetId, id, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesDatasetsSaicrewMlFieldsDestroy(datasetId, id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * SaiCrew-ML フィールド
     * @param {string} datasetId
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesDatasetsSaicrewMlFieldsList = function (datasetId, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesDatasetsSaicrewMlFieldsList(datasetId, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * SaiCrew-ML フィールド
     * @param {string} datasetId
     * @param {string} id
     * @param {string} nodeId
     * @param {PatchedSaicrewMlFields} [patchedSaicrewMlFields]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesDatasetsSaicrewMlFieldsPartialUpdate = function (datasetId, id, nodeId, patchedSaicrewMlFields, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesDatasetsSaicrewMlFieldsPartialUpdate(datasetId, id, nodeId, patchedSaicrewMlFields, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * SaiCrew-ML フィールド
     * @param {string} datasetId
     * @param {string} id
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesDatasetsSaicrewMlFieldsRetrieve = function (datasetId, id, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesDatasetsSaicrewMlFieldsRetrieve(datasetId, id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * SaiCrew-ML フィールド
     * @param {string} datasetId
     * @param {string} id
     * @param {string} nodeId
     * @param {SaicrewMlFields} [saicrewMlFields]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesDatasetsSaicrewMlFieldsUpdate = function (datasetId, id, nodeId, saicrewMlFields, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesDatasetsSaicrewMlFieldsUpdate(datasetId, id, nodeId, saicrewMlFields, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * アップロード CSV
     * @param {string} datasetId
     * @param {string} nodeId
     * @param {UploadCsvRequest} uploadCsvRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesDatasetsUploadsCreate = function (datasetId, nodeId, uploadCsvRequest, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesDatasetsUploadsCreate(datasetId, nodeId, uploadCsvRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * CSV アップロード用フォーマットダウンロード
     * @param {string} datasetId
     * @param {string} formatType フォーマット種別
     * @param {string} nodeId
     * @param {number} [timeFrom] 取得期間（開始）
     * @param {number} [timeTo] 取得期間（終了）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesDatasetsUploadsFormatRetrieve = function (datasetId, formatType, nodeId, timeFrom, timeTo, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesDatasetsUploadsFormatRetrieve(datasetId, formatType, nodeId, timeFrom, timeTo, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * アップロード履歴一覧取得
     * @param {string} datasetId
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesDatasetsUploadsHistoryList = function (datasetId, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesDatasetsUploadsHistoryList(datasetId, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * アップロードされた CSV データの処理を開始する API
     * @param {string} datasetId
     * @param {string} nodeId
     * @param {ProcessUploadedCsvRequest} processUploadedCsvRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesDatasetsUploadsProcessUploadedCsvCreate = function (datasetId, nodeId, processUploadedCsvRequest, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesDatasetsUploadsProcessUploadedCsvCreate(datasetId, nodeId, processUploadedCsvRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ドキュメント追加
     * @param {string} nodeId
     * @param {DocumentCreate} documentCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesDocumentsCreate = function (nodeId, documentCreate, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesDocumentsCreate(nodeId, documentCreate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ドキュメント削除
     * @param {string} id
     * @param {string} nodeId
     * @param {string} prefix 削除するドキュメントのパス
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesDocumentsDestroy = function (id, nodeId, prefix, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesDocumentsDestroy(id, nodeId, prefix, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ドキュメント一覧取得
     * @param {string} nodeId
     * @param {string} [prefix] 取得対象のパス
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesDocumentsList = function (nodeId, prefix, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesDocumentsList(nodeId, prefix, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ドキュメント取得
     * @param {string} id
     * @param {string} nodeId
     * @param {string} prefix 取得するドキュメントのパス
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesDocumentsRetrieve = function (id, nodeId, prefix, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesDocumentsRetrieve(id, nodeId, prefix, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ドキュメント更新
     * @param {string} id
     * @param {string} nodeId
     * @param {DocumentUpdate} documentUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesDocumentsUpdate = function (id, nodeId, documentUpdate, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesDocumentsUpdate(id, nodeId, documentUpdate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * CSV ダウンロード API
     * @param {string} nodeId
     * @param {number} timeFrom 取得期間（開始）
     * @param {number} timeTo 取得期間（終了）
     * @param {CSVDownload} cSVDownload
     * @param {string} [sources]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesDownloadsCreate = function (nodeId, timeFrom, timeTo, cSVDownload, sources, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesDownloadsCreate(nodeId, timeFrom, timeTo, cSVDownload, sources, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * モデル結果(ファイル)一覧取得
     * @param {string} gatewayId
     * @param {string} jobId
     * @param {string} modelId
     * @param {string} nodeId
     * @param {string} type 取得するデータのタイプ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesGatewayModelsBuildJobsFileList = function (gatewayId, jobId, modelId, nodeId, type, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesGatewayModelsBuildJobsFileList(gatewayId, jobId, modelId, nodeId, type, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * モデル結果(ファイル)取得
     * @param {string} gatewayId
     * @param {string} id
     * @param {string} jobId
     * @param {string} modelId
     * @param {string} nodeId
     * @param {string} type 取得するデータのタイプ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesGatewayModelsBuildJobsFileRetrieve = function (gatewayId, id, jobId, modelId, nodeId, type, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesGatewayModelsBuildJobsFileRetrieve(gatewayId, id, jobId, modelId, nodeId, type, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * モデル結果一覧取得
     * @param {string} gatewayId
     * @param {string} jobId
     * @param {string} modelId
     * @param {string} nodeId
     * @param {string} type 取得するデータのタイプ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesGatewayModelsBuildJobsResultList = function (gatewayId, jobId, modelId, nodeId, type, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesGatewayModelsBuildJobsResultList(gatewayId, jobId, modelId, nodeId, type, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * モデル結果取得
     * @param {string} gatewayId
     * @param {string} id
     * @param {string} jobId
     * @param {string} modelId
     * @param {string} nodeId
     * @param {string} type 取得するデータのタイプ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesGatewayModelsBuildJobsResultRetrieve = function (gatewayId, id, jobId, modelId, nodeId, type, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesGatewayModelsBuildJobsResultRetrieve(gatewayId, id, jobId, modelId, nodeId, type, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * SaiCrew デプロイ設定 説明変数のシミュレーション範囲一覧取得
     * @param {string} gatewayId
     * @param {string} nodeId
     * @param {Array<SaicrewAIModelMlSimulationsRequest>} saicrewAIModelMlSimulationsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesGatewaySaicrewMlSimulationsMlListCreate = function (gatewayId, nodeId, saicrewAIModelMlSimulationsRequest, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesGatewaySaicrewMlSimulationsMlListCreate(gatewayId, nodeId, saicrewAIModelMlSimulationsRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} cameraId
     * @param {string} nodeId
     * @param {number} [timestamp] 基準時間
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesGraphicCameraList = function (cameraId, nodeId, timestamp, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesGraphicCameraList(cameraId, nodeId, timestamp, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} fileName
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesGraphicImageList = function (fileName, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesGraphicImageList(fileName, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesGraphicIntervalList = function (nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesGraphicIntervalList(nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * グラフィックレコーダ用ジャーナル取得API
     * @param {string} nodeId
     * @param {number} timeFrom 取得期間（開始）
     * @param {number} timeTo 取得期間（終了）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesGraphicRecorderStatusRetrieve = function (nodeId, timeFrom, timeTo, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesGraphicRecorderStatusRetrieve(nodeId, timeFrom, timeTo, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * アップロードバリデーション
     * @param {string} nodeId
     * @param {string} tabIndex
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesGraphicTabsGraphicFilesCreate = function (nodeId, tabIndex, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesGraphicTabsGraphicFilesCreate(nodeId, tabIndex, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 項目選択API
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesItemSelectionList = function (nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesItemSelectionList(nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 最新ジャーナル取得API
     * @param {string} nodeId
     * @param {boolean} [includeDescendants] 子孫のデータセットを含むか
     * @param {boolean} [includeNotify] アナログ監視判定結果を含むか
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesLastestStatusList = function (nodeId, includeDescendants, includeNotify, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesLastestStatusList(nodeId, includeDescendants, includeNotify, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 発生中警報情報取得
     * @param {string} nodeId
     * @param {boolean} [controlDashboardDispFlag] ダッシュボード表示フラグの制御有無
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesLatestAlarmList = function (nodeId, controlDashboardDispFlag, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesLatestAlarmList(nodeId, controlDashboardDispFlag, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 発生中警報情報取得
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesLatestProcessList = function (nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesLatestProcessList(nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * メール設定 グループ別送信テスト
     * @param {string} nodeId
     * @param {MailGroupTest} mailGroupTest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesMailGroupTestCreate = function (nodeId, mailGroupTest, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesMailGroupTestCreate(nodeId, mailGroupTest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * シンプル記録追加
     * @param {string} nodeId
     * @param {MaintenanceHistory} maintenanceHistory
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesMaintenanceHistoriesCreate = function (nodeId, maintenanceHistory, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesMaintenanceHistoriesCreate(nodeId, maintenanceHistory, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * シンプル記録削除
     * @param {number} id A unique integer value identifying this t_maintenance_history.
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesMaintenanceHistoriesDestroy = function (id, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesMaintenanceHistoriesDestroy(id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * シンプル記録 API
     * @param {string} dateFrom 取得期間（開始）
     * @param {string} dateTo 取得期間（終了）
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesMaintenanceHistoriesList = function (dateFrom, dateTo, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesMaintenanceHistoriesList(dateFrom, dateTo, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * シンプル記録更新（一部）
     * @param {number} id A unique integer value identifying this t_maintenance_history.
     * @param {string} nodeId
     * @param {PatchedMaintenanceHistory} [patchedMaintenanceHistory]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesMaintenanceHistoriesPartialUpdate = function (id, nodeId, patchedMaintenanceHistory, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesMaintenanceHistoriesPartialUpdate(id, nodeId, patchedMaintenanceHistory, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * シンプル記録詳細取得
     * @param {number} id A unique integer value identifying this t_maintenance_history.
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesMaintenanceHistoriesRetrieve = function (id, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesMaintenanceHistoriesRetrieve(id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * シンプル記録更新
     * @param {number} id A unique integer value identifying this t_maintenance_history.
     * @param {string} nodeId
     * @param {MaintenanceHistory} maintenanceHistory
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesMaintenanceHistoriesUpdate = function (id, nodeId, maintenanceHistory, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesMaintenanceHistoriesUpdate(id, nodeId, maintenanceHistory, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * MBR 演算設定追加
     * @param {string} nodeId
     * @param {MbrCalculationSettings} mbrCalculationSettings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesMbrCalculationSettingsCreate = function (nodeId, mbrCalculationSettings, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesMbrCalculationSettingsCreate(nodeId, mbrCalculationSettings, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * MBR 演算設定削除
     * @param {string} id
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesMbrCalculationSettingsDestroy = function (id, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesMbrCalculationSettingsDestroy(id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * MBR 演算設定一覧
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesMbrCalculationSettingsList = function (nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesMbrCalculationSettingsList(nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * MBR 演算設定更新（一部）
     * @param {string} id
     * @param {string} nodeId
     * @param {PatchedMbrCalculationSettings} [patchedMbrCalculationSettings]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesMbrCalculationSettingsPartialUpdate = function (id, nodeId, patchedMbrCalculationSettings, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesMbrCalculationSettingsPartialUpdate(id, nodeId, patchedMbrCalculationSettings, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * MBR 演算設定 API
     * @param {string} id
     * @param {string} nodeId
     * @param {MbrCalculationSettings} mbrCalculationSettings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesMbrCalculationSettingsUpdate = function (id, nodeId, mbrCalculationSettings, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesMbrCalculationSettingsUpdate(id, nodeId, mbrCalculationSettings, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 傾向総合診断履歴 API
     * @param {string} nodeId
     * @param {MbrTechnicalReportJudgementHistory} mbrTechnicalReportJudgementHistory
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesMbrTechnicalReportJudgementHistoriesCreate = function (nodeId, mbrTechnicalReportJudgementHistory, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesMbrTechnicalReportJudgementHistoriesCreate(nodeId, mbrTechnicalReportJudgementHistory, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 傾向総合診断履歴の取得
     * @param {string} nodeId
     * @param {number} timeFrom 取得期間（開始）
     * @param {number} timeTo 取得期間（終了）
     * @param {number} [calculationNo] 演算 No
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesMbrTechnicalReportJudgementHistoriesList = function (nodeId, timeFrom, timeTo, calculationNo, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesMbrTechnicalReportJudgementHistoriesList(nodeId, timeFrom, timeTo, calculationNo, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 傾向総合診断追加
     * @param {string} nodeId
     * @param {MbrTechnicalReportJudgement} mbrTechnicalReportJudgement
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesMbrTechnicalReportJudgementsCreate = function (nodeId, mbrTechnicalReportJudgement, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesMbrTechnicalReportJudgementsCreate(nodeId, mbrTechnicalReportJudgement, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 傾向総合診断取得
     * @param {string} nodeId
     * @param {number} [calculationNo] 演算 No
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesMbrTechnicalReportJudgementsList = function (nodeId, calculationNo, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesMbrTechnicalReportJudgementsList(nodeId, calculationNo, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 傾向総合診断の取得
     * @param {string} dateFrom 取得期間（開始）
     * @param {string} dateTo 取得期間（終了）
     * @param {string} nodeId
     * @param {number} [calculationNo] 演算 No
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesMbrTechnicalReportResultsList = function (dateFrom, dateTo, nodeId, calculationNo, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesMbrTechnicalReportResultsList(dateFrom, dateTo, nodeId, calculationNo, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesMonitorDatasetMetricsList = function (nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesMonitorDatasetMetricsList(nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesMonitorDatasetMetricsRetrieve = function (id, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesMonitorDatasetMetricsRetrieve(id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 通知Gr1のオンオフ設定
     * @param {string} nodeId
     * @param {Array<MonitoringNotificationGr1Settings>} monitoringNotificationGr1Settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesMonitorNotificationGr1SettingsCreate = function (nodeId, monitoringNotificationGr1Settings, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesMonitorNotificationGr1SettingsCreate(nodeId, monitoringNotificationGr1Settings, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 通知Gr2のオンオフ設定
     * @param {string} nodeId
     * @param {Array<MonitoringNotificationGr2Settings>} monitoringNotificationGr2Settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesMonitorNotificationGr2SettingsCreate = function (nodeId, monitoringNotificationGr2Settings, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesMonitorNotificationGr2SettingsCreate(nodeId, monitoringNotificationGr2Settings, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * メール通知のオンオフ設定
     * @param {string} nodeId
     * @param {Array<MonitoringNotificationMailSettings>} monitoringNotificationMailSettings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesMonitorNotificationMailSettingsGeneralCreate = function (nodeId, monitoringNotificationMailSettings, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesMonitorNotificationMailSettingsGeneralCreate(nodeId, monitoringNotificationMailSettings, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * データ項目の設定
     * @param {string} nodeId
     * @param {Array<MonitoringSettings>} monitoringSettings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesMonitorSettingsCreate = function (nodeId, monitoringSettings, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesMonitorSettingsCreate(nodeId, monitoringSettings, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * クラウド設定警報取得 API
     * @param {string} nodeId
     * @param {string} [datasetId] データセットID
     * @param {string} [fieldNames] フィールド名
     * @param {string} [ruleNames] 条件
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesMonitorSettingsList = function (nodeId, datasetId, fieldNames, ruleNames, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesMonitorSettingsList(nodeId, datasetId, fieldNames, ruleNames, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 通知Gr1の設定
     * @param {string} nodeId
     * @param {NotificationGr1Settings} [notificationGr1Settings]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesNotificationGr1SettingsCreate = function (nodeId, notificationGr1Settings, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesNotificationGr1SettingsCreate(nodeId, notificationGr1Settings, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 通知Gr2の設定
     * @param {string} nodeId
     * @param {NotificationGr2Settings} [notificationGr2Settings]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesNotificationGr2SettingsCreate = function (nodeId, notificationGr2Settings, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesNotificationGr2SettingsCreate(nodeId, notificationGr2Settings, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * メール配信設定
     * @param {string} nodeId
     * @param {NotificationMailSettings} [notificationMailSettings]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesNotificationMailSettingsCreate = function (nodeId, notificationMailSettings, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesNotificationMailSettingsCreate(nodeId, notificationMailSettings, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * SaiCrew通知設定（メール通知）
     * @param {string} nodeId
     * @param {NotificationSaiCrewMailSettings} [notificationSaiCrewMailSettings]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesNotificationSaicrewMailSettingsCreate = function (nodeId, notificationSaiCrewMailSettings, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesNotificationSaicrewMailSettingsCreate(nodeId, notificationSaiCrewMailSettings, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * SaiIK通知設定（メール通知）
     * @param {string} nodeId
     * @param {NotificationSaiIKMailSettings} [notificationSaiIKMailSettings]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesNotificationSaiikMailSettingsCreate = function (nodeId, notificationSaiIKMailSettings, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesNotificationSaiikMailSettingsCreate(nodeId, notificationSaiIKMailSettings, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 設備の通知先の設定
     * @param {string} nodeId
     * @param {NotificationSettings} notificationSettings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesNotificationSettingsCreate = function (nodeId, notificationSettings, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesNotificationSettingsCreate(nodeId, notificationSettings, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 設備の通知設定の取得
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesNotificationSettingsList = function (nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesNotificationSettingsList(nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * システム警報異常通知先設定（メール通知）
     * @param {string} nodeId
     * @param {NotificationSystemMailSettings} [notificationSystemMailSettings]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesNotificationSystemMailSettingsCreate = function (nodeId, notificationSystemMailSettings, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesNotificationSystemMailSettingsCreate(nodeId, notificationSystemMailSettings, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * システム警報異常通知先設定（パトランプ通知）
     * @param {string} nodeId
     * @param {NotificationSystemPatliteSettings} notificationSystemPatliteSettings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesNotificationSystemPatliteSettingsCreate = function (nodeId, notificationSystemPatliteSettings, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesNotificationSystemPatliteSettingsCreate(nodeId, notificationSystemPatliteSettings, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * システム警報異常通知先設定（パトランプ通知） API
     * @param {string} id
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesNotificationSystemPatliteSettingsDestroy = function (id, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesNotificationSystemPatliteSettingsDestroy(id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * システム警報異常通知先設定（パトランプ通知） API
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesNotificationSystemPatliteSettingsList = function (nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesNotificationSystemPatliteSettingsList(nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 運転履歴取得
     * @param {string} nodeId
     * @param {number} timeFrom 取得期間（開始）
     * @param {number} timeTo 取得期間（終了）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesOperatingHistoryList = function (nodeId, timeFrom, timeTo, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesOperatingHistoryList(nodeId, timeFrom, timeTo, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 稼働情報取得
     * @param {string} nodeId
     * @param {number} timeFrom 取得期間（開始）
     * @param {number} timeTo 取得期間（終了）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesOperatingSummaryList = function (nodeId, timeFrom, timeTo, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesOperatingSummaryList(nodeId, timeFrom, timeTo, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * パトランプ通知追加
     * @param {string} datasetIds
     * @param {string} fieldNames
     * @param {string} nodeId
     * @param {Array<PatliteNotificationSetting>} patliteNotificationSetting
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesPatliteNotificationSettingsCreate = function (datasetIds, fieldNames, nodeId, patliteNotificationSetting, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesPatliteNotificationSettingsCreate(datasetIds, fieldNames, nodeId, patliteNotificationSetting, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * パトランプ通知削除
     * @param {number} id A unique integer value identifying this m_patlite_notification_setting.
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesPatliteNotificationSettingsDestroy = function (id, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesPatliteNotificationSettingsDestroy(id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * パトランプ通知 API
     * @param {string} nodeId
     * @param {string} [datasetId] データセット
     * @param {string} [fieldName] 項目
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesPatliteNotificationSettingsList = function (nodeId, datasetId, fieldName, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesPatliteNotificationSettingsList(nodeId, datasetId, fieldName, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * パトランプ通知更新（一部）
     * @param {number} id A unique integer value identifying this m_patlite_notification_setting.
     * @param {string} nodeId
     * @param {PatchedPatliteNotificationSetting} [patchedPatliteNotificationSetting]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesPatliteNotificationSettingsPartialUpdate = function (id, nodeId, patchedPatliteNotificationSetting, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesPatliteNotificationSettingsPartialUpdate(id, nodeId, patchedPatliteNotificationSetting, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * パトランプ通知詳細取得
     * @param {number} id A unique integer value identifying this m_patlite_notification_setting.
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesPatliteNotificationSettingsRetrieve = function (id, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesPatliteNotificationSettingsRetrieve(id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * パトランプ通知更新
     * @param {number} id A unique integer value identifying this m_patlite_notification_setting.
     * @param {string} nodeId
     * @param {PatliteNotificationSetting} patliteNotificationSetting
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesPatliteNotificationSettingsUpdate = function (id, nodeId, patliteNotificationSetting, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesPatliteNotificationSettingsUpdate(id, nodeId, patliteNotificationSetting, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * パトランプ設定
     * @param {string} nodeId
     * @param {Array<NodePatliteSetting>} nodePatliteSetting
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesPatliteSettingsCreate = function (nodeId, nodePatliteSetting, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesPatliteSettingsCreate(nodeId, nodePatliteSetting, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * パトランプ設定 API
     * @param {number} id A unique integer value identifying this m_node_patlite_setting.
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesPatliteSettingsDestroy = function (id, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesPatliteSettingsDestroy(id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * パトランプ設定取得
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesPatliteSettingsList = function (nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesPatliteSettingsList(nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * パトランプ設定 API
     * @param {number} id A unique integer value identifying this m_node_patlite_setting.
     * @param {string} nodeId
     * @param {PatchedNodePatliteSetting} [patchedNodePatliteSetting]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesPatliteSettingsPartialUpdate = function (id, nodeId, patchedNodePatliteSetting, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesPatliteSettingsPartialUpdate(id, nodeId, patchedNodePatliteSetting, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * パトランプ設定 API
     * @param {number} id A unique integer value identifying this m_node_patlite_setting.
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesPatliteSettingsRetrieve = function (id, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesPatliteSettingsRetrieve(id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * パトランプ設定 API
     * @param {number} id A unique integer value identifying this m_node_patlite_setting.
     * @param {string} nodeId
     * @param {NodePatliteSetting} nodePatliteSetting
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesPatliteSettingsUpdate = function (id, nodeId, nodePatliteSetting, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesPatliteSettingsUpdate(id, nodeId, nodePatliteSetting, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * パトランプテスト
     * @param {string} nodeId
     * @param {string} patliteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesPatlitesTestCreate = function (nodeId, patliteId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesPatlitesTestCreate(nodeId, patliteId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 遠隔操作履歴 API
     * @param {number} dateFrom 取得期間（開始）
     * @param {number} dateTo 取得期間（終了）
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesRemoteControlHistoryList = function (dateFrom, dateTo, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesRemoteControlHistoryList(dateFrom, dateTo, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id A unique integer value identifying this m_remote_control_history.
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesRemoteControlHistoryRetrieve = function (id, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesRemoteControlHistoryRetrieve(id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 長期データ取得
     * @param {string} id データセット ID
     * @param {string} nodeId
     * @param {string} [asFreq] 集約単位
     * @param {string} [fieldNames] 取得カラム
     * @param {string} [fieldTypes] 取得カラム型
     * @param {string} [method] 集約方法
     * @param {string} [splitBy] 表示単位
     * @param {string} [theLastPeriod] 直近〜（1W / 1M / 3M / 6M / 9M / 1Y / 3Y / 5Y）
     * @param {number} [timeFrom] 取得期間（開始）
     * @param {number} [timeTo] 取得期間（終了）
     * @param {string} [trendGraphFreq] トレンドグラフの集約単位
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesResampledDatasetsRetrieve = function (id, nodeId, asFreq, fieldNames, fieldTypes, method, splitBy, theLastPeriod, timeFrom, timeTo, trendGraphFreq, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesResampledDatasetsRetrieve(id, nodeId, asFreq, fieldNames, fieldTypes, method, splitBy, theLastPeriod, timeFrom, timeTo, trendGraphFreq, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * RO 演算設定追加
     * @param {string} nodeId
     * @param {RoCalculationSettings} roCalculationSettings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesRoCalculationSettingsCreate = function (nodeId, roCalculationSettings, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesRoCalculationSettingsCreate(nodeId, roCalculationSettings, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * RO 演算設定削除
     * @param {string} id
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesRoCalculationSettingsDestroy = function (id, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesRoCalculationSettingsDestroy(id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * RO 演算設定一覧
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesRoCalculationSettingsList = function (nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesRoCalculationSettingsList(nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * RO 演算設定更新（一部）
     * @param {string} id
     * @param {string} nodeId
     * @param {PatchedRoCalculationSettings} [patchedRoCalculationSettings]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesRoCalculationSettingsPartialUpdate = function (id, nodeId, patchedRoCalculationSettings, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesRoCalculationSettingsPartialUpdate(id, nodeId, patchedRoCalculationSettings, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * RO 演算設定 API
     * @param {string} id
     * @param {string} nodeId
     * @param {RoCalculationSettings} roCalculationSettings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesRoCalculationSettingsUpdate = function (id, nodeId, roCalculationSettings, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesRoCalculationSettingsUpdate(id, nodeId, roCalculationSettings, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ROテクニカルレポート
     * @param {string} nodeId
     * @param {string} [dateFrom] 取得期間（開始）
     * @param {string} [dateTo] 取得期間（終了）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesRoTechnicalReportResultsList = function (nodeId, dateFrom, dateTo, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesRoTechnicalReportResultsList(nodeId, dateFrom, dateTo, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns list of algorithms.
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaicrewAiAlgorithmsList = function (nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaicrewAiAlgorithmsList(nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns algorithm.
     * @param {string} id
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaicrewAiAlgorithmsRetrieve = function (id, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaicrewAiAlgorithmsRetrieve(id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns algorithm.
     * @param {string} algorithmName
     * @param {string} id
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaicrewAiAlgorithmsVersionsRetrieve = function (algorithmName, id, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaicrewAiAlgorithmsVersionsRetrieve(algorithmName, id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * SaiCrew-AIモデル追加
     * @param {string} nodeId
     * @param {SaicrewAIModel} saicrewAIModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaicrewAiModelsCreate = function (nodeId, saicrewAIModel, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaicrewAiModelsCreate(nodeId, saicrewAIModel, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * SaiCrew-AIモデル削除
     * @param {number} id A unique integer value identifying this m_saicrew_ai_model.
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaicrewAiModelsDestroy = function (id, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaicrewAiModelsDestroy(id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 最新MLPipelineIDの取得
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaicrewAiModelsLatestPipelineIdRetrieve = function (nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaicrewAiModelsLatestPipelineIdRetrieve(nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * SaiCrew-AIモデル覧取得
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaicrewAiModelsList = function (nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaicrewAiModelsList(nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * SaiCrew-AIモデル更新（一部）
     * @param {number} id A unique integer value identifying this m_saicrew_ai_model.
     * @param {string} nodeId
     * @param {PatchedSaicrewAIModel} [patchedSaicrewAIModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaicrewAiModelsPartialUpdate = function (id, nodeId, patchedSaicrewAIModel, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaicrewAiModelsPartialUpdate(id, nodeId, patchedSaicrewAIModel, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * SaiCrew-AIモデル詳細取得
     * @param {number} id A unique integer value identifying this m_saicrew_ai_model.
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaicrewAiModelsRetrieve = function (id, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaicrewAiModelsRetrieve(id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * SaiCrew-AIモデル更新
     * @param {number} id A unique integer value identifying this m_saicrew_ai_model.
     * @param {string} nodeId
     * @param {SaicrewAIModel} saicrewAIModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaicrewAiModelsUpdate = function (id, nodeId, saicrewAIModel, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaicrewAiModelsUpdate(id, nodeId, saicrewAIModel, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * List all SaiCrew node datasets in descendant nodes.
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaicrewDatasetsList = function (nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaicrewDatasetsList(nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * SaiCrew モデル構築・データ予測用の CSV フォーマットダウンロード
     * @param {string} datasetId
     * @param {string} nodeId
     * @param {Array<string>} [mlNames] ML変数
     * @param {number} [timeFrom] 取得期間（開始）
     * @param {number} [timeTo] 取得期間（終了）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaicrewDatasetsUploadsFormatRetrieve = function (datasetId, nodeId, mlNames, timeFrom, timeTo, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaicrewDatasetsUploadsFormatRetrieve(datasetId, nodeId, mlNames, timeFrom, timeTo, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} edgeDevice
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaicrewEdgeDeviceComponentList = function (edgeDevice, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaicrewEdgeDeviceComponentList(edgeDevice, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} nodeId
     * @param {SaicrewEdgeDevice} saicrewEdgeDevice
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaicrewEdgeDeviceCreate = function (nodeId, saicrewEdgeDevice, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaicrewEdgeDeviceCreate(nodeId, saicrewEdgeDevice, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Saicrewデプロイ承認
     * @param {string} edgeDevice
     * @param {string} id
     * @param {string} nodeId
     * @param {SaicrewDeploymentApprove} saicrewDeploymentApprove
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaicrewEdgeDeviceDeploymentsApproveCreate = function (edgeDevice, id, nodeId, saicrewDeploymentApprove, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaicrewEdgeDeviceDeploymentsApproveCreate(edgeDevice, id, nodeId, saicrewDeploymentApprove, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Saicrewデプロイキャンセル
     * @param {string} edgeDevice
     * @param {string} id
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaicrewEdgeDeviceDeploymentsCancelCreate = function (edgeDevice, id, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaicrewEdgeDeviceDeploymentsCancelCreate(edgeDevice, id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Saicrewデプロイ作成
     * @param {string} edgeDevice
     * @param {string} nodeId
     * @param {SaicrewDeployment} saicrewDeployment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaicrewEdgeDeviceDeploymentsCreate = function (edgeDevice, nodeId, saicrewDeployment, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaicrewEdgeDeviceDeploymentsCreate(edgeDevice, nodeId, saicrewDeployment, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * 環境取得
     * @param {string} edgeDevice
     * @param {string} id
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaicrewEdgeDeviceDeploymentsEnvironmentRetrieve = function (edgeDevice, id, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaicrewEdgeDeviceDeploymentsEnvironmentRetrieve(edgeDevice, id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Saicrewデプロイ一覧
     * @param {string} edgeDevice
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaicrewEdgeDeviceDeploymentsList = function (edgeDevice, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaicrewEdgeDeviceDeploymentsList(edgeDevice, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Saicrewデプロイ
     * @param {string} edgeDevice
     * @param {string} id
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaicrewEdgeDeviceDeploymentsRetrieve = function (edgeDevice, id, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaicrewEdgeDeviceDeploymentsRetrieve(edgeDevice, id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Saicrewデプロイ再試行
     * @param {string} edgeDevice
     * @param {string} id
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaicrewEdgeDeviceDeploymentsRetryCreate = function (edgeDevice, id, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaicrewEdgeDeviceDeploymentsRetryCreate(edgeDevice, id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaicrewEdgeDeviceDestroy = function (id, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaicrewEdgeDeviceDestroy(id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Saicrewエッジデバイス詳細取得
     * @param {string} nodeId
     * @param {boolean} [includeDeploymentCounts] 今月のデプロイ数も合わせて取得
     * @param {boolean} [includeModelBuildCounts] 今月のモデルビルド数も合わせて取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaicrewEdgeDeviceList = function (nodeId, includeDeploymentCounts, includeModelBuildCounts, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaicrewEdgeDeviceList(nodeId, includeDeploymentCounts, includeModelBuildCounts, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {string} nodeId
     * @param {PatchedSaicrewEdgeDevice} [patchedSaicrewEdgeDevice]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaicrewEdgeDevicePartialUpdate = function (id, nodeId, patchedSaicrewEdgeDevice, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaicrewEdgeDevicePartialUpdate(id, nodeId, patchedSaicrewEdgeDevice, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaicrewEdgeDeviceRetrieve = function (id, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaicrewEdgeDeviceRetrieve(id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {string} nodeId
     * @param {SaicrewEdgeDevice} saicrewEdgeDevice
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaicrewEdgeDeviceUpdate = function (id, nodeId, saicrewEdgeDevice, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaicrewEdgeDeviceUpdate(id, nodeId, saicrewEdgeDevice, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * SaiCrew-ML　Variables ViewSet.
     * @param {string} nodeId
     * @param {SaicrewMLVariables} saicrewMLVariables
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaicrewMlVariablesCreate = function (nodeId, saicrewMLVariables, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaicrewMlVariablesCreate(nodeId, saicrewMLVariables, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * SaiCrew-ML　Variables ViewSet.
     * @param {string} id
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaicrewMlVariablesDestroy = function (id, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaicrewMlVariablesDestroy(id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * SaiCrew-ML　Variables ViewSet.
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaicrewMlVariablesList = function (nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaicrewMlVariablesList(nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * SaiCrew-ML　Variables ViewSet.
     * @param {string} id
     * @param {string} nodeId
     * @param {PatchedSaicrewMLVariables} [patchedSaicrewMLVariables]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaicrewMlVariablesPartialUpdate = function (id, nodeId, patchedSaicrewMLVariables, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaicrewMlVariablesPartialUpdate(id, nodeId, patchedSaicrewMLVariables, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * SaiCrew-ML　Variables ViewSet.
     * @param {string} id
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaicrewMlVariablesRetrieve = function (id, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaicrewMlVariablesRetrieve(id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * SaiCrew-ML　Variables ViewSet.
     * @param {string} id
     * @param {string} nodeId
     * @param {SaicrewMLVariables} saicrewMLVariables
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaicrewMlVariablesUpdate = function (id, nodeId, saicrewMLVariables, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaicrewMlVariablesUpdate(id, nodeId, saicrewMLVariables, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * SaiCrewAIモデル構築ジョブ承認
     * @param {string} gatewayId
     * @param {string} id
     * @param {string} modelId
     * @param {string} nodeId
     * @param {SaicrewAIModelBuildJobApprove} saicrewAIModelBuildJobApprove
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaicrewModelsBuildJobsApproveCreate = function (gatewayId, id, modelId, nodeId, saicrewAIModelBuildJobApprove, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaicrewModelsBuildJobsApproveCreate(gatewayId, id, modelId, nodeId, saicrewAIModelBuildJobApprove, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * SaiCrewAIバッチ推論 構築ジョブキャンセル
     * @param {string} gatewayId
     * @param {string} id
     * @param {string} jobId
     * @param {string} modelId
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaicrewModelsBuildJobsBatchInferenceCancelCreate = function (gatewayId, id, jobId, modelId, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaicrewModelsBuildJobsBatchInferenceCancelCreate(gatewayId, id, jobId, modelId, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * SaiCrew-AIバッチ推論 構築ジョブ作成
     * @param {string} gatewayId
     * @param {string} jobId
     * @param {string} modelId
     * @param {string} nodeId
     * @param {SaiCrewAIModelBatchInferenceJob} data
     * @param {any} [zipFile]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaicrewModelsBuildJobsBatchInferenceCreate = function (gatewayId, jobId, modelId, nodeId, data, zipFile, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaicrewModelsBuildJobsBatchInferenceCreate(gatewayId, jobId, modelId, nodeId, data, zipFile, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Saicrew-AIバッチ推論 構築ジョブ一覧
     * @param {string} gatewayId
     * @param {string} jobId
     * @param {string} modelId
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaicrewModelsBuildJobsBatchInferenceList = function (gatewayId, jobId, modelId, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaicrewModelsBuildJobsBatchInferenceList(gatewayId, jobId, modelId, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Saicrew-AIバッチ推論 構築ジョブ詳細
     * @param {string} gatewayId
     * @param {string} id
     * @param {string} jobId
     * @param {string} modelId
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaicrewModelsBuildJobsBatchInferenceRetrieve = function (gatewayId, id, jobId, modelId, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaicrewModelsBuildJobsBatchInferenceRetrieve(gatewayId, id, jobId, modelId, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * SaiCrewAIバッチ推論 構築ジョブ再試行
     * @param {string} gatewayId
     * @param {string} id
     * @param {string} jobId
     * @param {string} modelId
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaicrewModelsBuildJobsBatchInferenceRetryCreate = function (gatewayId, id, jobId, modelId, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaicrewModelsBuildJobsBatchInferenceRetryCreate(gatewayId, id, jobId, modelId, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * SaiCrewAIモデル構築ジョブキャンセル
     * @param {string} gatewayId
     * @param {string} id
     * @param {string} modelId
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaicrewModelsBuildJobsCancelCreate = function (gatewayId, id, modelId, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaicrewModelsBuildJobsCancelCreate(gatewayId, id, modelId, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create comment.
     * @param {string} gatewayId
     * @param {string} jobId
     * @param {string} modelId
     * @param {string} nodeId
     * @param {SaicrewAIModelBuildJobComment} saicrewAIModelBuildJobComment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaicrewModelsBuildJobsCommentsCreate = function (gatewayId, jobId, modelId, nodeId, saicrewAIModelBuildJobComment, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaicrewModelsBuildJobsCommentsCreate(gatewayId, jobId, modelId, nodeId, saicrewAIModelBuildJobComment, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete comment
     * @param {string} gatewayId
     * @param {number} id A unique integer value identifying this t_saicrew_ai_model_build_job_comment.
     * @param {string} jobId
     * @param {string} modelId
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaicrewModelsBuildJobsCommentsDestroy = function (gatewayId, id, jobId, modelId, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaicrewModelsBuildJobsCommentsDestroy(gatewayId, id, jobId, modelId, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns list of comments.
     * @param {string} gatewayId
     * @param {string} jobId
     * @param {string} modelId
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaicrewModelsBuildJobsCommentsList = function (gatewayId, jobId, modelId, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaicrewModelsBuildJobsCommentsList(gatewayId, jobId, modelId, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * カメラAIモデル構築ジョブコメント
     * @param {string} gatewayId
     * @param {number} id A unique integer value identifying this t_saicrew_ai_model_build_job_comment.
     * @param {string} jobId
     * @param {string} modelId
     * @param {string} nodeId
     * @param {PatchedSaicrewAIModelBuildJobComment} [patchedSaicrewAIModelBuildJobComment]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaicrewModelsBuildJobsCommentsPartialUpdate = function (gatewayId, id, jobId, modelId, nodeId, patchedSaicrewAIModelBuildJobComment, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaicrewModelsBuildJobsCommentsPartialUpdate(gatewayId, id, jobId, modelId, nodeId, patchedSaicrewAIModelBuildJobComment, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * カメラAIモデル構築ジョブコメント
     * @param {string} gatewayId
     * @param {number} id A unique integer value identifying this t_saicrew_ai_model_build_job_comment.
     * @param {string} jobId
     * @param {string} modelId
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaicrewModelsBuildJobsCommentsRetrieve = function (gatewayId, id, jobId, modelId, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaicrewModelsBuildJobsCommentsRetrieve(gatewayId, id, jobId, modelId, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update comment.
     * @param {string} gatewayId
     * @param {number} id A unique integer value identifying this t_saicrew_ai_model_build_job_comment.
     * @param {string} jobId
     * @param {string} modelId
     * @param {string} nodeId
     * @param {SaicrewAIModelBuildJobComment} saicrewAIModelBuildJobComment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaicrewModelsBuildJobsCommentsUpdate = function (gatewayId, id, jobId, modelId, nodeId, saicrewAIModelBuildJobComment, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaicrewModelsBuildJobsCommentsUpdate(gatewayId, id, jobId, modelId, nodeId, saicrewAIModelBuildJobComment, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * SaiCrew-AIモデル構築ジョブ作成
     * @param {string} gatewayId
     * @param {string} modelId
     * @param {string} nodeId
     * @param {SaicrewAIModelBuildJob} data
     * @param {any} [zipFile]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaicrewModelsBuildJobsCreate = function (gatewayId, modelId, nodeId, data, zipFile, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaicrewModelsBuildJobsCreate(gatewayId, modelId, nodeId, data, zipFile, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Saicrew-AIモデル構築ジョブ一覧
     * @param {string} gatewayId
     * @param {string} modelId
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaicrewModelsBuildJobsList = function (gatewayId, modelId, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaicrewModelsBuildJobsList(gatewayId, modelId, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Saicrew-AIAIモデル構築ジョブ詳細
     * @param {string} gatewayId
     * @param {string} id
     * @param {string} modelId
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaicrewModelsBuildJobsRetrieve = function (gatewayId, id, modelId, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaicrewModelsBuildJobsRetrieve(gatewayId, id, modelId, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * SaiCrewAIモデル構築ジョブ再試行
     * @param {string} gatewayId
     * @param {string} id
     * @param {string} modelId
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaicrewModelsBuildJobsRetryCreate = function (gatewayId, id, modelId, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaicrewModelsBuildJobsRetryCreate(gatewayId, id, modelId, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * SaiForce 演算設定追加
     * @param {string} nodeId
     * @param {SaiforceCalculationSettings} saiforceCalculationSettings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaiforceCalculationSettingsCreate = function (nodeId, saiforceCalculationSettings, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaiforceCalculationSettingsCreate(nodeId, saiforceCalculationSettings, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * SaiForce 演算設定削除
     * @param {number} id dataset_id
     * @param {number} nodeId 設備 ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaiforceCalculationSettingsDestroy = function (id, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaiforceCalculationSettingsDestroy(id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * SaiForce 演算設定一覧
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSaiforceCalculationSettingsList = function (nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSaiforceCalculationSettingsList(nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ゲートウェイ定周期通信異常判定
     * @param {string} nodeId
     * @param {number} timeFrom 取得期間（開始）
     * @param {number} timeTo 取得期間（終了）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSysalartHistoryJudgementRetrieve = function (nodeId, timeFrom, timeTo, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSysalartHistoryJudgementRetrieve(nodeId, timeFrom, timeTo, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ゲートウェイ定周期通信異常情報取得
     * @param {string} nodeId
     * @param {number} timeFrom 取得期間（開始）
     * @param {number} timeTo 取得期間（終了）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesSysalartHistoryList = function (nodeId, timeFrom, timeTo, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesSysalartHistoryList(nodeId, timeFrom, timeTo, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * テクニカルレポートステータス
     * @param {string} nodeId
     * @param {boolean} [includeDescendants] 子孫のデータセットを含むか
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesTechnicalReportStatusList = function (nodeId, includeDescendants, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesTechnicalReportStatusList(nodeId, includeDescendants, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} nodeId
     * @param {string} technicalReportId
     * @param {TechnicalReportAttachments} [technicalReportAttachments]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesTechnicalReportsAttachmentsCreate = function (nodeId, technicalReportId, technicalReportAttachments, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesTechnicalReportsAttachmentsCreate(nodeId, technicalReportId, technicalReportAttachments, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id A unique integer value identifying this t_technical_report.
     * @param {string} nodeId
     * @param {string} technicalReportId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesTechnicalReportsAttachmentsDestroy = function (id, nodeId, technicalReportId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesTechnicalReportsAttachmentsDestroy(id, nodeId, technicalReportId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} nodeId
     * @param {string} technicalReportId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesTechnicalReportsAttachmentsList = function (nodeId, technicalReportId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesTechnicalReportsAttachmentsList(nodeId, technicalReportId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id A unique integer value identifying this t_technical_report.
     * @param {string} nodeId
     * @param {string} technicalReportId
     * @param {PatchedTechnicalReportAttachments} [patchedTechnicalReportAttachments]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesTechnicalReportsAttachmentsPartialUpdate = function (id, nodeId, technicalReportId, patchedTechnicalReportAttachments, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesTechnicalReportsAttachmentsPartialUpdate(id, nodeId, technicalReportId, patchedTechnicalReportAttachments, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * テクニカルレポート添付ファイル取得
     * @param {number} id A unique integer value identifying this t_technical_report.
     * @param {string} nodeId
     * @param {string} technicalReportId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesTechnicalReportsAttachmentsRetrieve = function (id, nodeId, technicalReportId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesTechnicalReportsAttachmentsRetrieve(id, nodeId, technicalReportId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id A unique integer value identifying this t_technical_report.
     * @param {string} nodeId
     * @param {string} technicalReportId
     * @param {TechnicalReportAttachments} [technicalReportAttachments]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesTechnicalReportsAttachmentsUpdate = function (id, nodeId, technicalReportId, technicalReportAttachments, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesTechnicalReportsAttachmentsUpdate(id, nodeId, technicalReportId, technicalReportAttachments, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * テクニカルレポート追加
     * @param {string} nodeId
     * @param {TechnicalReportRequest} technicalReportRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesTechnicalReportsCreate = function (nodeId, technicalReportRequest, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesTechnicalReportsCreate(nodeId, technicalReportRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * テクニカルレポート削除
     * @param {number} id A unique integer value identifying this t_technical_report.
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesTechnicalReportsDestroy = function (id, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesTechnicalReportsDestroy(id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * テクニカルレポート API
     * @param {string} dateFrom 取得期間（開始）
     * @param {string} dateTo 取得期間（終了）
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesTechnicalReportsList = function (dateFrom, dateTo, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesTechnicalReportsList(dateFrom, dateTo, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * テクニカルレポート更新（一部）
     * @param {number} id A unique integer value identifying this t_technical_report.
     * @param {string} nodeId
     * @param {PatchedTechnicalReportRequest} [patchedTechnicalReportRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesTechnicalReportsPartialUpdate = function (id, nodeId, patchedTechnicalReportRequest, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesTechnicalReportsPartialUpdate(id, nodeId, patchedTechnicalReportRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * テクニカルレポート詳細取得
     * @param {number} id A unique integer value identifying this t_technical_report.
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesTechnicalReportsRetrieve = function (id, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesTechnicalReportsRetrieve(id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id A unique integer value identifying this t_technical_report.
     * @param {string} nodeId
     * @param {TechnicalReport} technicalReport
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesTechnicalReportsUpdate = function (id, nodeId, technicalReport, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesTechnicalReportsUpdate(id, nodeId, technicalReport, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} nodeId
     * @param {TotalUploadedDocumentSize} totalUploadedDocumentSize
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesTotalUploadedDocumentSizeCreate = function (nodeId, totalUploadedDocumentSize, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesTotalUploadedDocumentSizeCreate(nodeId, totalUploadedDocumentSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesTotalUploadedDocumentSizeDestroy = function (id, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesTotalUploadedDocumentSizeDestroy(id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * アップロードされた全ドキュメントのルート階層単位でのサイズ取得
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesTotalUploadedDocumentSizeList = function (nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesTotalUploadedDocumentSizeList(nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {string} nodeId
     * @param {PatchedTotalUploadedDocumentSize} [patchedTotalUploadedDocumentSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesTotalUploadedDocumentSizePartialUpdate = function (id, nodeId, patchedTotalUploadedDocumentSize, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesTotalUploadedDocumentSizePartialUpdate(id, nodeId, patchedTotalUploadedDocumentSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {string} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesTotalUploadedDocumentSizeRetrieve = function (id, nodeId, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesTotalUploadedDocumentSizeRetrieve(id, nodeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {string} nodeId
     * @param {TotalUploadedDocumentSize} totalUploadedDocumentSize
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    NodesApi.prototype.nodesTotalUploadedDocumentSizeUpdate = function (id, nodeId, totalUploadedDocumentSize, options) {
        var _this = this;
        return (0, exports.NodesApiFp)(this.configuration).nodesTotalUploadedDocumentSizeUpdate(id, nodeId, totalUploadedDocumentSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return NodesApi;
}(base_1.BaseAPI));
exports.NodesApi = NodesApi;
/**
 * PasswordApi - axios parameter creator
 * @export
 */
var PasswordApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordChangeCreate: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/password/change/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordChangeRetrieve: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/password/change/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordForgetRetrieve: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/password/forget/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordResetRetrieve: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/password/reset/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.PasswordApiAxiosParamCreator = PasswordApiAxiosParamCreator;
/**
 * PasswordApi - functional programming interface
 * @export
 */
var PasswordApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.PasswordApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordChangeCreate: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.passwordChangeCreate(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordChangeRetrieve: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.passwordChangeRetrieve(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordForgetRetrieve: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.passwordForgetRetrieve(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordResetRetrieve: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.passwordResetRetrieve(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.PasswordApiFp = PasswordApiFp;
/**
 * PasswordApi - factory interface
 * @export
 */
var PasswordApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.PasswordApiFp)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordChangeCreate: function (options) {
            return localVarFp.passwordChangeCreate(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordChangeRetrieve: function (options) {
            return localVarFp.passwordChangeRetrieve(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordForgetRetrieve: function (options) {
            return localVarFp.passwordForgetRetrieve(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordResetRetrieve: function (options) {
            return localVarFp.passwordResetRetrieve(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.PasswordApiFactory = PasswordApiFactory;
/**
 * PasswordApi - object-oriented interface
 * @export
 * @class PasswordApi
 * @extends {BaseAPI}
 */
var PasswordApi = /** @class */ (function (_super) {
    __extends(PasswordApi, _super);
    function PasswordApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordApi
     */
    PasswordApi.prototype.passwordChangeCreate = function (options) {
        var _this = this;
        return (0, exports.PasswordApiFp)(this.configuration).passwordChangeCreate(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordApi
     */
    PasswordApi.prototype.passwordChangeRetrieve = function (options) {
        var _this = this;
        return (0, exports.PasswordApiFp)(this.configuration).passwordChangeRetrieve(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordApi
     */
    PasswordApi.prototype.passwordForgetRetrieve = function (options) {
        var _this = this;
        return (0, exports.PasswordApiFp)(this.configuration).passwordForgetRetrieve(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordApi
     */
    PasswordApi.prototype.passwordResetRetrieve = function (options) {
        var _this = this;
        return (0, exports.PasswordApiFp)(this.configuration).passwordResetRetrieve(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PasswordApi;
}(base_1.BaseAPI));
exports.PasswordApi = PasswordApi;
/**
 * TokenApi - axios parameter creator
 * @export
 */
var TokenApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenCreateRetrieve: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/token/create/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Takes a refresh type JSON web token and returns an access type JSON web token if the refresh token is valid.
         * @param {TokenRefresh} tokenRefresh
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenRefreshCreate: function (tokenRefresh, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'tokenRefresh' is not null or undefined
                    (0, common_1.assertParamExists)('tokenRefreshCreate', 'tokenRefresh', tokenRefresh);
                    localVarPath = "/swc-api/token/refresh/";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(tokenRefresh, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.TokenApiAxiosParamCreator = TokenApiAxiosParamCreator;
/**
 * TokenApi - functional programming interface
 * @export
 */
var TokenApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.TokenApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenCreateRetrieve: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.tokenCreateRetrieve(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Takes a refresh type JSON web token and returns an access type JSON web token if the refresh token is valid.
         * @param {TokenRefresh} tokenRefresh
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenRefreshCreate: function (tokenRefresh, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.tokenRefreshCreate(tokenRefresh, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.TokenApiFp = TokenApiFp;
/**
 * TokenApi - factory interface
 * @export
 */
var TokenApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.TokenApiFp)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenCreateRetrieve: function (options) {
            return localVarFp.tokenCreateRetrieve(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Takes a refresh type JSON web token and returns an access type JSON web token if the refresh token is valid.
         * @param {TokenRefresh} tokenRefresh
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenRefreshCreate: function (tokenRefresh, options) {
            return localVarFp.tokenRefreshCreate(tokenRefresh, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.TokenApiFactory = TokenApiFactory;
/**
 * TokenApi - object-oriented interface
 * @export
 * @class TokenApi
 * @extends {BaseAPI}
 */
var TokenApi = /** @class */ (function (_super) {
    __extends(TokenApi, _super);
    function TokenApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokenApi
     */
    TokenApi.prototype.tokenCreateRetrieve = function (options) {
        var _this = this;
        return (0, exports.TokenApiFp)(this.configuration).tokenCreateRetrieve(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Takes a refresh type JSON web token and returns an access type JSON web token if the refresh token is valid.
     * @param {TokenRefresh} tokenRefresh
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokenApi
     */
    TokenApi.prototype.tokenRefreshCreate = function (tokenRefresh, options) {
        var _this = this;
        return (0, exports.TokenApiFp)(this.configuration).tokenRefreshCreate(tokenRefresh, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return TokenApi;
}(base_1.BaseAPI));
exports.TokenApi = TokenApi;
/**
 * UserApi - axios parameter creator
 * @export
 */
var UserApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * カメラ系画面の表示設定
         * @param {MyCameraDisplaySetting} myCameraDisplaySetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userMyCameraDisplaySettingsCreate: function (myCameraDisplaySetting, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'myCameraDisplaySetting' is not null or undefined
                            (0, common_1.assertParamExists)('userMyCameraDisplaySettingsCreate', 'myCameraDisplaySetting', myCameraDisplaySetting);
                            localVarPath = "/swc-api/user/my-camera-display-settings";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(myCameraDisplaySetting, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * カメラ系画面の表示設定
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userMyCameraDisplaySettingsDestroy: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('userMyCameraDisplaySettingsDestroy', 'id', id);
                            localVarPath = "/swc-api/user/my-camera-display-settings/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * カメラ系画面の表示設定
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userMyCameraDisplaySettingsList: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/user/my-camera-display-settings";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * カメラ系画面の表示設定
         * @param {string} id
         * @param {PatchedMyCameraDisplaySetting} [patchedMyCameraDisplaySetting]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userMyCameraDisplaySettingsPartialUpdate: function (id, patchedMyCameraDisplaySetting, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('userMyCameraDisplaySettingsPartialUpdate', 'id', id);
                            localVarPath = "/swc-api/user/my-camera-display-settings/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchedMyCameraDisplaySetting, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * カメラ系画面の表示設定
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userMyCameraDisplaySettingsRetrieve: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('userMyCameraDisplaySettingsRetrieve', 'id', id);
                            localVarPath = "/swc-api/user/my-camera-display-settings/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * カメラ系画面の表示設定
         * @param {string} id
         * @param {MyCameraDisplaySetting} myCameraDisplaySetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userMyCameraDisplaySettingsUpdate: function (id, myCameraDisplaySetting, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('userMyCameraDisplaySettingsUpdate', 'id', id);
                            // verify required parameter 'myCameraDisplaySetting' is not null or undefined
                            (0, common_1.assertParamExists)('userMyCameraDisplaySettingsUpdate', 'myCameraDisplaySetting', myCameraDisplaySetting);
                            localVarPath = "/swc-api/user/my-camera-display-settings/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(myCameraDisplaySetting, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.UserApiAxiosParamCreator = UserApiAxiosParamCreator;
/**
 * UserApi - functional programming interface
 * @export
 */
var UserApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.UserApiAxiosParamCreator)(configuration);
    return {
        /**
         * カメラ系画面の表示設定
         * @param {MyCameraDisplaySetting} myCameraDisplaySetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userMyCameraDisplaySettingsCreate: function (myCameraDisplaySetting, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userMyCameraDisplaySettingsCreate(myCameraDisplaySetting, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * カメラ系画面の表示設定
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userMyCameraDisplaySettingsDestroy: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userMyCameraDisplaySettingsDestroy(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * カメラ系画面の表示設定
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userMyCameraDisplaySettingsList: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userMyCameraDisplaySettingsList(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * カメラ系画面の表示設定
         * @param {string} id
         * @param {PatchedMyCameraDisplaySetting} [patchedMyCameraDisplaySetting]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userMyCameraDisplaySettingsPartialUpdate: function (id, patchedMyCameraDisplaySetting, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userMyCameraDisplaySettingsPartialUpdate(id, patchedMyCameraDisplaySetting, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * カメラ系画面の表示設定
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userMyCameraDisplaySettingsRetrieve: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userMyCameraDisplaySettingsRetrieve(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * カメラ系画面の表示設定
         * @param {string} id
         * @param {MyCameraDisplaySetting} myCameraDisplaySetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userMyCameraDisplaySettingsUpdate: function (id, myCameraDisplaySetting, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userMyCameraDisplaySettingsUpdate(id, myCameraDisplaySetting, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.UserApiFp = UserApiFp;
/**
 * UserApi - factory interface
 * @export
 */
var UserApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.UserApiFp)(configuration);
    return {
        /**
         * カメラ系画面の表示設定
         * @param {MyCameraDisplaySetting} myCameraDisplaySetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userMyCameraDisplaySettingsCreate: function (myCameraDisplaySetting, options) {
            return localVarFp.userMyCameraDisplaySettingsCreate(myCameraDisplaySetting, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * カメラ系画面の表示設定
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userMyCameraDisplaySettingsDestroy: function (id, options) {
            return localVarFp.userMyCameraDisplaySettingsDestroy(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * カメラ系画面の表示設定
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userMyCameraDisplaySettingsList: function (options) {
            return localVarFp.userMyCameraDisplaySettingsList(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * カメラ系画面の表示設定
         * @param {string} id
         * @param {PatchedMyCameraDisplaySetting} [patchedMyCameraDisplaySetting]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userMyCameraDisplaySettingsPartialUpdate: function (id, patchedMyCameraDisplaySetting, options) {
            return localVarFp.userMyCameraDisplaySettingsPartialUpdate(id, patchedMyCameraDisplaySetting, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * カメラ系画面の表示設定
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userMyCameraDisplaySettingsRetrieve: function (id, options) {
            return localVarFp.userMyCameraDisplaySettingsRetrieve(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * カメラ系画面の表示設定
         * @param {string} id
         * @param {MyCameraDisplaySetting} myCameraDisplaySetting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userMyCameraDisplaySettingsUpdate: function (id, myCameraDisplaySetting, options) {
            return localVarFp.userMyCameraDisplaySettingsUpdate(id, myCameraDisplaySetting, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.UserApiFactory = UserApiFactory;
/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
var UserApi = /** @class */ (function (_super) {
    __extends(UserApi, _super);
    function UserApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * カメラ系画面の表示設定
     * @param {MyCameraDisplaySetting} myCameraDisplaySetting
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userMyCameraDisplaySettingsCreate = function (myCameraDisplaySetting, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).userMyCameraDisplaySettingsCreate(myCameraDisplaySetting, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * カメラ系画面の表示設定
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userMyCameraDisplaySettingsDestroy = function (id, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).userMyCameraDisplaySettingsDestroy(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * カメラ系画面の表示設定
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userMyCameraDisplaySettingsList = function (options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).userMyCameraDisplaySettingsList(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * カメラ系画面の表示設定
     * @param {string} id
     * @param {PatchedMyCameraDisplaySetting} [patchedMyCameraDisplaySetting]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userMyCameraDisplaySettingsPartialUpdate = function (id, patchedMyCameraDisplaySetting, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).userMyCameraDisplaySettingsPartialUpdate(id, patchedMyCameraDisplaySetting, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * カメラ系画面の表示設定
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userMyCameraDisplaySettingsRetrieve = function (id, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).userMyCameraDisplaySettingsRetrieve(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * カメラ系画面の表示設定
     * @param {string} id
     * @param {MyCameraDisplaySetting} myCameraDisplaySetting
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userMyCameraDisplaySettingsUpdate = function (id, myCameraDisplaySetting, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).userMyCameraDisplaySettingsUpdate(id, myCameraDisplaySetting, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return UserApi;
}(base_1.BaseAPI));
exports.UserApi = UserApi;
/**
 * UserinfoApi - axios parameter creator
 * @export
 */
var UserinfoApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * apps側のユーザーにパッチを当てる
         * @param {PatchedUser} [patchedUser]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userinfoPartialUpdate: function (patchedUser, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/userinfo/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchedUser, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * ユーザ情報を1件取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userinfoRetrieve: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/swc-api/userinfo/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication basicAuth required
                            // http basic authentication required
                            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication cookieAuth required
                            // authentication jwtAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.UserinfoApiAxiosParamCreator = UserinfoApiAxiosParamCreator;
/**
 * UserinfoApi - functional programming interface
 * @export
 */
var UserinfoApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.UserinfoApiAxiosParamCreator)(configuration);
    return {
        /**
         * apps側のユーザーにパッチを当てる
         * @param {PatchedUser} [patchedUser]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userinfoPartialUpdate: function (patchedUser, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userinfoPartialUpdate(patchedUser, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * ユーザ情報を1件取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userinfoRetrieve: function (options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userinfoRetrieve(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.UserinfoApiFp = UserinfoApiFp;
/**
 * UserinfoApi - factory interface
 * @export
 */
var UserinfoApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.UserinfoApiFp)(configuration);
    return {
        /**
         * apps側のユーザーにパッチを当てる
         * @param {PatchedUser} [patchedUser]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userinfoPartialUpdate: function (patchedUser, options) {
            return localVarFp.userinfoPartialUpdate(patchedUser, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * ユーザ情報を1件取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userinfoRetrieve: function (options) {
            return localVarFp.userinfoRetrieve(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.UserinfoApiFactory = UserinfoApiFactory;
/**
 * UserinfoApi - object-oriented interface
 * @export
 * @class UserinfoApi
 * @extends {BaseAPI}
 */
var UserinfoApi = /** @class */ (function (_super) {
    __extends(UserinfoApi, _super);
    function UserinfoApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * apps側のユーザーにパッチを当てる
     * @param {PatchedUser} [patchedUser]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserinfoApi
     */
    UserinfoApi.prototype.userinfoPartialUpdate = function (patchedUser, options) {
        var _this = this;
        return (0, exports.UserinfoApiFp)(this.configuration).userinfoPartialUpdate(patchedUser, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * ユーザ情報を1件取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserinfoApi
     */
    UserinfoApi.prototype.userinfoRetrieve = function (options) {
        var _this = this;
        return (0, exports.UserinfoApiFp)(this.configuration).userinfoRetrieve(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return UserinfoApi;
}(base_1.BaseAPI));
exports.UserinfoApi = UserinfoApi;
